/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

export interface PossibleTypesResultData {
	possibleTypes: {
		[key: string]: string[];
	};
}
const result: PossibleTypesResultData = {
	possibleTypes: {
		AudioChannelFeatureChange: [
			'AudioChannelAcousticEchoCancellationChange',
			'AudioChannelAcousticEchoCancellationMonoReferenceChange',
			'AudioChannelAcousticEchoCancellationStereoReferenceChange',
			'AudioChannelAnalogInputUseChange',
			'AudioChannelAnalogLevelChange',
			'AudioChannelAuracastChange',
			'AudioChannelAuracastEncryptionChange',
			'AudioChannelAutoLevelChange',
			'AudioChannelAutoMuteChange',
			'AudioChannelAutoPositionChange',
			'AudioChannelAutomaticGainControlChange',
			'AudioChannelAutomixSourceSelectorChange',
			'AudioChannelAutomixerChange',
			'AudioChannelAutomixerChannelActiveChange',
			'AudioChannelAutomixerEnableChange',
			'AudioChannelAutomixerInputAlwaysOnChange',
			'AudioChannelAutomixerInputChange',
			'AudioChannelAutomixerInputPriorityChange',
			'AudioChannelAutomixerInputSendToMonoMixChange',
			'AudioChannelAutomixerInputSendToStereoMixChange',
			'AudioChannelAutomixerVoiceActivityDetectionChange',
			'AudioChannelCarriedByRfChannelsChange',
			'AudioChannelChannelConfigurationChange',
			'AudioChannelCompressorChange',
			'AudioChannelConnectionDetectionChange',
			'AudioChannelDanteEncryptionStatusChange',
			'AudioChannelDanteRouteReceiverChange',
			'AudioChannelDanteRouteTransmitterChange',
			'AudioChannelDelayChange',
			'AudioChannelDenoiserChange',
			'AudioChannelDeverbChange',
			'AudioChannelDeviceSpecificEqualizerContourChange',
			'AudioChannelDirectOutputTapPointChange',
			'AudioChannelEqualizerChange',
			'AudioChannelEqualizerContourChange',
			'AudioChannelEqualizerPresetChange',
			'AudioChannelExternalAutomixerGateChange',
			'AudioChannelFaderGroupChange',
			'AudioChannelGainChange',
			'AudioChannelGainLockChange',
			'AudioChannelGroundLiftChange',
			'AudioChannelIdentifyChange',
			'AudioChannelInputSourceChange',
			'AudioChannelLightingBehaviorChange',
			'AudioChannelLimiterChange',
			'AudioChannelLobeConfigurationChange',
			'AudioChannelLobePositionChange',
			'AudioChannelLobeTalkerHeightChange',
			'AudioChannelLobeWidthChange',
			'AudioChannelLogicReceiverChange',
			'AudioChannelMicOptimizationChange',
			'AudioChannelMicPolarPatternChange',
			'AudioChannelMicrophoneAngleChange',
			'AudioChannelMonitorMixChange',
			'AudioChannelMonitorMixReverbChange',
			'AudioChannelMuteChange',
			'AudioChannelMuteGroupChange',
			'AudioChannelMuteLockChange',
			'AudioChannelNameChange',
			'AudioChannelNoiseReductionChange',
			'AudioChannelOutputMixProcessingChange',
			'AudioChannelOutputPathChange',
			'AudioChannelPadSwitchChange',
			'AudioChannelPanChange',
			'AudioChannelPassiveSpeakersChange',
			'AudioChannelPcPeripheralChange',
			'AudioChannelPeakHoldChange',
			'AudioChannelPhantomPowerChange',
			'AudioChannelPlosiveReductionChange',
			'AudioChannelPostGateGainChange',
			'AudioChannelPostGateMuteChange',
			'AudioChannelPostGateSoloChange',
			'AudioChannelPreFadeListenChange',
			'AudioChannelPreGateMuteChange',
			'AudioChannelReverbChange',
			'AudioChannelSelectedLoudspeakerChange',
			'AudioChannelSignalGeneratorChange',
			'AudioChannelSoloChange',
			'AudioChannelStereoGainChange',
			'AudioChannelStereoReverseChange',
			'AudioChannelStereoWidthChange',
			'AudioChannelTalkSwitchChange',
			'AudioChannelTalkerHeightChange',
			'AudioChannelToneGeneratorChange',
			'AudioChannelTransmitterClipChange',
			'AudioChannelUsbOutputModeChange',
			'AudioChannelVoiceActivityDetectionNoiseReductionChange',
			'AudioChannelVoiceActivityDetectionSensitivityChange',
			'AudioChannelWirelessEncryptionChange'
		],
		AudioCoverageAreaFeatureChange: [
			'AudioCoverageAreaConfigurationChange',
			'AudioCoverageAreaGainChange',
			'AudioCoverageAreaMuteChange'
		],
		ChargerBayFeatureChange: [
			'ChargerBayAssociationChange',
			'ChargerBayBatteryCapacityChange',
			'ChargerBayBatteryHealthChange',
			'ChargerBayBatteryTemperatureChange',
			'ChargerBayChargingModeChange',
			'ChargerBayDockedBatteryChange',
			'ChargerBayDockedBatteryLevelChange',
			'ChargerBayDockedDeviceChange'
		],
		ChargerSlotFeatureChange: [
			'ChargerSlotChargerBaysChange',
			'ChargerSlotChargingSlotTypeIdChange',
			'ChargerSlotFirmwareChange',
			'ChargerSlotModelChange',
			'ChargerSlotSerialNumberChange',
			'ChargerSlotTemperatureChange'
		],
		ClearedAssociation: ['ChargerBay', 'RfChannel'],
		CloneRoomEvent: [
			'CloneRoomAudioRouteUpdateEvent',
			'CloneRoomControlRouteUpdateEvent',
			'CloneRoomDeviceUpdateEvent',
			'CloneRoomResultEvent',
			'CloneRoomStartedEvent'
		],
		CrossPointFeatureChange: ['CrossPointConfigurationChange', 'CrossPointGainChange'],
		CrossPointInputAudioChannel: ['AudioChannel', 'StereoAudioChannel'],
		DeviceFeatureChange: [
			'ConnectedDeviceLabelChange',
			'DeviceActivePresetChange',
			'DeviceAes3WordClockChange',
			'DeviceAllEqualizersBypassChange',
			'DeviceAllIntellimixBypassChange',
			'DeviceAnalogAudioOutputModeChange',
			'DeviceAnalogLogicChange',
			'DeviceAnalogLogicPresetSwitchChange',
			'DeviceAnalogLogicPresetSwitchStatusChange',
			'DeviceAnalyticsChange',
			'DeviceAntennaBiasVoltageChange',
			'DeviceAssignedSpectrumManagerChange',
			'DeviceAudioAutoFocusChange',
			'DeviceAudioChannelCountChange',
			'DeviceAudioChannelTemplatesChange',
			'DeviceAudioChannelsChange',
			'DeviceAudioInputLevelChange',
			'DeviceAudioMuteChange',
			'DeviceAudioMuteControlChange',
			'DeviceAudioMuteControlGroupChange',
			'DeviceAudioMuteDefaultChange',
			'DeviceAudioMuteLockChange',
			'DeviceAudioNetworkChange',
			'DeviceAudioNetworkInterfaceChange',
			'DeviceAudioSummingChange',
			'DeviceAuracastChange',
			'DeviceAuthenticationChange',
			'DeviceAutomixGainMeteringChange',
			'DeviceAvailablePackagesChange',
			'DeviceBatteryCapacityChange',
			'DeviceBatteryHealthChange',
			'DeviceBatteryLevelChange',
			'DeviceBatteryLowVoltageIndicatorChange',
			'DeviceBatteryStorageModeChange',
			'DeviceBatteryVoltageChange',
			'DeviceBluetoothDeviceInformationServiceChange',
			'DeviceBluetoothPowerChange',
			'DeviceBodypackMicrophoneModeChange',
			'DeviceCallStatusChange',
			'DeviceCombinedFrontPanelAndPowerLockChange',
			'DeviceCommandStringsServiceChange',
			'DeviceConferencingOperationModeButtonLockChange',
			'DeviceConferencingOperationModeChange',
			'DeviceConferencingPlatformChange',
			'DeviceConfigurationLockChange',
			'DeviceControlNetworkChange',
			'DeviceControlNetworkInterfaceChange',
			'DeviceCoverageLockChange',
			'DeviceCoverageModeChange',
			'DeviceCoveragePositionChange',
			'DeviceCrashReportChange',
			'DeviceDanteAudioEncryptionChange',
			'DeviceDanteAudioNetworkAccessChange',
			'DeviceDanteAudioNetworkChange',
			'DeviceDanteDeviceLockChange',
			'DeviceDanteDomainManagementChange',
			'DeviceDanteSampleRateChange',
			'DeviceDcPowerModuleChange',
			'DeviceDebugModeChange',
			'DeviceDectRfSpectrumScanChange',
			'DeviceDeploymentCandidatesChange',
			'DeviceDnsClientConfigurationChange',
			'DeviceDoubleStuffProxiedTransmittersChange',
			'DeviceDspDebugModeChange',
			'DeviceEqualizerContourChange',
			'DeviceErrorIndicatorChange',
			'DeviceEthernetLightsChange',
			'DeviceExternalDisplaysChange',
			'DeviceFanModeChange',
			'DeviceFirmwareUpdatePolicyChange',
			'DeviceFirmwareUpdateRequestsChange',
			'DeviceFrequencyEngineChange',
			'DeviceFrontPanelGainLockChange',
			'DeviceFrontPanelLockChange',
			'DeviceFrontPanelScanLockChange',
			'DeviceFrontPanelSyncLockChange',
			'DeviceGatewayDeviceChange',
			'DeviceGlobalMicStatusChange',
			'DeviceHeightChange',
			'DeviceHostedFirmwareChange',
			'DeviceHostedUpdateProgressChange',
			'DeviceIdentifyChange',
			'DeviceInterferenceDetectionResolutionChange',
			'DeviceInternetOfThingsChange',
			'DeviceIotRoomProxyChange',
			'DeviceLicenseChange',
			'DeviceLicenseChangeV2',
			'DeviceLicenseChangeV3',
			'DeviceLicenseNetworkInterfaceChange',
			'DeviceLightingAudioActivityChange',
			'DeviceLightingAudioMetersChange',
			'DeviceLightingAudioMuteIndicatorOverrideChange',
			'DeviceLightingAutomixGatingChange',
			'DeviceLightingBehaviorChange',
			'DeviceLightingBrightnessChange',
			'DeviceLightingLiveAudioMetersChange',
			'DeviceLightingMuteBehaviorChange',
			'DeviceLightingRingChange',
			'DeviceLightingSegmentsBehaviorChange',
			'DeviceLightingSplitModeBreathingMeterColorChange',
			'DeviceLightingSplitModeSolidMeterColorChange',
			'DeviceLightingTouchPanelModeChange',
			'DeviceLightingUnmuteBehaviorChange',
			'DeviceLinkButtonLockChange',
			'DeviceLinkedAccessPointChange',
			'DeviceListenerHeightChange',
			'DeviceLogicMuteChange',
			'DeviceLogicReceiverChange',
			'DeviceLogicTransmitterChange',
			'DeviceLoudspeakerChange',
			'DeviceMdnsServiceChange',
			'DeviceMeteringModesChange',
			'DeviceMicSpatialOrientationChange',
			'DeviceMicStatusChange',
			'DeviceMicStatusV2Change',
			'DeviceMultiArrayLocalizationGroupReporterChange',
			'DeviceMuteButtonLockChange',
			'DeviceNameChange',
			'DeviceNetworkSwitchConfigurationChange',
			'DeviceOnChargerChange',
			'DevicePlacementChange',
			'DevicePowerSwitchLockChange',
			'DeviceProxiedDevicesChange',
			'DeviceQuadversityChange',
			'DeviceRebootPendingChange',
			'DeviceRedundantAudioNetworkChange',
			'DeviceRfBandChange',
			'DeviceRfChannelsChange',
			'DeviceRfCurrentDrawChange',
			'DeviceRfDensityModeChange',
			'DeviceRfMuteChange',
			'DeviceRfPowerChange',
			'DeviceRfTransmissionProfileChange',
			'DeviceRoomChange',
			'DeviceRotationChange',
			'DeviceRoutingPositionChange',
			'DeviceSecondaryControlNetworkChange',
			'DeviceSecondaryControlNetworkDnsClientConfigurationChange',
			'DeviceSecondaryEthernetPortChange',
			'DeviceSecurity8021XChange',
			'DeviceSmartGateChange',
			'DeviceStereoAudioChange',
			'DeviceTagsChange',
			'DeviceTalkerTrackingConfigChange',
			'DeviceTemperatureChange',
			'DeviceTransmitterIdentifyBehaviorChange',
			'DeviceTransmitterInitialStateFromChargerChange',
			'DeviceTransmitterLightingBehaviorChange',
			'DeviceTransmitterMuteBehaviorChange',
			'DeviceTransmitterOutOfRangeBehaviorChange',
			'DeviceTransmitterRejoinBehaviorChange',
			'DeviceTransmitterSwitchBehaviorChange',
			'DeviceUpdateProgressChange',
			'DeviceUptimeChange',
			'DeviceUsbConnectionChange',
			'DeviceUsbMuteSyncChange',
			'DeviceUsbTerminalTypeChange',
			'DeviceUserInterfacePreferencesChange',
			'DeviceUserPerspectiveChange',
			'DeviceUserPresetsChange',
			'DeviceVirtualAcousticBoundaryChange',
			'DeviceWebServiceChange',
			'DeviceWirelessEncryptionChange'
		],
		DeviceUnlinkingDetailResult: ['DeviceUnlinkingChargerBayResult', 'DeviceUnlinkingRfChannelResult'],
		DiscoveredDevicesEvent: ['DeviceAdded', 'DeviceRemoved'],
		DiscoveredRoomEvent: ['RoomAddedEvent', 'RoomRemovedEvent'],
		DspDebugAudioFenceLobeFeatureChange: ['DspDebugAudioFenceLobeCoreChange'],
		EqualizerFilterFeatureChange: [
			'EqualizerFilterBandwidthChange',
			'EqualizerFilterConfigurationChange',
			'EqualizerFilterFrequencyChange',
			'EqualizerFilterGainChange',
			'EqualizerFilterQFactorChange'
		],
		ExternalDisplayFeatureChange: ['ExternalDisplayConnectionChange', 'ExternalDisplayResolutionChange'],
		Fragment: [
			'AudioChannel',
			'AudioCoverageArea',
			'ChargerBay',
			'ChargerSlot',
			'CrossPoint',
			'DspDebugAudioFenceLobe',
			'EqualizerFilter',
			'ExternalDisplay',
			'RfChannel',
			'RfPort',
			'UserPreset'
		],
		IDurationRangeConstraints: ['AudioChannelDelayFieldConstraints', 'AutomixHoldTimeConstraints'],
		IFieldSupportInfo: [
			'AudioChannelCompressorLevelConstraints',
			'AudioChannelCompressorRatioConstraints',
			'AudioChannelCompressorThresholdConstraints',
			'AudioChannelLimiterThresholdConstraints',
			'AudioChannelLobePositionAutoFocusConstraints',
			'AudioChannelMicrophoneAngleAutoFocusConstraints',
			'AudioChannelTalkerHeightAutoFocusConstraints',
			'AutoLevelConfigurationConstraints',
			'AutoLevelModeConstraints',
			'AutoLevelPositionConstraints',
			'AutoLevelToneConstraints',
			'DeviceBatteryLevelBarsConstraints',
			'EqualizerEnabledConstraints',
			'EqualizerFiltersConstraints',
			'EqualizerToneConstraints',
			'FieldSupport',
			'NoiseReductionLevelConstraints',
			'NoiseReductionPercentageConstraints',
			'NonLinearProcessingLevelConstraints',
			'RfChannelPeripheralBatteryLevelBarsConstraints',
			'RfChannelPeripheralBatteryLevelPercentageConstraints',
			'TransmitterInitialStateFromChargerOptionalFormFactorConstraints'
		],
		IFloatRangeConstraints: [
			'AudioChannelAcousticEchoCancellationErleLevelConstraints',
			'AudioChannelAcousticEchoCancellationPeakMeterLevelConstraints',
			'AudioChannelAcousticEchoCancellationRmsMeterLevelConstraints',
			'AudioChannelAnalogStereoPeakLevelConstraints',
			'AudioChannelAnalogStereoRmsLevelConstraints',
			'AudioChannelAutomaticGainControlPeakMeterLevelConstraints',
			'AudioChannelAutomaticGainControlRmsMeterLevelConstraints',
			'AudioChannelAutomaticGainMaxBoostConstraints',
			'AudioChannelAutomaticGainMaxCutConstraints',
			'AudioChannelAutomaticGainTargetLevelConstraints',
			'AudioChannelAutomixGainConstraints',
			'AudioChannelAutomixerAutoLevelModeFieldConstraints',
			'AudioChannelAutomixerInputPeakLevelConstraints',
			'AudioChannelAutomixerInputRmsLevelConstraints',
			'AudioChannelAutomixerNoiseFloorEstimateFieldConstraints',
			'AudioChannelGainFieldConstraints',
			'AudioChannelLobePositionAutoFocusFieldConstraints',
			'AudioChannelLobePositionFixedFieldConstraints',
			'AudioChannelMatrixMixerInputPeakLevelConstraints',
			'AudioChannelMatrixMixerInputRmsLevelConstraints',
			'AudioChannelMatrixMixerOutputPeakLevelConstraints',
			'AudioChannelMatrixMixerOutputRmsLevelConstraints',
			'AudioChannelMatrixMixerPeakLevelConstraints',
			'AudioChannelMatrixMixerRmsLevelConstraints',
			'AudioChannelMatrixMixerStereoInputPeakLevelConstraints',
			'AudioChannelMatrixMixerStereoInputRmsLevelConstraints',
			'AudioChannelPeakMeterLevelConstraints',
			'AudioChannelPostGateFieldConstraints',
			'AudioChannelPostGateGainStereoPeakLevelConstraints',
			'AudioChannelPostGateGainStereoRmsLevelConstraints',
			'AudioChannelRmsLevelConstraints',
			'AudioChannelStereoAutomixGainConstraints',
			'AudioChannelStereoGainFieldConstraints',
			'AudioChannelStereoPeakLevelConstraints',
			'AudioChannelStereoRmsLevelConstraints',
			'AudioChannelTalkerHeightAutoFocusFieldConstraints',
			'AudioChannelTalkerHeightFieldConstraints',
			'AudioChannelTalkerHeightFixedFieldConstraints',
			'AudioCoverageAreaGainFieldConstraints',
			'AudioCoverageAreaPeakMeterLevelConstraints',
			'AudioCoverageRmsMeterLevelConstraints',
			'AutomixOffAttenuationConstraints',
			'CrossPointGainFieldConstraints',
			'DeviceHeightFieldConstraints',
			'DeviceListenerHeightFieldConstraints',
			'EqualizerFilterFrequencyFieldConstraints',
			'EqualizerFilterGainFieldConstraints',
			'PassiveSpeakerHeightFieldConstraints',
			'PassiveSpeakerListenerHeightFieldConstraints',
			'RectangularAreaFieldConstraints'
		],
		IIntRangeConstraints: [
			'AudioChannelAutomaticGainConstraints',
			'AudioChannelMicrophoneAngleAutoFocusFieldConstraints',
			'AudioChannelMicrophoneAngleFixedFieldConstraints',
			'AudioChannelMonitorMixTypeConstraints',
			'AudioChannelPadSwitchFieldConstraints',
			'AudioChannelPanFieldConstraints',
			'AudioChannelReverbIntensityConstraints',
			'AudioChannelStereoWidthAngleConstraints',
			'AudioChannelToneGeneratorGainFieldConstraints',
			'AutomixGatingSensitivityConstraints',
			'AutomixMaxOpenChannelsConstraints',
			'ChargerBayBatteryHealthPercentageConstraints',
			'ChargerBayDockedBatteryLevelBarsConstraints',
			'ChargerBayDockedBatteryLevelPercentageConstraints',
			'DeviceBatteryHealthPercentageConstraints',
			'DeviceBatteryLevelPercentageConstraints',
			'DeviceBatteryLowVoltageIndicatorThresholdConstraints',
			'DeviceCommandStringsServicePortConstraints',
			'DeviceLightingBrightnessFieldConstraints',
			'DeviceRotationAxisConstraints',
			'DeviceUserPerspectiveRotationAxisFieldConstraints',
			'DeviceVirtualAcousticBoundarySensitivityConstraints',
			'PassiveSpeakerRotationAxisConstraints',
			'RfChannelPeripheralBatteryHealthPercentageConstraints',
			'RfChannelQualityConstraints',
			'RfPortCurrentLevelConstraints',
			'RgbColorMixFieldConstraints'
		],
		INullableDurationRangeConstraints: [],
		INullableFloatRangeConstraints: ['AudioChannelLimiterThresholdConstraints'],
		INullableIntRangeConstraints: [
			'DeviceBatteryLevelBarsConstraints',
			'EqualizerToneConstraints',
			'RfChannelPeripheralBatteryLevelBarsConstraints',
			'RfChannelPeripheralBatteryLevelPercentageConstraints'
		],
		IStringPatternRangeConstraints: [
			'AudioChannelDanteRouteReceiverDanteChannelNameConstraints',
			'AudioChannelDanteRouteTransmitterDanteChannelNameConstraints',
			'AudioChannelNameFieldConstraints',
			'DeviceDanteAudioNetworkNameConstraints',
			'DeviceNameFieldConstraints',
			'DeviceSecurity8021XAnonymousIdConstraints',
			'DeviceSecurity8021XPasswordConstraints',
			'DeviceSecurity8021XUserNameConstraints',
			'PassiveSpeakerNameFieldConstraints',
			'UserPresetCoreNameConstraints'
		],
		IUtf8StringMaxBytesConstraints: [
			'AudioChannelAuracastNameConstraints',
			'ConnectedDeviceLabelFieldConstraints',
			'DeviceNameFieldConstraints'
		],
		MeterChange: ['AudioChannelMeterChange', 'AudioCoverageAreaMeterChange', 'RfChannelMeterChange'],
		Node: [
			'AudioChannel',
			'AudioCoverageArea',
			'ChargerBay',
			'ChargerSlot',
			'CrossPoint',
			'Device',
			'DspDebugAudioFenceLobe',
			'EqualizerFilter',
			'ExternalDisplay',
			'FirmwarePackageDownloadProgress',
			'FirmwarePackageDownloadRequestProgress',
			'FirmwareUpdateProgress',
			'FirmwareUpdateRequest',
			'FirmwareUpdateRequestProgress',
			'PassiveSpeaker',
			'RfChannel',
			'RfPort',
			'Room',
			'RoomManifestDevice',
			'StereoAudioChannel',
			'UserPreset'
		],
		NodeChange: [
			'AudioChannel',
			'AudioChannelChange',
			'AudioCoverageArea',
			'AudioCoverageAreaChange',
			'ChargerBay',
			'ChargerBayChange',
			'ChargerSlot',
			'ChargerSlotChange',
			'CrossPoint',
			'CrossPointChange',
			'Device',
			'DeviceChange',
			'DeviceStatusChange',
			'DspDebugAudioFenceLobe',
			'DspDebugAudioFenceLobeChange',
			'EqualizerFilter',
			'EqualizerFilterChange',
			'ExternalDisplay',
			'ExternalDisplayChange',
			'FirmwarePackageDownloadProgress',
			'FirmwarePackageDownloadRequestProgress',
			'FirmwareUpdateProgress',
			'FirmwareUpdateRequest',
			'FirmwareUpdateRequestProgress',
			'PassiveSpeaker',
			'PassiveSpeakerChange',
			'RfChannel',
			'RfChannelChange',
			'RfPort',
			'RfPortChange',
			'Room',
			'UserPreset',
			'UserPresetChange'
		],
		NodeOperationResult: [
			'AudioChannelOperationResult',
			'AudioCoverageAreaOperationResult',
			'ChargerBayOperationResult',
			'ChargerSlotOperationResult',
			'ClearAssociationResult',
			'CreateRouteOperationResult',
			'CrossPointOperationResult',
			'DeleteRouteOperationResult',
			'DeviceOperationResult',
			'EqualizerFilterOperationResult',
			'PassiveSpeakerOperationResult',
			'RfChannelOperationResult',
			'RfPortOperationResult',
			'RoomOperationResult',
			'UserPresetOperationResult'
		],
		OptimizeRoomProgress: ['OptimizeRoomProgressEvent', 'OptimizeRoomResult'],
		PassiveSpeakerFeatureChange: [
			'PassiveSpeakerCoveragePositionChange',
			'PassiveSpeakerHeightChange',
			'PassiveSpeakerListenerHeightChange',
			'PassiveSpeakerNameChange',
			'PassiveSpeakerRotationChange'
		],
		QFactorConstraint: ['EqualizerFilterValidQFactors', 'FloatRange'],
		ResetDeviceResult: ['DeviceOperationResult', 'OperationResult'],
		RfChannelFeatureChange: [
			'RfChannelAssignedRfBandChange',
			'RfChannelAssignedRfProfileChange',
			'RfChannelAssociationChange',
			'RfChannelCarriedAudioChannelsChange',
			'RfChannelFrequencyDiversityModeChange',
			'RfChannelInterferenceDetectionChange',
			'RfChannelInterferenceDetectionResolutionChange',
			'RfChannelInterferenceDetectorChange',
			'RfChannelLinkedTransmitterChange',
			'RfChannelMuteChange',
			'RfChannelPeripheralAudioMuteChange',
			'RfChannelPeripheralAudioPolarityChange',
			'RfChannelPeripheralAutoLockChange',
			'RfChannelPeripheralBatteryHealthChange',
			'RfChannelPeripheralBatteryLevelChange',
			'RfChannelPeripheralBatteryTemperatureChange',
			'RfChannelPeripheralBatteryTypeChange',
			'RfChannelPeripheralDeviceChange',
			'RfChannelPeripheralFirmwareChange',
			'RfChannelPeripheralSerialNumberChange',
			'RfChannelPeripheralWirelessEncryptionChange',
			'RfChannelReceiveStandbyModeChange',
			'RfChannelTuningChange',
			'RfChannelUtilizedRfPortsChange',
			'RfChannelWirelessEncryptionStatusChange'
		],
		RfPortFeatureChange: [
			'RfPortAntennaFaultChange',
			'RfPortDcPowerChange',
			'RfPortFrontEndPowerLimiterEngagedChange',
			'RfPortFrontEndPowerOverloadChange',
			'RfPortUtilizedByRfChannelsChange'
		],
		RoomDeploymentProgress: ['RoomDeploymentProgressEvent', 'RoomDeploymentResult'],
		Talker: ['AudioChannelTalker', 'AudioCoverageAreaTalker'],
		UserPresetFeatureChange: ['UserPresetCoreChange']
	}
};
export default result;

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `AudioChannelGroupName` scalar represents the type of an audio channel. Use the device 'constraints' field to
	 * get a list of possible values supported for a specific device. Note that this list is open to expansion in the future as more devices
	 * and thus newer channel groups are supported over time.
	 *
	 * For applications integrating with this API, it is recommended to use an object defining a collection of constants (like an Enumeration class)
	 * to support this future expansion.
	 *
	 * Here are the currently supported list of possible values:
	 *
	 * ADC_INPUT
	 *
	 * AEC_REFERENCE
	 *
	 * AEC_REFERENCE_MIX_OUTPUT
	 *
	 * ANALOG_70V_OUTPUT
	 *
	 * ANALOG_AUX_INPUT
	 *
	 * ANALOG_INPUT
	 *
	 * ANALOG_OUTPUT
	 *
	 * AURACAST_OUTPUT
	 *
	 * AUTOMIX
	 *
	 * AUTOMIX_STEREO
	 *
	 * AUX_INPUT
	 *
	 * AUX_OUTPUT
	 *
	 * BACK
	 *
	 * BLUETOOTH_INPUT
	 *
	 * BLUETOOTH_OUTPUT
	 *
	 * DANTE_ANALOG_INPUT
	 *
	 * DANTE_AUX_INPUT
	 *
	 * DANTE_INPUT
	 *
	 * DANTE_LINE_INPUT
	 *
	 * DANTE_LINE_OUTPUT
	 *
	 * DANTE_MIC_INPUT
	 *
	 * DANTE_OUTPUT
	 *
	 * DIRECT_OUTPUT
	 *
	 * DIRECT_OUTPUT_ANALOG_INPUT
	 *
	 * DIRECT_OUTPUT_DANTE_MIC_INPUT
	 *
	 * EXTERNAL_AUTOMIX
	 *
	 * GENERIC
	 *
	 * HEADPHONE
	 *
	 * LOBE
	 *
	 * LOUDSPEAKER
	 *
	 * MIC
	 *
	 * MIX_OUTPUT
	 *
	 * MOBILE_INPUT
	 *
	 * MOBILE_OUTPUT
	 *
	 * PC_INPUT
	 *
	 * PC_OUTPUT
	 *
	 * PRE_FADE_LISTEN
	 *
	 * SIGNAL_GENERATOR_INPUT
	 *
	 * SUM
	 *
	 * TRS_INPUT
	 *
	 * USB_INPUT
	 *
	 * USB_OUTPUT
	 *
	 * VIRTUAL_AUDIO_INPUT
	 *
	 * VIRTUAL_AUDIO_OUTPUT
	 *
	 * XLR_INPUT
	 */
	AudioChannelGroupName: { input: string; output: string };
	/** A DateTime in ISO-8601 format. (https://wikipedia.org/wiki/ISO_8601) */
	DateTime: { input: string; output: string };
	/**
	 * Corresponds to a period of time, as specified by https://en.wikipedia.org/wiki/ISO_8601#Durations
	 * E.g. PT1S is one second. PT0.1S is 100 milliseconds.
	 */
	Duration: { input: string; output: string };
	/**
	 * The `FirmwareUpdateError` scalar represents the reason why an update was rejected or failed. Note that this list is open to expansion in the future.
	 *
	 * For applications integrating with this API, it is recommended to use an object defining a collection of constants (like an Enumeration class)
	 * to support this future expansion.
	 *
	 * Here is the currently supported list of possible values:
	 *
	 *    * INVALID_PACKAGE: The device does not support the specified firmware package
	 *
	 *    * CORRUPT_PACKAGE: The firmware package was corrupted locally or in transfer to the device
	 *
	 *    * CONNECTIVITY_LOSS: There was a connectivity issue
	 *
	 *    * DEVICE_BUSY: The device is unavailable for a firmware update
	 *
	 *    * DEVICE_NOT_FOUND: The device cannot be found
	 *
	 *    * FILE_TRANSFER_ERROR: An error occurred while transferring the firmware package to the device
	 *
	 *    * DEVICE_REJECTED_PACKAGE
	 *
	 *    * INSTALLATION_ERROR: An error occurred while the device was installing the firmware package
	 *
	 *    * VERIFICATION_ERROR: An error occurred while the device was verifying the installation
	 *
	 *    * QUOTA_EXCEEDED: The maximum number of pending requests has been exceeded
	 *
	 *    * MISSING_PROXY: The device can only be updated through a proxy but none was found
	 *
	 *    * NOT_CONNECTED_VIA_USB: The device must be connected via USB instead of being proxied
	 *
	 *    * DANTE_LOCKED: The device is unavailable for a firmware update due to Dante Device Lock and/or DDM
	 *
	 *    * DANTE_NETWORK_MISMATCH: The device is unavailable for a firmware update due to Control and Dante IP addresses being on different networks
	 *
	 *    * NETWORK_LOCKED: The device is unavailable for a firmware update due to Access Control being enabled
	 *
	 *    * UPDATE_IN_PROGRESS: The device is unavailable for a firmware update as a firmware update is in progress already
	 *
	 *    * NOT_DOCKED: The device needs to be in the charging dock to perform a firmware update
	 */
	FirmwareUpdateError: { input: string; output: string };
	/**
	 * Guid stands for Globally Unique Identifier. Also referred to as UUIDs or Universaly Unique Identifiers.
	 * - Technically they are 128-bit unique reference numbers which are highly unlikely to repeat.
	 * - A Guid follows a specific structure defined in RFC `4122` and come in a few different
	 * versions and variants. All variants follow the same structure xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
	 * where M represents the version and the most significant bits of N represent the variant.
	 */
	Guid: { input: string; output: string };
	/**
	 * The `IpAddress` scalar represents a dotted quad string notation of
	 * an IPv4 address.
	 */
	IpAddress: { input: string; output: string };
	Regex: { input: string; output: string };
	/**
	 * The `RfChannelSeriesName` scalar represents the characteristics of an RF Channel such as
	 * - bandwidth/Q factor
	 * - desired channel spacing
	 * - and more.
	 *
	 * Note that this list is open to expansion in the future.
	 *
	 * For applications integrating with this API, it is recommended to use an object defining a collection of constants (like an Enumeration class)
	 * to support this future expansion.
	 *
	 * Here is the currently supported list of possible values, followed by their applicable device models (seriesName: applicable model 1, ..., applicable model N)
	 *    * AD: AD1, AD2, AD3, AD4D-A, AD4D-B, AD4D-C, AD4D-D, AD4D-F, AD4D-P55, AD4D-R52, AD4Q-A, AD4Q-B, AD4Q-C, AD4Q-D, AD4Q-F, AD4Q-P55, AD4Q-R52, ADX1, ADX1M, ADX2, ADX2FD, ADX3, ADX5D-A, ADX5D-B, ADX5D-C, ADX5D-P, ADX5D-R, ANX4 (AD)
	 *    * ADPSM: ADTD, ADTQ, ADXR-A, ADXR-B, ADXR-C, ADXR-P55, ADXR-X57, ADXR-Z16
	 *    * AXT: AXT100, AXT200, AXT210, AXT400 A, AXT400 B, AXT400 C, AXT400 D, AXT400 J, AXT400 R16
	 *    * BLX: BLX1, BLX2, BLX4, BLX4R, BLX88
	 *    * FP: FP1, FP2, FP3, FP5
	 *    * KCX: KCX
	 *    * MW: MW4D
	 *    * MW5: MW5
	 *    * PG: PG4
	 *    * PGX: PGX4
	 *    * PSM1000: P10R, P10T
	 *    * PSM200: P2R, P2T
	 *    * PSM300: P3T
	 *    * PSM400: P4R, P4T
	 *    * PSM600: P6R, P6T
	 *    * PSM700: P7R, P7T
	 *    * PSM900: P9R, P9RA, P9RA+, P9T
	 *    * QLXD: QLXD1, QLXD2, QLXD4
	 *    * SLX: SLX4
	 *    * SLXD: SLXD1, SLXD2, SLXD3, SLXD4, SLXD4+, SLXD4D, SLXD4D+, SLXD4Q+, SLXD4Q+DAN
	 *    * SLXD5: SLXD5, SLXD5+
	 *    * SLX_master_list: SLX_master_list
	 *    * SVX: SVX
	 *    * UC: UC4
	 *    * UHF: U4D, U4S
	 *    * UHFR: UR1, UR1M, UR2, UR3, UR4D, UR4S
	 *    * ULX: ULXS4
	 *    * ULXD: ANX4 (ULXD), ULXD1, ULXD2, ULXD4, ULXD4D, ULXD4Q, ULXD6, ULXD8
	 *    * ULX_master_list: ULX_master_list
	 *    * UR5: UR5
	 */
	RfChannelSeriesName: { input: string; output: string };
	/**
	 * The `RfPortLabel` scalar represents the name of an RF Port.
	 *
	 * Note that this list is open to expansion in the future as more devices
	 * and thus newer RF Port names are supported over time.
	 *
	 * Here are the currently supported list of possible values:
	 *
	 * A
	 *
	 * B
	 *
	 * C
	 *
	 * D
	 *
	 * E
	 *
	 * F
	 *
	 * A1
	 *
	 * A2
	 *
	 * B1
	 *
	 * B2
	 *
	 * C1
	 *
	 * C2
	 *
	 * D1
	 *
	 * D2
	 */
	RfPortLabel: { input: string; output: string };
	/**
	 * The `RfProfileName` scalar represents the name of an RF Profile from WILMA's DeviceProfileTypes table.
	 *
	 * Note that this list is open to expansion in the future.
	 *
	 * Here are the currently supported list of possible values:
	 *   * Standard
	 *   * HD
	 *   * AXT
	 *   * UHF-R
	 *   * MW
	 *   * Narrowband
	 *   * 4-channel_wideband
	 *   * Analog_FM
	 *   * 2-channel_wideband
	 *   * AD_Standard_PTP
	 *   * SC_narrowband
	 */
	RfProfileName: { input: string; output: string };
	SemanticVersion: { input: string; output: string };
};

export enum AccessPointDeviceOperationMode {
	ConferenceMode = 'CONFERENCE_MODE',
	PresentationMode = 'PRESENTATION_MODE'
}

export type AcousticEchoCancellationConstraints = {
	nonLinearProcessingLevel: Maybe<NonLinearProcessingLevelConstraints>;
};

export type ActivateLicenseInput = {
	activationKey: Scalars['String']['input'];
	count: Scalars['Int']['input'];
	id: Scalars['ID']['input'];
};

export enum Aes3ClockSource {
	External = 'EXTERNAL',
	Internal = 'INTERNAL'
}

export type Aes3ExternalClock = {
	/** Clock rate (Hz) */
	detectedClockRate: Scalars['Int']['output'];
};

export type Aes3InternalClock = {
	/** Clock rate (Hz) */
	clockRate: Scalars['Int']['output'];
};

export type Aes3InternalClockUpdateInput = {
	/** Clock rate (Hz) */
	clockRate: Scalars['Int']['input'];
};

export enum Aes3TerminationSwitch {
	/** Allow signal to pass to downstream components. Also known as 'THRU' in device front panels and control software (e.g. Wireless Workbench) */
	PassThrough = 'PASS_THROUGH',
	/** Terminated with a 75-ohm resistor to prevent reflections, signal degradation, and timing errors */
	Terminated_75Ohm = 'TERMINATED_75_OHM'
}

export enum AnalogAudioOutputMode {
	LowImpedanceFourChannels = 'LOW_IMPEDANCE_FOUR_CHANNELS',
	/**
	 * For use with low impedance speakers (a.k.a Low Z), such as 8-ohm or 16-ohm speakers.
	 * Speakers will be wired individually to each audio channel.
	 * Users can select between two or four channels.
	 */
	LowImpedanceTwoChannels = 'LOW_IMPEDANCE_TWO_CHANNELS',
	/**
	 * For use with 70V speakers with step-up / step-down transformers inside.
	 * Speakers are wired in a daisy-chained way to a single audio channel.
	 */
	SeventyVolt = 'SEVENTY_VOLT'
}

export type AnalogAudioOutputModeConstraints = {
	options: Array<AnalogAudioOutputMode | `${AnalogAudioOutputMode}`>;
};

export enum AnalogInputUseMode {
	/** The channel is an Acoustic Echo Cancellation reference input */
	AcousticEchoCancellation = 'ACOUSTIC_ECHO_CANCELLATION',
	/** The channel is an audio input */
	MicIn = 'MIC_IN'
}

export enum AnalogLevel {
	Aux = 'AUX',
	Headphone = 'HEADPHONE',
	Line = 'LINE',
	Mic = 'MIC'
}

export type AnalogLevelConstraints = {
	level: AnalogLevelModeConstraints;
};

export type AnalogLevelModeConstraints = {
	options: Array<AnalogLevel | `${AnalogLevel}`>;
};

export enum AnalogLogicPresetSwitch {
	/** Mode A: This is the default selection. When there is no signal, the device loads Preset 1. When there is signal, the device switches to Preset 2. */
	ModeA = 'MODE_A',
	/** Mode B: When there is no signal, the device loads Preset 2. When there is signal, the device switches to Preset 1. */
	ModeB = 'MODE_B'
}

export enum AnalogLogicPresetSwitchStatus {
	NoSignal = 'NO_SIGNAL',
	Signal = 'SIGNAL'
}

export type AnalogLogicPresetSwitchStatusConstraints = {
	options: Array<AnalogLogicPresetSwitchStatus | `${AnalogLogicPresetSwitchStatus}`>;
};

/** Refer to https://www.youtube.com/watch?v=EIEr7rKio30&ab_channel=ShurePerformance%26Production for more information, starting at 21:30 minutes. */
export enum AntennaDiversityMode {
	/**
	 * If signal degrades, the device will instead attempt to receive signal from another antenna in an attempt to provide the best signal quality.
	 * The device cannot know it is objectively better until after attempting the switch (hence "predictive").
	 * Only one RSSI is relevant to show at a time.
	 */
	PredictiveDiversity = 'PREDICTIVE_DIVERSITY',
	/**
	 * The device uses multiple antennas simultaneously to mitigate multipath effects, but does not allow
	 * for individual antenna placement. As a result, only one RSSI is relevant to show at a time.
	 */
	SpatialDiversity = 'SPATIAL_DIVERSITY',
	/**
	 * Combines audio information carried from multiple active antennas to 'fill in the gaps'
	 * from missing data by correlating RF signals received from other active antennas which are not detecting interference.
	 * All antennas are relevant to show RSSI for.
	 */
	TrueDigitalDiversity = 'TRUE_DIGITAL_DIVERSITY'
}

export type AssignedRfProfileConstraints = {
	options: Array<Scalars['RfProfileName']['output']>;
};

export enum AssociationStatus {
	/** Access point is not discoverable */
	AccessPointDeviceNotFound = 'ACCESS_POINT_DEVICE_NOT_FOUND',
	/** Charger device is not discoverable */
	ChargerDeviceNotFound = 'CHARGER_DEVICE_NOT_FOUND',
	/** Failure occured on pre-processing a Charger Bay. This include failure in clearing existing association duing re-association */
	FailurePreProcessingChargerBay = 'FAILURE_PRE_PROCESSING_CHARGER_BAY',
	/** Failure occured on pre-processing a RF Channel. This include failure in clearing existing association duing re-association */
	FailurePreProcessingRfChannel = 'FAILURE_PRE_PROCESSING_RF_CHANNEL',
	/** Failure occured when processing association request on Charger Bay. This includes failed opeartions on Charger Bay */
	FailureProcessingChargerBay = 'FAILURE_PROCESSING_CHARGER_BAY',
	/** Failure occured when processing association request on RF Channel. This includes failed opeartions on RF Channel */
	FailureProcessingRfChannel = 'FAILURE_PROCESSING_RF_CHANNEL',
	/** Input node id(s) provided in association request is not valid */
	InvalidInput = 'INVALID_INPUT',
	/** Provided input devices either does not support association feature or not a valid input for this operation */
	InvalidOperation = 'INVALID_OPERATION',
	/** Successfully associated RF channel and Charger bay */
	Success = 'SUCCESS'
}

export enum AudioActivityLevel {
	Clipping = 'CLIPPING',
	Good = 'GOOD',
	Low = 'LOW'
}

export type AudioChannel = Fragment &
	Node & {
		description: AudioChannelDescription;
		features: AudioChannelFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type AudioChannelAcousticEchoCancellation = {
	enabled: Scalars['Boolean']['output'];
	nonLinearProcessingLevel: Maybe<NonLinearProcessingLevel | `${NonLinearProcessingLevel}`>;
};

export type AudioChannelAcousticEchoCancellationChange = {
	acousticEchoCancellation: Maybe<AudioChannelAcousticEchoCancellation>;
};

export type AudioChannelAcousticEchoCancellationErleLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAcousticEchoCancellationErleMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAcousticEchoCancellationErleMeterConstraints = {
	level: AudioChannelAcousticEchoCancellationErleLevelConstraints;
};

export type AudioChannelAcousticEchoCancellationErleMeterSource = {
	audioChannels: Array<AudioChannel>;
};

export type AudioChannelAcousticEchoCancellationInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	nonLinearProcessingLevel?: InputMaybe<NonLinearProcessingLevel | `${NonLinearProcessingLevel}`>;
};

export type AudioChannelAcousticEchoCancellationMonoReference = {
	/** An audio channel of the device used for monitoring the selected reference source. */
	reference: AudioChannel;
	/** A list of audio channels within this device that can be used as a mono reference for acoustic echo cancellation. */
	referenceSourceOptions: Maybe<Array<AudioChannel>>;
	/**
	 * The audio channel used as a far end mono reference signal.
	 * For best results, use the signal that also feeds your local reinforcement system (e.g. conference room loudspeakers).
	 * On MXA mics, route a far-end signal to the AEC Reference In channel.
	 * On digital signal processors, choose an option from 'referenceSourceOptions'.
	 */
	selectedReferenceSource: AudioChannel;
};

export type AudioChannelAcousticEchoCancellationMonoReferenceChange = {
	acousticEchoCancellationMonoReference: Maybe<AudioChannelAcousticEchoCancellationMonoReference>;
};

export type AudioChannelAcousticEchoCancellationMonoReferenceConstraints = {
	referenceSourceOptions: FieldSupport;
};

export type AudioChannelAcousticEchoCancellationMonoReferenceInput = {
	/** Audio channel which can configure the 'acousticEchoCancellationMonoReference' feature */
	id: Scalars['ID']['input'];
	/** Audio channel to be selected as acoustic echo cancellation mono reference source */
	source: Scalars['ID']['input'];
};

export type AudioChannelAcousticEchoCancellationPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAcousticEchoCancellationPeakMeterConstraints = {
	level: AudioChannelAcousticEchoCancellationPeakMeterLevelConstraints;
};

export type AudioChannelAcousticEchoCancellationPeakMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAcousticEchoCancellationRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAcousticEchoCancellationRmsMeterConstraints = {
	level: AudioChannelAcousticEchoCancellationRmsMeterLevelConstraints;
};

export type AudioChannelAcousticEchoCancellationRmsMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAcousticEchoCancellationStereoReference = {
	/**
	 * An internal audio channel of the device used for monitoring the selected reference source.
	 * Use stereoRms and stereoPeak(or matrixMixerStereoInputRms and matrixMixerStereoInputPeak) features for reference channel meters
	 */
	reference: AudioChannel;
	/** A list of audio channels within this device that can be used as a stereo reference for acoustic echo cancellation. */
	referenceSourceOptions: Array<AudioChannel>;
	/**
	 * The audio channel used as a far end stereo left reference signal.
	 * Choose an option from 'referenceSourceOptions'.
	 */
	selectedLeftReferenceSource: AudioChannel;
	/**
	 * The audio channel used as a far end stereo right reference signal.
	 * Choose an option from 'referenceSourceOptions'.
	 */
	selectedRightReferenceSource: AudioChannel;
};

export type AudioChannelAcousticEchoCancellationStereoReferenceChange = {
	acousticEchoCancellationStereoReference: Maybe<AudioChannelAcousticEchoCancellationStereoReference>;
};

export type AudioChannelAcousticEchoCancellationStereoReferenceInput = {
	/** Audio channel which can congfigure the 'acousticEchoCancellationStereoReference' feature */
	id: Scalars['ID']['input'];
	/** Audio channel to be selected as acoustic echo cancellation stereo reference source */
	source: Scalars['ID']['input'];
	/** Audio channel spatial separation information which can configure the 'acousticEchoCancellationStereoReference' feature */
	stereoAudioChannelSpatialSeparation: StereoAudioChannelSpatialSeparation | `${StereoAudioChannelSpatialSeparation}`;
};

export type AudioChannelActivityMeter = {
	level: AudioActivityLevel | `${AudioActivityLevel}`;
};

export type AudioChannelAnalogInputUse = {
	/** The use of the analog input may differ based on the device conferencingOperationMode */
	mode: AnalogInputUseMode | `${AnalogInputUseMode}`;
};

export type AudioChannelAnalogInputUseChange = {
	analogInputUse: Maybe<AudioChannelAnalogInputUse>;
};

export type AudioChannelAnalogInputUseConstraints = {
	mode: AudioChannelAnalogInputUseModeConstraints;
};

export type AudioChannelAnalogInputUseModeConstraints = {
	options: Array<AnalogInputUseMode | `${AnalogInputUseMode}`>;
};

export type AudioChannelAnalogInputUseUpdateInput = {
	mode: AnalogInputUseMode | `${AnalogInputUseMode}`;
};

/**
 * The level which the audio channel is expected to receive signal at.
 * This is used to perform additional amplification within the device as needed
 * for signal to be intelligible.
 */
export type AudioChannelAnalogLevel = {
	/** Refer to https://www.shure.com/en-MEA/conferencing-meetings/ignite/tell-me-about-mic-and-line-level for the differences between levels */
	level: AnalogLevel | `${AnalogLevel}`;
};

export type AudioChannelAnalogLevelChange = {
	analogLevel: Maybe<AudioChannelAnalogLevel>;
};

export type AudioChannelAnalogLevelInput = {
	level: AnalogLevel | `${AnalogLevel}`;
};

export type AudioChannelAnalogStereoPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

/** Analog Stereo Peak Level (dBV) */
export type AudioChannelAnalogStereoPeakMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelAnalogStereoPeakMeterConstraints = {
	leftLevel: AudioChannelAnalogStereoPeakLevelConstraints;
	rightLevel: AudioChannelAnalogStereoPeakLevelConstraints;
};

export type AudioChannelAnalogStereoRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

/** Analog Stereo Rms Level (dBV) */
export type AudioChannelAnalogStereoRmsMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelAnalogStereoRmsMeterConstraints = {
	leftLevel: AudioChannelAnalogStereoRmsLevelConstraints;
	rightLevel: AudioChannelAnalogStereoRmsLevelConstraints;
};

export type AudioChannelAuracast = {
	enabled: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
};

export type AudioChannelAuracastChange = {
	auracast: Maybe<AudioChannelAuracast>;
};

export type AudioChannelAuracastConstraints = {
	name: AudioChannelAuracastNameConstraints;
};

export type AudioChannelAuracastEncryption = {
	enabled: Scalars['Boolean']['output'];
	/**
	 * passphrase is only returned when auracast encryption is enabled and a passphrase is set. Otherwise, it returns null.
	 * Empty string is considered as passphrase not set, and it will be treated as null.
	 */
	passphrase: Maybe<Scalars['String']['output']>;
};

export type AudioChannelAuracastEncryptionChange = {
	auracastEncryption: Maybe<AudioChannelAuracastEncryption>;
};

export type AudioChannelAuracastEncryptionEnableInput = {
	id: Scalars['ID']['input'];
	passphrase: Scalars['String']['input'];
};

export type AudioChannelAuracastNameConstraints = IUtf8StringMaxBytesConstraints & {
	utf8MaxBytes: Scalars['Int']['output'];
};

export type AudioChannelAuracastUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
};

export type AudioChannelAutoLevel = {
	configuration: Maybe<AutoLevelConfiguration | `${AutoLevelConfiguration}`>;
	mode: Maybe<AutoLevelMode | `${AutoLevelMode}`>;
	position: Maybe<AutoLevelPosition | `${AutoLevelPosition}`>;
	tone: Maybe<AutoLevelTone | `${AutoLevelTone}`>;
};

export type AudioChannelAutoLevelChange = {
	autoLevel: Maybe<AudioChannelAutoLevel>;
};

export type AudioChannelAutoLevelConstraints = {
	configuration: AutoLevelConfigurationConstraints;
	mode: AutoLevelModeConstraints;
	position: AutoLevelPositionConstraints;
	tone: AutoLevelToneConstraints;
};

export type AudioChannelAutoLevelUpdateInput = {
	configuration?: InputMaybe<AutoLevelConfiguration | `${AutoLevelConfiguration}`>;
	mode?: InputMaybe<AutoLevelMode | `${AutoLevelMode}`>;
	position?: InputMaybe<AutoLevelPosition | `${AutoLevelPosition}`>;
	tone?: InputMaybe<AutoLevelTone | `${AutoLevelTone}`>;
};

export type AudioChannelAutoMute = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutoMuteChange = {
	autoMute: Maybe<AudioChannelAutoMute>;
};

export type AudioChannelAutoMuteUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelAutoPosition = {
	status: AutoPositionStatus | `${AutoPositionStatus}`;
};

export type AudioChannelAutoPositionChange = {
	autoPosition: Maybe<AudioChannelAutoPosition>;
};

export type AudioChannelAutoPositionConstraints = {
	status: AudioChannelAutoPositionStatusConstraints;
};

export type AudioChannelAutoPositionStatusConstraints = {
	options: Array<AutoPositionStatus | `${AutoPositionStatus}`>;
};

export type AudioChannelAutomaticGainConstraints = IIntRangeConstraints & {
	range: IntRange;
};

/**
 * Automatic gain control adjusts audio channel levels to ensure consistent volume for all talkers, in all scenarios.
 * For quieter voices, it increases gain; for louder voices, it attenuates the signal.
 *
 * Automatic gain control is postfader, and adjusts the audio channel level after the input level has been adjusted.
 * Enable it on audio channels where the distance between the talker and the microphone may vary, or in rooms where many different
 * people will use the conferencing system.
 */
export type AudioChannelAutomaticGainControl = {
	/** Indicates whether or not the AGC feature is enabled on the audio channel. */
	enabled: Scalars['Boolean']['output'];
	/** The maximum amount of gain that can be applied (dB). */
	maxBoost: Scalars['Float']['output'];
	/** The maximum amount of attenuation that can be applied (dB). */
	maxCut: Scalars['Float']['output'];
	/**
	 * The level that you want the signal to be normalized to (dBFS).
	 * This level is different from adjusting the input fader according to peak levels to avoid clipping.
	 */
	targetLevel: Scalars['Float']['output'];
};

export type AudioChannelAutomaticGainControlChange = {
	automaticGainControl: Maybe<AudioChannelAutomaticGainControl>;
};

export type AudioChannelAutomaticGainControlConstraints = {
	/** Describes the range of values for the maximum gain that can be applied to the audio channel (dB). */
	maxBoost: AudioChannelAutomaticGainMaxBoostConstraints;
	/** Describes the range of values for the maximum attenuation that can be applied to the audio channel (dB). */
	maxCut: AudioChannelAutomaticGainMaxCutConstraints;
	/** Describes the range of values which the AGC can target for the audio channel by applying gain or attenutation. (dB) */
	targetLevel: AudioChannelAutomaticGainTargetLevelConstraints;
};

export type AudioChannelAutomaticGainControlPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAutomaticGainControlPeakMeterConstraints = {
	level: AudioChannelAutomaticGainControlPeakMeterLevelConstraints;
};

export type AudioChannelAutomaticGainControlPeakMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomaticGainControlRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAutomaticGainControlRmsMeterConstraints = {
	level: AudioChannelAutomaticGainControlRmsMeterLevelConstraints;
};

export type AudioChannelAutomaticGainControlRmsMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomaticGainControlUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	maxBoost?: InputMaybe<Scalars['Float']['input']>;
	maxCut?: InputMaybe<Scalars['Float']['input']>;
	targetLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type AudioChannelAutomaticGainMaxBoostConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomaticGainMaxCutConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomaticGainMeter = {
	gain: Scalars['Int']['output'];
};

export type AudioChannelAutomaticGainMeterConstraints = {
	gain: AudioChannelAutomaticGainConstraints;
};

export type AudioChannelAutomaticGainTargetLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomixGainConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomixGainMeter = {
	gain: Scalars['Float']['output'];
};

export type AudioChannelAutomixGainMeterConstraints = {
	gain: AudioChannelAutomixGainConstraints;
};

export type AudioChannelAutomixSourceSelector = {
	/**
	 * When an audio channel is selected, the corresponding automixed content will be replaced with the source.
	 * When null, the automixer will decide which channels it mixes based on the automixer capability.
	 */
	source: Maybe<AudioChannel>;
	sourceOptions: Array<AudioChannel>;
};

export type AudioChannelAutomixSourceSelectorChange = {
	automixSourceSelector: Maybe<AudioChannelAutomixSourceSelector>;
};

/**
 * Automixer takes in multiple audio channels and automatically mixes them into a singular output channel.
 * This helps improve intelligibility of meeting audio by focusing on the most relevant audio content, and removing
 * less relevant audio content.
 */
export type AudioChannelAutomixer = {
	enabled: Maybe<Scalars['Boolean']['output']>;
	/**
	 * The threshold of the level at which the gate is opened, as a numeric level.
	 * Lower is less sensitive (meaning fewer false detections due to room noise or talkers outside the meeting room, at the expense of missing desired talkers).
	 * Higher is more sensitive (meaning more false detections due to room noise or talkers outside the meeting room, but better at catching the start of every talker).
	 */
	gatingSensitivity: Scalars['Int']['output'];
	/** The duration for which the audio channel remains open after the level drops below the gate threshold. */
	holdTime: Scalars['Duration']['output'];
	/**
	 * Indicates whether or not the most recently used audio channel should remain active.
	 * This keeps natural room sound in the signal so that meeting participants at the far end know the
	 * audio signal has not been interrupted.
	 */
	leaveLastChannelOn: Scalars['Boolean']['output'];
	/** The maximum number of simultaneously active audio channels. */
	maxOpenChannels: Scalars['Int']['output'];
	/**
	 * Constraints for maxOpenChannels.
	 * Use this field to determine the valid range of values for maxOpenChannels instead of deprecated maxOpenChannels field in AudioChannelAutomixerConstraints.
	 * For example, APX devices will have different valid ranges based on the current channel count and fusion feature support.
	 */
	maxOpenChannelsRange: IntRange;
	/** How the automix should be performed */
	mode: AutomixMode | `${AutomixMode}`;
	/** The amount of signal reduction that is applied when an audio channel is not active (dB). */
	offAttenuation: Scalars['Float']['output'];
};

export type AudioChannelAutomixerAutoLevelModeFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomixerAutoLevelModeMeter = {
	/** Auto Level Mode Gain (dB) */
	gain: Scalars['Float']['output'];
};

export type AudioChannelAutomixerAutoLevelModeMeterConstraints = {
	/** Describes the range of values for the auto level mode gain value that are supported on the channel. */
	gain: AudioChannelAutomixerAutoLevelModeFieldConstraints;
};

export type AudioChannelAutomixerChange = {
	automixer: Maybe<AudioChannelAutomixer>;
};

export type AudioChannelAutomixerChannelActive = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutomixerChannelActiveChange = {
	automixerChannelActive: Maybe<AudioChannelAutomixerChannelActive>;
};

export type AudioChannelAutomixerConstraints = {
	enabled: FieldSupport;
	/**
	 * Describes the range of thresholds at which the gate is opened.
	 * Lower is less sensitive, and higher is more sensitive.
	 */
	gatingSensitivity: AutomixGatingSensitivityConstraints;
	/** Describes the range of values for the hold time. */
	holdTime: AutomixHoldTimeConstraints;
	/**
	 * Describes the range of audio channels which can remain simultaneously active.
	 * @deprecated Use maxOpenChannelsRange in automixer feature instead. This is fixed information from device description file and it does not reflect dynamic channel count changes.
	 */
	maxOpenChannels: AutomixMaxOpenChannelsConstraints;
	/** Describes the supported automix modes on this audio channel's automixer. */
	mode: AutomixModeConstraints;
	/** Describes the range of attenutation that can be applied when an audio channel is not active (dB). */
	offAttenuation: AutomixOffAttenuationConstraints;
};

export type AudioChannelAutomixerEnable = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutomixerEnableChange = {
	automixerEnable: Maybe<AudioChannelAutomixerEnable>;
};

export type AudioChannelAutomixerEnableUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelAutomixerGateMeter = {
	open: Scalars['Boolean']['output'];
};

/** Automixer input describes the features which correspond to an audio channel's participation in the device's automixer. */
export type AudioChannelAutomixerInput = {
	/**
	 * When enabled, this audio channel will always be active in the automixer.
	 * When the capability exists, but this field is null, the audio channel cannot be assumed to always be sent to the automix.
	 * @deprecated Use the automixerInputAlwaysOn feature to control this feature.
	 */
	alwaysOn: Maybe<Scalars['Boolean']['output']>;
	/**
	 * When enabled, this audio channel's gate activates within the automixer,
	 * regardless of the number of maximum open channels configured on this device's automixer.
	 * @deprecated Use the automixerInputPriority feature to control this feature.
	 */
	priority: Scalars['Boolean']['output'];
	/**
	 * When enabled, sends this channel to the automix channel.
	 * When this capability exists, but this field is null, the audio channel is always assumed to be sent to the automix.
	 * @deprecated Use the automixerInputSendToMonoMix feature to control this feature.
	 */
	sendToMix: Maybe<Scalars['Boolean']['output']>;
};

export type AudioChannelAutomixerInputAlwaysOn = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutomixerInputAlwaysOnChange = {
	automixerInputAlwaysOn: Maybe<AudioChannelAutomixerInputAlwaysOn>;
};

export type AudioChannelAutomixerInputAlwaysOnUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelAutomixerInputChange = {
	automixerInput: Maybe<AudioChannelAutomixerInput>;
};

export type AudioChannelAutomixerInputConstraints = {
	/** Describes whether or not this audio channel can always be active in the automixer. */
	alwaysOn: FieldSupport;
	/** Describes whether or not this audio channel supports being conditionally sent to the automixer. */
	sendToMix: FieldSupport;
};

export type AudioChannelAutomixerInputPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomixerInputPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAutomixerInputPeakMeterConstraints = {
	level: AudioChannelAutomixerInputPeakLevelConstraints;
};

export type AudioChannelAutomixerInputPriority = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutomixerInputPriorityChange = {
	automixerInputPriority: Maybe<AudioChannelAutomixerInputPriority>;
};

export type AudioChannelAutomixerInputPriorityUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelAutomixerInputRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomixerInputRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelAutomixerInputRmsMeterConstraints = {
	level: AudioChannelAutomixerInputRmsLevelConstraints;
};

export type AudioChannelAutomixerInputSendToMonoMix = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutomixerInputSendToMonoMixChange = {
	automixerInputSendToMonoMix: Maybe<AudioChannelAutomixerInputSendToMonoMix>;
};

export type AudioChannelAutomixerInputSendToMonoMixUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelAutomixerInputSendToStereoMix = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelAutomixerInputSendToStereoMixChange = {
	automixerInputSendToStereoMix: Maybe<AudioChannelAutomixerInputSendToStereoMix>;
};

export type AudioChannelAutomixerInputSendToStereoMixUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelAutomixerInputUpdateInput = {
	alwaysOn?: InputMaybe<Scalars['Boolean']['input']>;
	priority?: InputMaybe<Scalars['Boolean']['input']>;
	sendToMix?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelAutomixerNoiseFloorEstimateFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelAutomixerNoiseFloorEstimateMeter = {
	/** Noise Floor Estimate (dBFS) is the measure of unwanted noise in the surrounding reported by the automixer. */
	noiseFloor: Scalars['Float']['output'];
};

export type AudioChannelAutomixerNoiseFloorEstimateMeterConstraints = {
	/** Describes the range of values for the noise floor estimate that are supported by the automixer. */
	noiseFloor: AudioChannelAutomixerNoiseFloorEstimateFieldConstraints;
};

export type AudioChannelAutomixerUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	gatingSensitivity?: InputMaybe<Scalars['Int']['input']>;
	holdTime?: InputMaybe<Scalars['Duration']['input']>;
	leaveLastChannelOn?: InputMaybe<Scalars['Boolean']['input']>;
	maxOpenChannels?: InputMaybe<Scalars['Int']['input']>;
	mode?: InputMaybe<AutomixMode | `${AutomixMode}`>;
	offAttenuation?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioChannelAutomixerVoiceActivityDetection = {
	noiseDetectionSensitivity: NoiseDetectionSensitivity | `${NoiseDetectionSensitivity}`;
	noiseRemovalLevel: NoiseRemovalLevel | `${NoiseRemovalLevel}`;
};

export type AudioChannelAutomixerVoiceActivityDetectionChange = {
	automixerVoiceActivityDetection: Maybe<AudioChannelAutomixerVoiceActivityDetection>;
};

export type AudioChannelAutomixerVoiceActivityDetectionConstraints = {
	noiseDetectionSensitivity: NoiseDetectionSensitivityConstraints;
	noiseRemovalLevel: NoiseRemovalLevelConstraints;
};

export type AudioChannelAutomixerVoiceActivityDetectionUpdateInput = {
	noiseDetectionSensitivity?: InputMaybe<NoiseDetectionSensitivity | `${NoiseDetectionSensitivity}`>;
	noiseRemovalLevel?: InputMaybe<NoiseRemovalLevel | `${NoiseRemovalLevel}`>;
};

export type AudioChannelCarriedByRfChannels = {
	rfChannels: Array<RfChannel>;
};

export type AudioChannelCarriedByRfChannelsChange = {
	carriedByRfChannels: Maybe<AudioChannelCarriedByRfChannels>;
};

export type AudioChannelChange = {
	features: AudioChannelFeatureChange;
	id: Scalars['ID']['output'];
};

export type AudioChannelChannelBonding = {
	audioChannels: Array<AudioChannel>;
	spatialSeparation: StereoAudioChannelSpatialSeparation | `${StereoAudioChannelSpatialSeparation}`;
};

export type AudioChannelChannelConfiguration = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelChannelConfigurationChange = {
	channelConfiguration: Maybe<AudioChannelChannelConfiguration>;
};

export type AudioChannelClipMeter = {
	clip: Scalars['Boolean']['output'];
};

export type AudioChannelCompressor = {
	/** Indicates whether or not the compressor is enabled. */
	enabled: Maybe<Scalars['Boolean']['output']>;
	/** Level of compression applied to the audio signal */
	level: Maybe<CompressorLevel | `${CompressorLevel}`>;
	/**
	 * The amount of attenuation that is applied when the signal exceeds the threshold.
	 *
	 * A lower ratio of 2:1 means that for every 2 dB above the threshold, the output signal will only exceed the threshold by 1 dB.
	 *
	 * A higher ratio of 10:1 means a loud sound that exceeds the threshold by 10 dB will only exceed the threshold by 1 dB, effectively reducing the signal by 9 dB.
	 */
	ratio: Maybe<Scalars['Float']['output']>;
	/** The signal level at which compressor takes effect (dB). */
	threshold: Maybe<Scalars['Float']['output']>;
};

export type AudioChannelCompressorChange = {
	compressor: Maybe<AudioChannelCompressor>;
};

export type AudioChannelCompressorConstraints = {
	/** Indicates whether compressor can be enabled on the audio channel. */
	enabled: FieldSupport;
	/** Describes the range of supported values for the compressor level on the audio channel. */
	level: AudioChannelCompressorLevelConstraints;
	/** Describes the range of supported values for the compressor ratio on the audio channel. */
	ratio: AudioChannelCompressorRatioConstraints;
	/** Describes the range of supported values for the compressor threshold on the audio channel. */
	threshold: AudioChannelCompressorThresholdConstraints;
};

export type AudioChannelCompressorEngagedMeter = {
	engaged: Scalars['Boolean']['output'];
};

export type AudioChannelCompressorLevelConstraints = IFieldSupportInfo & {
	options: Maybe<Array<CompressorLevel | `${CompressorLevel}`>>;
	supported: Scalars['Boolean']['output'];
};

export type AudioChannelCompressorRatioConstraints = IFieldSupportInfo & {
	range: Maybe<FloatRange>;
	supported: Scalars['Boolean']['output'];
};

export type AudioChannelCompressorThresholdConstraints = IFieldSupportInfo & {
	range: Maybe<FloatRange>;
	supported: Scalars['Boolean']['output'];
};

export type AudioChannelCompressorUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	level?: InputMaybe<CompressorLevel | `${CompressorLevel}`>;
	ratio?: InputMaybe<Scalars['Float']['input']>;
	threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type AudioChannelConnectionDetection = {
	connected: Scalars['Boolean']['output'];
};

export type AudioChannelConnectionDetectionChange = {
	connectionDetection: Maybe<AudioChannelConnectionDetection>;
};

export type AudioChannelConstraints = {
	acousticEchoCancellation: Maybe<AcousticEchoCancellationConstraints>;
	acousticEchoCancellationErle: Maybe<AudioChannelAcousticEchoCancellationErleMeterConstraints>;
	acousticEchoCancellationMonoReference: Maybe<AudioChannelAcousticEchoCancellationMonoReferenceConstraints>;
	acousticEchoCancellationPeak: Maybe<AudioChannelAcousticEchoCancellationPeakMeterConstraints>;
	acousticEchoCancellationRms: Maybe<AudioChannelAcousticEchoCancellationRmsMeterConstraints>;
	analogInputUse: Maybe<AudioChannelAnalogInputUseConstraints>;
	analogLevel: Maybe<AnalogLevelConstraints>;
	analogStereoPeak: Maybe<AudioChannelAnalogStereoPeakMeterConstraints>;
	analogStereoRms: Maybe<AudioChannelAnalogStereoRmsMeterConstraints>;
	auracast: Maybe<AudioChannelAuracastConstraints>;
	autoLevel: Maybe<AudioChannelAutoLevelConstraints>;
	autoPosition: Maybe<AudioChannelAutoPositionConstraints>;
	automaticGain: Maybe<AudioChannelAutomaticGainMeterConstraints>;
	automaticGainControl: Maybe<AudioChannelAutomaticGainControlConstraints>;
	automaticGainControlPeak: Maybe<AudioChannelAutomaticGainControlPeakMeterConstraints>;
	automaticGainControlRms: Maybe<AudioChannelAutomaticGainControlRmsMeterConstraints>;
	automixGain: Maybe<AudioChannelAutomixGainMeterConstraints>;
	automixer: Maybe<AudioChannelAutomixerConstraints>;
	automixerAutoLevelMode: Maybe<AudioChannelAutomixerAutoLevelModeMeterConstraints>;
	automixerInput: Maybe<AudioChannelAutomixerInputConstraints>;
	automixerInputPeak: Maybe<AudioChannelAutomixerInputPeakMeterConstraints>;
	automixerInputRms: Maybe<AudioChannelAutomixerInputRmsMeterConstraints>;
	automixerNoiseFloorEstimate: Maybe<AudioChannelAutomixerNoiseFloorEstimateMeterConstraints>;
	automixerVoiceActivityDetection: Maybe<AudioChannelAutomixerVoiceActivityDetectionConstraints>;
	compressor: Maybe<AudioChannelCompressorConstraints>;
	danteRouteReceiver: Maybe<AudioChannelDanteRouteReceiverConstraints>;
	danteRouteTransmitter: Maybe<AudioChannelDanteRouteTransmitterConstraints>;
	delay: Maybe<AudioChannelDelayConstraints>;
	denoiser: Maybe<AudioChannelDenoiserLevelConstraints>;
	deverb: Maybe<AudioChannelDeverbConstraints>;
	deviceSpecificEqualizerContour: Maybe<AudioChannelDeviceSpecificEqualizerContourConstraints>;
	directOutputTapPoint: Maybe<AudioChannelDirectOutputTapPointConstraints>;
	equalizer: Maybe<AudioChannelEqualizerConstraints>;
	equalizerContour: Maybe<AudioChannelEqualizerContourConstraints>;
	equalizerPreset: Maybe<AudioChannelEqualizerPresetConstraints>;
	gain: Maybe<AudioChannelGainConstraints>;
	inputSource: Maybe<AudioChannelInputSourceConstraints>;
	lightingBehavior: Maybe<AudioChannelLightingBehaviorConstraints>;
	limiter: Maybe<AudioChannelLimiterConstraints>;
	lobePosition: Maybe<AudioChannelLobePositionConstraints>;
	lobeTalkerHeight: Maybe<AudioChannelLobeTalkerHeightConstraints>;
	lobeWidth: Maybe<AudioChannelLobeWidthConstraints>;
	/** @deprecated Prefer 'matrixMixerPeak' constraints instead for greater genericism if the audio channel supports it. */
	matrixMixerInputPeak: Maybe<AudioChannelMatrixMixerInputPeakMeterConstraints>;
	/** @deprecated Prefer 'matrixMixerRms' constraints instead for greater genericism if the audio channel supports it. */
	matrixMixerInputRms: Maybe<AudioChannelMatrixMixerInputRmsMeterConstraints>;
	/** @deprecated Prefer 'matrixMixerPeak' constraints instead for greater genericism if the audio channel supports it. */
	matrixMixerOutputPeak: Maybe<AudioChannelMatrixMixerOutputPeakMeterConstraints>;
	/** @deprecated Prefer 'matrixMixerRms' constraints instead for greater genericism if the audio channel supports it. */
	matrixMixerOutputRms: Maybe<AudioChannelMatrixMixerOutputRmsMeterConstraints>;
	matrixMixerPeak: Maybe<AudioChannelMatrixMixerPeakMeterConstraints>;
	matrixMixerRms: Maybe<AudioChannelMatrixMixerRmsMeterConstraints>;
	matrixMixerStereoInputPeak: Maybe<AudioChannelMatrixMixerStereoInputPeakMeterConstraints>;
	matrixMixerStereoInputRms: Maybe<AudioChannelMatrixMixerStereoInputRmsMeterConstraints>;
	micOptimization: Maybe<AudioChannelMicOptimizationConstraints>;
	micPolarPattern: Maybe<AudioChannelMicPolarPatternConstraints>;
	microphoneAngle: Maybe<AudioChannelMicrophoneAngleConstraints>;
	monitorMix: Maybe<AudioChannelMonitorMixConstraints>;
	name: Maybe<AudioChannelNameConstraints>;
	noiseReduction: Maybe<AudioChannelNoiseReductionConstraints>;
	outputMixProcessing: Maybe<AudioChannelOutputMixProcessingConstraints>;
	outputPath: Maybe<AudioChannelOutputPathConstraints>;
	padSwitch: Maybe<AudioChannelPadSwitchConstraints>;
	pan: Maybe<AudioChannelPanConstraints>;
	passiveSpeakers: Maybe<AudioChannelPassiveSpeakersConstraints>;
	peak: Maybe<AudioChannelPeakMeterConstraints>;
	phantomPower: Maybe<AudioChannelPhantomPowerConstraints>;
	postGateGain: Maybe<AudioChannelPostGateGainConstraints>;
	postGateGainStereoPeak: Maybe<AudioChannelPostGateGainStereoPeakMeterConstraints>;
	postGateGainStereoRms: Maybe<AudioChannelPostGateGainStereoRmsMeterConstraints>;
	reverb: Maybe<AudioChannelReverbConstraints>;
	rms: Maybe<AudioChannelRmsMeterConstraints>;
	signalGenerator: Maybe<AudioChannelSignalGeneratorConstraints>;
	stereoAutomixGain: Maybe<AudioChannelStereoAutomixGainMeterConstraints>;
	stereoGain: Maybe<AudioChannelStereoGainConstraints>;
	stereoPeak: Maybe<AudioChannelStereoPeakMeterConstraints>;
	stereoRms: Maybe<AudioChannelStereoRmsMeterConstraints>;
	stereoWidth: Maybe<AudioChannelStereoWidthConstraints>;
	talkSwitch: Maybe<AudioChannelTalkSwitchConstraints>;
	/** @deprecated Use 'lobeTalkerHeight' constraints instead. */
	talkerHeight: Maybe<AudioChannelTalkerHeightConstraints>;
	toneGenerator: Maybe<AudioChannelToneGeneratorConstraints>;
	usbOutputMode: Maybe<AudioChannelUsbOutputModeConstraints>;
	voiceActivityDetectionNoiseReduction: Maybe<AudioChannelVoiceActivityDetectionNoiseReductionConstraints>;
	voiceActivityDetectionSensitivity: Maybe<AudioChannelVoiceActivityDetectionSensitivityConstraints>;
	wirelessEncryption: Maybe<AudioChannelWirelessEncryptionConstraints>;
};

export type AudioChannelCountInput = {
	count: Scalars['Int']['input'];
	id: Scalars['ID']['input'];
};

export type AudioChannelDanteEncryptionStatus = {
	/** Status of audio encryption for a routed audio channel over Dante. */
	status: DanteAudioEncryptionStatus | `${DanteAudioEncryptionStatus}`;
};

export type AudioChannelDanteEncryptionStatusChange = {
	danteEncryptionStatus: Maybe<AudioChannelDanteEncryptionStatus>;
};

export type AudioChannelDanteRouteReceiver = {
	/**
	 * The Dante channel name for uniquely identifying a channel within this device.
	 * Dante channel names are not guaranteed unique throughout a network.
	 */
	danteChannelName: Scalars['String']['output'];
	/** The subscription which the receiver is listening to. Null when no subscription exists. */
	subscription: Maybe<DanteAudioRouteSubscription>;
};

export type AudioChannelDanteRouteReceiverChange = {
	danteRouteReceiver: Maybe<AudioChannelDanteRouteReceiver>;
};

export type AudioChannelDanteRouteReceiverConstraints = {
	danteChannelName: AudioChannelDanteRouteReceiverDanteChannelNameConstraints;
};

export type AudioChannelDanteRouteReceiverDanteChannelNameConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type AudioChannelDanteRouteReceiverUpdateInput = {
	danteChannelName: Scalars['String']['input'];
};

export type AudioChannelDanteRouteTransmitter = {
	/**
	 * The Dante channel name for uniquely identifying a channel within this device.
	 * Dante channel names are not guaranteed unique throughout a network.
	 */
	danteChannelName: Scalars['String']['output'];
};

export type AudioChannelDanteRouteTransmitterChange = {
	danteRouteTransmitter: Maybe<AudioChannelDanteRouteTransmitter>;
};

export type AudioChannelDanteRouteTransmitterConstraints = {
	danteChannelName: AudioChannelDanteRouteTransmitterDanteChannelNameConstraints;
};

export type AudioChannelDanteRouteTransmitterDanteChannelNameConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type AudioChannelDanteRouteTransmitterUpdateInput = {
	danteChannelName: Scalars['String']['input'];
};

export type AudioChannelDelay = {
	/**
	 * The amount of signal delay being applied to the channel (ms).
	 *
	 * This is used for synchronizing audio and video, or audio from multiple talkers.
	 */
	delay: Scalars['Duration']['output'];
	/** Indicates whether or not the delay feature is enabled */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelDelayChange = {
	delay: Maybe<AudioChannelDelay>;
};

export type AudioChannelDelayConstraints = {
	/** Describes the range of values for the signal delay that are supported on the channel. */
	delay: AudioChannelDelayFieldConstraints;
};

export type AudioChannelDelayFieldConstraints = IDurationRangeConstraints & {
	/** Describes the range of values for the signal delay that are supported on the channel. */
	range: DurationRange;
};

export type AudioChannelDelayUpdateInput = {
	delay?: InputMaybe<Scalars['Duration']['input']>;
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelDenoiser = {
	enabled: Scalars['Boolean']['output'];
	level: DenoiserLevel | `${DenoiserLevel}`;
};

export type AudioChannelDenoiserChange = {
	denoiser: Maybe<AudioChannelDenoiser>;
};

export type AudioChannelDenoiserLevelConstraints = {
	level: AudioChannelValidDenoiserLevelConstraints;
};

export type AudioChannelDenoiserNoiseReductionMeter = {
	percentage: Scalars['Int']['output'];
};

export type AudioChannelDenoiserUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	level?: InputMaybe<DenoiserLevel | `${DenoiserLevel}`>;
};

export type AudioChannelDescription = {
	constraints: AudioChannelConstraints;
	features: AudioChannelSupportedFeatures;
	/** @deprecated Use the 'groupName' field instead to ensure your code is open to extension to new audio channel groups. This enum is no longer preferred since it regularly breaks on expanding the available enum members to cover new channel groupings for new devices. */
	group: AudioChannelGroup | `${AudioChannelGroup}`;
	groupName: Scalars['AudioChannelGroupName']['output'];
	/** Ordering is relative within audio channels sharing the same group name */
	index: Scalars['Int']['output'];
	role: AudioChannelRole | `${AudioChannelRole}`;
};

export type AudioChannelDeverb = {
	enabled: Scalars['Boolean']['output'];
	intensity: DeverbIntensity | `${DeverbIntensity}`;
};

export type AudioChannelDeverbChange = {
	deverb: Maybe<AudioChannelDeverb>;
};

export type AudioChannelDeverbConstraints = {
	intensity: AudioChannelDeverbIntensityConstraints;
};

export type AudioChannelDeverbIntensityConstraints = {
	options: Array<DeverbIntensity | `${DeverbIntensity}`>;
};

export type AudioChannelDeverbUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	intensity?: InputMaybe<DeverbIntensity | `${DeverbIntensity}`>;
};

export type AudioChannelDeviceSpecificEqualizerContour = {
	/**
	 * Built-in equalizer contours optimized to routed audio from the devices specified by the contour options.
	 * Applying both the device-level 'equalizerContour' as well as any audio-channel level 'equalizer' changes will be cumulative.
	 *
	 * Refer to your device's user guide for more. E.g. https://pubs.shure.com/guide/IntelliMixRoom/en-US
	 */
	deviceSpecificEqualizerContour: DeviceSpecificEqualizerContour | `${DeviceSpecificEqualizerContour}`;
};

export type AudioChannelDeviceSpecificEqualizerContourChange = {
	deviceSpecificEqualizerContour: Maybe<AudioChannelDeviceSpecificEqualizerContour>;
};

export type AudioChannelDeviceSpecificEqualizerContourConstraints = {
	deviceSpecificEqualizerContour: Maybe<AudioChannelDeviceSpecificEqualizerContourTypeConstraints>;
};

export type AudioChannelDeviceSpecificEqualizerContourTypeConstraints = {
	options: Array<DeviceSpecificEqualizerContour | `${DeviceSpecificEqualizerContour}`>;
};

export type AudioChannelDeviceSpecificEqualizerContourUpdateInput = {
	deviceSpecificEqualizerContour: DeviceSpecificEqualizerContour | `${DeviceSpecificEqualizerContour}`;
};

export type AudioChannelDirectOutputTapPoint = {
	/** Indicates where the signal to the matrix mixer should come from. */
	tapPoint: DirectOutputTapPoint | `${DirectOutputTapPoint}`;
};

export type AudioChannelDirectOutputTapPointChange = {
	directOutputTapPoint: Maybe<AudioChannelDirectOutputTapPoint>;
};

export type AudioChannelDirectOutputTapPointConstraints = {
	tapPoint: Maybe<AudioChannelDirectOutputTapPointTypeConstraints>;
};

export type AudioChannelDirectOutputTapPointTypeConstraints = {
	options: Array<DirectOutputTapPoint | `${DirectOutputTapPoint}`>;
};

export type AudioChannelDirectOutputTapPointUpdateInput = {
	tapPoint: DirectOutputTapPoint | `${DirectOutputTapPoint}`;
};

export type AudioChannelEqualizer = {
	enabled: Maybe<Scalars['Boolean']['output']>;
	filters: Array<EqualizerFilter>;
	tone: Maybe<Scalars['Int']['output']>;
};

export type AudioChannelEqualizerChange = {
	equalizer: Maybe<AudioChannelEqualizer>;
};

export type AudioChannelEqualizerConstraints = {
	enabled: EqualizerEnabledConstraints;
	filters: EqualizerFiltersConstraints;
	tone: EqualizerToneConstraints;
};

export type AudioChannelEqualizerContour = {
	equalizerContour: EqualizerContour | `${EqualizerContour}`;
};

export type AudioChannelEqualizerContourChange = {
	equalizerContour: Maybe<AudioChannelEqualizerContour>;
};

export type AudioChannelEqualizerContourConstraints = {
	equalizerContour: Maybe<AudioChannelEqualizerContourTypeConstraints>;
};

export type AudioChannelEqualizerContourTypeConstraints = {
	options: Array<EqualizerContour | `${EqualizerContour}`>;
};

export type AudioChannelEqualizerContourUpdateInput = {
	equalizerContour: EqualizerContour | `${EqualizerContour}`;
};

export type AudioChannelEqualizerPreset = {
	/** Equalizer preset mode applied to the audio channel. Value of `null` implies that the currently set audio settings for the audio channel does not correspond to any preset mode. */
	equalizerPreset: Maybe<EqualizerPreset | `${EqualizerPreset}`>;
};

export type AudioChannelEqualizerPresetChange = {
	equalizerPreset: Maybe<AudioChannelEqualizerPreset>;
};

export type AudioChannelEqualizerPresetConstraints = {
	equalizerPreset: Maybe<AudioChannelEqualizerPresetTypeConstraints>;
};

export type AudioChannelEqualizerPresetTypeConstraints = {
	options: Array<EqualizerPreset | `${EqualizerPreset}`>;
	/**
	 * Indicates whether the device actively monitors changes to audio settings and adjusts the equalizer preset mode automatically if the new audio settings corresponds to any known preset mode setting.
	 * If true, the `equalizerPreset` feature field can be null to represent cases where the new audio settings does not correspond to any known preset mode setting. If false, the `equalizerPreset` value can never be null
	 * and it will always reflect either the value set on the device or its default value.
	 */
	tracksAudioSettingChanges: Scalars['Boolean']['output'];
};

export type AudioChannelEqualizerPresetUpdateInput = {
	equalizerPreset: EqualizerPreset | `${EqualizerPreset}`;
	/** Audio channel node ID */
	id: Scalars['ID']['input'];
};

export type AudioChannelEqualizerUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	tone?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioChannelExternalAutomixerGate = {
	open: Scalars['Boolean']['output'];
};

export type AudioChannelExternalAutomixerGateChange = {
	externalAutomixerGate: Maybe<AudioChannelExternalAutomixerGate>;
};

export type AudioChannelExternalAutomixerGateUpdateInput = {
	open: Scalars['Boolean']['input'];
};

export type AudioChannelFaderGroup = {
	/** Indicates whether or not the audio channel is participating in the fader group for linking gain adjustments across multiple audio channels */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelFaderGroupChange = {
	faderGroup: Maybe<AudioChannelFaderGroup>;
};

export type AudioChannelFaderGroupUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelFeatureChange =
	| AudioChannelAcousticEchoCancellationChange
	| AudioChannelAcousticEchoCancellationMonoReferenceChange
	| AudioChannelAcousticEchoCancellationStereoReferenceChange
	| AudioChannelAnalogInputUseChange
	| AudioChannelAnalogLevelChange
	| AudioChannelAuracastChange
	| AudioChannelAuracastEncryptionChange
	| AudioChannelAutoLevelChange
	| AudioChannelAutoMuteChange
	| AudioChannelAutoPositionChange
	| AudioChannelAutomaticGainControlChange
	| AudioChannelAutomixSourceSelectorChange
	| AudioChannelAutomixerChange
	| AudioChannelAutomixerChannelActiveChange
	| AudioChannelAutomixerEnableChange
	| AudioChannelAutomixerInputAlwaysOnChange
	| AudioChannelAutomixerInputChange
	| AudioChannelAutomixerInputPriorityChange
	| AudioChannelAutomixerInputSendToMonoMixChange
	| AudioChannelAutomixerInputSendToStereoMixChange
	| AudioChannelAutomixerVoiceActivityDetectionChange
	| AudioChannelCarriedByRfChannelsChange
	| AudioChannelChannelConfigurationChange
	| AudioChannelCompressorChange
	| AudioChannelConnectionDetectionChange
	| AudioChannelDanteEncryptionStatusChange
	| AudioChannelDanteRouteReceiverChange
	| AudioChannelDanteRouteTransmitterChange
	| AudioChannelDelayChange
	| AudioChannelDenoiserChange
	| AudioChannelDeverbChange
	| AudioChannelDeviceSpecificEqualizerContourChange
	| AudioChannelDirectOutputTapPointChange
	| AudioChannelEqualizerChange
	| AudioChannelEqualizerContourChange
	| AudioChannelEqualizerPresetChange
	| AudioChannelExternalAutomixerGateChange
	| AudioChannelFaderGroupChange
	| AudioChannelGainChange
	| AudioChannelGainLockChange
	| AudioChannelGroundLiftChange
	| AudioChannelIdentifyChange
	| AudioChannelInputSourceChange
	| AudioChannelLightingBehaviorChange
	| AudioChannelLimiterChange
	| AudioChannelLobeConfigurationChange
	| AudioChannelLobePositionChange
	| AudioChannelLobeTalkerHeightChange
	| AudioChannelLobeWidthChange
	| AudioChannelLogicReceiverChange
	| AudioChannelMicOptimizationChange
	| AudioChannelMicPolarPatternChange
	| AudioChannelMicrophoneAngleChange
	| AudioChannelMonitorMixChange
	| AudioChannelMonitorMixReverbChange
	| AudioChannelMuteChange
	| AudioChannelMuteGroupChange
	| AudioChannelMuteLockChange
	| AudioChannelNameChange
	| AudioChannelNoiseReductionChange
	| AudioChannelOutputMixProcessingChange
	| AudioChannelOutputPathChange
	| AudioChannelPadSwitchChange
	| AudioChannelPanChange
	| AudioChannelPassiveSpeakersChange
	| AudioChannelPcPeripheralChange
	| AudioChannelPeakHoldChange
	| AudioChannelPhantomPowerChange
	| AudioChannelPlosiveReductionChange
	| AudioChannelPostGateGainChange
	| AudioChannelPostGateMuteChange
	| AudioChannelPostGateSoloChange
	| AudioChannelPreFadeListenChange
	| AudioChannelPreGateMuteChange
	| AudioChannelReverbChange
	| AudioChannelSelectedLoudspeakerChange
	| AudioChannelSignalGeneratorChange
	| AudioChannelSoloChange
	| AudioChannelStereoGainChange
	| AudioChannelStereoReverseChange
	| AudioChannelStereoWidthChange
	| AudioChannelTalkSwitchChange
	| AudioChannelTalkerHeightChange
	| AudioChannelToneGeneratorChange
	| AudioChannelTransmitterClipChange
	| AudioChannelUsbOutputModeChange
	| AudioChannelVoiceActivityDetectionNoiseReductionChange
	| AudioChannelVoiceActivityDetectionSensitivityChange
	| AudioChannelWirelessEncryptionChange;

export type AudioChannelFeatureUpdateInput =
	| {
			acousticEchoCancellation: AudioChannelAcousticEchoCancellationInput;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse: AudioChannelAnalogInputUseUpdateInput;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel: AudioChannelAnalogLevelInput;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast: AudioChannelAuracastUpdateInput;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel: AudioChannelAutoLevelUpdateInput;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute: AudioChannelAutoMuteUpdateInput;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl: AudioChannelAutomaticGainControlUpdateInput;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer: AudioChannelAutomixerUpdateInput;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable: AudioChannelAutomixerEnableUpdateInput;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput: AudioChannelAutomixerInputUpdateInput;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn: AudioChannelAutomixerInputAlwaysOnUpdateInput;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority: AudioChannelAutomixerInputPriorityUpdateInput;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix: AudioChannelAutomixerInputSendToMonoMixUpdateInput;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix: AudioChannelAutomixerInputSendToStereoMixUpdateInput;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection: AudioChannelAutomixerVoiceActivityDetectionUpdateInput;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor: AudioChannelCompressorUpdateInput;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver: AudioChannelDanteRouteReceiverUpdateInput;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter: AudioChannelDanteRouteTransmitterUpdateInput;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay: AudioChannelDelayUpdateInput;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser: AudioChannelDenoiserUpdateInput;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb: AudioChannelDeverbUpdateInput;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour: AudioChannelDeviceSpecificEqualizerContourUpdateInput;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint: AudioChannelDirectOutputTapPointUpdateInput;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer: AudioChannelEqualizerUpdateInput;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour: AudioChannelEqualizerContourUpdateInput;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate: AudioChannelExternalAutomixerGateUpdateInput;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup: AudioChannelFaderGroupUpdateInput;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain: AudioChannelGainUpdateInput;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock: AudioChannelGainLockUpdateInput;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource: AudioChannelInputSourceUpdateInput;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter: AudioChannelLimiterUpdateInput;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration: AudioChannelLobeConfigurationUpdateInput;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition: AudioChannelLobePositionUpdateInput;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight: AudioChannelFixedLobeTalkerHeightUpdateInput;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth: AudioChannelLobeWidthUpdateInput;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization: AudioChannelMicOptimizationUpdateInput;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern: AudioChannelMicPolarPatternUpdateInput;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle: AudioChannelFixedMicrophoneAngleUpdateInput;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix: AudioChannelMonitorMixUpdateInput;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb: AudioChannelMonitorMixReverbUpdateInput;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute: AudioChannelMuteUpdateInput;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup: AudioChannelMuteGroupUpdateInput;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock: AudioChannelMuteLockUpdateInput;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name: AudioChannelNameUpdateInput;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction: AudioChannelNoiseReductionUpdateInput;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing: AudioChannelOutputMixProcessingUpdateInput;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath: AudioChannelOutputPathUpdateInput;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch: AudioChannelPadSwitchUpdateInput;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan: AudioChannelPanUpdateInput;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers: AudioChannelPassiveSpeakersUpdateInput;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral: AudioChannelPcPeripheralUpdateInput;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold: AudioChannelPeakHoldUpdateInput;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower: AudioChannelPhantomPowerUpdateInput;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction: AudioChannelPlosiveReductionUpdateInput;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain: AudioChannelPostGateGainUpdateInput;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute: AudioChannelPostGateMuteUpdateInput;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo: AudioChannelPostGateSoloUpdateInput;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen: AudioChannelPreFadeListenUpdateInput;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute: AudioChannelPreGateMuteUpdateInput;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb: AudioChannelReverbUpdateInput;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker: AudioChannelSelectedLoudspeakerInput;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator: AudioChannelSignalGeneratorUpdateInput;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo: AudioChannelSoloUpdateInput;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain: AudioChannelStereoGainUpdateInput;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse: AudioChannelStereoReverseUpdateInput;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth: AudioChannelStereoWidthUpdateInput;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch: AudioChannelTalkSwitchUpdateInput;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight: AudioChannelTalkerHeightUpdateInput;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator: AudioChannelToneGeneratorUpdateInput;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode: AudioChannelUsbOutputModeUpdateInput;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction: AudioChannelVoiceActivityDetectionNoiseReductionUpdateInput;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity: AudioChannelVoiceActivityDetectionSensitivityUpdateInput;
			wirelessEncryption?: never;
	  }
	| {
			acousticEchoCancellation?: never;
			analogInputUse?: never;
			analogLevel?: never;
			auracast?: never;
			autoLevel?: never;
			autoMute?: never;
			automaticGainControl?: never;
			automixer?: never;
			automixerEnable?: never;
			automixerInput?: never;
			automixerInputAlwaysOn?: never;
			automixerInputPriority?: never;
			automixerInputSendToMonoMix?: never;
			automixerInputSendToStereoMix?: never;
			automixerVoiceActivityDetection?: never;
			compressor?: never;
			danteRouteReceiver?: never;
			danteRouteTransmitter?: never;
			delay?: never;
			denoiser?: never;
			deverb?: never;
			deviceSpecificEqualizerContour?: never;
			directOutputTapPoint?: never;
			equalizer?: never;
			equalizerContour?: never;
			externalAutomixerGate?: never;
			faderGroup?: never;
			gain?: never;
			gainLock?: never;
			inputSource?: never;
			limiter?: never;
			lobeConfiguration?: never;
			lobePosition?: never;
			lobeTalkerHeight?: never;
			lobeWidth?: never;
			micOptimization?: never;
			micPolarPattern?: never;
			microphoneAngle?: never;
			monitorMix?: never;
			monitorMixReverb?: never;
			mute?: never;
			muteGroup?: never;
			muteLock?: never;
			name?: never;
			noiseReduction?: never;
			outputMixProcessing?: never;
			outputPath?: never;
			padSwitch?: never;
			pan?: never;
			passiveSpeakers?: never;
			pcPeripheral?: never;
			peakHold?: never;
			phantomPower?: never;
			plosiveReduction?: never;
			postGateGain?: never;
			postGateMute?: never;
			postGateSolo?: never;
			preFadeListen?: never;
			preGateMute?: never;
			reverb?: never;
			selectedLoudspeaker?: never;
			signalGenerator?: never;
			solo?: never;
			stereoGain?: never;
			stereoReverse?: never;
			stereoWidth?: never;
			talkSwitch?: never;
			talkerHeight?: never;
			toneGenerator?: never;
			usbOutputMode?: never;
			voiceActivityDetectionNoiseReduction?: never;
			voiceActivityDetectionSensitivity?: never;
			wirelessEncryption: AudioChannelWirelessEncryptionInput;
	  };

export type AudioChannelFeatures = {
	acousticEchoCancellation: Maybe<AudioChannelAcousticEchoCancellation>;
	/** Acoustic Echo Cancellation Echo Return Loss Enhancement Meter level (dB) */
	acousticEchoCancellationErle: Maybe<AudioChannelAcousticEchoCancellationErleMeter>;
	acousticEchoCancellationErleMeterSource: Maybe<AudioChannelAcousticEchoCancellationErleMeterSource>;
	acousticEchoCancellationMonoReference: Maybe<AudioChannelAcousticEchoCancellationMonoReference>;
	acousticEchoCancellationPeak: Maybe<AudioChannelAcousticEchoCancellationPeakMeter>;
	acousticEchoCancellationRms: Maybe<AudioChannelAcousticEchoCancellationRmsMeter>;
	acousticEchoCancellationStereoReference: Maybe<AudioChannelAcousticEchoCancellationStereoReference>;
	activity: Maybe<AudioChannelActivityMeter>;
	analogInputUse: Maybe<AudioChannelAnalogInputUse>;
	analogLevel: Maybe<AudioChannelAnalogLevel>;
	analogStereoPeak: Maybe<AudioChannelAnalogStereoPeakMeter>;
	analogStereoRms: Maybe<AudioChannelAnalogStereoRmsMeter>;
	/**
	 * Auracast is a Bluetooth capability that enables an audio transmitter to broadcast to an unlimited number of receivers.
	 * auracast feature on audio channel node configures auracast settings.
	 */
	auracast: Maybe<AudioChannelAuracast>;
	/**
	 * Auracast is a Bluetooth capability that enables an audio transmitter to broadcast to an unlimited number of receivers.
	 * auracastEncryption feature on audio channel node configures auracast encryption settings.
	 */
	auracastEncryption: Maybe<AudioChannelAuracastEncryption>;
	autoLevel: Maybe<AudioChannelAutoLevel>;
	autoMute: Maybe<AudioChannelAutoMute>;
	autoPosition: Maybe<AudioChannelAutoPosition>;
	automaticGain: Maybe<AudioChannelAutomaticGainMeter>;
	automaticGainControl: Maybe<AudioChannelAutomaticGainControl>;
	automaticGainControlPeak: Maybe<AudioChannelAutomaticGainControlPeakMeter>;
	automaticGainControlRms: Maybe<AudioChannelAutomaticGainControlRmsMeter>;
	automixGain: Maybe<AudioChannelAutomixGainMeter>;
	automixSourceSelector: Maybe<AudioChannelAutomixSourceSelector>;
	automixer: Maybe<AudioChannelAutomixer>;
	automixerAutoLevelMode: Maybe<AudioChannelAutomixerAutoLevelModeMeter>;
	automixerChannelActive: Maybe<AudioChannelAutomixerChannelActive>;
	automixerEnable: Maybe<AudioChannelAutomixerEnable>;
	automixerGate: Maybe<AudioChannelAutomixerGateMeter>;
	automixerInput: Maybe<AudioChannelAutomixerInput>;
	automixerInputAlwaysOn: Maybe<AudioChannelAutomixerInputAlwaysOn>;
	/**
	 * The preferred metering point for input channels participating in automixing.
	 * For devices that don't support this feature, an earlier metering point must be used, such as peak.
	 */
	automixerInputPeak: Maybe<AudioChannelAutomixerInputPeakMeter>;
	automixerInputPriority: Maybe<AudioChannelAutomixerInputPriority>;
	/**
	 * The preferred metering point for input channels participating in automixing.
	 * For devices that don't support this feature, an earlier metering point must be used, such as rms.
	 */
	automixerInputRms: Maybe<AudioChannelAutomixerInputRmsMeter>;
	automixerInputSendToMonoMix: Maybe<AudioChannelAutomixerInputSendToMonoMix>;
	automixerInputSendToStereoMix: Maybe<AudioChannelAutomixerInputSendToStereoMix>;
	automixerNoiseFloorEstimate: Maybe<AudioChannelAutomixerNoiseFloorEstimateMeter>;
	/** @deprecated Use voiceActivityDetectionSensitivity and voiceActivityDetectionNoiseReduction instead */
	automixerVoiceActivityDetection: Maybe<AudioChannelAutomixerVoiceActivityDetection>;
	carriedByRfChannels: Maybe<AudioChannelCarriedByRfChannels>;
	channelBonding: Maybe<AudioChannelChannelBonding>;
	channelConfiguration: Maybe<AudioChannelChannelConfiguration>;
	clip: Maybe<AudioChannelClipMeter>;
	compressor: Maybe<AudioChannelCompressor>;
	compressorEngaged: Maybe<AudioChannelCompressorEngagedMeter>;
	connectionDetection: Maybe<AudioChannelConnectionDetection>;
	danteEncryptionStatus: Maybe<AudioChannelDanteEncryptionStatus>;
	danteRouteReceiver: Maybe<AudioChannelDanteRouteReceiver>;
	danteRouteTransmitter: Maybe<AudioChannelDanteRouteTransmitter>;
	delay: Maybe<AudioChannelDelay>;
	denoiser: Maybe<AudioChannelDenoiser>;
	denoiserNoiseReduction: Maybe<AudioChannelDenoiserNoiseReductionMeter>;
	deverb: Maybe<AudioChannelDeverb>;
	deviceSpecificEqualizerContour: Maybe<AudioChannelDeviceSpecificEqualizerContour>;
	directOutputTapPoint: Maybe<AudioChannelDirectOutputTapPoint>;
	equalizer: Maybe<AudioChannelEqualizer>;
	equalizerContour: Maybe<AudioChannelEqualizerContour>;
	equalizerPreset: Maybe<AudioChannelEqualizerPreset>;
	externalAutomixerGate: Maybe<AudioChannelExternalAutomixerGate>;
	faderGroup: Maybe<AudioChannelFaderGroup>;
	gain: Maybe<AudioChannelGain>;
	gainLock: Maybe<AudioChannelGainLock>;
	groundLift: Maybe<AudioChannelGroundLift>;
	identify: Maybe<AudioChannelIdentify>;
	inputSource: Maybe<AudioChannelInputSource>;
	lightingBehavior: Maybe<AudioChannelLightingBehavior>;
	limiter: Maybe<AudioChannelLimiter>;
	limiterEngaged: Maybe<AudioChannelLimiterEngagedMeter>;
	lobeConfiguration: Maybe<AudioChannelLobeConfiguration>;
	lobePosition: Maybe<AudioChannelLobePosition>;
	lobeTalkerHeight: Maybe<AudioChannelLobeTalkerHeight>;
	lobeWidth: Maybe<AudioChannelLobeWidth>;
	logicReceiver: Maybe<AudioChannelLogicReceiver>;
	/**
	 * The preferred metering point for input channels participating in matrix mixing.
	 * For devices that don't support this feature, an earlier metering point must be used, such as peak.
	 * @deprecated Prefer 'matrixMixerPeak' feature instead for greater genericism if the audio channel supports it.
	 */
	matrixMixerInputPeak: Maybe<AudioChannelMatrixMixerInputPeakMeter>;
	/**
	 * The preferred metering point for input channels participating in matrix mixing.
	 * For devices that don't support this feature, an earlier metering point must be used, such as rms.
	 * @deprecated Prefer 'matrixMixerRms' feature instead for greater genericism if the audio channel supports it.
	 */
	matrixMixerInputRms: Maybe<AudioChannelMatrixMixerInputRmsMeter>;
	matrixMixerOutput: Maybe<AudioChannelMatrixMixerOutput>;
	/**
	 * The preferred metering point for output channels participating in matrix mixing.
	 * For devices that don't support this feature, a later metering point must be used, such as peak.
	 * @deprecated Prefer 'matrixMixerPeak' feature instead for greater genericism if the audio channel supports it.
	 */
	matrixMixerOutputPeak: Maybe<AudioChannelMatrixMixerOutputPeakMeter>;
	/**
	 * The preferred metering point for output channels participating in matrix mixing.
	 * For devices that don't support this feature, a later metering point must be used, such as rms.
	 * @deprecated Prefer 'matrixMixerRms' feature instead for greater genericism if the audio channel supports it.
	 */
	matrixMixerOutputRms: Maybe<AudioChannelMatrixMixerOutputRmsMeter>;
	/**
	 * The preferred metering point for channels participating in matrix mixing.
	 * For devices that don't support this feature, an earlier metering point must be used, such as peak.
	 */
	matrixMixerPeak: Maybe<AudioChannelMatrixMixerPeakMeter>;
	/**
	 * The preferred metering point for channels participating in matrix mixing.
	 * For devices that don't support this feature, an earlier metering point must be used, such as rms.
	 */
	matrixMixerRms: Maybe<AudioChannelMatrixMixerRmsMeter>;
	/** When the related device feature, 'stereoAudio''s enabled field is 'false', the 'rightLevel' field will be "negative infinity" and unchanging (e.g -60 dBFS on IMX-R). E.g. The 'leftLevel' will continue to return the Mono signal for the audio channel. */
	matrixMixerStereoInputPeak: Maybe<AudioChannelMatrixMixerStereoInputPeakMeter>;
	/** When the related device feature, 'stereoAudio''s enabled field is 'false', the 'rightLevel' field will be "negative infinity" and unchanging (e.g -60 dBFS on IMX-R). E.g. The 'leftLevel' will continue to return the Mono signal for the audio channel. */
	matrixMixerStereoInputRms: Maybe<AudioChannelMatrixMixerStereoInputRmsMeter>;
	micOptimization: Maybe<AudioChannelMicOptimization>;
	micPolarPattern: Maybe<AudioChannelMicPolarPattern>;
	microphoneAngle: Maybe<AudioChannelMicrophoneAngle>;
	monitorMix: Maybe<AudioChannelMonitorMix>;
	monitorMixReverb: Maybe<AudioChannelMonitorMixReverb>;
	mute: Maybe<AudioChannelMute>;
	muteGroup: Maybe<AudioChannelMuteGroup>;
	muteLock: Maybe<AudioChannelMuteLock>;
	name: Maybe<AudioChannelName>;
	noiseReduction: Maybe<AudioChannelNoiseReduction>;
	outputMixProcessing: Maybe<AudioChannelOutputMixProcessing>;
	outputPath: Maybe<AudioChannelOutputPath>;
	padSwitch: Maybe<AudioChannelPadSwitch>;
	pan: Maybe<AudioChannelPan>;
	passiveSpeakers: Maybe<AudioChannelPassiveSpeakers>;
	pcPeripheral: Maybe<AudioChannelPcPeripheral>;
	/**
	 * When the device-level feature stereoAudio's enabled field is true, the left channel of that stereo signal will be available here and in the stereoPeak capability.
	 * This capability always represents a mono send (a.k.a L/Mono).
	 */
	peak: Maybe<AudioChannelPeakMeter>;
	peakHold: Maybe<AudioChannelPeakHold>;
	phantomPower: Maybe<AudioChannelPhantomPower>;
	plosiveReduction: Maybe<AudioChannelPlosiveReduction>;
	postGateGain: Maybe<AudioChannelPostGateGain>;
	postGateGainStereoPeak: Maybe<AudioChannelPostGateGainStereoPeakMeter>;
	postGateGainStereoRms: Maybe<AudioChannelPostGateGainStereoRmsMeter>;
	postGateMute: Maybe<AudioChannelPostGateMute>;
	postGateSolo: Maybe<AudioChannelPostGateSolo>;
	preFadeListen: Maybe<AudioChannelPreFadeListen>;
	preGateMute: Maybe<AudioChannelPreGateMute>;
	reverb: Maybe<AudioChannelReverb>;
	/**
	 * When the device-level feature stereoAudio's enabled field is true, the left channel of that stereo signal will be available here and in the stereoPeak capability.
	 * This capability always represents a mono send (a.k.a L/Mono).
	 */
	rms: Maybe<AudioChannelRmsMeter>;
	selectedLoudspeaker: Maybe<AudioChannelSelectedLoudspeaker>;
	signalGenerator: Maybe<AudioChannelSignalGenerator>;
	solo: Maybe<AudioChannelSolo>;
	stereoAutomixGain: Maybe<AudioChannelStereoAutomixGainMeter>;
	stereoAutomixerGate: Maybe<AudioChannelStereoAutomixerGateMeter>;
	stereoGain: Maybe<AudioChannelStereoGain>;
	/** When the related device feature, 'stereoAudio''s enabled field is 'false', the 'rightLevel' field will be "negative infinity" and unchanging (e.g -110 dBFS on IMX-R). E.g. The 'leftLevel' will continue to return the Mono signal for the audio channel. */
	stereoPeak: Maybe<AudioChannelStereoPeakMeter>;
	/** Reverse stereo - also known as Left-Right (L/R) Swap - indicates whether the left and right stereo audio is swapped */
	stereoReverse: Maybe<AudioChannelStereoReverse>;
	/** When the related device feature, 'stereoAudio''s enabled field is 'false', the 'rightLevel' field will be "negative infinity" and unchanging (e.g -110 dBFS on IMX-R). E.g. The 'leftLevel' will continue to return the Mono signal for the audio channel. */
	stereoRms: Maybe<AudioChannelStereoRmsMeter>;
	stereoWidth: Maybe<AudioChannelStereoWidth>;
	talkSwitch: Maybe<AudioChannelTalkSwitch>;
	/** @deprecated Use 'lobeTalkerHeight' feature instead. */
	talkerHeight: Maybe<AudioChannelTalkerHeight>;
	toneGenerator: Maybe<AudioChannelToneGenerator>;
	transmitterClip: Maybe<AudioChannelTransmitterClip>;
	usbOutputMode: Maybe<AudioChannelUsbOutputMode>;
	voiceActivityDetectionNoiseReduction: Maybe<AudioChannelVoiceActivityDetectionNoiseReduction>;
	voiceActivityDetectionSensitivity: Maybe<AudioChannelVoiceActivityDetectionSensitivity>;
	wirelessEncryption: Maybe<AudioChannelWirelessEncryption>;
};

export type AudioChannelFixedLobeTalkerHeightUpdateInput = {
	fixed: AudioChannelLobeTalkerHeightUpdateInput;
};

export type AudioChannelFixedMicrophoneAngleUpdateInput = {
	fixed: AudioChannelMicrophoneAngleUpdateInput;
};

export type AudioChannelGain = {
	/** Signal gain (dB) */
	gain: Scalars['Float']['output'];
};

export type AudioChannelGainChange = {
	gain: Maybe<AudioChannelGain>;
};

export type AudioChannelGainConstraints = {
	/** Describes the range of values for the signal gain that are supported on the channel. */
	gain: AudioChannelGainFieldConstraints;
};

export type AudioChannelGainFieldConstraints = IFloatRangeConstraints & {
	/**
	 * If present, clients should use this list as the authoritative set of valid values
	 * rather than interpolating across `range`. This field exists to support devices
	 * with non-uniform gain constraints where `range` correctly describes the upper
	 * and lower bounds but not every value within that range is valid (e.g. PSM1000).
	 */
	options: Maybe<Array<Scalars['Int']['output']>>;
	range: FloatRange;
};

/**
 * Gain lock prevents users from adjusting gain via both the device's front panel AND remote control.
 * When enabled, gain adjustment is completely disabled from all sources.
 *
 * Note: This differs from DeviceFrontPanelGainLock, which only locks front panel control while allowing remote adjustments.
 */
export type AudioChannelGainLock = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelGainLockChange = {
	gainLock: Maybe<AudioChannelGainLock>;
};

export type AudioChannelGainLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelGainUpdateInput = {
	gain: Scalars['Float']['input'];
};

export type AudioChannelGroundLift = {
	/** Stereo Channel GroundLift */
	grounding: Maybe<Grounding | `${Grounding}`>;
};

export type AudioChannelGroundLiftChange = {
	groundLift: Maybe<AudioChannelGroundLift>;
};

export enum AudioChannelGroup {
	AecReference = 'AEC_REFERENCE',
	Analog_70VOutput = 'ANALOG_70V_OUTPUT',
	AnalogAuxInput = 'ANALOG_AUX_INPUT',
	AnalogOutput = 'ANALOG_OUTPUT',
	Automix = 'AUTOMIX',
	AuxInput = 'AUX_INPUT',
	AuxOutput = 'AUX_OUTPUT',
	Back = 'BACK',
	BluetoothInput = 'BLUETOOTH_INPUT',
	BluetoothOutput = 'BLUETOOTH_OUTPUT',
	DanteAnalogInput = 'DANTE_ANALOG_INPUT',
	DanteAuxInput = 'DANTE_AUX_INPUT',
	DanteInput = 'DANTE_INPUT',
	DanteLineInput = 'DANTE_LINE_INPUT',
	DanteLineOutput = 'DANTE_LINE_OUTPUT',
	DanteMicInput = 'DANTE_MIC_INPUT',
	DanteOutput = 'DANTE_OUTPUT',
	DirectOutput = 'DIRECT_OUTPUT',
	Generic = 'GENERIC',
	Headphone = 'HEADPHONE',
	Lobe = 'LOBE',
	Loudspeaker = 'LOUDSPEAKER',
	Mic = 'MIC',
	MixOutput = 'MIX_OUTPUT',
	MobileInput = 'MOBILE_INPUT',
	MobileOutput = 'MOBILE_OUTPUT',
	PcInput = 'PC_INPUT',
	PcOutput = 'PC_OUTPUT',
	SignalGeneratorInput = 'SIGNAL_GENERATOR_INPUT',
	Sum = 'SUM',
	UsbInput = 'USB_INPUT',
	UsbOutput = 'USB_OUTPUT',
	VirtualAudioInput = 'VIRTUAL_AUDIO_INPUT',
	VirtualAudioOutput = 'VIRTUAL_AUDIO_OUTPUT'
}

export type AudioChannelIdentify = {
	identifying: Scalars['Boolean']['output'];
};

export type AudioChannelIdentifyChange = {
	identify: Maybe<AudioChannelIdentify>;
};

/**
 * Determines the source of the input for this audio channel.
 * This feature is only supported for audio channels which have multiple input sources
 * (e.g. digital and analog input sources, combination inputs, etc)
 */
export type AudioChannelInputSource = {
	source: AudioChannelInputSourceType | `${AudioChannelInputSourceType}`;
};

export type AudioChannelInputSourceChange = {
	inputSource: Maybe<AudioChannelInputSource>;
};

export type AudioChannelInputSourceConstraints = {
	source: Maybe<AudioChannelInputSourceTypeConstraints>;
};

export enum AudioChannelInputSourceType {
	Analog = 'ANALOG',
	Digital = 'DIGITAL'
}

export type AudioChannelInputSourceTypeConstraints = {
	options: Array<AudioChannelInputSourceType | `${AudioChannelInputSourceType}`>;
};

export type AudioChannelInputSourceUpdateInput = {
	source?: InputMaybe<AudioChannelInputSourceType | `${AudioChannelInputSourceType}`>;
};

export type AudioChannelLightingBehavior = {
	color: Maybe<LightingColor | `${LightingColor}`>;
	mode: Maybe<LightingMode | `${LightingMode}`>;
	state: Maybe<LightingState | `${LightingState}`>;
};

export type AudioChannelLightingBehaviorChange = {
	lightingBehavior: Maybe<AudioChannelLightingBehavior>;
};

export type AudioChannelLightingBehaviorColorConstraints = {
	options: Array<LightingColor | `${LightingColor}`>;
};

export type AudioChannelLightingBehaviorConstraints = {
	color: AudioChannelLightingBehaviorColorConstraints;
	mode: AudioChannelLightingBehaviorModeConstraints;
	state: AudioChannelLightingBehaviorStateConstraints;
};

export type AudioChannelLightingBehaviorModeConstraints = {
	options: Array<LightingMode | `${LightingMode}`>;
};

export type AudioChannelLightingBehaviorStateConstraints = {
	options: Array<LightingState | `${LightingState}`>;
};

export type AudioChannelLimiter = {
	bypassed: Maybe<Scalars['Boolean']['output']>;
	enabled: Scalars['Boolean']['output'];
	threshold: Maybe<Scalars['Float']['output']>;
};

export type AudioChannelLimiterChange = {
	limiter: Maybe<AudioChannelLimiter>;
};

export type AudioChannelLimiterConstraints = {
	bypassed: FieldSupport;
	threshold: AudioChannelLimiterThresholdConstraints;
};

export type AudioChannelLimiterEngagedMeter = {
	engaged: Scalars['Boolean']['output'];
};

export type AudioChannelLimiterThresholdConstraints = IFieldSupportInfo &
	INullableFloatRangeConstraints & {
		range: Maybe<FloatRange>;
		supported: Scalars['Boolean']['output'];
	};

export type AudioChannelLimiterUpdateInput = {
	bypassed?: InputMaybe<Scalars['Boolean']['input']>;
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type AudioChannelLobeConfiguration = {
	/** Indicates whether lobe is enabled */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelLobeConfigurationChange = {
	lobeConfiguration: Maybe<AudioChannelLobeConfiguration>;
};

export type AudioChannelLobeConfigurationUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelLobePosition = {
	/** Auto-focus lobe displacement in millimeters (mm) relative to the center of the device */
	autoFocus: Maybe<FloatPosition>;
	/** Lobe displacement in millimeters (mm) relative to the center of the device */
	fixed: FloatPosition;
};

export type AudioChannelLobePositionAutoFocusConstraints = IFieldSupportInfo & {
	supported: Scalars['Boolean']['output'];
	xPosition: Maybe<AudioChannelLobePositionAutoFocusFieldConstraints>;
	yPosition: Maybe<AudioChannelLobePositionAutoFocusFieldConstraints>;
	zPosition: Maybe<AudioChannelLobePositionAutoFocusFieldConstraints>;
};

export type AudioChannelLobePositionAutoFocusFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelLobePositionChange = {
	lobePosition: Maybe<AudioChannelLobePosition>;
};

export type AudioChannelLobePositionConstraints = {
	autoFocus: AudioChannelLobePositionAutoFocusConstraints;
	fixed: AudioChannelLobePositionFixedConstraints;
};

export type AudioChannelLobePositionFixedConstraints = {
	xPosition: AudioChannelLobePositionFixedFieldConstraints;
	yPosition: AudioChannelLobePositionFixedFieldConstraints;
	zPosition: AudioChannelLobePositionFixedFieldConstraints;
};

export type AudioChannelLobePositionFixedFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelLobePositionUpdateInput = {
	fixed?: InputMaybe<FloatPositionUpdateInput>;
};

export type AudioChannelLobeTalkerHeight = {
	/** Height of the talker's head in millimeters (mm), measured from the floor */
	autoFocus: Maybe<TalkerHeight>;
	/** Height of the talker's head in millimeters (mm), measured from the floor */
	fixed: TalkerHeight;
};

export type AudioChannelLobeTalkerHeightChange = {
	lobeTalkerHeight: Maybe<AudioChannelLobeTalkerHeight>;
};

export type AudioChannelLobeTalkerHeightConstraints = {
	autoFocus: AudioChannelTalkerHeightAutoFocusConstraints;
	fixed: AudioChannelTalkerHeightFixedConstraints;
};

export type AudioChannelLobeTalkerHeightUpdateInput = {
	height?: InputMaybe<Scalars['Float']['input']>;
};

export type AudioChannelLobeWidth = {
	/** Specifies the lobe width */
	width: LobeWidth | `${LobeWidth}`;
};

export type AudioChannelLobeWidthChange = {
	lobeWidth: Maybe<AudioChannelLobeWidth>;
};

export type AudioChannelLobeWidthConstraints = {
	/** Describes the range of supported values for the lobe width on the audio channel. */
	width: LobeWidthConstraints;
};

export type AudioChannelLobeWidthUpdateInput = {
	width?: InputMaybe<LobeWidth | `${LobeWidth}`>;
};

/**
 * Represents the logic signal sending and receiving happening between devices participating in the device-enabled logic feature.
 * This feature optimizes mute status synchronization at the optimal places in the signal path between particapting microphones and digital signal processors.
 */
export type AudioChannelLogicReceiver = {
	inputDeviceType: Maybe<Scalars['String']['output']>;
	/** Indicates whether or not the channel is receiving a logic input signal from a logic-enabled microphone */
	inputSignal: Scalars['Boolean']['output'];
	/** Indicates whether or not the channel is sending a logic output signal to a logic-enabled microphone */
	outputGated: Scalars['Boolean']['output'];
};

export type AudioChannelLogicReceiverChange = {
	logicReceiver: Maybe<AudioChannelLogicReceiver>;
};

export type AudioChannelMatrixMixerInputPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerInputPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerInputPeakMeterConstraints = {
	level: AudioChannelMatrixMixerInputPeakLevelConstraints;
};

export type AudioChannelMatrixMixerInputRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerInputRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerInputRmsMeterConstraints = {
	level: AudioChannelMatrixMixerInputRmsLevelConstraints;
};

export type AudioChannelMatrixMixerOutput = {
	crossPoints: Array<CrossPoint>;
};

export type AudioChannelMatrixMixerOutputPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerOutputPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerOutputPeakMeterConstraints = {
	level: AudioChannelMatrixMixerOutputPeakLevelConstraints;
};

export type AudioChannelMatrixMixerOutputRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerOutputRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerOutputRmsMeterConstraints = {
	level: AudioChannelMatrixMixerOutputRmsLevelConstraints;
};

export type AudioChannelMatrixMixerPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerPeakMeterConstraints = {
	level: AudioChannelMatrixMixerPeakLevelConstraints;
};

export type AudioChannelMatrixMixerRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerRmsMeterConstraints = {
	level: AudioChannelMatrixMixerRmsLevelConstraints;
};

export type AudioChannelMatrixMixerStereoInputPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerStereoInputPeakMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerStereoInputPeakMeterConstraints = {
	leftLevel: AudioChannelMatrixMixerStereoInputPeakLevelConstraints;
	rightLevel: AudioChannelMatrixMixerStereoInputPeakLevelConstraints;
};

export type AudioChannelMatrixMixerStereoInputRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelMatrixMixerStereoInputRmsMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelMatrixMixerStereoInputRmsMeterConstraints = {
	leftLevel: AudioChannelMatrixMixerStereoInputRmsLevelConstraints;
	rightLevel: AudioChannelMatrixMixerStereoInputRmsLevelConstraints;
};

export type AudioChannelMeterChange = {
	features: Maybe<AudioChannelMeterFeatureChange>;
	id: Scalars['ID']['output'];
};

export type AudioChannelMeterFeatureChange = {
	acousticEchoCancellationErle: Maybe<AudioChannelAcousticEchoCancellationErleMeter>;
	acousticEchoCancellationPeak: Maybe<AudioChannelAcousticEchoCancellationPeakMeter>;
	acousticEchoCancellationRms: Maybe<AudioChannelAcousticEchoCancellationRmsMeter>;
	activity: Maybe<AudioChannelActivityMeter>;
	analogStereoPeak: Maybe<AudioChannelAnalogStereoPeakMeter>;
	analogStereoRms: Maybe<AudioChannelAnalogStereoRmsMeter>;
	automaticGain: Maybe<AudioChannelAutomaticGainMeter>;
	automaticGainControlPeak: Maybe<AudioChannelAutomaticGainControlPeakMeter>;
	automaticGainControlRms: Maybe<AudioChannelAutomaticGainControlRmsMeter>;
	automixGain: Maybe<AudioChannelAutomixGainMeter>;
	automixerAutoLevelMode: Maybe<AudioChannelAutomixerAutoLevelModeMeter>;
	automixerGate: Maybe<AudioChannelAutomixerGateMeter>;
	automixerInputPeak: Maybe<AudioChannelAutomixerInputPeakMeter>;
	automixerInputRms: Maybe<AudioChannelAutomixerInputRmsMeter>;
	automixerNoiseFloorEstimate: Maybe<AudioChannelAutomixerNoiseFloorEstimateMeter>;
	clip: Maybe<AudioChannelClipMeter>;
	compressorEngaged: Maybe<AudioChannelCompressorEngagedMeter>;
	denoiserNoiseReduction: Maybe<AudioChannelDenoiserNoiseReductionMeter>;
	limiterEngaged: Maybe<AudioChannelLimiterEngagedMeter>;
	matrixMixerInputPeak: Maybe<AudioChannelMatrixMixerInputPeakMeter>;
	matrixMixerInputRms: Maybe<AudioChannelMatrixMixerInputRmsMeter>;
	matrixMixerOutputPeak: Maybe<AudioChannelMatrixMixerOutputPeakMeter>;
	matrixMixerOutputRms: Maybe<AudioChannelMatrixMixerOutputRmsMeter>;
	matrixMixerPeak: Maybe<AudioChannelMatrixMixerPeakMeter>;
	matrixMixerRms: Maybe<AudioChannelMatrixMixerRmsMeter>;
	matrixMixerStereoInputPeak: Maybe<AudioChannelMatrixMixerStereoInputPeakMeter>;
	matrixMixerStereoInputRms: Maybe<AudioChannelMatrixMixerStereoInputRmsMeter>;
	peak: Maybe<AudioChannelPeakMeter>;
	postGateGainStereoPeak: Maybe<AudioChannelPostGateGainStereoPeakMeter>;
	postGateGainStereoRms: Maybe<AudioChannelPostGateGainStereoRmsMeter>;
	rms: Maybe<AudioChannelRmsMeter>;
	stereoAutomixGain: Maybe<AudioChannelStereoAutomixGainMeter>;
	stereoAutomixerGate: Maybe<AudioChannelStereoAutomixerGateMeter>;
	stereoPeak: Maybe<AudioChannelStereoPeakMeter>;
	stereoRms: Maybe<AudioChannelStereoRmsMeter>;
};

export type AudioChannelMicOptimization = {
	mode: MicOptimizationMode | `${MicOptimizationMode}`;
};

export type AudioChannelMicOptimizationChange = {
	micOptimization: Maybe<AudioChannelMicOptimization>;
};

export type AudioChannelMicOptimizationConstraints = {
	mode: AudioChannelMicOptimizationModeConstraints;
};

export type AudioChannelMicOptimizationModeConstraints = {
	options: Array<MicOptimizationMode | `${MicOptimizationMode}`>;
};

export type AudioChannelMicOptimizationUpdateInput = {
	mode: MicOptimizationMode | `${MicOptimizationMode}`;
};

export type AudioChannelMicPolarPattern = {
	pattern: MicPolarPattern | `${MicPolarPattern}`;
};

export type AudioChannelMicPolarPatternChange = {
	micPolarPattern: Maybe<AudioChannelMicPolarPattern>;
};

export type AudioChannelMicPolarPatternConstraints = {
	pattern: AudioChannelMicPolarPatternTypeConstraints;
};

export type AudioChannelMicPolarPatternTypeConstraints = {
	options: Array<MicPolarPattern | `${MicPolarPattern}`>;
};

export type AudioChannelMicPolarPatternUpdateInput = {
	pattern: MicPolarPattern | `${MicPolarPattern}`;
};

export type AudioChannelMicrophoneAngle = {
	/** Auto-focused position of the microphone angle in degrees. The zero position will be indicated physically on the device. */
	autoFocus: Maybe<MicrophoneAngle>;
	/** Statically positioned microphone angle in degrees. The zero position will be indicated physically on the device. */
	fixed: MicrophoneAngle;
};

export type AudioChannelMicrophoneAngleAutoFocusConstraints = IFieldSupportInfo & {
	angle: Maybe<AudioChannelMicrophoneAngleAutoFocusFieldConstraints>;
	supported: Scalars['Boolean']['output'];
};

export type AudioChannelMicrophoneAngleAutoFocusFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelMicrophoneAngleChange = {
	microphoneAngle: Maybe<AudioChannelMicrophoneAngle>;
};

export type AudioChannelMicrophoneAngleConstraints = {
	autoFocus: AudioChannelMicrophoneAngleAutoFocusConstraints;
	fixed: AudioChannelMicrophoneAngleFixedConstraints;
};

export type AudioChannelMicrophoneAngleFixedConstraints = {
	angle: AudioChannelMicrophoneAngleFixedFieldConstraints;
};

export type AudioChannelMicrophoneAngleFixedFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelMicrophoneAngleUpdateInput = {
	angle?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioChannelMonitorMix = {
	/**
	 * A percentage describing a configurable blend of audio from a microphone, and inbound playback audio.
	 * This is used for direct monitoring of multiple simultaneous audio signals.
	 *
	 * 100% - All audio output is currently being captured by the microphone (direct monitoring).
	 *       (e.g. a podcast host can here themselves talk with headphones on with minimal latency without processing from device receiving the signal)
	 * 50%  - Equal amounts of audio from both the microphone signal and the host device playback signal
	 * 0%   - All audio output is the playback audio from the host device (input monitoring).
	 *       (e.g. USB audio input back into the microphone from the operating system for listening to a co-host on a podcast)
	 *       (e.g. a podcast host can listen to their audio post processed by a denoiser on their computer, or from DSP in their DAW)
	 */
	percentage: Scalars['Int']['output'];
};

export type AudioChannelMonitorMixChange = {
	monitorMix: Maybe<AudioChannelMonitorMix>;
};

export type AudioChannelMonitorMixConstraints = {
	/** Describes the range of values for the monitoring mix that are supported on the channel. */
	percentage: AudioChannelMonitorMixTypeConstraints;
};

export type AudioChannelMonitorMixReverb = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelMonitorMixReverbChange = {
	monitorMixReverb: Maybe<AudioChannelMonitorMixReverb>;
};

export type AudioChannelMonitorMixReverbUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelMonitorMixTypeConstraints = IIntRangeConstraints & {
	/** Describes the range of values for the monitoring mix that are supported on the channel. */
	range: IntRange;
};

export type AudioChannelMonitorMixUpdateInput = {
	percentage: Scalars['Int']['input'];
};

export type AudioChannelMute = {
	/** Indicates whether or not the channel is muted */
	muted: Scalars['Boolean']['output'];
};

export type AudioChannelMuteChange = {
	mute: Maybe<AudioChannelMute>;
};

export type AudioChannelMuteGroup = {
	/** Indicates whether or not the audio channel is participating in the mute group for linking mute state across multiple channels */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelMuteGroupChange = {
	muteGroup: Maybe<AudioChannelMuteGroup>;
};

export type AudioChannelMuteGroupUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelMuteLock = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelMuteLockChange = {
	muteLock: Maybe<AudioChannelMuteLock>;
};

export type AudioChannelMuteLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type AudioChannelName = {
	/** Name assigned to the channel */
	name: Scalars['String']['output'];
};

export type AudioChannelNameChange = {
	name: Maybe<AudioChannelName>;
};

export type AudioChannelNameConflict = {
	audioChannel: AudioChannel;
	/** Channel name that is in conflict with another channel on the device */
	channelName: Scalars['String']['output'];
};

export type AudioChannelNameConstraints = {
	name: AudioChannelNameFieldConstraints;
};

export type AudioChannelNameFieldConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type AudioChannelNameUpdateInput = {
	name: Scalars['String']['input'];
};

export type AudioChannelNoiseReduction = {
	/** Indicates whether or not the noise reduction feature is enabled */
	enabled: Scalars['Boolean']['output'];
	/** Amount of noise reduction applied to the channel as a predefined level. */
	level: Maybe<NoiseReductionLevel | `${NoiseReductionLevel}`>;
	/** Amount of noise reduction applied to the channel in percentage. */
	percentage: Maybe<Scalars['Int']['output']>;
};

export type AudioChannelNoiseReductionChange = {
	noiseReduction: Maybe<AudioChannelNoiseReduction>;
};

export type AudioChannelNoiseReductionConstraints = {
	level: NoiseReductionLevelConstraints;
	percentage: NoiseReductionPercentageConstraints;
};

export type AudioChannelNoiseReductionUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	level?: InputMaybe<NoiseReductionLevel | `${NoiseReductionLevel}`>;
	percentage?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioChannelOperationResult = NodeOperationResult & {
	audioChannel: Maybe<AudioChannel>;
	error: Maybe<OperationError>;
};

export type AudioChannelOutputMixProcessing = {
	type: OutputMixProcessing | `${OutputMixProcessing}`;
};

export type AudioChannelOutputMixProcessingChange = {
	outputMixProcessing: Maybe<AudioChannelOutputMixProcessing>;
};

export type AudioChannelOutputMixProcessingConstraints = {
	type: AudioChannelOutputMixProcessingTypeConstraints;
};

export type AudioChannelOutputMixProcessingTypeConstraints = {
	options: Array<OutputMixProcessing | `${OutputMixProcessing}`>;
};

export type AudioChannelOutputMixProcessingUpdateInput = {
	type: OutputMixProcessing | `${OutputMixProcessing}`;
};

export type AudioChannelOutputPath = {
	path: OutputSignalPath | `${OutputSignalPath}`;
	/** path is not configurable if the option is null */
	pathOptions: Maybe<Array<OutputSignalPath | `${OutputSignalPath}`>>;
};

export type AudioChannelOutputPathChange = {
	outputPath: Maybe<AudioChannelOutputPath>;
};

export type AudioChannelOutputPathConstraints = {
	/** @deprecated Use 'outputPath.pathOptions' field instead */
	path: AudioChannelValidOutputPathConstraints;
};

export type AudioChannelOutputPathUpdateInput = {
	path: OutputSignalPath | `${OutputSignalPath}`;
};

export type AudioChannelPadSwitch = {
	/** Gain/attenuation (in dB) applied to the audio channel, corresponding to the pad switch level */
	gain: Scalars['Float']['output'];
	/** N-way switch position indicating the level of gain or attenuation to provide to a signal */
	level: Scalars['Int']['output'];
};

export type AudioChannelPadSwitchChange = {
	padSwitch: Maybe<AudioChannelPadSwitch>;
};

export type AudioChannelPadSwitchConstraints = {
	level: AudioChannelPadSwitchFieldConstraints;
};

export type AudioChannelPadSwitchFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelPadSwitchUpdateInput = {
	level: Scalars['Int']['input'];
};

export type AudioChannelPan = {
	/** Stereo Channel Pan */
	percentage: Scalars['Int']['output'];
};

export type AudioChannelPanChange = {
	pan: Maybe<AudioChannelPan>;
};

export type AudioChannelPanConstraints = {
	/** Describes the range of values for stereo pan that are supported on this channel. */
	percentage: AudioChannelPanFieldConstraints;
};

export type AudioChannelPanFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelPanUpdateInput = {
	percentage: Scalars['Int']['input'];
};

export type AudioChannelPassiveSpeakers = {
	/**  null if passive speaker type is not configured  */
	count: Maybe<Scalars['Int']['output']>;
	/**  null if passive speaker type is not configured  */
	passiveSpeakers: Maybe<Array<PassiveSpeaker>>;
	type: SpeakerType | `${SpeakerType}`;
};

export type AudioChannelPassiveSpeakersChange = {
	passiveSpeakers: Maybe<AudioChannelPassiveSpeakers>;
};

export type AudioChannelPassiveSpeakersConstraints = {
	count: AudioChannelPassiveSpeakersCountFieldConstraints;
	type: AudioChannelPassiveSpeakersTypeFieldConstraints;
};

export type AudioChannelPassiveSpeakersCountFieldConstraints = {
	range: IntRange;
};

export type AudioChannelPassiveSpeakersTypeFieldConstraints = {
	options: Array<SpeakerType | `${SpeakerType}`>;
};

export type AudioChannelPassiveSpeakersUpdateInput = {
	/**
	 * count is required when type is not NOT_CONFIGURED
	 * count should be 1 when analog audio output mode is Low Z mode(2-channel or 4-channel)
	 */
	count?: InputMaybe<Scalars['Int']['input']>;
	type?: InputMaybe<SpeakerType | `${SpeakerType}`>;
};

export type AudioChannelPcPeripheral = {
	peripheralOptions: Array<PcPeripheral>;
	selectedPeripheral: Maybe<PcPeripheral>;
};

export type AudioChannelPcPeripheralChange = {
	pcPeripheral: Maybe<AudioChannelPcPeripheral>;
};

export type AudioChannelPcPeripheralIdUpdateInput = {
	id: Scalars['String']['input'];
};

export type AudioChannelPcPeripheralUpdateInput = {
	selectedPeripheral: AudioChannelPcPeripheralIdUpdateInput;
};

export type AudioChannelPeakHold = {
	enabled: Scalars['Boolean']['output'];
	peakDetected: Scalars['Boolean']['output'];
};

export type AudioChannelPeakHoldChange = {
	peakHold: Maybe<AudioChannelPeakHold>;
};

export type AudioChannelPeakHoldUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioChannelPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelPeakMeterConstraints = {
	level: AudioChannelPeakMeterLevelConstraints;
};

export type AudioChannelPeakMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelPhantomPower = {
	/** Phantom power setting in volts */
	volts: Scalars['Int']['output'];
};

export type AudioChannelPhantomPowerChange = {
	phantomPower: Maybe<AudioChannelPhantomPower>;
};

export type AudioChannelPhantomPowerConstraints = {
	/** Describes the list of supported values for the phantom power on the audio channel. */
	volts: PhantomPowerConstraints;
};

export type AudioChannelPhantomPowerUpdateInput = {
	volts: Scalars['Int']['input'];
};

export type AudioChannelPlosiveReduction = {
	/** Indicates whether or not plosive reduction is enabled */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelPlosiveReductionChange = {
	plosiveReduction: Maybe<AudioChannelPlosiveReduction>;
};

export type AudioChannelPlosiveReductionUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelPostGateFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelPostGateGain = {
	/** Signal gain (dB) after the automixer gating decision has occurred */
	gain: Scalars['Float']['output'];
};

export type AudioChannelPostGateGainChange = {
	postGateGain: Maybe<AudioChannelPostGateGain>;
};

export type AudioChannelPostGateGainConstraints = {
	gain: AudioChannelPostGateFieldConstraints;
};

export type AudioChannelPostGateGainStereoPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelPostGateGainStereoPeakMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelPostGateGainStereoPeakMeterConstraints = {
	leftLevel: AudioChannelPostGateGainStereoPeakLevelConstraints;
	rightLevel: AudioChannelPostGateGainStereoPeakLevelConstraints;
};

export type AudioChannelPostGateGainStereoRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelPostGateGainStereoRmsMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelPostGateGainStereoRmsMeterConstraints = {
	leftLevel: AudioChannelPostGateGainStereoRmsLevelConstraints;
	rightLevel: AudioChannelPostGateGainStereoRmsLevelConstraints;
};

export type AudioChannelPostGateGainUpdateInput = {
	gain: Scalars['Float']['input'];
};

export type AudioChannelPostGateMute = {
	/** Audio mute status after the automixer gating decision has occurred */
	muted: Scalars['Boolean']['output'];
};

export type AudioChannelPostGateMuteChange = {
	postGateMute: Maybe<AudioChannelPostGateMute>;
};

export type AudioChannelPostGateMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type AudioChannelPostGateSolo = {
	/** Whether or not the audio channel direct out is soloed after the automixer gating decision has occurred. */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelPostGateSoloChange = {
	postGateSolo: Maybe<AudioChannelPostGateSolo>;
};

export type AudioChannelPostGateSoloUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelPreFadeListen = {
	/** Route reference-level channel audio to the Pre-Fade Listen output. */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelPreFadeListenChange = {
	preFadeListen: Maybe<AudioChannelPreFadeListen>;
};

export type AudioChannelPreFadeListenUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelPreGateMute = {
	/** Audio mute status before the automixer gating decision has occurred */
	muted: Scalars['Boolean']['output'];
};

export type AudioChannelPreGateMuteChange = {
	preGateMute: Maybe<AudioChannelPreGateMute>;
};

export type AudioChannelPreGateMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export enum AudioChannelReassignmentOperation {
	Replace = 'Replace',
	Swap = 'Swap'
}

export type AudioChannelReverb = {
	enabled: Scalars['Boolean']['output'];
	intensity: Scalars['Int']['output'];
	type: ReverbType | `${ReverbType}`;
};

export type AudioChannelReverbChange = {
	reverb: Maybe<AudioChannelReverb>;
};

export type AudioChannelReverbConstraints = {
	intensity: AudioChannelReverbIntensityConstraints;
	type: AudioChannelReverbTypeConstraints;
};

export type AudioChannelReverbIntensityConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelReverbTypeConstraints = {
	options: Array<ReverbType | `${ReverbType}`>;
};

export type AudioChannelReverbUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	intensity?: InputMaybe<Scalars['Int']['input']>;
	type?: InputMaybe<ReverbType | `${ReverbType}`>;
};

export type AudioChannelRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioChannelRmsMeterConstraints = {
	level: AudioChannelRmsLevelConstraints;
};

export enum AudioChannelRole {
	Filter = 'FILTER',
	Sink = 'SINK',
	Source = 'SOURCE'
}

export type AudioChannelSelectedLoudspeaker = {
	loudspeaker: Loudspeaker | `${Loudspeaker}`;
	loudspeakerOptions: Array<Loudspeaker | `${Loudspeaker}`>;
};

export type AudioChannelSelectedLoudspeakerChange = {
	selectedLoudspeaker: Maybe<AudioChannelSelectedLoudspeaker>;
};

export type AudioChannelSelectedLoudspeakerInput = {
	loudspeaker: Loudspeaker | `${Loudspeaker}`;
};

export type AudioChannelSignalGenerator = {
	enabled: Scalars['Boolean']['output'];
	frequency: Scalars['Float']['output'];
	gain: Scalars['Float']['output'];
	signalType: SignalType | `${SignalType}`;
};

export type AudioChannelSignalGeneratorChange = {
	signalGenerator: Maybe<AudioChannelSignalGenerator>;
};

/**
 * Signal generators are constrained in the gain range they provide by their...
 * - signal type
 * - available power to the speaker
 * - frequency (applies only to sine waves)
 */
export type AudioChannelSignalGeneratorConstraints = {
	signalTypes: Array<SignalGeneratorSignalTypeConstraints>;
};

export type AudioChannelSignalGeneratorUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	frequency?: InputMaybe<Scalars['Float']['input']>;
	gain?: InputMaybe<Scalars['Float']['input']>;
	signalType?: InputMaybe<SignalType | `${SignalType}`>;
};

export type AudioChannelSolo = {
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelSoloChange = {
	solo: Maybe<AudioChannelSolo>;
};

export type AudioChannelSoloUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelStereoAutomixGainConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelStereoAutomixGainMeter = {
	gain: Scalars['Float']['output'];
};

export type AudioChannelStereoAutomixGainMeterConstraints = {
	gain: AudioChannelStereoAutomixGainConstraints;
};

export type AudioChannelStereoAutomixerGateMeter = {
	open: Scalars['Boolean']['output'];
};

export type AudioChannelStereoGain = {
	/** Stereo gain (dB) */
	gain: Scalars['Float']['output'];
};

export type AudioChannelStereoGainChange = {
	stereoGain: Maybe<AudioChannelStereoGain>;
};

export type AudioChannelStereoGainConstraints = {
	/** Describes the range of gain values that are supported on the channel while on stereo mode. */
	gain: AudioChannelStereoGainFieldConstraints;
};

export type AudioChannelStereoGainFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelStereoGainUpdateInput = {
	gain: Scalars['Float']['input'];
};

export type AudioChannelStereoPeakLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

/** Stereo Peak Level (dBFS) */
export type AudioChannelStereoPeakMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelStereoPeakMeterConstraints = {
	leftLevel: AudioChannelStereoPeakLevelConstraints;
	rightLevel: AudioChannelStereoPeakLevelConstraints;
};

export type AudioChannelStereoReverse = {
	/** True, if the left and right stereo audio is swapped, false otherwise */
	enabled: Scalars['Boolean']['output'];
};

export type AudioChannelStereoReverseChange = {
	stereoReverse: Maybe<AudioChannelStereoReverse>;
};

export type AudioChannelStereoReverseUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type AudioChannelStereoRmsLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

/** Stereo Rms Level (dBFS) */
export type AudioChannelStereoRmsMeter = {
	leftLevel: Scalars['Float']['output'];
	rightLevel: Scalars['Float']['output'];
};

export type AudioChannelStereoRmsMeterConstraints = {
	leftLevel: AudioChannelStereoRmsLevelConstraints;
	rightLevel: AudioChannelStereoRmsLevelConstraints;
};

export type AudioChannelStereoWidth = {
	/** The width of the stereo image expressed as an angle in degrees. */
	angle: Scalars['Int']['output'];
};

export type AudioChannelStereoWidthAngleConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelStereoWidthChange = {
	stereoWidth: Maybe<AudioChannelStereoWidth>;
};

export type AudioChannelStereoWidthConstraints = {
	angle: AudioChannelStereoWidthAngleConstraints;
};

export type AudioChannelStereoWidthUpdateInput = {
	angle: Scalars['Int']['input'];
};

export type AudioChannelSupportedFeatures = {
	acousticEchoCancellation: FeatureSupport;
	acousticEchoCancellationErle: FeatureSupport;
	acousticEchoCancellationErleMeterSource: FeatureSupport;
	acousticEchoCancellationMonoReference: FeatureSupport;
	acousticEchoCancellationPeak: FeatureSupport;
	acousticEchoCancellationRms: FeatureSupport;
	acousticEchoCancellationStereoReference: FeatureSupport;
	activity: FeatureSupport;
	analogInputUse: FeatureSupport;
	analogLevel: FeatureSupport;
	analogStereoPeak: FeatureSupport;
	analogStereoRms: FeatureSupport;
	auracast: FeatureSupport;
	auracastEncryption: FeatureSupport;
	autoLevel: FeatureSupport;
	autoMute: FeatureSupport;
	autoPosition: FeatureSupport;
	automaticGain: FeatureSupport;
	automaticGainControl: FeatureSupport;
	automaticGainControlPeak: FeatureSupport;
	automaticGainControlRms: FeatureSupport;
	automixGain: FeatureSupport;
	automixSourceSelector: FeatureSupport;
	automixer: FeatureSupport;
	automixerAutoLevelMode: FeatureSupport;
	automixerChannelActive: FeatureSupport;
	automixerEnable: FeatureSupport;
	automixerGate: FeatureSupport;
	automixerInput: FeatureSupport;
	automixerInputAlwaysOn: FeatureSupport;
	automixerInputPeak: FeatureSupport;
	automixerInputPriority: FeatureSupport;
	automixerInputRms: FeatureSupport;
	automixerInputSendToMonoMix: FeatureSupport;
	automixerInputSendToStereoMix: FeatureSupport;
	automixerNoiseFloorEstimate: FeatureSupport;
	automixerVoiceActivityDetection: FeatureSupport;
	carriedByRfChannels: FeatureSupport;
	channelBonding: FeatureSupport;
	channelConfiguration: FeatureSupport;
	clip: FeatureSupport;
	compressor: FeatureSupport;
	compressorEngaged: FeatureSupport;
	connectionDetection: FeatureSupport;
	danteEncryptionStatus: FeatureSupport;
	danteRouteReceiver: FeatureSupport;
	danteRouteTransmitter: FeatureSupport;
	delay: FeatureSupport;
	denoiser: FeatureSupport;
	denoiserNoiseReduction: FeatureSupport;
	deverb: FeatureSupport;
	deviceSpecificEqualizerContour: FeatureSupport;
	directOutputTapPoint: FeatureSupport;
	equalizer: FeatureSupport;
	equalizerContour: FeatureSupport;
	equalizerPreset: FeatureSupport;
	externalAutomixerGate: FeatureSupport;
	faderGroup: FeatureSupport;
	gain: FeatureSupport;
	gainLock: FeatureSupport;
	groundLift: FeatureSupport;
	identify: FeatureSupport;
	inputSource: FeatureSupport;
	lightingBehavior: FeatureSupport;
	limiter: FeatureSupport;
	limiterEngaged: FeatureSupport;
	lobeConfiguration: FeatureSupport;
	lobePosition: FeatureSupport;
	lobeReset: FeatureSupport;
	lobeTalkerHeight: FeatureSupport;
	lobeWidth: FeatureSupport;
	logicReceiver: FeatureSupport;
	matrixMixerInputPeak: FeatureSupport;
	matrixMixerInputRms: FeatureSupport;
	matrixMixerOutput: FeatureSupport;
	matrixMixerOutputPeak: FeatureSupport;
	matrixMixerOutputRms: FeatureSupport;
	matrixMixerPeak: FeatureSupport;
	matrixMixerRms: FeatureSupport;
	matrixMixerStereoInputPeak: FeatureSupport;
	matrixMixerStereoInputRms: FeatureSupport;
	micOptimization: FeatureSupport;
	micPolarPattern: FeatureSupport;
	microphoneAngle: FeatureSupport;
	monitorMix: FeatureSupport;
	monitorMixReverb: FeatureSupport;
	mute: FeatureSupport;
	muteGroup: FeatureSupport;
	muteLock: FeatureSupport;
	name: FeatureSupport;
	noiseReduction: FeatureSupport;
	outputMixProcessing: FeatureSupport;
	outputPath: FeatureSupport;
	padSwitch: FeatureSupport;
	pan: FeatureSupport;
	passiveSpeakers: FeatureSupport;
	pcPeripheral: FeatureSupport;
	peak: FeatureSupport;
	peakHold: FeatureSupport;
	phantomPower: FeatureSupport;
	plosiveReduction: FeatureSupport;
	postGateGain: FeatureSupport;
	postGateGainStereoPeak: FeatureSupport;
	postGateGainStereoRms: FeatureSupport;
	postGateMute: FeatureSupport;
	postGateSolo: FeatureSupport;
	preFadeListen: FeatureSupport;
	preGateMute: FeatureSupport;
	reverb: FeatureSupport;
	rms: FeatureSupport;
	selectedLoudspeaker: FeatureSupport;
	signalGenerator: FeatureSupport;
	solo: FeatureSupport;
	stereoAutomixGain: FeatureSupport;
	stereoAutomixerGate: FeatureSupport;
	stereoGain: FeatureSupport;
	stereoPeak: FeatureSupport;
	stereoReverse: FeatureSupport;
	stereoRms: FeatureSupport;
	stereoWidth: FeatureSupport;
	talkSwitch: FeatureSupport;
	talkerHeight: FeatureSupport;
	toneGenerator: FeatureSupport;
	transmitterClip: FeatureSupport;
	usbOutputMode: FeatureSupport;
	voiceActivityDetectionNoiseReduction: FeatureSupport;
	voiceActivityDetectionSensitivity: FeatureSupport;
	wirelessEncryption: FeatureSupport;
};

/** Configuration of accessory talk switch buttons (wireless and battery operated) which allow the talent to control output audio routing for private conversations when mic'ed up */
export type AudioChannelTalkSwitch = {
	/** When null, the state of the battery is not known (e.g. talk switch is out of range or not detected via RF side channel) */
	batteryLevel: Maybe<TalkSwitchBatteryLevel | `${TalkSwitchBatteryLevel}`>;
	/** Output routing rules for each output supported by the device */
	outputRouting: TalkSwitchOutputRoutingConfiguration;
	/** When null, the state of the button press is not known (e.g. talk switch is out of range or is not detected via RF side channel) */
	pressed: Maybe<Scalars['Boolean']['output']>;
};

export type AudioChannelTalkSwitchChange = {
	talkSwitch: Maybe<AudioChannelTalkSwitch>;
};

export type AudioChannelTalkSwitchConstraints = {
	outputRouting: AudioChannelTalkSwitchOutputRoutingConstraints;
};

/** Indicates for each output type, which routing options are supported for the audio channel */
export type AudioChannelTalkSwitchOutputRoutingConstraints = {
	aes3: FieldSupport;
	dante: FieldSupport;
	danteAlternate: FieldSupport;
	trs: FieldSupport;
	xlr: FieldSupport;
};

export type AudioChannelTalkSwitchUpdateInput = {
	outputRouting: TalkSwitchOutputRoutingConfigurationInput;
};

/** Audio tracking information for a given talker. */
export type AudioChannelTalker = {
	/** Identifiers (unique within a device) for identifying an audio channel amongst the device's collection of audio channels. */
	audioChannel: NodeAndFragmentIds;
	/** Distance information (in millimeters) from the center of the device to an active talker. */
	position: TalkerPosition;
	/**
	 * Audio source type and confidence level information.
	 *
	 * Null if advanced talker tracking is disabled.
	 */
	voiceActivityDetection: Maybe<VoiceActivityDetection>;
};

/** height values are scaled to represent in millimeters (mm) */
export type AudioChannelTalkerHeight = {
	height: Scalars['Float']['output'];
};

export type AudioChannelTalkerHeightAutoFocusConstraints = IFieldSupportInfo & {
	height: Maybe<AudioChannelTalkerHeightAutoFocusFieldConstraints>;
	supported: Scalars['Boolean']['output'];
};

export type AudioChannelTalkerHeightAutoFocusFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelTalkerHeightChange = {
	talkerHeight: Maybe<AudioChannelTalkerHeight>;
};

export type AudioChannelTalkerHeightConstraints = {
	height: Maybe<AudioChannelTalkerHeightFieldConstraints>;
};

export type AudioChannelTalkerHeightFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelTalkerHeightFixedConstraints = {
	height: AudioChannelTalkerHeightFixedFieldConstraints;
};

export type AudioChannelTalkerHeightFixedFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioChannelTalkerHeightUpdateInput = {
	height: Scalars['Float']['input'];
};

export type AudioChannelTemplatesConstraints = {
	template: AudioChannelTemplatesOptionConstraints;
};

export type AudioChannelTemplatesOptionConstraints = {
	options: Array<Scalars['String']['output']>;
};

export type AudioChannelToneGenerator = {
	/** The frequency (in Hz) of the generated tone. */
	frequency: Scalars['Float']['output'];
	/**
	 * The gain (in dB) of the generated tone. Setting this value enabled the tone generator
	 * If set to null, the tone generator is disabled.
	 */
	gain: Maybe<Scalars['Int']['output']>;
};

export type AudioChannelToneGeneratorChange = {
	toneGenerator: Maybe<AudioChannelToneGenerator>;
};

export type AudioChannelToneGeneratorConstraints = {
	frequency: AudioChannelToneGeneratorFrequencyFieldConstraints;
	gain: AudioChannelToneGeneratorGainFieldConstraints;
};

export type AudioChannelToneGeneratorFrequencyFieldConstraints = {
	options: Array<Scalars['Float']['output']>;
};

export type AudioChannelToneGeneratorGainFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AudioChannelToneGeneratorUpdateInput = {
	frequency?: InputMaybe<Scalars['Float']['input']>;
	gain?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * When the incoming audio on a channel is clipping, but at the transmitter side (as opposed to the receiver side).
 * Mitigate by reducing transmitter's audio gain (a.k.a input pad) or by reducing the level of the audio to be captured.
 */
export type AudioChannelTransmitterClip = {
	clip: Scalars['Boolean']['output'];
};

export type AudioChannelTransmitterClipChange = {
	transmitterClip: Maybe<AudioChannelTransmitterClip>;
};

export type AudioChannelUpdateInput = {
	features?: InputMaybe<AudioChannelFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

/**
 * The USB output mode indicates how the output signal is processed by the USB audio output channel.
 *
 *
 * Mixdown Mode: USB sends “summed” input signals as one mono stream. Great for live-streaming interviews.
 *
 *
 * Tracking Mode: USB sends discrete streams for each input channel which are rendered as separate mono audio files. Great for multitrack recording and musicians recording voice and instrument who want to process their signals separately in post.
 *
 *
 * Stereo Mode: USB sends one Stereo stream that renders as a stereo file with preserved Left & Right stereo contents. Great for voiceover with stereo backing content, or emceeing over a stereo mixdown from a board.
 */
export type AudioChannelUsbOutputMode = {
	mode: UsbOutputMode | `${UsbOutputMode}`;
};

export type AudioChannelUsbOutputModeChange = {
	usbOutputMode: Maybe<AudioChannelUsbOutputMode>;
};

export type AudioChannelUsbOutputModeConstraints = {
	mode: Maybe<AudioChannelUsbOutputModeTypeConstraints>;
};

export type AudioChannelUsbOutputModeTypeConstraints = {
	options: Array<UsbOutputMode | `${UsbOutputMode}`>;
};

export type AudioChannelUsbOutputModeUpdateInput = {
	mode: UsbOutputMode | `${UsbOutputMode}`;
};

export type AudioChannelValidDenoiserLevelConstraints = {
	options: Array<DenoiserLevel | `${DenoiserLevel}`>;
};

export type AudioChannelValidOutputPathConstraints = {
	options: Array<OutputSignalPath | `${OutputSignalPath}`>;
};

export type AudioChannelVoiceActivityDetectionNoiseReduction = {
	level: NoiseRemovalLevel | `${NoiseRemovalLevel}`;
};

export type AudioChannelVoiceActivityDetectionNoiseReductionChange = {
	voiceActivityDetectionNoiseReduction: Maybe<AudioChannelVoiceActivityDetectionNoiseReduction>;
};

export type AudioChannelVoiceActivityDetectionNoiseReductionConstraints = {
	level: NoiseRemovalLevelConstraints;
};

export type AudioChannelVoiceActivityDetectionNoiseReductionUpdateInput = {
	level: NoiseRemovalLevel | `${NoiseRemovalLevel}`;
};

export type AudioChannelVoiceActivityDetectionSensitivity = {
	sensitivity: NoiseDetectionSensitivity | `${NoiseDetectionSensitivity}`;
};

export type AudioChannelVoiceActivityDetectionSensitivityChange = {
	voiceActivityDetectionSensitivity: Maybe<AudioChannelVoiceActivityDetectionSensitivity>;
};

export type AudioChannelVoiceActivityDetectionSensitivityConstraints = {
	sensitivity: NoiseDetectionSensitivityConstraints;
};

export type AudioChannelVoiceActivityDetectionSensitivityUpdateInput = {
	sensitivity: NoiseDetectionSensitivity | `${NoiseDetectionSensitivity}`;
};

export type AudioChannelWirelessEncryption = {
	mode: AudioChannelWirelessEncryptionMode | `${AudioChannelWirelessEncryptionMode}`;
};

export type AudioChannelWirelessEncryptionChange = {
	wirelessEncryption: Maybe<AudioChannelWirelessEncryption>;
};

export type AudioChannelWirelessEncryptionConstraints = {
	mode: AudioChannelWirelessEncryptionModeConstraints;
};

export type AudioChannelWirelessEncryptionInput = {
	mode: AudioChannelWirelessEncryptionMode | `${AudioChannelWirelessEncryptionMode}`;
};

export enum AudioChannelWirelessEncryptionMode {
	/** Turn encryption mode off */
	Off = 'OFF',
	/** Turn encryption mode on */
	On = 'ON',
	/** Turn encryption mode on with automatic key re-generation */
	OnAuto = 'ON_AUTO',
	/** Turn encryption mode on with manual key re-generation */
	OnManual = 'ON_MANUAL'
}

export type AudioChannelWirelessEncryptionModeConstraints = {
	options: Array<AudioChannelWirelessEncryptionMode | `${AudioChannelWirelessEncryptionMode}`>;
};

export type AudioCoverageArea = Fragment &
	Node & {
		description: AudioCoverageAreaDescription;
		features: AudioCoverageAreaFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type AudioCoverageAreaAutomixerGateMeter = {
	open: Scalars['Boolean']['output'];
};

export type AudioCoverageAreaChange = {
	features: AudioCoverageAreaFeatureChange;
	id: Scalars['ID']['output'];
};

export type AudioCoverageAreaConfiguration = {
	/** Indicates whether or not the coverage area is enabled or disabled */
	active: Scalars['Boolean']['output'];
	/** Coordinates of the rectangular bounds of the coverage area */
	coordinates: RectangularCoordinates;
	/**
	 * Dynamic coverage areas have flexible coverage; the microphone intelligently adapts to cover all talkers in the coverage area. Any talker within the boundaries of the coverage area will have microphone coverage (even as they move).
	 *
	 * With Dedicated coverage areas, the microphone assigns coverage to a fixed location all the time, whether a talker is there or not. Dedicated coverage is perfect for a podium or VIP seat that needs priority coverage at all times.
	 */
	type: AudioCoverageAreaType | `${AudioCoverageAreaType}`;
};

export type AudioCoverageAreaConfigurationChange = {
	configuration: Maybe<AudioCoverageAreaConfiguration>;
};

export type AudioCoverageAreaConfigurationConstraints = {
	type: AudioCoverageAreaTypeConstraints;
};

export type AudioCoverageAreaConstraints = {
	configuration: Maybe<AudioCoverageAreaConfigurationConstraints>;
	gain: Maybe<AudioCoverageAreaGainConstraints>;
	peak: Maybe<AudioCoverageAreaPeakMeterConstraints>;
	rms: Maybe<AudioCoverageAreaRmsMeterConstraints>;
};

export type AudioCoverageAreaDescription = {
	constraints: AudioCoverageAreaConstraints;
	features: AudioCoverageAreaSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type AudioCoverageAreaFeatureChange =
	| AudioCoverageAreaConfigurationChange
	| AudioCoverageAreaGainChange
	| AudioCoverageAreaMuteChange;

export type AudioCoverageAreaFeatureUpdateInput =
	| { gain: AudioCoverageAreaGainUpdateInput; mute?: never }
	| { gain?: never; mute: AudioCoverageAreaMuteUpdateInput };

export type AudioCoverageAreaFeatures = {
	automixerGate: Maybe<AudioCoverageAreaAutomixerGateMeter>;
	configuration: Maybe<AudioCoverageAreaConfiguration>;
	gain: Maybe<AudioCoverageAreaGain>;
	mute: Maybe<AudioCoverageAreaMute>;
	peak: Maybe<AudioCoverageAreaPeakMeter>;
	rms: Maybe<AudioCoverageAreaRmsMeter>;
};

export type AudioCoverageAreaGain = {
	gain: Scalars['Float']['output'];
};

export type AudioCoverageAreaGainChange = {
	gain: Maybe<AudioCoverageAreaGain>;
};

export type AudioCoverageAreaGainConstraints = {
	gain: Maybe<AudioCoverageAreaGainFieldConstraints>;
};

export type AudioCoverageAreaGainFieldConstraints = IFloatRangeConstraints & {
	/** Describes the range of values for the signal gain that are supported on the coverage area. */
	range: FloatRange;
};

export type AudioCoverageAreaGainUpdateInput = {
	gain: Scalars['Float']['input'];
};

export type AudioCoverageAreaMeterChange = {
	features: Maybe<AudioCoverageAreaMeterFeatureChange>;
	id: Scalars['ID']['output'];
};

export type AudioCoverageAreaMeterFeatureChange = {
	automixerGate: Maybe<AudioCoverageAreaAutomixerGateMeter>;
	peak: Maybe<AudioCoverageAreaPeakMeter>;
	rms: Maybe<AudioCoverageAreaRmsMeter>;
};

export type AudioCoverageAreaMute = {
	/** Indicates whether or not the coverage area is muted */
	muted: Scalars['Boolean']['output'];
};

export type AudioCoverageAreaMuteChange = {
	mute: Maybe<AudioCoverageAreaMute>;
};

export type AudioCoverageAreaMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type AudioCoverageAreaOperationResult = NodeOperationResult & {
	audioCoverageArea: Maybe<AudioCoverageArea>;
	error: Maybe<OperationError>;
};

export type AudioCoverageAreaPeakMeter = {
	level: Scalars['Float']['output'];
};

export type AudioCoverageAreaPeakMeterConstraints = {
	level: AudioCoverageAreaPeakMeterLevelConstraints;
};

export type AudioCoverageAreaPeakMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioCoverageAreaRmsMeter = {
	level: Scalars['Float']['output'];
};

export type AudioCoverageAreaRmsMeterConstraints = {
	level: Maybe<AudioCoverageRmsMeterLevelConstraints>;
};

export type AudioCoverageAreaSupportedFeatures = {
	automixerGate: FeatureSupport;
	configuration: FeatureSupport;
	gain: FeatureSupport;
	mute: FeatureSupport;
	peak: FeatureSupport;
	rms: FeatureSupport;
};

export type AudioCoverageAreaTalker = {
	/** Identifiers (unique within a device) for identifying an audio channel amongst the device's collection of audio channels. */
	audioCoverageArea: NodeAndFragmentIds;
	/**
	 * These states indicate the detection of a talker relative to audio coverage areas.
	 *
	 * Null if advanced talker tracking is disabled.
	 */
	audioCoverageAreaAffiliation: Maybe<CoverageAreaAffiliationType | `${CoverageAreaAffiliationType}`>;
	/** Distance information (in millimeters) from the center of the device to an active talker. */
	position: TalkerPosition;
	/**
	 * Audio source type and confidence level information.
	 *
	 * Null if advanced talker tracking is disabled.
	 */
	voiceActivityDetection: Maybe<VoiceActivityDetection>;
};

export enum AudioCoverageAreaType {
	Dedicated = 'DEDICATED',
	Dynamic = 'DYNAMIC'
}

export type AudioCoverageAreaTypeConstraints = {
	options: Array<RectangularAreaConstraints>;
};

export type AudioCoverageAreaUpdateInput = {
	features?: InputMaybe<AudioCoverageAreaFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export type AudioCoverageRmsMeterLevelConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AudioEncryptionSettingsInput = {
	id: Scalars['ID']['input'];
	passphrase: Scalars['String']['input'];
};

export type AudioInputLevelConstraints = {
	level: AudioInputLevelModeConstraints;
};

export type AudioInputLevelModeConstraints = {
	options: Array<AnalogLevel | `${AnalogLevel}`>;
};

export enum AudioMetersLightingMode {
	Breathing = 'BREATHING',
	Live = 'LIVE',
	Solid = 'SOLID'
}

export type AudioNetworkConfiguration = {
	gateway?: InputMaybe<Scalars['IpAddress']['input']>;
	ipAddress?: InputMaybe<Scalars['IpAddress']['input']>;
	ipMode: IpMode | `${IpMode}`;
	subnetMask?: InputMaybe<Scalars['IpAddress']['input']>;
};

export type AudioNetworkNameSyncInput = {
	id: Scalars['ID']['input'];
	/**
	 * By default, prior to setting Audio Network Channel Names, Shure (generic) channel names will be checked for conflicts.
	 * This validation can be skipped (if, perhaps, it has already been performed prior to invoking
	 * synchronization).
	 */
	validateChannelNameConflicts?: InputMaybe<Scalars['Boolean']['input']>;
	/**
	 * By default, prior to setting Audio Network Device Name, discovered devices will be checked for conflicts.
	 * This validation can be skipped (if, perhaps, it has already been performed prior to invoking synchronization).
	 */
	validateDeviceNameConflicts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudioNetworkNameSyncResult = {
	audioChannelNameConflicts: Maybe<Array<AudioChannelNameConflict>>;
	deviceNameConflicts: Maybe<Array<DeviceNameConflict>>;
	success: Scalars['Boolean']['output'];
};

export type AudioSummingModeConstraints = {
	options: Array<SummingMode | `${SummingMode}`>;
};

export enum AutoLevelConfiguration {
	Loud = 'LOUD',
	Normal = 'NORMAL',
	Quiet = 'QUIET'
}

export type AutoLevelConfigurationConstraints = IFieldSupportInfo & {
	options: Maybe<Array<AutoLevelConfiguration | `${AutoLevelConfiguration}`>>;
	subscribe: Scalars['Boolean']['output'];
	supported: Scalars['Boolean']['output'];
};

export enum AutoLevelMode {
	Auto = 'AUTO',
	Manual = 'MANUAL'
}

export type AutoLevelModeConstraints = IFieldSupportInfo & {
	options: Maybe<Array<AutoLevelMode | `${AutoLevelMode}`>>;
	supported: Scalars['Boolean']['output'];
};

export enum AutoLevelPosition {
	Far = 'FAR',
	Near = 'NEAR'
}

export type AutoLevelPositionConstraints = IFieldSupportInfo & {
	options: Maybe<Array<AutoLevelPosition | `${AutoLevelPosition}`>>;
	supported: Scalars['Boolean']['output'];
};

export enum AutoLevelTone {
	Bright = 'BRIGHT',
	Dark = 'DARK',
	Natural = 'NATURAL'
}

export type AutoLevelToneConstraints = IFieldSupportInfo & {
	options: Maybe<Array<AutoLevelTone | `${AutoLevelTone}`>>;
	supported: Scalars['Boolean']['output'];
};

export enum AutoPositionStatus {
	Failed = 'FAILED',
	Inactive = 'INACTIVE',
	Processing = 'PROCESSING',
	Recording = 'RECORDING'
}

export type AutomixGatingSensitivityConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type AutomixHoldTimeConstraints = IDurationRangeConstraints & {
	range: DurationRange;
};

export type AutomixMaxOpenChannelsConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export enum AutomixMode {
	/**
	 * Emulates the Shure SCM820 automixer default settings. It is renowned for fast-acting, seamless channel gating and consistent perceived ambient sound levels.
	 * Off-attenuation in this mode is fixed at -12dB per channel, regardless of the number of open channels.
	 */
	Classic = 'CLASSIC',
	/** Provides manual control over all automixing parameters. This mode is useful when adjustments must be made to one of the preset modes to fit a particular application. */
	Custom = 'CUSTOM',
	/**
	 * Dynamically balances system gain between open and closed audio channels.
	 * The system gain remains consistent by distributing gain across audio channels to equal one open audio channel.
	 * The scaled gain structure helps to reduce noise when there is a high audio channel count.
	 * When fewer audio channels are used, the off attenuation setting is lower and provides transparent gating.
	 */
	GainSharing = 'GAIN_SHARING',
	/**
	 * Delivers fast-acting, seamless audio channel gating and consistent perceived ambient sound levels.
	 * Off attenuation  is fixed at -20 dB, regardless of the number of open audio channels.
	 */
	Gating = 'GATING',
	/**
	 * Sums all active audio channels and sends the summed signal over a single Dante output.
	 * The gain of all audio channels apply to the summed output.
	 */
	Manual = 'MANUAL',
	/**
	 * Off-attenuation settings for each channel are scaled, depending on the number of open channels.
	 * The scaled gain structure helps to reduce noise when there is a high channel count.
	 * When fewer channels are used, the lower off-attenuation provides transparent gating.
	 */
	Smooth = 'SMOOTH'
}

export type AutomixModeConstraints = {
	options: Array<AutomixMode | `${AutomixMode}`>;
};

export type AutomixOffAttenuationConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type AutomixSourceSelectorInput = {
	/** Node Id of the channel where automixing is performed on a source channel */
	automix: Scalars['ID']['input'];
	/** Node Id of the source channel to be used as selector for automixing. Optional/Null represents a behavior to deselect a source channel if selected */
	source?: InputMaybe<Scalars['ID']['input']>;
};

export enum AutomixerInputDisengagedBehavior {
	FollowMuteColor = 'FOLLOW_MUTE_COLOR',
	Off = 'OFF'
}

export type AutomixerInputDisengagedBehaviorConstraints = {
	options: Array<AutomixerInputDisengagedBehavior | `${AutomixerInputDisengagedBehavior}`>;
};

/** The state machine describing the lifecycle of a battery-powered device. */
export enum BatteryState {
	Calculating = 'CALCULATING',
	Charging = 'CHARGING',
	Discharging = 'DISCHARGING',
	Empty = 'EMPTY',
	Full = 'FULL',
	OptimalStorage = 'OPTIMAL_STORAGE'
}

export type BetaDeviceIdentitity = {
	category: Scalars['String']['input'];
	versions: Array<Scalars['SemanticVersion']['input']>;
};

export enum BluetoothPower {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM'
}

export type BluetoothPowerConstraints = {
	options: Array<BluetoothPower | `${BluetoothPower}`>;
};

export enum BodypackMicrophoneMode {
	External = 'EXTERNAL',
	Internal = 'INTERNAL'
}

export type BodypackMicrophoneModeConstraints = {
	options: Array<BodypackMicrophoneMode | `${BodypackMicrophoneMode}`>;
};

export type BypassCredentialsInput = {
	accessLevel: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export enum CallStatus {
	InACall = 'IN_A_CALL',
	NotInACall = 'NOT_IN_A_CALL'
}

export type CancelPendingActivationLicenseInput = {
	activationKey: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export type Certificate8021XValidationResult = {
	certificateInfo: Maybe<CertificateInfo8021X>;
	error: Maybe<OperationError>;
};

export type CertificateInfo8021X = {
	expirationDate: Scalars['DateTime']['output'];
	hash: Maybe<Scalars['String']['output']>;
	issuer: Maybe<Scalars['String']['output']>;
	validFromDate: Scalars['DateTime']['output'];
};

export type CertificateInput = {
	anonymousId?: InputMaybe<Scalars['String']['input']>;
	clientCertificate?: InputMaybe<Scalars['String']['input']>;
	passphrase: Scalars['String']['input'];
	rootCertificate: Scalars['String']['input'];
	username: Scalars['String']['input'];
};

export type ChargerBay = Fragment &
	Node & {
		description: ChargerBayDescription;
		features: ChargerBayFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type ChargerBayAssociatedAccessPoint = {
	/** device and rfChannel fields are null when there is an association established with an access point but the access point isn't discovered */
	device: Maybe<Device>;
	lastKnownAssociationDetails: RfChannelLastKnownAssociationDetails;
	rfChannel: Maybe<RfChannel>;
};

export type ChargerBayAssociation = {
	/** associatedAccessPoint field is null when there is no association established with an access point */
	associatedAccessPoint: Maybe<ChargerBayAssociatedAccessPoint>;
};

export type ChargerBayAssociationChange = {
	association: Maybe<ChargerBayAssociation>;
};

export type ChargerBayBatteryCapacity = {
	/** There was a fault with the smart battery. To troubleshoot further, check the battery and the charger bay. */
	batteryFault: Scalars['Boolean']['output'];
	/** This indicates the total amount of energy the battery can currently hold. This value may decrease over time due to usage and battery wear. */
	current: Maybe<Scalars['Int']['output']>;
	/** Whether or not a battery is docked on the charger bay */
	docked: Scalars['Boolean']['output'];
	/** The energy storage capacity of the battery as specified by the manufacturer at the time of production. This represents the designed capacity the battery is expected to have when new. */
	manufactured: Maybe<Scalars['Int']['output']>;
	/** The maximum possible energy storage capacity the battery can reach under ideal conditions. This represents the upper limit of energy storage for the battery. */
	maximum: Maybe<Scalars['Int']['output']>;
};

export type ChargerBayBatteryCapacityChange = {
	batteryCapacity: Maybe<ChargerBayBatteryCapacity>;
};

export type ChargerBayBatteryHealth = {
	/** There was a fault with the smart battery. To troubleshoot further, check the battery and the charger bay. */
	batteryFault: Scalars['Boolean']['output'];
	/**
	 * The number of charge cycles this battery has been through.
	 * Null when batteryFault is true, or when docked is false.
	 */
	cycleCount: Maybe<Scalars['Int']['output']>;
	/** Whether or not a battery is docked on the charger bay */
	docked: Scalars['Boolean']['output'];
	/**
	 * The overall health of the battery, as a function of its maximum possible capacity when fully charged now relative to when it was manufactured.
	 * Null when batteryFault is true, or when docked is false
	 */
	percentage: Maybe<Scalars['Int']['output']>;
};

export type ChargerBayBatteryHealthChange = {
	batteryHealth: Maybe<ChargerBayBatteryHealth>;
};

export type ChargerBayBatteryHealthConstraints = {
	percentage: ChargerBayBatteryHealthPercentageConstraints;
};

export type ChargerBayBatteryHealthPercentageConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type ChargerBayBatteryTemperature = {
	/** There was a fault with the smart battery. To troubleshoot further, check the battery and the charger bay. */
	batteryFault: Scalars['Boolean']['output'];
	/** The current temperature of the docked battery measured in Celsius. */
	celsius: Maybe<Scalars['Int']['output']>;
	/** Whether or not a battery is docked on the charger bay */
	docked: Scalars['Boolean']['output'];
};

export type ChargerBayBatteryTemperatureChange = {
	batteryTemperature: Maybe<ChargerBayBatteryTemperature>;
};

export type ChargerBayChange = {
	features: ChargerBayFeatureChange;
	id: Scalars['ID']['output'];
};

export type ChargerBayChargingMode = {
	mode: Maybe<ChargingMode | `${ChargingMode}`>;
};

export type ChargerBayChargingModeChange = {
	chargingMode: Maybe<ChargerBayChargingMode>;
};

export type ChargerBayChargingModeConstraints = {
	mode: ChargingModeConstraints;
};

export type ChargerBayConstraints = {
	batteryHealth: Maybe<ChargerBayBatteryHealthConstraints>;
	/** @deprecated Proof of concept of charger bay on device.  Do not use. */
	chargingMode: Maybe<ChargerBayChargingModeConstraints>;
	dockedBatteryLevel: Maybe<ChargerBayDockedBatteryLevelConstraints>;
};

export type ChargerBayDescription = {
	constraints: ChargerBayConstraints;
	features: ChargerBaySupportedFeatures;
	index: Scalars['Int']['output'];
};

export enum ChargerBayDockAction {
	Dock = 'DOCK',
	Undock = 'UNDOCK'
}

export type ChargerBayDockedBattery = {
	/** There was a fault with the smart battery. To troubleshoot further, check the battery and the charger bay. */
	batteryFault: Scalars['Boolean']['output'];
	/** Null when nothing is docked. */
	batteryType: Maybe<ChargerBayDockedBatteryType | `${ChargerBayDockedBatteryType}`>;
	/** Whether or not a battery is docked on the charger bay. */
	docked: Scalars['Boolean']['output'];
	/** Whether or not the battery is docked within a peripheral. */
	installedInPeripheral: Scalars['Boolean']['output'];
};

export type ChargerBayDockedBatteryChange = {
	dockedBattery: Maybe<ChargerBayDockedBattery>;
};

/**
 * Battery condition describes factors affecting the ability of the charger to reach the target state.
 *
 * Batteries which are `NOMINAL` are operating within their designed specifications and charge or discharge normally.
 * Batteries which are `WARM` will continue towards their `targetState` with reduced performance.
 * Batteries which are `COLD` or `HOT` will not charge or discharge until they return to a safe temperature range.
 * Batteries in `PRECHARGE` will be trickle-charged attempting to return to `NOMINAL` condition.
 */
export enum ChargerBayDockedBatteryCondition {
	Cold = 'COLD',
	Hot = 'HOT',
	Nominal = 'NOMINAL',
	Precharge = 'PRECHARGE',
	Warm = 'WARM'
}

export type ChargerBayDockedBatteryConditionConstraints = {
	/** The eligible battery conditions reported by the charger. */
	options: Array<ChargerBayDockedBatteryCondition | `${ChargerBayDockedBatteryCondition}`>;
};

/** Describes the battery level and charge state of a docked battery */
export type ChargerBayDockedBatteryLevel = {
	/** The current level as a discrete number of bars. Each bar represents a specific range of battery percentage, providing a coarse representation of the remaining battery life. */
	bars: Scalars['Int']['output'];
	/** The current level of charge held by the docked battery, as a percentage */
	percentage: Scalars['Int']['output'];
	/** Status about the battery's remaining time to the state it is targetting, whether that be charging or discharging. */
	status: ChargerBayDockedBatteryStatus;
};

export type ChargerBayDockedBatteryLevelBarsConstraints = IIntRangeConstraints & {
	/** Describes the range of values (number of bars) for battery charge bars. */
	range: IntRange;
};

export type ChargerBayDockedBatteryLevelChange = {
	dockedBatteryLevel: Maybe<ChargerBayDockedBatteryLevel>;
};

export type ChargerBayDockedBatteryLevelConstraints = {
	/** Describes the range of valid bar values (number of bars) which can be reported by the docked battery. */
	bars: ChargerBayDockedBatteryLevelBarsConstraints;
	/** Describes the range of valid percentage values which can be reported by the docked battery. */
	percentage: ChargerBayDockedBatteryLevelPercentageConstraints;
	/** Describes the possible states of the charging state machine. */
	status: ChargerBayDockedBatteryLevelStatusConstraints;
};

export type ChargerBayDockedBatteryLevelPercentageConstraints = IIntRangeConstraints & {
	/** Describes the range of values for battery charge percentage */
	range: IntRange;
};

export type ChargerBayDockedBatteryLevelStateConstraints = {
	/** The eligible states in the battery state machine. */
	options: Array<ChargerBayDockedBatteryState | `${ChargerBayDockedBatteryState}`>;
};

export type ChargerBayDockedBatteryLevelStatusConstraints = {
	batteryCondition: ChargerBayDockedBatteryConditionConstraints;
	currentState: ChargerBayDockedBatteryLevelStateConstraints;
	targetState: ChargerBayDockedBatteryLevelStateConstraints;
};

/**
 * The states describing the lifecycle of a docked battery.
 *
 * The battery typically starts in the `CALCULATING` state when first docked. A charger in storage mode will transition it to a `CHARGING` or `DISCHARGING`
 * state based on the battery's state of charge and settle into `OPTIMAL_STORAGE` when the battery has reached the target maintenance voltage.
 * A charger in normal charging mode will transition to `CHARGING` if necessary before terminating at `FULL`.
 * A docked battery that is too hot or cold to be charged will remain in `CALCULATING` state until the temperature is back within the acceptable range.
 */
export enum ChargerBayDockedBatteryState {
	Calculating = 'CALCULATING',
	Charging = 'CHARGING',
	Discharging = 'DISCHARGING',
	Full = 'FULL',
	OptimalStorage = 'OPTIMAL_STORAGE'
}

export type ChargerBayDockedBatteryStatus = {
	/** Describes the current condition of the docked battery. */
	batteryCondition: ChargerBayDockedBatteryCondition | `${ChargerBayDockedBatteryCondition}`;
	/** Describes the instantaneous state of the docked battery. */
	currentState: ChargerBayDockedBatteryState | `${ChargerBayDockedBatteryState}`;
	/** Describes the desired terminal state of the docked battery based on the charger's configuration. */
	targetState: ChargerBayDockedBatteryState | `${ChargerBayDockedBatteryState}`;
	/**
	 * The estimated time to transition from the `currentState` to the `targetState`. Actual time may vary while charging or discharging.
	 * When transitioning between states (docking on a charger, undocking from a charger), a temporary calculating state will be entered.
	 * During this time, the time can be null.
	 */
	timeToTargetState: Maybe<Scalars['Duration']['output']>;
};

export enum ChargerBayDockedBatteryType {
	Axt901 = 'AXT901',
	Axt902 = 'AXT902',
	Sb900 = 'SB900',
	Sb910 = 'SB910',
	Sb910M = 'SB910M',
	Sb920 = 'SB920',
	Sb930 = 'SB930'
}

export type ChargerBayDockedDevice = {
	/** device field is null when there is a docked transmitter on the charger bay but the transmitter isn't discovered */
	device: Maybe<Device>;
};

export type ChargerBayDockedDeviceChange = {
	dockedDevice: Maybe<ChargerBayDockedDevice>;
};

export type ChargerBayFeatureChange =
	| ChargerBayAssociationChange
	| ChargerBayBatteryCapacityChange
	| ChargerBayBatteryHealthChange
	| ChargerBayBatteryTemperatureChange
	| ChargerBayChargingModeChange
	| ChargerBayDockedBatteryChange
	| ChargerBayDockedBatteryLevelChange
	| ChargerBayDockedDeviceChange;

export type ChargerBayFeatures = {
	association: Maybe<ChargerBayAssociation>;
	batteryCapacity: Maybe<ChargerBayBatteryCapacity>;
	batteryHealth: Maybe<ChargerBayBatteryHealth>;
	batteryTemperature: Maybe<ChargerBayBatteryTemperature>;
	/** @deprecated Proof of concept of charger bay on device.  Do not use. */
	chargingMode: Maybe<ChargerBayChargingMode>;
	dockedBattery: Maybe<ChargerBayDockedBattery>;
	dockedBatteryLevel: Maybe<ChargerBayDockedBatteryLevel>;
	dockedDevice: Maybe<ChargerBayDockedDevice>;
	testDockAction: Maybe<ChargerBayTestDockAction>;
};

export type ChargerBayLastKnownAssociationDetails = {
	/** charger bay slot of charger device associated to this device */
	chargerBaySlot: Scalars['Int']['output'];
	/** name of charger device associated to this device */
	deviceName: Scalars['String']['output'];
};

export type ChargerBayOperationResult = NodeOperationResult & {
	chargerBay: Maybe<ChargerBay>;
	error: Maybe<OperationError>;
};

export type ChargerBaySupportedFeatures = {
	association: FeatureSupport;
	batteryCapacity: FeatureSupport;
	batteryHealth: FeatureSupport;
	batteryTemperature: FeatureSupport;
	/** @deprecated Proof of concept of charger bay on device.  Do not use. */
	chargingMode: FeatureSupport;
	dockedBattery: FeatureSupport;
	dockedBatteryLevel: FeatureSupport;
	dockedDevice: FeatureSupport;
	linking: FeatureSupport;
	testDockAction: FeatureSupport;
};

export type ChargerBayTestDockAction = {
	dockAction: ChargerBayDockAction | `${ChargerBayDockAction}`;
};

export type ChargerBayTestDockActionUpdateInput = {
	dockAction: ChargerBayDockAction | `${ChargerBayDockAction}`;
	/** The chargerBay node ID to mutate */
	id: Scalars['ID']['input'];
};

export type ChargerSlot = Fragment &
	Node & {
		description: ChargerSlotDescription;
		features: ChargerSlotFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type ChargerSlotChange = {
	features: ChargerSlotFeatureChange;
	id: Scalars['ID']['output'];
};

export type ChargerSlotChargerBays = {
	chargerBays: Array<ChargerBay>;
};

export type ChargerSlotChargerBaysChange = {
	chargerBays: Maybe<ChargerSlotChargerBays>;
};

export type ChargerSlotChargingSlotTypeIdChange = {
	slotTypeId: Maybe<ChargerSlotTypeId>;
};

export type ChargerSlotChargingSlotTypeIdConstraints = {
	typeId: ChargingSlotTypeIdConstraints;
};

export type ChargerSlotConstraints = {
	/** @deprecated Proof of concept of charger slot on device.  Do not use. */
	slotTypeId: Maybe<ChargerSlotChargingSlotTypeIdConstraints>;
};

export type ChargerSlotDescription = {
	constraints: ChargerSlotConstraints;
	features: ChargerSlotSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type ChargerSlotFeatureChange =
	| ChargerSlotChargerBaysChange
	| ChargerSlotChargingSlotTypeIdChange
	| ChargerSlotFirmwareChange
	| ChargerSlotModelChange
	| ChargerSlotSerialNumberChange
	| ChargerSlotTemperatureChange;

export type ChargerSlotFeatures = {
	chargerBays: Maybe<ChargerSlotChargerBays>;
	firmware: Maybe<ChargerSlotFirmware>;
	model: Maybe<ChargerSlotModel>;
	serialNumber: Maybe<ChargerSlotSerialNumber>;
	/** @deprecated Proof of concept of charger slot on device.  Do not use. */
	slotTypeId: Maybe<ChargerSlotTypeId>;
	temperature: Maybe<ChargerSlotTemperature>;
};

export type ChargerSlotFirmware = {
	valid: Scalars['Boolean']['output'];
	version: Scalars['SemanticVersion']['output'];
};

export type ChargerSlotFirmwareChange = {
	firmware: Maybe<ChargerSlotFirmware>;
};

export type ChargerSlotModel = {
	model: Scalars['String']['output'];
};

export type ChargerSlotModelChange = {
	model: Maybe<ChargerSlotModel>;
};

export type ChargerSlotOperationResult = NodeOperationResult & {
	chargerSlot: Maybe<ChargerSlot>;
	error: Maybe<OperationError>;
};

export type ChargerSlotSerialNumber = {
	serialNumber: Scalars['String']['output'];
};

export type ChargerSlotSerialNumberChange = {
	serialNumber: Maybe<ChargerSlotSerialNumber>;
};

export type ChargerSlotSupportedFeatures = {
	chargerBays: FeatureSupport;
	firmware: FeatureSupport;
	model: FeatureSupport;
	serialNumber: FeatureSupport;
	/** @deprecated Proof of concept of charger slot on device.  Do not use. */
	slotTypeId: FeatureSupport;
	temperature: FeatureSupport;
};

export type ChargerSlotTemperature = {
	/** Charger slot case temperature in degrees celsius. */
	celsius: Scalars['Int']['output'];
	/** Indicates whether the charger slot case is over temperature. */
	overTemperature: Scalars['Boolean']['output'];
};

export type ChargerSlotTemperatureChange = {
	temperature: Maybe<ChargerSlotTemperature>;
};

export type ChargerSlotTypeId = {
	typeId: Maybe<ChargingSlotTypeIds | `${ChargingSlotTypeIds}`>;
};

export enum ChargingMode {
	Calculating = 'CALCULATING',
	Full = 'FULL',
	Normal = 'NORMAL',
	Warm = 'WARM',
	Warmandfull = 'WARMANDFULL'
}

export type ChargingModeConstraints = {
	options: Maybe<Array<ChargingMode | `${ChargingMode}`>>;
};

export type ChargingSlotTypeIdConstraints = {
	options: Array<ChargingSlotTypeIds | `${ChargingSlotTypeIds}`>;
};

export enum ChargingSlotTypeIds {
	Blackhawkbodypack = 'BLACKHAWKBODYPACK',
	Blackhawkhandheld = 'BLACKHAWKHANDHELD',
	Blackhawkmicrobodypack = 'BLACKHAWKMICROBODYPACK',
	Cylindrical = 'CYLINDRICAL',
	Line2Viva = 'LINE2VIVA',
	None = 'None',
	Odincasecharger = 'ODINCASECHARGER',
	Odintabletopcharger = 'ODINTABLETOPCHARGER',
	Prismatic = 'PRISMATIC',
	Sbc220Sb900Bodypackganged = 'SBC220SB900BODYPACKGANGED',
	Sbc240Blackhawkganged = 'SBC240BLACKHAWKGANGED',
	Sbc441 = 'SBC441',
	Sbc840Blackhawktray = 'SBC840BLACKHAWKTRAY',
	Sbc840Mblackhawkmicrobodypack = 'SBC840MBLACKHAWKMICROBODYPACK',
	Unrecognized = 'UNRECOGNIZED'
}

export type ClearAssociationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	result: Maybe<ClearedAssociation>;
};

export type ClearedAssociation = ChargerBay | RfChannel;

export type CloneRoomAudioRouteUpdateEvent = {
	audioRouteUpdate: CloneRoomAudioRouteUpdateEventDetails;
	originalRoom: Scalars['ID']['output'];
	progressPercentage: Maybe<Scalars['Int']['output']>;
};

export type CloneRoomAudioRouteUpdateEventDetails = {
	clonedAudioRoutes: Scalars['Int']['output'];
	totalAudioRoutes: Scalars['Int']['output'];
};

export type CloneRoomControlRouteUpdateEvent = {
	controlRouteUpdate: CloneRoomControlRouteUpdateEventDetails;
	originalRoom: Scalars['ID']['output'];
	progressPercentage: Maybe<Scalars['Int']['output']>;
};

export type CloneRoomControlRouteUpdateEventDetails = {
	clonedControlRoutes: Scalars['Int']['output'];
	totalControlRoutes: Scalars['Int']['output'];
};

export type CloneRoomDeviceUpdateEvent = {
	deviceUpdate: CloneRoomDeviceUpdateEventDetails;
	originalRoom: Scalars['ID']['output'];
	progressPercentage: Maybe<Scalars['Int']['output']>;
};

export type CloneRoomDeviceUpdateEventDetails = {
	clonedDevices: Scalars['Int']['output'];
	totalDevices: Scalars['Int']['output'];
};

export type CloneRoomEvent =
	| CloneRoomAudioRouteUpdateEvent
	| CloneRoomControlRouteUpdateEvent
	| CloneRoomDeviceUpdateEvent
	| CloneRoomResultEvent
	| CloneRoomStartedEvent;

export type CloneRoomInput = {
	cloningStrategy?: InputMaybe<RoomCloningStrategy | `${RoomCloningStrategy}`>;
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	sourceRoom: Scalars['ID']['input'];
};

export type CloneRoomResultEvent = {
	originalRoom: Scalars['ID']['output'];
	result: CloneRoomResultEventDetails;
};

export type CloneRoomResultEventDetails = {
	clonedRoom: Maybe<Scalars['ID']['output']>;
	conflict: Scalars['Boolean']['output'];
	status: CloneRoomStatus | `${CloneRoomStatus}`;
};

export type CloneRoomStartEventDetails = {
	clonedRoom: Scalars['ID']['output'];
};

export type CloneRoomStartedEvent = {
	originalRoom: Scalars['ID']['output'];
	progressPercentage: Maybe<Scalars['Int']['output']>;
	started: CloneRoomStartEventDetails;
};

export enum CloneRoomStatus {
	AudioRouteCloningFailed = 'AUDIO_ROUTE_CLONING_FAILED',
	Canceled = 'CANCELED',
	ControlRouteCloningFailed = 'CONTROL_ROUTE_CLONING_FAILED',
	DeviceCloningFailed = 'DEVICE_CLONING_FAILED',
	InternalPrecondFailed = 'INTERNAL_PRECOND_FAILED',
	MxwnAssociationCloningFailed = 'MXWN_ASSOCIATION_CLONING_FAILED',
	OriginRoomCompletePrecondFailed = 'ORIGIN_ROOM_COMPLETE_PRECOND_FAILED',
	OriginRoomConflictPrecondFailed = 'ORIGIN_ROOM_CONFLICT_PRECOND_FAILED',
	OriginRoomExistsprecondFailed = 'ORIGIN_ROOM_EXISTSPRECOND_FAILED',
	OriginRoomUnavailablePrecondFailed = 'ORIGIN_ROOM_UNAVAILABLE_PRECOND_FAILED',
	OrigRoomNonEmptyPrecondFailed = 'ORIG_ROOM_NON_EMPTY_PRECOND_FAILED',
	RoomCloningTimeout = 'ROOM_CLONING_TIMEOUT',
	RoomCreationFailed = 'ROOM_CREATION_FAILED',
	Success = 'SUCCESS'
}

export enum ColorTheme {
	Custom = 'CUSTOM',
	Default = 'DEFAULT',
	Fruity = 'FRUITY',
	Seaside = 'SEASIDE',
	Shure = 'SHURE',
	Space = 'SPACE'
}

export type ColorThemeConstraints = {
	options: Array<ColorTheme | `${ColorTheme}`>;
};

export enum CombinedFrontPanelAndPowerLockMode {
	MenuAndPowerLocked = 'MENU_AND_POWER_LOCKED',
	MenuLocked = 'MENU_LOCKED',
	Unlocked = 'UNLOCKED'
}

export type CombinedFrontPanelAndPowerLockModeConstraints = {
	options: Array<CombinedFrontPanelAndPowerLockMode | `${CombinedFrontPanelAndPowerLockMode}`>;
};

/** The means by which this API is communicating with the device */
export type CommunicationProtocol = {
	/** An address which uniquely identifies this device via its given communication protocol */
	address: Maybe<Scalars['String']['output']>;
	dmp: Maybe<DmpCommunicationProtocol>;
	type: Scalars['String']['output'];
};

/**
 * Describes the state of compatibility between this software, and the discovered device.
 * Different states may indicate a need to upgrade either the device firmware, or this software,
 * in order to use the latest available features.
 */
export enum CompatibilityLevel {
	/** The device firmware is the latest version tested with this software version. */
	CompatibleLatest = 'COMPATIBLE_LATEST',
	/**
	 * The device firmware is ahead of the latest version this software was tested with, but can be completely interacted with.
	 * There may be newer versions of this software which may interact with new features of this device.
	 */
	CompatibleNew = 'COMPATIBLE_NEW',
	/**
	 * The device firmware is behind the latest available, but can be completely interacted with.
	 * There are likely newer versions of firmware available for this device which may have additional features which could be interacted with.
	 * Updating the device's firmware is recommended.
	 */
	CompatibleOld = 'COMPATIBLE_OLD',
	/**
	 * The device firmware is not supported, and therefore no capability interaction is supported.
	 * Update this software to interact with the device.
	 */
	IncompatibleTooNew = 'INCOMPATIBLE_TOO_NEW',
	/**
	 * The device firmware is not supported, and therefore no capability interaction is supported.
	 * Update the device's firmware to interact with the device.
	 */
	IncompatibleTooOld = 'INCOMPATIBLE_TOO_OLD'
}

export enum CompressorLevel {
	Heavy = 'HEAVY',
	Light = 'LIGHT',
	Medium = 'MEDIUM',
	Off = 'OFF'
}

export enum ConferencingOperationMode {
	Conference = 'CONFERENCE',
	Custom = 'CUSTOM',
	Direct = 'DIRECT',
	Presentation = 'PRESENTATION'
}

export type ConferencingOperationModeConstraints = {
	options: Array<ConferencingOperationMode | `${ConferencingOperationMode}`>;
};

export enum ConferencingPlatform {
	MicrosoftTeams = 'MICROSOFT_TEAMS',
	Zoom = 'ZOOM'
}

export type ConfigInput8021X =
	| {
			eapMd5: UsernamePassphraseInput;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd?: never;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc: CertificateInput;
			peapMschapv2?: never;
			pwd?: never;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2: CertificateInput;
			pwd?: never;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd: UsernamePassphraseInput;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd?: never;
			tls: TlsCertificateInput;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd?: never;
			tls?: never;
			ttlsGtc: CertificateInput;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd?: never;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5: CertificateInput;
			ttlsMschapv2?: never;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd?: never;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2: CertificateInput;
			ttlsPap?: never;
	  }
	| {
			eapMd5?: never;
			peapGtc?: never;
			peapMschapv2?: never;
			pwd?: never;
			tls?: never;
			ttlsGtc?: never;
			ttlsMd5?: never;
			ttlsMschapv2?: never;
			ttlsPap: CertificateInput;
	  };

export type ConfigurationFilterTypeConstraints = {
	options: Maybe<Array<EqFilterType | `${EqFilterType}`>>;
	supported: Scalars['Boolean']['output'];
};

export type ConnectedDeviceLabel = {
	label: Scalars['String']['output'];
};

export type ConnectedDeviceLabelChange = {
	connectedDeviceLabel: Maybe<ConnectedDeviceLabel>;
};

export type ConnectedDeviceLabelConstraints = {
	label: ConnectedDeviceLabelFieldConstraints;
};

export type ConnectedDeviceLabelFieldConstraints = IUtf8StringMaxBytesConstraints & {
	utf8MaxBytes: Scalars['Int']['output'];
};

export type ConnectedDeviceLabelUpdateInput = {
	label: Scalars['String']['input'];
};

/** These states indicate the detection of a talker relative to audio coverage areas. */
export enum CoverageAreaAffiliationType {
	/** Talker is detected within a muted audio coverage area */
	InsideMuted = 'INSIDE_MUTED',
	/** Talker is detected within an unmuted audio coverage area */
	InsideUnmuted = 'INSIDE_UNMUTED',
	/** Talker is detected outstide of all defined audio coverage areas */
	Outside = 'OUTSIDE'
}

export enum CoverageMode {
	Automatic = 'AUTOMATIC',
	Manual = 'MANUAL'
}

export type CreateCredentialsInput = {
	accessLevel: Scalars['String']['input'];
	id: Scalars['ID']['input'];
	passphrase: Scalars['String']['input'];
};

export type CreateRoomInput = {
	created?: InputMaybe<Scalars['DateTime']['input']>;
	description: Scalars['String']['input'];
	devices: Array<Scalars['ID']['input']>;
	dimensions?: InputMaybe<RoomDimensionsInput>;
	name: Scalars['String']['input'];
};

export type CreateRouteOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	receiveDevice: Maybe<Device>;
	transmitDevice: Maybe<Device>;
};

export enum CredentialsState {
	InitializedNotSet = 'INITIALIZED_NOT_SET',
	Set = 'SET',
	Uninitialized = 'UNINITIALIZED'
}

export type CrossPoint = Fragment &
	Node & {
		description: CrossPointDescription;
		features: CrossPointFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
		inputChannel: CrossPointInputAudioChannel;
	};

export type CrossPointChange = {
	features: CrossPointFeatureChange;
	id: Scalars['ID']['output'];
};

export type CrossPointConfiguration = {
	/**
	 * Whether or not to route the input audio channel specified by this cross point node to
	 * the output audio channel specified by the audio channel implementing 'matrixMixerOutput' capability
	 */
	enabled: Maybe<Scalars['Boolean']['output']>;
};

export type CrossPointConfigurationChange = {
	configuration: Maybe<CrossPointConfiguration>;
};

export type CrossPointConfigurationUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrossPointConstraints = {
	gain: Maybe<CrossPointGainConstraints>;
};

export type CrossPointDescription = {
	constraints: CrossPointConstraints;
	features: CrossPointSupportedFeatures;
};

export type CrossPointFeatureChange = CrossPointConfigurationChange | CrossPointGainChange;

export type CrossPointFeatureUpdateInput = {
	configuration?: InputMaybe<CrossPointConfigurationUpdateInput>;
	gain?: InputMaybe<CrossPointGainUpdateInput>;
};

export type CrossPointFeatures = {
	configuration: Maybe<CrossPointConfiguration>;
	gain: Maybe<CrossPointGain>;
};

/** Gain applied to the input audio sent to the output channel */
export type CrossPointGain = {
	gain: Maybe<Scalars['Float']['output']>;
};

export type CrossPointGainChange = {
	gain: Maybe<CrossPointGain>;
};

export type CrossPointGainConstraints = {
	gain: Maybe<CrossPointGainFieldConstraints>;
};

export type CrossPointGainFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type CrossPointGainUpdateInput = {
	gain?: InputMaybe<Scalars['Float']['input']>;
};

export type CrossPointInputAudioChannel = AudioChannel | StereoAudioChannel;

export type CrossPointOperationResult = NodeOperationResult & {
	crossPoint: Maybe<CrossPoint>;
	error: Maybe<OperationError>;
};

export type CrossPointSupportedFeatures = {
	configuration: FeatureSupport;
	gain: FeatureSupport;
};

export type CrossPointUpdateInput = {
	features?: InputMaybe<CrossPointFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export enum DanteAudioEncryptionStatus {
	/** Audio encryption is enabled between the routed devices, and the symmetric encryption/decryiption key matches between the routed devices. */
	Active = 'ACTIVE',
	/**
	 * Audio encryption is inactive because of one or more of the following:
	 * 1) It is not enabled on this device, and/or the routed device
	 * 2) There is no route between this audio channel and another Shure device which supports Dante audio encryption.
	 */
	Inactive = 'INACTIVE',
	/**
	 * Audio encryption is enabled on this audio channel, but the symmetric encryption/decryiption does not match between the devices. No audio shall pass.
	 * This state will be represented on the audio receive channel, and not on the transmit audio channel (as the transmit audio channel can go to multiple receive channels, and the key may be a match for other receivers).
	 */
	KeyMismatch = 'KEY_MISMATCH'
}

export type DanteAudioRouteSubscription = {
	/** Whether or not the subscription is transmitting audio. */
	active: Scalars['Boolean']['output'];
	/**
	 * The name of the Dante subscription this receiver is subscribed to. E.g. DanteChannelName@DanteDeviceName.
	 * Replaces a self-subscription with the actual Dante device name.
	 */
	name: Scalars['String']['output'];
	/**
	 * Information about the Shure device transmitting audio. Null in the following conditions:
	 * 1) Rx is discovered before Tx which Rx is listening to
	 * 2) Third party device
	 */
	transmitter: Maybe<DanteAudioRouteTransmitter>;
};

export type DanteAudioRouteTransmitter = {
	/** AudioChannel of the Shure device transmitting audio. */
	audioChannel: AudioChannel;
	/** The Shure device transmitting audio. */
	device: Device;
};

export enum DanteDeviceLockStatus {
	Locked = 'LOCKED',
	NotAvailable = 'NOT_AVAILABLE',
	Unlocked = 'UNLOCKED'
}

export enum DanteDomainConnectionStatus {
	Connected = 'CONNECTED',
	Disconnected = 'DISCONNECTED',
	Initializing = 'INITIALIZING'
}

export type DanteDomainConnectionStatusConstraints = {
	options: Array<DanteDomainConnectionStatus | `${DanteDomainConnectionStatus}`>;
};

export enum DanteDomainLocalControlPolicy {
	ReadOnly = 'READ_ONLY',
	ReadWrite = 'READ_WRITE'
}

export type DanteDomainLocalControlPolicyConstraints = {
	options: Array<DanteDomainLocalControlPolicy | `${DanteDomainLocalControlPolicy}`>;
};

export enum DanteDomainRemoteControlPolicy {
	Guest = 'GUEST',
	None = 'NONE',
	Operator = 'OPERATOR'
}

export type DanteDomainRemoteControlPolicyConstraints = {
	options: Array<DanteDomainRemoteControlPolicy | `${DanteDomainRemoteControlPolicy}`>;
};

export enum DanteDomainType {
	Managed = 'MANAGED',
	Unmanaged = 'UNMANAGED'
}

export type DanteDomainTypeConstraints = {
	options: Array<DanteDomainType | `${DanteDomainType}`>;
};

export type DeactivateLicenseInput = {
	activationKey: Scalars['String']['input'];
	count: Scalars['Int']['input'];
	id: Scalars['ID']['input'];
};

export type DeleteDeviceResult = {
	error: Maybe<OperationError>;
	id: Scalars['ID']['output'];
	status: DeleteDeviceStatus | `${DeleteDeviceStatus}`;
};

export enum DeleteDeviceStatus {
	Fail = 'FAIL',
	NotDeletable = 'NOT_DELETABLE',
	Success = 'SUCCESS'
}

export type DeleteDevicesInput = {
	/** Node IDs of the virtual and offline devices to remove */
	ids: Array<Scalars['ID']['input']>;
};

export type DeleteDevicesResult = {
	results: Array<DeleteDeviceResult>;
};

export type DeleteRouteOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	receiveDevice: Maybe<Device>;
};

export enum DenoiserLevel {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM'
}

export enum DeverbIntensity {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM'
}

export type Device = Node & {
	/** The interface used by the device to advertise it's traits. */
	advertisedInterface: InterfaceDetails;
	compatibility: CompatibilityLevel | `${CompatibilityLevel}`;
	description: DeviceDescription;
	features: DeviceFeatures;
	hardwareId: Scalars['Guid']['output'];
	id: Scalars['ID']['output'];
	/**
	 * The most applicable interface known which is being used to interact with the device.
	 * When a matching interface is not available to the application,
	 * the application assumes forwards compatibility within the same interface ID major version.
	 * If the device's advertisedInterface is in a greater major version than is known by this API,
	 * then the interface presented here will be a different interface used to preserve the lowest
	 * common denominator of interactivity.
	 */
	interface: InterfaceDetails;
	manufacturer: Scalars['String']['output'];
	protocol: CommunicationProtocol;
	status: DeviceStatus | `${DeviceStatus}`;
	/** Whether or not the device being interacted with is virtualized to simulate the behavior of real hardware */
	virtual: Scalars['Boolean']['output'];
};

export enum DeviceActivePowerSource {
	/** if the DC Power module is not installed, this will always be AC_ONLY */
	AcOnly = 'AC_ONLY',
	AcPrimaryWithDcBackup = 'AC_PRIMARY_WITH_DC_BACKUP',
	DcOnly = 'DC_ONLY'
}

export type DeviceActivePreset = {
	activePreset: Maybe<UserPreset>;
};

export type DeviceActivePresetChange = {
	activePreset: Maybe<DeviceActivePreset>;
};

/**
 * Event emitted whenever a device is added under management
 * (e.g. discovered for the first time as DeviceState.Discovered)
 */
export type DeviceAdded = {
	added: Device;
};

export type DeviceAes3WordClock = {
	/** Current clock rate (Hz) */
	clockRate: Scalars['Int']['output'];
	clockSource: Aes3ClockSource | `${Aes3ClockSource}`;
	/** External clock rate (detected) */
	externalClock: Aes3ExternalClock;
	/** Internal clock rate */
	internalClock: Aes3InternalClock;
	/** Whether the word clock signal is terminated by this device */
	terminationSwitch: Aes3TerminationSwitch | `${Aes3TerminationSwitch}`;
};

export type DeviceAes3WordClockChange = {
	aes3WordClock: Maybe<DeviceAes3WordClock>;
};

export type DeviceAes3WordClockConstraints = {
	internalClock: DeviceAes3WordClockInternalClockConstraints;
};

export type DeviceAes3WordClockInternalClockConstraints = {
	clockRate: DeviceAes3WordClockInternalClockRateConstraints;
};

export type DeviceAes3WordClockInternalClockRateConstraints = {
	options: Array<Scalars['Int']['output']>;
};

export type DeviceAes3WordClockUpdateInput = {
	internalClock: Aes3InternalClockUpdateInput;
};

export type DeviceAllEqualizersBypass = {
	bypassed: Scalars['Boolean']['output'];
};

export type DeviceAllEqualizersBypassChange = {
	allEqualizersBypass: Maybe<DeviceAllEqualizersBypass>;
};

export type DeviceAllEqualizersBypassUpdateInput = {
	bypassed: Scalars['Boolean']['input'];
};

export type DeviceAllIntellimixBypass = {
	bypassed: Scalars['Boolean']['output'];
};

export type DeviceAllIntellimixBypassChange = {
	allIntellimixBypass: Maybe<DeviceAllIntellimixBypass>;
};

export type DeviceAllIntellimixBypassUpdateInput = {
	bypassed: Scalars['Boolean']['input'];
};

export type DeviceAnalogAudioOutputMode = {
	mode: AnalogAudioOutputMode | `${AnalogAudioOutputMode}`;
};

export type DeviceAnalogAudioOutputModeChange = {
	analogAudioOutputMode: Maybe<DeviceAnalogAudioOutputMode>;
};

export type DeviceAnalogAudioOutputModeConstraints = {
	mode: Maybe<AnalogAudioOutputModeConstraints>;
};

export type DeviceAnalogAudioOutputModeUpdateInput = {
	mode: AnalogAudioOutputMode | `${AnalogAudioOutputMode}`;
};

export type DeviceAnalogLogic = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceAnalogLogicChange = {
	analogLogic: Maybe<DeviceAnalogLogic>;
};

export type DeviceAnalogLogicPresetSwitch = {
	/** When analogLogic is enabled, a user can select which preset(1 or 2) will be loaded when there is signal. */
	mode: AnalogLogicPresetSwitch | `${AnalogLogicPresetSwitch}`;
};

export type DeviceAnalogLogicPresetSwitchChange = {
	analogLogicPresetSwitch: Maybe<DeviceAnalogLogicPresetSwitch>;
};

export type DeviceAnalogLogicPresetSwitchConstraints = {
	mode: Maybe<DeviceAnalogLogicPresetSwitchModeConstraints>;
};

export type DeviceAnalogLogicPresetSwitchModeConstraints = {
	options: Array<AnalogLogicPresetSwitch | `${AnalogLogicPresetSwitch}`>;
};

export type DeviceAnalogLogicPresetSwitchStatus = {
	status: AnalogLogicPresetSwitchStatus | `${AnalogLogicPresetSwitchStatus}`;
};

export type DeviceAnalogLogicPresetSwitchStatusChange = {
	analogLogicPresetSwitchStatus: Maybe<DeviceAnalogLogicPresetSwitchStatus>;
};

export type DeviceAnalogLogicPresetSwitchStatusConstraints = {
	status: Maybe<AnalogLogicPresetSwitchStatusConstraints>;
};

export type DeviceAnalogLogicPresetSwitchUpdateInput = {
	mode: AnalogLogicPresetSwitch | `${AnalogLogicPresetSwitch}`;
};

export type DeviceAnalogLogicUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceAnalytics = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceAnalyticsChange = {
	analytics: Maybe<DeviceAnalytics>;
};

export type DeviceAnalyticsUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceAntennaBiasVoltage = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceAntennaBiasVoltageChange = {
	antennaBiasVoltage: Maybe<DeviceAntennaBiasVoltage>;
};

export type DeviceAntennaBiasVoltageUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceAssignSpectrumManagerUpdateInput = {
	client: Scalars['ID']['input'];
	spectrumManager: Scalars['ID']['input'];
};

export type DeviceAssignedSpectrumManager = {
	/** The current spectrum manager for this device */
	device: Maybe<Device>;
	/** The last known spectrum manager that was assigned to this device */
	lastKnownSpectrumManager: Maybe<SpectrumManager>;
	/** A list of devices which could be this device's spectrum manager */
	spectrumManagerOptions: Array<Device>;
};

export type DeviceAssignedSpectrumManagerChange = {
	assignedSpectrumManager: Maybe<DeviceAssignedSpectrumManager>;
};

export type DeviceAssociationInput = {
	chargerBay: Scalars['ID']['input'];
	rfChannel: Scalars['ID']['input'];
};

export type DeviceAssociationResult = {
	chargerBay: Maybe<ChargerBay>;
	rfChannel: Maybe<RfChannel>;
	status: AssociationStatus | `${AssociationStatus}`;
};

export type DeviceAudioAutoFocus = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceAudioAutoFocusChange = {
	audioAutoFocus: Maybe<DeviceAudioAutoFocus>;
};

export type DeviceAudioAutoFocusUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceAudioChannelCount = {
	count: Scalars['Int']['output'];
};

export type DeviceAudioChannelCountChange = {
	audioChannelCount: Maybe<DeviceAudioChannelCount>;
};

export type DeviceAudioChannelCountConstraints = {
	count: DeviceAudioChannelCountCountConstraints;
};

export type DeviceAudioChannelCountCountConstraints = {
	options: Array<Scalars['Int']['output']>;
};

export type DeviceAudioChannelReassignmentInput = {
	/** The reassignment operation to execute (Replace, Swap) */
	operation: AudioChannelReassignmentOperation | `${AudioChannelReassignmentOperation}`;
	/** Audio channel which will act as the source for the reassignment */
	sourceId: Scalars['ID']['input'];
	/** Audio channel which will act as the target for the reassignment */
	targetId: Scalars['ID']['input'];
};

export type DeviceAudioChannelTemplates = {
	/** Null if no template is active */
	template: Maybe<Scalars['String']['output']>;
};

export type DeviceAudioChannelTemplatesChange = {
	audioChannelTemplates: Maybe<DeviceAudioChannelTemplates>;
};

export type DeviceAudioChannelTemplatesUpdateInput = {
	template: Scalars['String']['input'];
};

export type DeviceAudioChannels = {
	/** Audio channels present on the device */
	audioChannels: Array<AudioChannel>;
};

export type DeviceAudioChannelsChange = {
	audioChannels: Maybe<DeviceAudioChannels>;
};

export type DeviceAudioChannelsConstraints = {
	groupNames: Array<Scalars['AudioChannelGroupName']['output']>;
	/** @deprecated Use the 'groupName' field instead to ensure your code is open to extension to new audio channel groups. This enum is no longer preferred since it regularly breaks on expanding the available enum members to cover new channel groupings for new devices. */
	groups: Array<AudioChannelGroup | `${AudioChannelGroup}`>;
};

export type DeviceAudioCoverageAreas = {
	audioCoverageAreas: Array<AudioCoverageArea>;
};

export type DeviceAudioInputLevel = {
	level: AnalogLevel | `${AnalogLevel}`;
};

export type DeviceAudioInputLevelChange = {
	audioInputLevel: Maybe<DeviceAudioInputLevel>;
};

export type DeviceAudioInputLevelUpdateInput = {
	level: AnalogLevel | `${AnalogLevel}`;
};

export type DeviceAudioMute = {
	muted: Scalars['Boolean']['output'];
};

export type DeviceAudioMuteChange = {
	audioMute: Maybe<DeviceAudioMute>;
};

export type DeviceAudioMuteControl = {
	function: MuteControlFunction | `${MuteControlFunction}`;
	mode: MuteButtonMode | `${MuteButtonMode}`;
};

export type DeviceAudioMuteControlChange = {
	audioMuteControl: Maybe<DeviceAudioMuteControl>;
};

export type DeviceAudioMuteControlConstraints = {
	function: Maybe<DeviceAudioMuteControlFunctionConstraints>;
	mode: Maybe<DeviceAudioMuteControlModeConstraints>;
};

export type DeviceAudioMuteControlFunctionConstraints = {
	options: Array<MuteControlFunction | `${MuteControlFunction}`>;
};

export type DeviceAudioMuteControlGroup = {
	associatedDevices: Array<Device>;
};

export type DeviceAudioMuteControlGroupChange = {
	audioMuteControlGroup: Maybe<DeviceAudioMuteControlGroup>;
};

export type DeviceAudioMuteControlModeConstraints = {
	options: Array<MuteButtonMode | `${MuteButtonMode}`>;
};

export type DeviceAudioMuteControlUpdateInput = {
	function?: InputMaybe<MuteControlFunction | `${MuteControlFunction}`>;
	mode?: InputMaybe<MuteButtonMode | `${MuteButtonMode}`>;
};

export type DeviceAudioMuteDefault = {
	muted: Scalars['Boolean']['output'];
};

export type DeviceAudioMuteDefaultChange = {
	audioMuteDefault: Maybe<DeviceAudioMuteDefault>;
};

export type DeviceAudioMuteDefaultUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type DeviceAudioMuteLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceAudioMuteLockChange = {
	audioMuteLock: Maybe<DeviceAudioMuteLock>;
};

export type DeviceAudioMuteLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceAudioMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type DeviceAudioNetwork = {
	interface: NetworkInterfaceInfo;
};

export type DeviceAudioNetworkChange = {
	audioNetwork: Maybe<DeviceAudioNetwork>;
};

export type DeviceAudioNetworkInputChannelCount = {
	count: Scalars['Int']['output'];
};

export type DeviceAudioNetworkInterface = {
	available: Scalars['Boolean']['output'];
	interfaceOptions: Array<DeviceNetworkInterface>;
	selectedInterface: Maybe<DeviceNetworkInterface>;
};

export type DeviceAudioNetworkInterfaceChange = {
	audioNetworkInterface: Maybe<DeviceAudioNetworkInterface>;
};

export type DeviceAudioNetworkOutputChannelCount = {
	count: Scalars['Int']['output'];
};

export type DeviceAudioSumming = {
	clip: Scalars['Boolean']['output'];
	mode: SummingMode | `${SummingMode}`;
};

export type DeviceAudioSummingChange = {
	audioSumming: Maybe<DeviceAudioSumming>;
};

export type DeviceAudioSummingModeConstraints = {
	mode: AudioSummingModeConstraints;
};

export type DeviceAudioSummingUpdateInput = {
	mode: SummingMode | `${SummingMode}`;
};

export type DeviceAuracast = {
	available: Scalars['Boolean']['output'];
};

export type DeviceAuracastChange = {
	auracast: Maybe<DeviceAuracast>;
};

export type DeviceAuthenticationChange = {
	authentication: Maybe<DeviceAuthenticationStateChange>;
};

export type DeviceAuthenticationCredential = {
	accessLevel: Scalars['String']['output'];
	credentialsState: CredentialsState | `${CredentialsState}`;
};

export type DeviceAuthenticationState = {
	credentials: Maybe<Array<DeviceAuthenticationCredential>>;
};

export type DeviceAuthenticationStateChange = {
	credentials: Maybe<Array<DeviceAuthenticationCredential>>;
	verifyCredentialsRequired: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceAutomixGainMetering = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceAutomixGainMeteringChange = {
	automixGainMetering: Maybe<DeviceAutomixGainMetering>;
};

export type DeviceAutomixGainMeteringUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceAvailablePackages = {
	hostedPackages: Array<FirmwarePackage>;
	primaryPackages: Array<FirmwarePackage>;
};

export type DeviceAvailablePackagesChange = {
	availablePackages: Maybe<DeviceAvailablePackages>;
};

/** Describes the battery capacity of a battery-powered device */
export type DeviceBatteryCapacity = {
	/** This indicates the total amount of energy the battery can currently hold. This value may decrease over time due to usage and battery wear. */
	current: Scalars['Int']['output'];
	/** The energy storage capacity of the battery as specified by the manufacturer at the time of production. This represents the designed capacity the battery is expected to have when new. */
	manufactured: Scalars['Int']['output'];
	/** The maximum possible energy storage capacity the battery can reach under ideal conditions. This represents the upper limit of energy storage for the battery. */
	maximum: Scalars['Int']['output'];
};

export type DeviceBatteryCapacityChange = {
	batteryCapacity: Maybe<DeviceBatteryCapacity>;
};

export type DeviceBatteryHealth = {
	cycleCount: Scalars['Int']['output'];
	percentage: Scalars['Int']['output'];
};

export type DeviceBatteryHealthChange = {
	batteryHealth: Maybe<DeviceBatteryHealth>;
};

export type DeviceBatteryHealthConstraints = {
	percentage: DeviceBatteryHealthPercentageConstraints;
};

export type DeviceBatteryHealthPercentageConstraints = IIntRangeConstraints & {
	range: IntRange;
};

/** Describes the battery level of a battery-powered device */
export type DeviceBatteryLevel = {
	/**
	 * The current level as a discrete number of bars. Each bar represents a specific range of battery percentage, providing a coarse representation of the remaining battery life.
	 * If the device does not support this field (as indicated by field constraints), this value will be null.
	 */
	bars: Maybe<Scalars['Int']['output']>;
	/** The current level of charge held by the device's battery, as a percentage */
	percentage: Scalars['Int']['output'];
	/** Status about the battery's remaining time to the state it is targetting, whether that be charging or discharging partially or completely. */
	status: DeviceBatteryStatus;
};

export type DeviceBatteryLevelBarsConstraints = IFieldSupportInfo &
	INullableIntRangeConstraints & {
		/** Describes the range of values (number of bars) for battery charge bars. */
		range: Maybe<IntRange>;
		supported: Scalars['Boolean']['output'];
	};

export type DeviceBatteryLevelChange = {
	batteryLevel: Maybe<DeviceBatteryLevel>;
};

export type DeviceBatteryLevelConstraints = {
	/** Describes the range of valid bar values (number of bars) which can be reported by the battery-powered device. */
	bars: DeviceBatteryLevelBarsConstraints;
	/**
	 * Describes the range of valid percentage values which can be reported by the battery-powered device.
	 * E.g. Shure smart batteries can provide greater granularity about charge percentage than traditional AAs
	 * when a device is on-air.
	 */
	percentage: DeviceBatteryLevelPercentageConstraints;
	/** Describes the current status regarding the battery level, and any changes which are expected based on whether it is charging or discharging. */
	status: DeviceBatteryLevelStatusConstraints;
};

export type DeviceBatteryLevelPercentageConstraints = IIntRangeConstraints & {
	/** Describes the range of values for battery charge percentage */
	range: IntRange;
};

export type DeviceBatteryLevelStatusConstraints = {
	targetState: DeviceBatteryLevelTargetStateConstraints;
};

export type DeviceBatteryLevelTargetStateConstraints = {
	/**
	 * The possible states in the battery state machine for this device.
	 * E.g. Not all devices support "OPTIMAL_STORAGE", which allows for long time preservation of unused batteries.
	 */
	options: Array<BatteryState | `${BatteryState}`>;
};

/**
 * Provides low voltage alert functionality for external batteries, allowing users to monitor
 * and configure when they should be notified about low battery conditions.
 */
export type DeviceBatteryLowVoltageIndicator = {
	/** Whether the low voltage indicator is enabled */
	enabled: Scalars['Boolean']['output'];
	/** Whether the low voltage alert is currently engaged (threshold has been crossed) */
	engaged: Scalars['Boolean']['output'];
	/** The voltage threshold in millivolts at which the low voltage alert will trigger */
	threshold: Scalars['Int']['output'];
};

export type DeviceBatteryLowVoltageIndicatorChange = {
	batteryLowVoltageIndicator: Maybe<DeviceBatteryLowVoltageIndicator>;
};

export type DeviceBatteryLowVoltageIndicatorConstraints = {
	threshold: DeviceBatteryLowVoltageIndicatorThresholdConstraints;
};

export type DeviceBatteryLowVoltageIndicatorThresholdConstraints = IIntRangeConstraints & {
	/** The valid range for the threshold value in millivolts */
	range: IntRange;
};

export type DeviceBatteryLowVoltageIndicatorUpdateInput = {
	/** Enable or disable the low voltage indicator */
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	/** Set the voltage threshold in millivolts at which the low voltage alert will trigger */
	threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceBatteryStatus = {
	currentState: BatteryState | `${BatteryState}`;
	/** Describes the state machine of the battery both when the device is on the air or on the charger. */
	targetState: Maybe<BatteryState | `${BatteryState}`>;
	/**
	 * The estimated time to transition from the `currentState` to the `targetState`. Actual time may vary while charging or discharging.
	 * When transitioning between states (docking on a charger, undocking from a charger), a temporary calculating state will be entered.
	 * During this time, the time can be null.
	 */
	timeToTargetState: Maybe<Scalars['Duration']['output']>;
};

export type DeviceBatteryStorageMode = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceBatteryStorageModeChange = {
	batteryStorageMode: Maybe<DeviceBatteryStorageMode>;
};

export type DeviceBatteryStorageModeUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

/** Reports the current voltage of the device's battery */
export type DeviceBatteryVoltage = {
	/** The current battery voltage in millivolts. Returns null when the voltage is unknown or cannot be determined. */
	voltage: Maybe<Scalars['Int']['output']>;
};

export type DeviceBatteryVoltageChange = {
	batteryVoltage: Maybe<DeviceBatteryVoltage>;
};

export type DeviceBluetoothDeviceInformationService = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceBluetoothDeviceInformationServiceChange = {
	bluetoothDeviceInformationService: Maybe<DeviceBluetoothDeviceInformationService>;
};

export type DeviceBluetoothDeviceInformationServiceUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceBluetoothPower = {
	level: BluetoothPower | `${BluetoothPower}`;
};

export type DeviceBluetoothPowerChange = {
	bluetoothPower: Maybe<DeviceBluetoothPower>;
};

export type DeviceBluetoothPowerConstraints = {
	level: BluetoothPowerConstraints;
};

export type DeviceBluetoothPowerUpdateInput = {
	level: BluetoothPower | `${BluetoothPower}`;
};

export type DeviceBodypackMicrophoneMode = {
	mode: BodypackMicrophoneMode | `${BodypackMicrophoneMode}`;
};

export type DeviceBodypackMicrophoneModeChange = {
	bodypackMicrophoneMode: Maybe<DeviceBodypackMicrophoneMode>;
};

export type DeviceBodypackMicrophoneModeConstraints = {
	mode: Maybe<BodypackMicrophoneModeConstraints>;
};

export type DeviceBodypackMicrophoneModeUpdateInput = {
	mode: BodypackMicrophoneMode | `${BodypackMicrophoneMode}`;
};

export type DeviceCallStatus = {
	enabled: Scalars['Boolean']['output'];
	status: CallStatus | `${CallStatus}`;
};

export type DeviceCallStatusChange = {
	callStatus: Maybe<DeviceCallStatus>;
};

export type DeviceCallStatusUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceChange = {
	features: DeviceFeatureChange;
	id: Scalars['ID']['output'];
};

export type DeviceChargerBays = {
	chargerBays: Array<ChargerBay>;
};

export type DeviceChargerSlots = {
	chargerSlots: Array<ChargerSlot>;
};

/**
 * Provides front panel and power locking functionality for SLX-D devices, allowing users to lock
 * physical access to a device's onboard controls.
 */
export type DeviceCombinedFrontPanelAndPowerLock = {
	/**
	 * For SLX-D receivers, determines the current lock state.
	 * For SLX-D transmitters, determines the device lock behavior, when the device is locked.
	 */
	mode: CombinedFrontPanelAndPowerLockMode | `${CombinedFrontPanelAndPowerLockMode}`;
};

export type DeviceCombinedFrontPanelAndPowerLockChange = {
	combinedFrontPanelAndPowerLock: Maybe<DeviceCombinedFrontPanelAndPowerLock>;
};

export type DeviceCombinedFrontPanelAndPowerLockConstraints = {
	mode: CombinedFrontPanelAndPowerLockModeConstraints;
};

export type DeviceCombinedFrontPanelAndPowerLockUpdateInput = {
	mode: CombinedFrontPanelAndPowerLockMode | `${CombinedFrontPanelAndPowerLockMode}`;
};

export type DeviceCommandStringsService = {
	enabled: Scalars['Boolean']['output'];
	port: Scalars['Int']['output'];
};

export type DeviceCommandStringsServiceChange = {
	commandStringsService: Maybe<DeviceCommandStringsService>;
};

export type DeviceCommandStringsServiceConstraints = {
	port: DeviceCommandStringsServicePortConstraints;
};

export type DeviceCommandStringsServicePortConstraints = IIntRangeConstraints & {
	mutate: Scalars['Boolean']['output'];
	range: IntRange;
};

export type DeviceCommandStringsServiceUpdateInput = {
	enabled: Scalars['Boolean']['input'];
	port?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceConferencingOperationMode = {
	mode: ConferencingOperationMode | `${ConferencingOperationMode}`;
};

export type DeviceConferencingOperationModeButtonLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceConferencingOperationModeButtonLockChange = {
	conferencingOperationModeButtonLock: Maybe<DeviceConferencingOperationModeButtonLock>;
};

export type DeviceConferencingOperationModeButtonLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceConferencingOperationModeChange = {
	conferencingOperationMode: Maybe<DeviceConferencingOperationMode>;
};

export type DeviceConferencingOperationModeConstraints = {
	mode: ConferencingOperationModeConstraints;
};

export type DeviceConferencingOperationModeUpdateInput = {
	mode: ConferencingOperationMode | `${ConferencingOperationMode}`;
};

export type DeviceConferencingPlatform = {
	platform: ConferencingPlatform | `${ConferencingPlatform}`;
};

export type DeviceConferencingPlatformChange = {
	conferencingPlatform: Maybe<DeviceConferencingPlatform>;
};

export type DeviceConfigurationLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceConfigurationLockChange = {
	configurationLock: Maybe<DeviceConfigurationLock>;
};

export type DeviceConfigurationLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceConstraints = {
	aes3WordClock: Maybe<DeviceAes3WordClockConstraints>;
	analogAudioOutputMode: Maybe<DeviceAnalogAudioOutputModeConstraints>;
	analogLogicPresetSwitch: Maybe<DeviceAnalogLogicPresetSwitchConstraints>;
	analogLogicPresetSwitchStatus: Maybe<DeviceAnalogLogicPresetSwitchStatusConstraints>;
	audioChannelCount: Maybe<DeviceAudioChannelCountConstraints>;
	audioChannelTemplates: Maybe<AudioChannelTemplatesConstraints>;
	audioChannels: Maybe<DeviceAudioChannelsConstraints>;
	audioInputLevel: Maybe<AudioInputLevelConstraints>;
	audioMuteControl: Maybe<DeviceAudioMuteControlConstraints>;
	audioSumming: Maybe<DeviceAudioSummingModeConstraints>;
	batteryHealth: Maybe<DeviceBatteryHealthConstraints>;
	batteryLevel: Maybe<DeviceBatteryLevelConstraints>;
	batteryLowVoltageIndicator: Maybe<DeviceBatteryLowVoltageIndicatorConstraints>;
	bluetoothPower: Maybe<DeviceBluetoothPowerConstraints>;
	bodypackMicrophoneMode: Maybe<DeviceBodypackMicrophoneModeConstraints>;
	combinedFrontPanelAndPowerLock: Maybe<DeviceCombinedFrontPanelAndPowerLockConstraints>;
	commandStringsService: Maybe<DeviceCommandStringsServiceConstraints>;
	conferencingOperationMode: Maybe<DeviceConferencingOperationModeConstraints>;
	connectedDeviceLabel: Maybe<ConnectedDeviceLabelConstraints>;
	danteAudioNetwork: Maybe<DeviceDanteAudioNetworkConstraints>;
	danteDomainManagement: Maybe<DeviceDanteDomainManagementConstraints>;
	danteSampleRate: Maybe<DeviceDanteSampleRateConstraints>;
	dnsClientConfiguration: Maybe<DeviceDnsClientConfigurationConstraints>;
	dspDebugSettings: Maybe<DeviceDspDebugSettingsConstraints>;
	equalizerContour: Maybe<DeviceEqualizerContourConstraints>;
	ethernetPowerSource: Maybe<DeviceEthernetPowerSourceConstraints>;
	fanMode: Maybe<DeviceFanModeConstraints>;
	freqEng: Maybe<FrequencyEngineConstraints>;
	height: Maybe<DeviceHeightConstraints>;
	interferenceDetectionResolution: Maybe<DeviceInterferenceDetectionResolutionConstraints>;
	lightingAudioMeters: Maybe<DeviceLightingAudioMetersConstraints>;
	lightingAutomixGating: Maybe<DeviceLightingAutomixGatingConstraints>;
	lightingBehavior: Maybe<DeviceLightingBehaviorConstraints>;
	lightingBrightness: Maybe<DeviceLightingBrightnessConstraints>;
	lightingMuteBehavior: Maybe<DeviceLightingMuteBehaviorConstraints>;
	lightingRing: Maybe<DeviceLightingRingConstraints>;
	lightingSplitModeBreathingMeterColor: Maybe<DeviceLightingSplitModeMeterColorConstraints>;
	lightingSplitModeSolidMeterColor: Maybe<DeviceLightingSplitModeMeterColorConstraints>;
	lightingTouchPanelMode: Maybe<DeviceLightingTouchPanelModeConstraints>;
	lightingUnmuteBehavior: Maybe<DeviceLightingUnmuteBehaviorConstraints>;
	listenerHeight: Maybe<DeviceListenerHeightConstraints>;
	micSpatialOrientation: Maybe<DeviceMicSpatialOrientationConstraints>;
	name: Maybe<DeviceNameConstraints>;
	networkSwitchConfiguration: Maybe<DeviceNetworkSwitchConfigurationConstraints>;
	placement: Maybe<DevicePlacementConstraints>;
	rfBand: Maybe<DeviceRfBandConstraints>;
	rfDensityMode: Maybe<DeviceRfDensityModeConstraints>;
	rfPower: Maybe<DeviceRfPowerConstraints>;
	rfTransmissionProfile: Maybe<DeviceRfTransmissionProfileConstraints>;
	rotation: Maybe<DeviceRotationConstraints>;
	secondaryControlNetworkDnsClientConfiguration: Maybe<DeviceSecondaryControlNetworkDnsClientConfigurationConstraints>;
	security8021X: Maybe<DeviceSecurity8021XConstraints>;
	talkerTrackingConfig: Maybe<DeviceTalkerTrackingConfigConstraints>;
	transmitterInitialStateFromCharger: Maybe<DeviceTransmitterInitialStateFromChargerConstraints>;
	transmitterLightingBehavior: Maybe<DeviceTransmitterLightingBehaviorConstraints>;
	transmitterSwitchBehavior: Maybe<DeviceTransmitterSwitchBehaviorConstraints>;
	usbTerminalType: Maybe<DeviceUsbTerminalTypeConstraints>;
	userInterfacePreferences: Maybe<DeviceUserInterfacePreferencesConstraints>;
	userPerspective: Maybe<DeviceUserPerspectiveConstraints>;
	virtualAcousticBoundary: Maybe<DeviceVirtualAcousticBoundaryConstraints>;
	webService: DeviceWebServiceConstraints;
	wirelessEncryption: Maybe<DeviceWirelessEncryptionConstraints>;
};

export type DeviceControlNetwork = {
	interface: NetworkInterfaceInfo;
};

export type DeviceControlNetworkChange = {
	controlNetwork: Maybe<DeviceControlNetwork>;
};

export type DeviceControlNetworkInterface = {
	available: Scalars['Boolean']['output'];
	interfaceOptions: Array<DeviceNetworkInterface>;
	selectedInterface: Maybe<DeviceNetworkInterface>;
};

export type DeviceControlNetworkInterfaceChange = {
	controlNetworkInterface: Maybe<DeviceControlNetworkInterface>;
};

export type DeviceCoverageLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceCoverageLockChange = {
	coverageLock: Maybe<DeviceCoverageLock>;
};

export type DeviceCoverageLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceCoverageMode = {
	/**
	 * Automatic coverage mode will automatically adjust lobes within pre-defined coverage areas
	 * Manual coverage mode will require the user to manually adjust the position and width of each microphone lobe
	 */
	coverageMode: CoverageMode | `${CoverageMode}`;
};

export type DeviceCoverageModeChange = {
	coverageMode: Maybe<DeviceCoverageMode>;
};

export type DeviceCoverageModeUpdateInput = {
	coverageMode: CoverageMode | `${CoverageMode}`;
};

export type DeviceCoveragePositionChange = {
	coveragePosition: Maybe<DevicePosition>;
};

export type DeviceCoveragePositionInput = {
	xPosition: Scalars['Float']['input'];
	yPosition: Scalars['Float']['input'];
};

export type DeviceCrashReport = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceCrashReportChange = {
	crashReport: Maybe<DeviceCrashReport>;
};

export type DeviceCrashReportUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceDanteAudioEncryption = {
	enabled: Scalars['Boolean']['output'];
	passphraseSet: Scalars['Boolean']['output'];
};

export type DeviceDanteAudioEncryptionChange = {
	danteAudioEncryption: Maybe<DeviceDanteAudioEncryption>;
};

export type DeviceDanteAudioNetwork = {
	/** If null, this field is not supported on this device. */
	clockMuted: Maybe<Scalars['Boolean']['output']>;
	name: Scalars['String']['output'];
	/** If null, this field is not supported on this device. */
	nameConflict: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceDanteAudioNetworkAccess = {
	changesAllowed: Scalars['Boolean']['output'];
	factoryResetAllowed: Scalars['Boolean']['output'];
};

export type DeviceDanteAudioNetworkAccessChange = {
	danteAudioNetworkAccess: Maybe<DeviceDanteAudioNetworkAccess>;
};

export type DeviceDanteAudioNetworkChange = {
	danteAudioNetwork: Maybe<DeviceDanteAudioNetwork>;
};

export type DeviceDanteAudioNetworkConstraints = {
	clockMuted: FieldSupport;
	name: DeviceDanteAudioNetworkNameConstraints;
	nameConflict: FieldSupport;
};

export type DeviceDanteAudioNetworkNameConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type DeviceDanteAudioNetworkUpdateInput = {
	name: Scalars['String']['input'];
};

export type DeviceDanteDeviceLock = {
	/**
	 * Refer to Audinate documentation for information about this feature:
	 * https://dev.audinate.com/GA/dante-controller/userguide/webhelp/content/device_lock.htm?Highlight=lock
	 */
	status: DanteDeviceLockStatus | `${DanteDeviceLockStatus}`;
};

export type DeviceDanteDeviceLockChange = {
	danteDeviceLock: Maybe<DeviceDanteDeviceLock>;
};

export type DeviceDanteDomainManagement = {
	/**
	 * Dante Domain Manager Connection Status. Values:
	 * INITIALIZING - transient state
	 * DISCONNECTED - when there is no connection
	 * CONNECTED    - when there is connection
	 */
	connectionStatus: Maybe<DanteDomainConnectionStatus | `${DanteDomainConnectionStatus}`>;
	/**
	 * Local Control Policy reflects Dante Domain Manager setting Config of device with values:
	 * Allow in Dante Domain Manager - READ_WRITE - A local controller (such as front panel) can query or change device settings
	 * Prevent in Dante Domain Manager - READ_ONLY - A local controller (such as front panel) can query device settings but not change them
	 */
	localControlPolicy: Maybe<DanteDomainLocalControlPolicy | `${DanteDomainLocalControlPolicy}`>;
	/**
	 * Remote Control Policy reflects Dante Domain Manager setting Dante Network Role Media with values:
	 * None in Dante Domain Manager - NONE  - Remote controllers (such as Dante Controller) cannot query or change device settings
	 * Readonly in Dante Domain Manager - GUEST - Remote controllers (such as Dante Controller) can only query device settings
	 * Control in Dante Domain Manager - OPERATOR - Remote controllers (such as Dante Controller) can query or change device settings
	 */
	remoteControlPolicy: Maybe<DanteDomainRemoteControlPolicy | `${DanteDomainRemoteControlPolicy}`>;
	/**
	 * DanteDomainType has value MANAGED if device is managed by Dante Domain Manager (assigned to a domain).
	 * Value UNMANAGED if device is not managed by Dante Domain Manager (not assigned to a domain).
	 */
	type: Maybe<DanteDomainType | `${DanteDomainType}`>;
};

export type DeviceDanteDomainManagementChange = {
	danteDomainManagement: Maybe<DeviceDanteDomainManagement>;
};

export type DeviceDanteDomainManagementConstraints = {
	connectionStatus: DanteDomainConnectionStatusConstraints;
	localControlPolicy: DanteDomainLocalControlPolicyConstraints;
	remoteControlPolicy: DanteDomainRemoteControlPolicyConstraints;
	type: DanteDomainTypeConstraints;
};

/**
 * Provides Dante network audio sample rate configuration, allowing users to set
 * the sample rate for Dante audio transmission and reception.
 */
export type DeviceDanteSampleRate = {
	/** The current Dante sample rate in Hz */
	sampleRate: Scalars['Int']['output'];
};

export type DeviceDanteSampleRateChange = {
	danteSampleRate: Maybe<DeviceDanteSampleRate>;
};

export type DeviceDanteSampleRateConstraints = {
	sampleRate: DeviceDanteSampleRateFieldConstraints;
};

export type DeviceDanteSampleRateFieldConstraints = {
	/** Describes the available sample rate options in Hz */
	options: Array<Scalars['Int']['output']>;
};

export type DeviceDanteSampleRateInput = {
	sampleRate: Scalars['Int']['input'];
};

/** Information about the optional DC Power Module for both alternate and/or redundant device power options. */
export type DeviceDcPowerModule = {
	/** The active power source configuration of the device */
	activePowerSource: DeviceActivePowerSource | `${DeviceActivePowerSource}`;
	/** whether or not the DC Power Module has been installed */
	installed: Scalars['Boolean']['output'];
	/** The current temperature of the DC Power Module */
	temperature: Maybe<Temperature>;
};

export type DeviceDcPowerModuleChange = {
	dcPowerModule: Maybe<DeviceDcPowerModule>;
};

export type DeviceDebugMode = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceDebugModeChange = {
	debugMode: Maybe<DeviceDebugMode>;
};

export type DeviceDebugModeUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceDectChannelCount = {
	input: Scalars['Int']['output'];
	output: Scalars['Int']['output'];
};

export type DeviceDectRfSpectrumScan = {
	inProgress: Scalars['Boolean']['output'];
	results: DeviceDectRfSpectrumScanResults;
};

export type DeviceDectRfSpectrumScanChange = {
	dectRfSpectrumScan: Maybe<DeviceDectRfSpectrumScan>;
};

export type DeviceDectRfSpectrumScanChannelCountRange = {
	max: Scalars['Int']['output'];
	min: Scalars['Int']['output'];
};

export type DeviceDectRfSpectrumScanResult = {
	channelCounts: DeviceDectRfSpectrumScanResultByRfDensityMode;
	rfAvailability: DeviceDectRfSpectrumScanRfAvailability;
};

export type DeviceDectRfSpectrumScanResultByRfDensityMode = {
	highDensity: DeviceDectRfSpectrumScanResultChannelCounts;
	standardDensity: DeviceDectRfSpectrumScanResultChannelCounts;
};

export type DeviceDectRfSpectrumScanResultChannelCounts = {
	aggressive: DeviceDectRfSpectrumScanChannelCountRange;
	conservative: DeviceDectRfSpectrumScanChannelCountRange;
};

export type DeviceDectRfSpectrumScanResults = {
	cumulative: DeviceDectRfSpectrumScanResult;
	current: DeviceDectRfSpectrumScanResult;
};

export type DeviceDectRfSpectrumScanRfAvailability = {
	high: Scalars['Int']['output'];
	low: Scalars['Int']['output'];
	moderate: Scalars['Int']['output'];
};

/** The list of physical devices that can be deployed to from this (virtual) device. */
export type DeviceDeploymentCandidates = {
	candidates: Array<Device>;
};

export type DeviceDeploymentCandidatesChange = {
	deployment: Maybe<DeviceDeploymentCandidates>;
};

export type DeviceDeploymentInput = {
	/** Determines the name of the target device after deployment. If not set, the target device name will not change. */
	deviceName?: InputMaybe<Scalars['String']['input']>;
	sourceDevice: Scalars['ID']['input'];
	/**
	 * Syncs the Shure device and Channel names with the Dante device and channel names.
	 * If not set, Dante names on the target device will remain the same.
	 */
	syncDanteNamesWithShureNames?: InputMaybe<Scalars['Boolean']['input']>;
	targetDevice?: InputMaybe<Scalars['ID']['input']>;
};

export type DeviceDeploymentResult = {
	failureStage: DeviceDeploymentStage | `${DeviceDeploymentStage}`;
	sourceDevice: Device;
	targetDevice: Device;
};

export enum DeviceDeploymentStage {
	/** Inter-device deployment(Eg: Routing) */
	AssociationDeployment = 'ASSOCIATION_DEPLOYMENT',
	/** Generic handling of a device(Eg: Name) */
	GenericDeployment = 'GENERIC_DEPLOYMENT',
	/** Specialized handling of a device */
	SpecificDeployment = 'SPECIFIC_DEPLOYMENT'
}

export type DeviceDescription = {
	/** @deprecated Use advertisedInterface.category or interface.category instead */
	category: Scalars['String']['output'];
	constraints: DeviceConstraints;
	features: DeviceSupportedFeatures;
	/**
	 * The interface used to determine whether or not a feature is supported for the device.
	 *
	 * This often differs from the advertised interface of a device, and the interface
	 * used to communicate with the features of a device.
	 * If a discovered device is not in the range of supported interface IDs,
	 * most device features will be unavailable as means of preventing unsupported user interaction.
	 */
	interface: InterfaceDetails;
	/** @deprecated Use advertisedInterface.model or interface.model instead */
	model: Scalars['String']['output'];
	/** @deprecated Use CompatibilityLevel type for feature support */
	unsupported: Scalars['Boolean']['output'];
};

export type DeviceDisassociationInput = {
	chargerBay: Scalars['ID']['input'];
	rfChannel: Scalars['ID']['input'];
};

export type DeviceDisassociationResult = {
	chargerBay: Maybe<ChargerBay>;
	rfChannel: Maybe<RfChannel>;
	status: DisassociationStatus | `${DisassociationStatus}`;
};

export type DeviceDnsClientConfiguration = {
	/**
	 * The first array item is the primary server IP address
	 * and the second array item is the secondary server IP address
	 */
	automaticConfiguration: Array<Scalars['IpAddress']['output']>;
	/**
	 * The first array item is the primary server IP address
	 * and the second array item is the secondary server IP address
	 */
	manualConfiguration: Array<Scalars['IpAddress']['output']>;
	mode: DeviceDnsClientConfigurationMode | `${DeviceDnsClientConfigurationMode}`;
};

export type DeviceDnsClientConfigurationChange = {
	dnsClientConfiguration: Maybe<DeviceDnsClientConfiguration>;
};

export type DeviceDnsClientConfigurationConstraints = {
	automaticConfiguration: DeviceDnsClientConfigurationIpAddressArrayConstraints;
	manualConfiguration: DeviceDnsClientConfigurationIpAddressArrayConstraints;
	mode: DeviceDnsClientConfigurationModeConstraints;
};

export type DeviceDnsClientConfigurationIpAddressArrayConstraints = {
	length: Scalars['Int']['output'];
};

export enum DeviceDnsClientConfigurationMode {
	Automatic = 'AUTOMATIC',
	Manual = 'MANUAL'
}

export type DeviceDnsClientConfigurationModeConstraints = {
	options: Array<DeviceDnsClientConfigurationMode | `${DeviceDnsClientConfigurationMode}`>;
};

export type DeviceDoubleStuffProxiedTransmitters = {
	mic1: Maybe<DoubleStuffProxiedTransmitter>;
	mic2: Maybe<DoubleStuffProxiedTransmitter>;
};

export type DeviceDoubleStuffProxiedTransmittersChange = {
	doublestuffProxiedTransmitters: Maybe<DeviceDoubleStuffProxiedTransmitters>;
};

export type DeviceDspDebugAudioFenceLobes = {
	dspDebugAudioFenceLobes: Array<DspDebugAudioFenceLobe>;
};

export type DeviceDspDebugMode = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceDspDebugModeChange = {
	dspDebugMode: Maybe<DeviceDspDebugMode>;
};

export type DeviceDspDebugSettingsConstraints = {
	dspDebugSettings: Array<DeviceDspDebugSettingsDescriptionConstraints>;
};

export type DeviceDspDebugSettingsDescriptionConstraints = {
	blockId: Scalars['Int']['output'];
	description: DspParamBlockIdDescription | `${DspParamBlockIdDescription}`;
};

export type DeviceDspDebugSettingsEvent = {
	blockId: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	paramId: Scalars['Int']['output'];
	paramIndex: Scalars['Int']['output'];
	value: Scalars['Int']['output'];
};

export type DeviceDspDebugSettingsQueryInput = {
	blockId: Scalars['Int']['input'];
	id: Scalars['ID']['input'];
	paramId: Scalars['Int']['input'];
	paramIndex: Scalars['Int']['input'];
};

export type DeviceDspDebugSettingsUpdateInput = {
	blockId: Scalars['Int']['input'];
	id: Scalars['ID']['input'];
	paramId: Scalars['Int']['input'];
	paramIndex: Scalars['Int']['input'];
	value: Scalars['Int']['input'];
};

export type DeviceEdge = {
	cursor: Scalars['String']['output'];
	node: Maybe<Device>;
};

export type DeviceEqualizerContour = {
	equalizerContour: EqualizerContour | `${EqualizerContour}`;
};

export type DeviceEqualizerContourChange = {
	equalizerContour: Maybe<DeviceEqualizerContour>;
};

export type DeviceEqualizerContourConstraints = {
	equalizerContour: Maybe<DeviceEqualizerContourTypeConstraints>;
};

export type DeviceEqualizerContourTypeConstraints = {
	options: Array<EqualizerContour | `${EqualizerContour}`>;
};

export type DeviceEqualizerContourUpdateInput = {
	equalizerContour: EqualizerContour | `${EqualizerContour}`;
};

export type DeviceErrorIndicator = {
	state: ErrorIndicator | `${ErrorIndicator}`;
};

export type DeviceErrorIndicatorChange = {
	errorIndicator: Maybe<DeviceErrorIndicator>;
};

export type DeviceEthernetLights = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceEthernetLightsChange = {
	ethernetLights: Maybe<DeviceEthernetLights>;
};

export type DeviceEthernetLightsUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceEthernetPowerSource = {
	type: EthernetPowerSourceType | `${EthernetPowerSourceType}`;
};

export type DeviceEthernetPowerSourceConstraints = {
	type: DeviceEthernetPowerSourceTypeConstraints;
};

export type DeviceEthernetPowerSourceTypeConstraints = {
	options: Array<EthernetPowerSourceType | `${EthernetPowerSourceType}`>;
};

export type DeviceExternalDisplays = {
	displays: Array<ExternalDisplay>;
};

export type DeviceExternalDisplaysChange = {
	externalDisplays: Maybe<DeviceExternalDisplays>;
};

export type DeviceFanMode = {
	mode: Maybe<FanMode | `${FanMode}`>;
};

export type DeviceFanModeChange = {
	fanMode: Maybe<DeviceFanMode>;
};

export type DeviceFanModeConstraints = {
	mode: DeviceFanModeModeConstraints;
};

export type DeviceFanModeModeConstraints = {
	options: Array<FanMode | `${FanMode}`>;
};

export type DeviceFanModeUpdateInput = {
	mode: FanMode | `${FanMode}`;
};

export type DeviceFeatureChange =
	| ConnectedDeviceLabelChange
	| DeviceActivePresetChange
	| DeviceAes3WordClockChange
	| DeviceAllEqualizersBypassChange
	| DeviceAllIntellimixBypassChange
	| DeviceAnalogAudioOutputModeChange
	| DeviceAnalogLogicChange
	| DeviceAnalogLogicPresetSwitchChange
	| DeviceAnalogLogicPresetSwitchStatusChange
	| DeviceAnalyticsChange
	| DeviceAntennaBiasVoltageChange
	| DeviceAssignedSpectrumManagerChange
	| DeviceAudioAutoFocusChange
	| DeviceAudioChannelCountChange
	| DeviceAudioChannelTemplatesChange
	| DeviceAudioChannelsChange
	| DeviceAudioInputLevelChange
	| DeviceAudioMuteChange
	| DeviceAudioMuteControlChange
	| DeviceAudioMuteControlGroupChange
	| DeviceAudioMuteDefaultChange
	| DeviceAudioMuteLockChange
	| DeviceAudioNetworkChange
	| DeviceAudioNetworkInterfaceChange
	| DeviceAudioSummingChange
	| DeviceAuracastChange
	| DeviceAuthenticationChange
	| DeviceAutomixGainMeteringChange
	| DeviceAvailablePackagesChange
	| DeviceBatteryCapacityChange
	| DeviceBatteryHealthChange
	| DeviceBatteryLevelChange
	| DeviceBatteryLowVoltageIndicatorChange
	| DeviceBatteryStorageModeChange
	| DeviceBatteryVoltageChange
	| DeviceBluetoothDeviceInformationServiceChange
	| DeviceBluetoothPowerChange
	| DeviceBodypackMicrophoneModeChange
	| DeviceCallStatusChange
	| DeviceCombinedFrontPanelAndPowerLockChange
	| DeviceCommandStringsServiceChange
	| DeviceConferencingOperationModeButtonLockChange
	| DeviceConferencingOperationModeChange
	| DeviceConferencingPlatformChange
	| DeviceConfigurationLockChange
	| DeviceControlNetworkChange
	| DeviceControlNetworkInterfaceChange
	| DeviceCoverageLockChange
	| DeviceCoverageModeChange
	| DeviceCoveragePositionChange
	| DeviceCrashReportChange
	| DeviceDanteAudioEncryptionChange
	| DeviceDanteAudioNetworkAccessChange
	| DeviceDanteAudioNetworkChange
	| DeviceDanteDeviceLockChange
	| DeviceDanteDomainManagementChange
	| DeviceDanteSampleRateChange
	| DeviceDcPowerModuleChange
	| DeviceDebugModeChange
	| DeviceDectRfSpectrumScanChange
	| DeviceDeploymentCandidatesChange
	| DeviceDnsClientConfigurationChange
	| DeviceDoubleStuffProxiedTransmittersChange
	| DeviceDspDebugModeChange
	| DeviceEqualizerContourChange
	| DeviceErrorIndicatorChange
	| DeviceEthernetLightsChange
	| DeviceExternalDisplaysChange
	| DeviceFanModeChange
	| DeviceFirmwareUpdatePolicyChange
	| DeviceFirmwareUpdateRequestsChange
	| DeviceFrequencyEngineChange
	| DeviceFrontPanelGainLockChange
	| DeviceFrontPanelLockChange
	| DeviceFrontPanelScanLockChange
	| DeviceFrontPanelSyncLockChange
	| DeviceGatewayDeviceChange
	| DeviceGlobalMicStatusChange
	| DeviceHeightChange
	| DeviceHostedFirmwareChange
	| DeviceHostedUpdateProgressChange
	| DeviceIdentifyChange
	| DeviceInterferenceDetectionResolutionChange
	| DeviceInternetOfThingsChange
	| DeviceIotRoomProxyChange
	| DeviceLicenseChange
	| DeviceLicenseChangeV2
	| DeviceLicenseChangeV3
	| DeviceLicenseNetworkInterfaceChange
	| DeviceLightingAudioActivityChange
	| DeviceLightingAudioMetersChange
	| DeviceLightingAudioMuteIndicatorOverrideChange
	| DeviceLightingAutomixGatingChange
	| DeviceLightingBehaviorChange
	| DeviceLightingBrightnessChange
	| DeviceLightingLiveAudioMetersChange
	| DeviceLightingMuteBehaviorChange
	| DeviceLightingRingChange
	| DeviceLightingSegmentsBehaviorChange
	| DeviceLightingSplitModeBreathingMeterColorChange
	| DeviceLightingSplitModeSolidMeterColorChange
	| DeviceLightingTouchPanelModeChange
	| DeviceLightingUnmuteBehaviorChange
	| DeviceLinkButtonLockChange
	| DeviceLinkedAccessPointChange
	| DeviceListenerHeightChange
	| DeviceLogicMuteChange
	| DeviceLogicReceiverChange
	| DeviceLogicTransmitterChange
	| DeviceLoudspeakerChange
	| DeviceMdnsServiceChange
	| DeviceMeteringModesChange
	| DeviceMicSpatialOrientationChange
	| DeviceMicStatusChange
	| DeviceMicStatusV2Change
	| DeviceMultiArrayLocalizationGroupReporterChange
	| DeviceMuteButtonLockChange
	| DeviceNameChange
	| DeviceNetworkSwitchConfigurationChange
	| DeviceOnChargerChange
	| DevicePlacementChange
	| DevicePowerSwitchLockChange
	| DeviceProxiedDevicesChange
	| DeviceQuadversityChange
	| DeviceRebootPendingChange
	| DeviceRedundantAudioNetworkChange
	| DeviceRfBandChange
	| DeviceRfChannelsChange
	| DeviceRfCurrentDrawChange
	| DeviceRfDensityModeChange
	| DeviceRfMuteChange
	| DeviceRfPowerChange
	| DeviceRfTransmissionProfileChange
	| DeviceRoomChange
	| DeviceRotationChange
	| DeviceRoutingPositionChange
	| DeviceSecondaryControlNetworkChange
	| DeviceSecondaryControlNetworkDnsClientConfigurationChange
	| DeviceSecondaryEthernetPortChange
	| DeviceSecurity8021XChange
	| DeviceSmartGateChange
	| DeviceStereoAudioChange
	| DeviceTagsChange
	| DeviceTalkerTrackingConfigChange
	| DeviceTemperatureChange
	| DeviceTransmitterIdentifyBehaviorChange
	| DeviceTransmitterInitialStateFromChargerChange
	| DeviceTransmitterLightingBehaviorChange
	| DeviceTransmitterMuteBehaviorChange
	| DeviceTransmitterOutOfRangeBehaviorChange
	| DeviceTransmitterRejoinBehaviorChange
	| DeviceTransmitterSwitchBehaviorChange
	| DeviceUpdateProgressChange
	| DeviceUptimeChange
	| DeviceUsbConnectionChange
	| DeviceUsbMuteSyncChange
	| DeviceUsbTerminalTypeChange
	| DeviceUserInterfacePreferencesChange
	| DeviceUserPerspectiveChange
	| DeviceUserPresetsChange
	| DeviceVirtualAcousticBoundaryChange
	| DeviceWebServiceChange
	| DeviceWirelessEncryptionChange;

export type DeviceFeatureUpdateInput =
	| {
			aes3WordClock: DeviceAes3WordClockUpdateInput;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass: DeviceAllEqualizersBypassUpdateInput;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass: DeviceAllIntellimixBypassUpdateInput;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode: DeviceAnalogAudioOutputModeUpdateInput;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic: DeviceAnalogLogicUpdateInput;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch: DeviceAnalogLogicPresetSwitchUpdateInput;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics: DeviceAnalyticsUpdateInput;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage: DeviceAntennaBiasVoltageUpdateInput;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus: DeviceAudioAutoFocusUpdateInput;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates: DeviceAudioChannelTemplatesUpdateInput;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel: DeviceAudioInputLevelUpdateInput;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute: DeviceAudioMuteUpdateInput;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl: DeviceAudioMuteControlUpdateInput;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault: DeviceAudioMuteDefaultUpdateInput;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock: DeviceAudioMuteLockUpdateInput;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming: DeviceAudioSummingUpdateInput;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering: DeviceAutomixGainMeteringUpdateInput;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator: DeviceBatteryLowVoltageIndicatorUpdateInput;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode: DeviceBatteryStorageModeUpdateInput;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService: DeviceBluetoothDeviceInformationServiceUpdateInput;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower: DeviceBluetoothPowerUpdateInput;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode: DeviceBodypackMicrophoneModeUpdateInput;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus: DeviceCallStatusUpdateInput;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock: DeviceCombinedFrontPanelAndPowerLockUpdateInput;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService: DeviceCommandStringsServiceUpdateInput;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode: DeviceConferencingOperationModeUpdateInput;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock: DeviceConferencingOperationModeButtonLockUpdateInput;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock: DeviceConfigurationLockUpdateInput;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel: ConnectedDeviceLabelUpdateInput;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock: DeviceCoverageLockUpdateInput;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode: DeviceCoverageModeUpdateInput;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition: DeviceCoveragePositionInput;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport: DeviceCrashReportUpdateInput;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork: DeviceDanteAudioNetworkUpdateInput;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate: DeviceDanteSampleRateInput;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode: DeviceDebugModeUpdateInput;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour: DeviceEqualizerContourUpdateInput;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights: DeviceEthernetLightsUpdateInput;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode: DeviceFanModeUpdateInput;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy: DeviceFirmwareUpdatePolicyUpdateInput;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng: DeviceFrequencyEngineUpdateInput;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock: DeviceFrontPanelGainLockUpdateInput;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock: DeviceFrontPanelLockUpdateInput;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock: DeviceFrontPanelScanLockUpdateInput;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock: DeviceFrontPanelSyncLockUpdateInput;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height: DeviceHeightUpdateInput;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution: DeviceInterferenceDetectionResolutionUpdateInput;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings: DeviceInternetOfThingsUpdateInput;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy: DeviceIotRoomProxyUpdateInput;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity: DeviceLightingAudioActivityUpdateInput;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters: DeviceLightingAudioMetersUpdateInput;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride: DeviceLightingAudioMuteIndicatorOverrideUpdateInput;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating: DeviceLightingAutomixGatingUpdateInput;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters: DeviceLightingLiveAudioMetersUpdateInput;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior: DeviceLightingBehaviorUpdateInput;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing: DeviceLightingRingUpdateInput;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor: DeviceLightingSplitModeMeterColorUpdateInput;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor: DeviceLightingSplitModeMeterColorUpdateInput;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode: DeviceLightingTouchPanelModeUpdateInput;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior: DeviceLightingBehaviorUpdateInput;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock: DeviceLinkButtonLockUpdateInput;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight: DeviceListenerHeightUpdateInput;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute: DeviceLogicMuteUpdateInput;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver: DeviceLogicReceiverUpdateInput;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker: DeviceLoudspeakerUpdateInput;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService: DeviceMdnsServiceUpdateInput;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes: DeviceMeteringModesUpdateInput;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation: DeviceMicSpatialOrientationUpdateInput;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus: DeviceMicStatusUpdateInput;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock: DeviceMuteButtonLockUpdateInput;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name: DeviceNameUpdateInput;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement: DevicePlacementUpdateInput;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock: DevicePowerSwitchLockUpdateInput;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand: DeviceRfBandUpdateInput;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode: DeviceRfDensityModeUpdateInput;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower: DeviceRfPowerUpdateInput;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation: DeviceRotationUpdateInput;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition: DeviceRoutingPositionInput;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort: DeviceSecondaryEthernetPortUpdateInput;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate: DeviceSmartGateUpdateInput;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio: DeviceStereoAudioUpdateInput;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig: DeviceTalkerTrackingConfigUpdateInput;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior: DeviceTransmitterIdentifyBehaviorInput;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger: DeviceTransmitterInitialStateFromChargerInput;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior: DeviceTransmitterLightingBehaviorUpdateInput;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior: DeviceTransmitterMuteBehaviorUpdateInput;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior: DeviceTransmitterOutOfRangeBehaviorInput;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior: DeviceTransmitterRejoinBehaviorInput;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior: DeviceTransmitterSwitchBehaviorUpdateInput;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync: DeviceUsbMuteSyncUpdateInput;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType: DeviceUsbTerminalTypeUpdateInput;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective: DeviceUserPerspectiveUpdateInput;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary: DeviceVirtualAcousticBoundaryUpdateInput;
			webService?: never;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService: DeviceWebServiceUpdateInput;
			wirelessEncryption?: never;
	  }
	| {
			aes3WordClock?: never;
			allEqualizersBypass?: never;
			allIntellimixBypass?: never;
			analogAudioOutputMode?: never;
			analogLogic?: never;
			analogLogicPresetSwitch?: never;
			analytics?: never;
			antennaBiasVoltage?: never;
			audioAutoFocus?: never;
			audioChannelTemplates?: never;
			audioInputLevel?: never;
			audioMute?: never;
			audioMuteControl?: never;
			audioMuteDefault?: never;
			audioMuteLock?: never;
			audioSumming?: never;
			automixGainMetering?: never;
			batteryLowVoltageIndicator?: never;
			batteryStorageMode?: never;
			bluetoothDeviceInformationService?: never;
			bluetoothPower?: never;
			bodypackMicrophoneMode?: never;
			callStatus?: never;
			combinedFrontPanelAndPowerLock?: never;
			commandStringsService?: never;
			conferencingOperationMode?: never;
			conferencingOperationModeButtonLock?: never;
			configurationLock?: never;
			connectedDeviceLabel?: never;
			coverageLock?: never;
			coverageMode?: never;
			coveragePosition?: never;
			crashReport?: never;
			danteAudioNetwork?: never;
			danteSampleRate?: never;
			debugMode?: never;
			equalizerContour?: never;
			ethernetLights?: never;
			fanMode?: never;
			firmwareUpdatePolicy?: never;
			freqEng?: never;
			frontPanelGainLock?: never;
			frontPanelLock?: never;
			frontPanelScanLock?: never;
			frontPanelSyncLock?: never;
			height?: never;
			interferenceDetectionResolution?: never;
			internetOfThings?: never;
			iotRoomProxy?: never;
			lightingAudioActivity?: never;
			lightingAudioMeters?: never;
			lightingAudioMuteIndicatorOverride?: never;
			lightingAutomixGating?: never;
			lightingLiveAudioMeters?: never;
			lightingMuteBehavior?: never;
			lightingRing?: never;
			lightingSplitModeBreathingMeterColor?: never;
			lightingSplitModeSolidMeterColor?: never;
			lightingTouchPanelMode?: never;
			lightingUnmuteBehavior?: never;
			linkButtonLock?: never;
			listenerHeight?: never;
			logicMute?: never;
			logicReceiver?: never;
			loudspeaker?: never;
			mdnsService?: never;
			meteringModes?: never;
			micSpatialOrientation?: never;
			micStatus?: never;
			muteButtonLock?: never;
			name?: never;
			placement?: never;
			powerSwitchLock?: never;
			rfBand?: never;
			rfDensityMode?: never;
			rfPower?: never;
			rotation?: never;
			routingPosition?: never;
			secondaryEthernetPort?: never;
			smartGate?: never;
			stereoAudio?: never;
			talkerTrackingConfig?: never;
			transmitterIdentifyBehavior?: never;
			transmitterInitialStateFromCharger?: never;
			transmitterLightingBehavior?: never;
			transmitterMuteBehavior?: never;
			transmitterOutOfRangeBehavior?: never;
			transmitterRejoinBehavior?: never;
			transmitterSwitchBehavior?: never;
			usbMuteSync?: never;
			usbTerminalType?: never;
			userPerspective?: never;
			virtualAcousticBoundary?: never;
			webService?: never;
			wirelessEncryption: DeviceWirelessEncryptionInput;
	  };

export type DeviceFeatures = {
	activePreset: Maybe<DeviceActivePreset>;
	aes3WordClock: Maybe<DeviceAes3WordClock>;
	allEqualizersBypass: Maybe<DeviceAllEqualizersBypass>;
	allIntellimixBypass: Maybe<DeviceAllIntellimixBypass>;
	/**
	 * Determines how the device should amplify all outputted analog audio to provide sound reinforcement in the space.
	 * Different output modes require different wiring, and potentially different speakers to handle the given output.
	 */
	analogAudioOutputMode: Maybe<DeviceAnalogAudioOutputMode>;
	/**
	 * Determines how the device should amplify all outputted analog audio to provide sound reinforcement in the space.
	 * Different output modes (whether analogLogic is enabled) specify the behavior for what to do with a high or a low signal over the analog logic connection.
	 */
	analogLogic: Maybe<DeviceAnalogLogic>;
	analogLogicPresetSwitch: Maybe<DeviceAnalogLogicPresetSwitch>;
	analogLogicPresetSwitchStatus: Maybe<DeviceAnalogLogicPresetSwitchStatus>;
	analytics: Maybe<DeviceAnalytics>;
	antennaBiasVoltage: Maybe<DeviceAntennaBiasVoltage>;
	assignedSpectrumManager: Maybe<DeviceAssignedSpectrumManager>;
	audioAutoFocus: Maybe<DeviceAudioAutoFocus>;
	audioChannelCount: Maybe<DeviceAudioChannelCount>;
	audioChannelTemplates: Maybe<DeviceAudioChannelTemplates>;
	audioChannels: Maybe<DeviceAudioChannels>;
	audioCoverageAreas: Maybe<DeviceAudioCoverageAreas>;
	audioInputLevel: Maybe<DeviceAudioInputLevel>;
	audioMute: Maybe<DeviceAudioMute>;
	audioMuteControl: Maybe<DeviceAudioMuteControl>;
	audioMuteControlGroup: Maybe<DeviceAudioMuteControlGroup>;
	audioMuteDefault: Maybe<DeviceAudioMuteDefault>;
	audioMuteLock: Maybe<DeviceAudioMuteLock>;
	audioNetwork: Maybe<DeviceAudioNetwork>;
	audioNetworkInputChannelCount: Maybe<DeviceAudioNetworkInputChannelCount>;
	audioNetworkInterface: Maybe<DeviceAudioNetworkInterface>;
	audioNetworkOutputChannelCount: Maybe<DeviceAudioNetworkOutputChannelCount>;
	audioSumming: Maybe<DeviceAudioSumming>;
	/**
	 * Auracast is a Bluetooth capability that enables an audio transmitter to broadcast to an unlimited number of receivers.
	 * Shure supports Auracast as a licensed feature and 'available' field will be true when it's licensed.
	 */
	auracast: Maybe<DeviceAuracast>;
	authentication: Maybe<DeviceAuthenticationState>;
	automixGainMetering: Maybe<DeviceAutomixGainMetering>;
	availablePackages: Maybe<DeviceAvailablePackages>;
	batteryCapacity: Maybe<DeviceBatteryCapacity>;
	batteryHealth: Maybe<DeviceBatteryHealth>;
	batteryLevel: Maybe<DeviceBatteryLevel>;
	batteryLowVoltageIndicator: Maybe<DeviceBatteryLowVoltageIndicator>;
	batteryStorageMode: Maybe<DeviceBatteryStorageMode>;
	batteryVoltage: Maybe<DeviceBatteryVoltage>;
	/** This feature is only supported by MXWAPXD2 in order to comply with legal requirements and to differentiate from future Bluetooth features. */
	bluetoothDeviceInformationService: Maybe<DeviceBluetoothDeviceInformationService>;
	bluetoothPower: Maybe<DeviceBluetoothPower>;
	bodypackMicrophoneMode: Maybe<DeviceBodypackMicrophoneMode>;
	callStatus: Maybe<DeviceCallStatus>;
	chargerBays: Maybe<DeviceChargerBays>;
	chargerSlots: Maybe<DeviceChargerSlots>;
	combinedFrontPanelAndPowerLock: Maybe<DeviceCombinedFrontPanelAndPowerLock>;
	commandStringsService: Maybe<DeviceCommandStringsService>;
	conferencingOperationMode: Maybe<DeviceConferencingOperationMode>;
	conferencingOperationModeButtonLock: Maybe<DeviceConferencingOperationModeButtonLock>;
	conferencingPlatform: Maybe<DeviceConferencingPlatform>;
	configurationLock: Maybe<DeviceConfigurationLock>;
	/** A user-settable digital label name for a device which is connected to this device */
	connectedDeviceLabel: Maybe<ConnectedDeviceLabel>;
	controlNetwork: Maybe<DeviceControlNetwork>;
	controlNetworkInterface: Maybe<DeviceControlNetworkInterface>;
	coverageLock: Maybe<DeviceCoverageLock>;
	coverageMode: Maybe<DeviceCoverageMode>;
	coveragePosition: Maybe<DevicePosition>;
	crashReport: Maybe<DeviceCrashReport>;
	danteAudioEncryption: Maybe<DeviceDanteAudioEncryption>;
	danteAudioNetwork: Maybe<DeviceDanteAudioNetwork>;
	danteAudioNetworkAccess: Maybe<DeviceDanteAudioNetworkAccess>;
	danteDeviceLock: Maybe<DeviceDanteDeviceLock>;
	danteDomainManagement: Maybe<DeviceDanteDomainManagement>;
	danteSampleRate: Maybe<DeviceDanteSampleRate>;
	dcPowerModule: Maybe<DeviceDcPowerModule>;
	debugMode: Maybe<DeviceDebugMode>;
	dectChannelCount: Maybe<DeviceDectChannelCount>;
	dectRfSpectrumScan: Maybe<DeviceDectRfSpectrumScan>;
	deployment: Maybe<DeviceDeploymentCandidates>;
	dnsClientConfiguration: Maybe<DeviceDnsClientConfiguration>;
	/** @deprecated For Cloud Managed Rooms Use Only. */
	doublestuffProxiedTransmitters: Maybe<DeviceDoubleStuffProxiedTransmitters>;
	/** @deprecated This is an internal feature used to track Audio fence lobe positioning that is intended to be used as an R&D feature for debugging */
	dspDebugAudioFenceLobes: Maybe<DeviceDspDebugAudioFenceLobes>;
	/** @deprecated This is an internal feature used to enable/disable Audio debug mode that is intended to be used as an R&D feature for debugging things like lobe positioning under a coverage area, talker position detection etc. */
	dspDebugMode: Maybe<DeviceDspDebugMode>;
	equalizerContour: Maybe<DeviceEqualizerContour>;
	errorIndicator: Maybe<DeviceErrorIndicator>;
	ethernetLights: Maybe<DeviceEthernetLights>;
	ethernetPowerSource: Maybe<DeviceEthernetPowerSource>;
	externalDisplays: Maybe<DeviceExternalDisplays>;
	fanMode: Maybe<DeviceFanMode>;
	firmware: Maybe<DeviceFirmware>;
	firmwareUpdatePolicy: Maybe<DeviceFirmwareUpdatePolicy>;
	firmwareUpdateRequests: Maybe<DeviceFirmwareUpdateRequests>;
	freqEng: Maybe<DeviceFrequencyEngine>;
	frontPanelGainLock: Maybe<DeviceFrontPanelGainLock>;
	frontPanelLock: Maybe<DeviceFrontPanelLock>;
	frontPanelScanLock: Maybe<DeviceFrontPanelScanLock>;
	frontPanelSyncLock: Maybe<DeviceFrontPanelSyncLock>;
	gatewayDevice: Maybe<DeviceGatewayDevice>;
	globalMicStatus: Maybe<DeviceGlobalMicStatus>;
	height: Maybe<DeviceHeight>;
	hostedFirmware: Maybe<DeviceHostedFirmware>;
	hostedUpdateProgress: Maybe<DeviceHostedUpdateProgress>;
	identify: Maybe<DeviceIdentify>;
	interferenceDetectionResolution: Maybe<DeviceInterferenceDetectionResolution>;
	internetOfThings: Maybe<DeviceInternetOfThings>;
	iotRoomProxy: Maybe<DeviceIotRoomProxy>;
	license: Maybe<DeviceLicense>;
	licenseNetworkInterface: Maybe<DeviceLicenseNetworkInterface>;
	licenseV2: Maybe<DeviceLicenseV2>;
	licenseV3: Maybe<DeviceLicenseV3>;
	lightingAudioActivity: Maybe<DeviceLightingAudioActivity>;
	lightingAudioMeters: Maybe<DeviceLightingAudioMeters>;
	lightingAudioMuteIndicatorOverride: Maybe<DeviceLightingAudioMuteIndicatorOverride>;
	lightingAutomixGating: Maybe<DeviceLightingAutomixGating>;
	lightingBehavior: Maybe<DeviceLightingBehavior>;
	lightingBrightness: Maybe<DeviceLightingBrightness>;
	lightingLiveAudioMeters: Maybe<DeviceLightingLiveAudioMeters>;
	lightingMuteBehavior: Maybe<DeviceLightingMuteBehavior>;
	lightingRing: Maybe<DeviceLightingRing>;
	lightingSegmentsBehavior: Maybe<DeviceLightingSegmentsBehavior>;
	lightingSplitModeBreathingMeterColor: Maybe<DeviceLightingSplitModeMeterColor>;
	lightingSplitModeSolidMeterColor: Maybe<DeviceLightingSplitModeMeterColor>;
	lightingTouchPanelMode: Maybe<DeviceLightingTouchPanelMode>;
	lightingUnmuteBehavior: Maybe<DeviceLightingUnmuteBehavior>;
	linkButtonLock: Maybe<DeviceLinkButtonLock>;
	linkedAccessPoint: Maybe<DeviceLinkedAccessPoint>;
	listenerHeight: Maybe<DeviceListenerHeight>;
	logicMute: Maybe<DeviceLogicMute>;
	logicReceiver: Maybe<DeviceLogicReceiver>;
	logicTransmitter: Maybe<DeviceLogicTransmitter>;
	loudspeaker: Maybe<DeviceLoudspeaker>;
	mdnsService: Maybe<DeviceMdnsService>;
	meteringModes: Maybe<DeviceMeteringModes>;
	micSpatialOrientation: Maybe<DeviceMicSpatialOrientation>;
	/** Status of MXW legacy microphones (MXW1 / MXW2 / MXW6 / MXW8) */
	micStatus: Maybe<DeviceMicStatus>;
	/** Status of MXW NeXt microphones (MXW1X / MXW2X / MXW6X / MXW8X) */
	micStatusV2: Maybe<DeviceMicStatusV2>;
	multiArrayLocalizationGroupReporter: Maybe<DeviceMultiArrayLocalizationGroupReporter>;
	/** Enable or disable the physical mute button on the device. Note: The mute state can still be toggled programatically through API even when the physical mute button on device is in disabled state. */
	muteButtonLock: Maybe<DeviceMuteButtonLock>;
	name: Maybe<DeviceName>;
	networkSwitchConfiguration: Maybe<DeviceNetworkSwitchConfiguration>;
	onCharger: Maybe<DeviceOnCharger>;
	pcSpecification: Maybe<DevicePcSpecification>;
	placement: Maybe<DevicePlacement>;
	powerSwitchLock: Maybe<DevicePowerSwitchLock>;
	proxiedDevices: Maybe<DeviceProxiedDevices>;
	quadversity: Maybe<DeviceQuadversity>;
	rebootPending: Maybe<DeviceRebootPending>;
	redundantAudioNetwork: Maybe<DeviceRedundantAudioNetwork>;
	rfBand: Maybe<DeviceRfBand>;
	rfChannels: Maybe<DeviceRfChannels>;
	/** @deprecated This API is subject to drastic change while being finalized */
	rfCurrentDraw: Maybe<DeviceRfCurrentDraw>;
	rfDensityMode: Maybe<DeviceRfDensityMode>;
	rfMute: Maybe<DeviceRfMute>;
	rfPorts: Maybe<DeviceRfPorts>;
	rfPower: Maybe<DeviceRfPower>;
	rfTransmissionProfile: Maybe<DeviceRfTransmissionProfile>;
	room: Maybe<DeviceRoom>;
	rotation: Maybe<DeviceRotation>;
	routingPosition: Maybe<DevicePosition>;
	secondaryControlNetwork: Maybe<DeviceSecondaryControlNetwork>;
	secondaryControlNetworkDnsClientConfiguration: Maybe<DeviceSecondaryControlNetworkDnsClientConfiguration>;
	secondaryEthernetPort: Maybe<DeviceSecondaryEthernetPort>;
	security8021X: Maybe<DeviceSecurity8021X>;
	serialNumber: Maybe<DeviceSerialNumber>;
	smartGate: Maybe<DeviceSmartGate>;
	stereoAudio: Maybe<DeviceStereoAudio>;
	tags: Maybe<DeviceTags>;
	talkerTrackingConfig: Maybe<DeviceTalkerTrackingConfig>;
	temperature: Maybe<DeviceTemperature>;
	transmitterIdentifyBehavior: Maybe<DeviceTransmitterIdentifyBehavior>;
	transmitterInitialStateFromCharger: Maybe<DeviceTransmitterInitialStateFromCharger>;
	transmitterLightingBehavior: Maybe<DeviceTransmitterLightingBehavior>;
	transmitterMuteBehavior: Maybe<DeviceTransmitterMuteBehavior>;
	transmitterOutOfRangeBehavior: Maybe<DeviceTransmitterOutOfRangeBehavior>;
	transmitterRejoinBehavior: Maybe<DeviceTransmitterRejoinBehavior>;
	transmitterSwitchBehavior: Maybe<DeviceTransmitterSwitchBehavior>;
	updateProgress: Maybe<DeviceUpdateProgress>;
	uptime: Maybe<DeviceUptime>;
	usbConnection: Maybe<DeviceUsbConnection>;
	usbMuteSync: Maybe<DeviceUsbMuteSync>;
	usbTerminalType: Maybe<DeviceUsbTerminalType>;
	userInterfacePreferences: Maybe<DeviceUserInterfacePreferences>;
	/** Persisted storage of the user view of the device on a web UI */
	userPerspective: Maybe<DeviceUserPerspective>;
	userPresets: Maybe<DeviceUserPresets>;
	virtual: Maybe<DeviceVirtual>;
	virtualAcousticBoundary: Maybe<DeviceVirtualAcousticBoundary>;
	webService: Maybe<DeviceWebService>;
	wirelessEncryption: Maybe<DeviceWirelessEncryption>;
};

export type DeviceFirmware = {
	valid: Scalars['Boolean']['output'];
	version: Scalars['SemanticVersion']['output'];
};

export type DeviceFirmwareUpdatePolicy = {
	downgradeAllowed: Scalars['Boolean']['output'];
};

export type DeviceFirmwareUpdatePolicyChange = {
	firmwareUpdatePolicy: Maybe<DeviceFirmwareUpdatePolicy>;
};

export type DeviceFirmwareUpdatePolicyUpdateInput = {
	downgradeAllowed: Scalars['Boolean']['input'];
};

export type DeviceFirmwareUpdateRequests = {
	/** The hosted firmware update requests of the device */
	hosted: FirmwareUpdateRequestsByStatus;
	/** The primary firmware update requests of the device */
	primary: FirmwareUpdateRequestsByStatus;
};

export type DeviceFirmwareUpdateRequestsChange = {
	firmwareUpdateRequests: Maybe<DeviceFirmwareUpdateRequests>;
};

export type DeviceFrequencyEngine = {
	/**
	 * The name of the radio frequency band used by the device's Frequency Engine. (e.g. G57HD, Z11).
	 * This is a dynamic property settable by the user.
	 */
	band: Scalars['String']['output'];
	/** A display name for the band which may be more easily recognized in software (e.g. G57, J-DECT) */
	displayName: Scalars['String']['output'];
	/**
	 * The overall radio frequency range covered by the band.
	 * The underlying band may be a list of ranges, and portions within the band may be unusable for regulatory reasons.
	 */
	frequencyRange: FrequencyRange;
	/** The index of the Frequency Engine. */
	index: Scalars['Int']['output'];
};

export type DeviceFrequencyEngineChange = {
	freqEng: Maybe<DeviceFrequencyEngine>;
};

export type DeviceFrequencyEngineUpdateInput = {
	band: Scalars['String']['input'];
	index?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Front panel gain lock prevents users from adjusting gain via the device's physical front panel interface.
 * Remote control (via API, software, etc.) remains available.
 *
 * Note: This differs from AudioChannelGainLock, which locks gain adjustment from both front panel AND remote control.
 */
export type DeviceFrontPanelGainLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceFrontPanelGainLockChange = {
	frontPanelGainLock: Maybe<DeviceFrontPanelGainLock>;
};

export type DeviceFrontPanelGainLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceFrontPanelLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceFrontPanelLockChange = {
	frontPanelLock: Maybe<DeviceFrontPanelLock>;
};

export type DeviceFrontPanelLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceFrontPanelScanLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceFrontPanelScanLockChange = {
	frontPanelScanLock: Maybe<DeviceFrontPanelScanLock>;
};

export type DeviceFrontPanelScanLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceFrontPanelSyncLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceFrontPanelSyncLockChange = {
	frontPanelSyncLock: Maybe<DeviceFrontPanelSyncLock>;
};

export type DeviceFrontPanelSyncLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceGatewayDevice = {
	device: Device;
};

export type DeviceGatewayDeviceChange = {
	gatewayDevice: Maybe<DeviceGatewayDevice>;
};

export type DeviceGlobalMicStatus = {
	status: GlobalMicStatus | `${GlobalMicStatus}`;
};

export type DeviceGlobalMicStatusChange = {
	globalMicStatus: Maybe<DeviceGlobalMicStatus>;
};

export type DeviceGlobalMicStatusUpdateInput = {
	id: Scalars['ID']['input'];
	status: GlobalMicStatusInput | `${GlobalMicStatusInput}`;
};

export type DeviceGroupLinkingResult = {
	details: Maybe<Array<DeviceLinkingDetailResult>>;
	overallResult: LinkingOperationResult | `${LinkingOperationResult}`;
};

export type DeviceGroupUnlinkingResult = {
	details: Maybe<Array<DeviceUnlinkingDetailResult>>;
	overallResult: UnlinkingOperationResult | `${UnlinkingOperationResult}`;
};

/** height values are scaled to represent in millimeters (mm) */
export type DeviceHeight = {
	height: Scalars['Float']['output'];
};

export type DeviceHeightChange = {
	height: Maybe<DeviceHeight>;
};

export type DeviceHeightConstraints = {
	height: DeviceHeightFieldConstraints;
};

export type DeviceHeightFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type DeviceHeightUpdateInput = {
	height: Scalars['Float']['input'];
};

export type DeviceHostedFirmware = {
	key: Scalars['String']['output'];
	version: Scalars['String']['output'];
};

export type DeviceHostedFirmwareChange = {
	hostedFirmware: Maybe<DeviceHostedFirmware>;
};

export type DeviceHostedUpdateProgress = {
	deviceProgressPercentage: Scalars['Int']['output'];
	firmwarePackageKey: Scalars['String']['output'];
	firmwarePackageVersion: Scalars['String']['output'];
	stageProgressPercentage: Scalars['Int']['output'];
	updateStage: FirmwareUpdateStage | `${FirmwareUpdateStage}`;
	updateStatus: FirmwareUpdateStatus | `${FirmwareUpdateStatus}`;
};

export type DeviceHostedUpdateProgressChange = {
	hostedUpdateProgress: Maybe<DeviceHostedUpdateProgress>;
};

export type DeviceIdentify = {
	identifying: Scalars['Boolean']['output'];
};

export type DeviceIdentifyChange = {
	identify: Maybe<DeviceIdentify>;
};

export type DeviceInterferenceDetectionResolution = {
	mode: DeviceInterferenceDetectionResolutionMode | `${DeviceInterferenceDetectionResolutionMode}`;
};

export type DeviceInterferenceDetectionResolutionChange = {
	interferenceDetectionResolution: Maybe<DeviceInterferenceDetectionResolution>;
};

export type DeviceInterferenceDetectionResolutionConstraints = {
	mode: DeviceInterferenceDetectionResolutionModeConstraints;
};

export enum DeviceInterferenceDetectionResolutionMode {
	Auto = 'AUTO',
	Manual = 'MANUAL',
	Off = 'OFF'
}

export type DeviceInterferenceDetectionResolutionModeConstraints = {
	options: Array<DeviceInterferenceDetectionResolutionMode | `${DeviceInterferenceDetectionResolutionMode}`>;
};

export type DeviceInterferenceDetectionResolutionUpdateInput = {
	interferenceDetectionResolution:
		| DeviceInterferenceDetectionResolutionMode
		| `${DeviceInterferenceDetectionResolutionMode}`;
};

/** represents device IOT feature */
export type DeviceInternetOfThings = {
	connected: Scalars['Boolean']['output'];
	enabled: Scalars['Boolean']['output'];
};

export type DeviceInternetOfThingsChange = {
	internetOfThings: Maybe<DeviceInternetOfThings>;
};

export type DeviceInternetOfThingsUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceIotRoomProxy = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceIotRoomProxyChange = {
	iotRoomProxy: Maybe<DeviceIotRoomProxy>;
};

export type DeviceIotRoomProxyUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceIpsInput = {
	ipAddress: Array<Scalars['IpAddress']['input']>;
};

export type DeviceLastKnownLinkageDetails = {
	/** name of access point linked to the transmitter */
	deviceName: Scalars['String']['output'];
	/** access point's RF channel index linked to the transmitter */
	rfChannelIndex: Scalars['Int']['output'];
};

export type DeviceLicense = {
	info: Array<DeviceLicenseInfo>;
};

export type DeviceLicenseActivationProgress = {
	activationKey: Scalars['String']['output'];
	count: Scalars['Int']['output'];
	device: Device;
	message: Scalars['String']['output'];
	state: LicenseActivationState | `${LicenseActivationState}`;
};

export type DeviceLicenseCancelPendingActivationProgress = {
	activationKey: Scalars['String']['output'];
	device: Device;
	message: Scalars['String']['output'];
	state: LicenseCancelationState | `${LicenseCancelationState}`;
};

export type DeviceLicenseChange = {
	license: Maybe<DeviceLicense>;
};

export type DeviceLicenseChangeV2 = {
	licenseV2: Maybe<DeviceLicenseV2>;
};

export type DeviceLicenseChangeV3 = {
	licenseV3: Maybe<DeviceLicenseV3>;
};

export type DeviceLicenseDeactivationProgress = {
	activationKey: Scalars['String']['output'];
	count: Scalars['Int']['output'];
	device: Device;
	message: Scalars['String']['output'];
	state: LicenseDeactivationState | `${LicenseDeactivationState}`;
};

export type DeviceLicenseInfo = {
	activationId: Maybe<Scalars['String']['output']>;
	activationKey: Scalars['String']['output'];
	count: Scalars['Int']['output'];
	entitlementId: Maybe<Scalars['String']['output']>;
	expirationDate: Maybe<Scalars['DateTime']['output']>;
	/** @deprecated Use expirationDate for more accurate time handling when close to expiration. This will be removed in a subsequent release */
	expiresIn: Maybe<Scalars['Duration']['output']>;
	featureName: Maybe<Scalars['String']['output']>;
	/** @deprecated This will be removed in a subsequent release. There should be no remaining requirements enforcing that we notify the user of how many days their license remains in the grace period. */
	graceExpirationDate: Maybe<Scalars['DateTime']['output']>;
	/** @deprecated Use graceExpirationDate for more accurate time handling when close to expiration. This will be removed in a subsequent release */
	graceExpiresIn: Maybe<Scalars['Duration']['output']>;
	inGrace: Maybe<Scalars['Boolean']['output']>;
	inUse: Maybe<Scalars['Boolean']['output']>;
	inWarning: Maybe<Scalars['Boolean']['output']>;
	perpetual: Maybe<Scalars['Boolean']['output']>;
	soldTo: Maybe<Scalars['String']['output']>;
	startDate: Maybe<Scalars['DateTime']['output']>;
	state: LicenseState | `${LicenseState}`;
	type: Maybe<LicenseType | `${LicenseType}`>;
};

export type DeviceLicenseInfoV2 = {
	activationId: Maybe<Scalars['String']['output']>;
	activationKey: Scalars['String']['output'];
	count: Scalars['Int']['output'];
	entitlementId: Maybe<Scalars['String']['output']>;
	expirationDate: Maybe<Scalars['DateTime']['output']>;
	featureName: Maybe<Scalars['String']['output']>;
	inGrace: Maybe<Scalars['Boolean']['output']>;
	inUse: Maybe<Scalars['Boolean']['output']>;
	inWarning: Maybe<Scalars['Boolean']['output']>;
	perpetual: Maybe<Scalars['Boolean']['output']>;
	soldTo: Maybe<Scalars['String']['output']>;
	startDate: Maybe<Scalars['DateTime']['output']>;
	state: LicenseState | `${LicenseState}`;
	type: Maybe<LicenseType | `${LicenseType}`>;
};

export type DeviceLicenseInfoV3 = {
	activationId: Maybe<Scalars['String']['output']>;
	activationKey: Scalars['String']['output'];
	count: Scalars['Int']['output'];
	entitlementId: Maybe<Scalars['String']['output']>;
	expirationDate: Maybe<Scalars['DateTime']['output']>;
	featureName: Maybe<Scalars['String']['output']>;
	inUse: Maybe<Scalars['Boolean']['output']>;
	inWarning: Maybe<Scalars['Boolean']['output']>;
	perpetual: Maybe<Scalars['Boolean']['output']>;
	soldTo: Maybe<Scalars['String']['output']>;
	startDate: Maybe<Scalars['DateTime']['output']>;
	state: LicenseStateV3 | `${LicenseStateV3}`;
	type: Maybe<LicenseTypeV3 | `${LicenseTypeV3}`>;
};

export type DeviceLicenseNetworkInterface = {
	available: Scalars['Boolean']['output'];
	description: Scalars['String']['output'];
	ipAddress: Scalars['IpAddress']['output'];
	macAddress: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type DeviceLicenseNetworkInterfaceChange = {
	licenseNetworkInterface: Maybe<DeviceLicenseNetworkInterface>;
};

export type DeviceLicenseSystemStatus = {
	communication: LicenseSystemCommunication;
	integrity: LicenseSystemIntegrityState | `${LicenseSystemIntegrityState}`;
	ownershipMatch: Scalars['Boolean']['output'];
};

export type DeviceLicenseV2 = {
	info: Array<DeviceLicenseInfoV2>;
};

export type DeviceLicenseV3 = {
	info: Array<DeviceLicenseInfoV3>;
	systemStatus: DeviceLicenseSystemStatus;
};

export type DeviceLightingAudioActivity = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLightingAudioActivityChange = {
	lightingAudioActivity: Maybe<DeviceLightingAudioActivity>;
};

export type DeviceLightingAudioActivityUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceLightingAudioMeters = {
	breathingMeterColor: MeterColorThemeInfo;
	liveMeterColor: LiveMeterColorThemeInfo;
	mode: AudioMetersLightingMode | `${AudioMetersLightingMode}`;
	solidMeterColor: MeterColorThemeInfo;
};

export type DeviceLightingAudioMetersChange = {
	lightingAudioMeters: Maybe<DeviceLightingAudioMeters>;
};

export type DeviceLightingAudioMetersConstraints = {
	breathingMeterColor: MeterColorConstraints;
	liveMeterColor: LiveMeterColorConstraints;
	solidMeterColor: MeterColorConstraints;
};

export type DeviceLightingAudioMetersUpdateInput = {
	breathingMeterColor?: InputMaybe<MeterColorThemeInfoInput>;
	liveMeterColor?: InputMaybe<LiveMeterColorThemeInfoInput>;
	mode?: InputMaybe<AudioMetersLightingMode | `${AudioMetersLightingMode}`>;
	solidMeterColor?: InputMaybe<MeterColorThemeInfoInput>;
};

export type DeviceLightingAudioMuteIndicatorOverride = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLightingAudioMuteIndicatorOverrideChange = {
	lightingAudioMuteIndicatorOverride: Maybe<DeviceLightingAudioMuteIndicatorOverride>;
};

export type DeviceLightingAudioMuteIndicatorOverrideUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceLightingAutomixGating = {
	automixerInputDisengagedBehavior: AutomixerInputDisengagedBehavior | `${AutomixerInputDisengagedBehavior}`;
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLightingAutomixGatingChange = {
	lightingAutomixGating: Maybe<DeviceLightingAutomixGating>;
};

export type DeviceLightingAutomixGatingConstraints = {
	automixerInputDisengagedBehavior: Maybe<AutomixerInputDisengagedBehaviorConstraints>;
};

export type DeviceLightingAutomixGatingUpdateInput = {
	automixerInputDisengagedBehavior?: InputMaybe<
		AutomixerInputDisengagedBehavior | `${AutomixerInputDisengagedBehavior}`
	>;
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceLightingBehavior = {
	color: Maybe<LightingColor | `${LightingColor}`>;
	mode: Maybe<LightingMode | `${LightingMode}`>;
	state: Maybe<LightingState | `${LightingState}`>;
};

export type DeviceLightingBehaviorChange = {
	lightingBehavior: Maybe<DeviceLightingBehavior>;
};

export type DeviceLightingBehaviorColorConstraints = {
	options: Array<LightingColor | `${LightingColor}`>;
};

export type DeviceLightingBehaviorConstraints = {
	color: DeviceLightingBehaviorColorConstraints;
	mode: DeviceLightingBehaviorModeConstraints;
	state: DeviceLightingBehaviorStateConstraints;
};

export type DeviceLightingBehaviorModeConstraints = {
	options: Array<LightingMode | `${LightingMode}`>;
};

export type DeviceLightingBehaviorStateConstraints = {
	options: Array<LightingState | `${LightingState}`>;
};

export type DeviceLightingBehaviorUpdateInput = {
	color?: InputMaybe<LightingColor | `${LightingColor}`>;
	mode?: InputMaybe<LightingMode | `${LightingMode}`>;
};

export type DeviceLightingBrightness = {
	/** The current brightness level of the device's lights */
	level: Scalars['Int']['output'];
	/** Number of brightness levels supported by the device's lights */
	supportedLevels: Scalars['Int']['output'];
};

export type DeviceLightingBrightnessChange = {
	lightingBrightness: Maybe<DeviceLightingBrightness>;
};

export type DeviceLightingBrightnessConstraints = {
	level: DeviceLightingBrightnessFieldConstraints;
};

export type DeviceLightingBrightnessFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type DeviceLightingBrightnessUpdateInput = {
	id: Scalars['ID']['input'];
	level: Scalars['Int']['input'];
};

export type DeviceLightingLiveAudioMeters = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLightingLiveAudioMetersChange = {
	lightingLiveAudioMeters: Maybe<DeviceLightingLiveAudioMeters>;
};

export type DeviceLightingLiveAudioMetersUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceLightingMuteBehavior = {
	color: LightingColor | `${LightingColor}`;
	mode: LightingMode | `${LightingMode}`;
};

export type DeviceLightingMuteBehaviorChange = {
	lightingMuteBehavior: Maybe<DeviceLightingMuteBehavior>;
};

export type DeviceLightingMuteBehaviorConstraints = {
	color: DeviceLightingMuteColorConstraints;
	mode: DeviceLightingMuteModeConstraints;
};

export type DeviceLightingMuteColorConstraints = {
	options: Array<LightingColor | `${LightingColor}`>;
};

export type DeviceLightingMuteModeConstraints = {
	options: Array<LightingMode | `${LightingMode}`>;
};

export type DeviceLightingRing = {
	style: LightingStyle | `${LightingStyle}`;
};

export type DeviceLightingRingChange = {
	lightingRing: Maybe<DeviceLightingRing>;
};

export type DeviceLightingRingConstraints = {
	style: DeviceLightingRingStyleConstraints;
};

export type DeviceLightingRingStyleConstraints = {
	options: Array<LightingStyle | `${LightingStyle}`>;
};

export type DeviceLightingRingUpdateInput = {
	style?: InputMaybe<LightingStyle | `${LightingStyle}`>;
};

export type DeviceLightingSegmentsBehavior = {
	segments: Array<LightingSegmentBehavior>;
};

export type DeviceLightingSegmentsBehaviorChange = {
	lightingSegmentsBehavior: Maybe<DeviceLightingSegmentsBehavior>;
};

export type DeviceLightingSplitModeBreathingMeterColorChange = {
	lightingSplitModeBreathingMeterColor: Maybe<DeviceLightingSplitModeMeterColor>;
};

export type DeviceLightingSplitModeMeterColor = {
	auxiliaryCustomThemeLightColor: RgbColorMix;
	primaryCustomThemeLightColor: RgbColorMix;
	theme: ColorTheme | `${ColorTheme}`;
};

export type DeviceLightingSplitModeMeterColorConstraints = {
	auxiliaryCustomThemeLightColor: RgbColorMixConstraints;
	primaryCustomThemeLightColor: RgbColorMixConstraints;
	theme: ColorThemeConstraints;
};

export type DeviceLightingSplitModeMeterColorUpdateInput = {
	auxiliaryCustomThemeLightColor?: InputMaybe<RgbColorMixInput>;
	primaryCustomThemeLightColor?: InputMaybe<RgbColorMixInput>;
	theme?: InputMaybe<ColorTheme | `${ColorTheme}`>;
};

export type DeviceLightingSplitModeSolidMeterColorChange = {
	lightingSplitModeSolidMeterColor: Maybe<DeviceLightingSplitModeMeterColor>;
};

export type DeviceLightingTouchPanelMode = {
	/** Indicates whether the lighting touch panel mode should switch automatically whenever new input is connected/disconnected to/from the device. */
	automaticModeChange: Scalars['Boolean']['output'];
	/**
	 * Lighting touch panel mode controls the lighting display and also the mute control of the device.
	 *
	 *
	 * Split Mode: The lighting display is split into multiple segments represent different input signals of the device. Each segment's lighting color can be customized and also the mute status of each input can be controlled separately by tapping the specific segment of the lighing panel.
	 *
	 *
	 * Combined Mode: One single lighting display is shown for all inputs of the device. Similarly, the mute status changes would be applicable for all inputs of the device.
	 */
	mode: LightingTouchPanelMode | `${LightingTouchPanelMode}`;
};

export type DeviceLightingTouchPanelModeChange = {
	lightingTouchPanelMode: Maybe<DeviceLightingTouchPanelMode>;
};

export type DeviceLightingTouchPanelModeConstraints = {
	mode: DeviceLightingTouchPanelModeTypeConstraints;
};

export type DeviceLightingTouchPanelModeTypeConstraints = {
	options: Array<LightingTouchPanelMode | `${LightingTouchPanelMode}`>;
};

export type DeviceLightingTouchPanelModeUpdateInput = {
	automaticModeChange?: InputMaybe<Scalars['Boolean']['input']>;
	mode?: InputMaybe<LightingTouchPanelMode | `${LightingTouchPanelMode}`>;
};

export type DeviceLightingUnmuteBehavior = {
	color: LightingColor | `${LightingColor}`;
	mode: LightingMode | `${LightingMode}`;
};

export type DeviceLightingUnmuteBehaviorChange = {
	lightingUnmuteBehavior: Maybe<DeviceLightingUnmuteBehavior>;
};

export type DeviceLightingUnmuteBehaviorConstraints = {
	color: DeviceLightingUnmuteColorConstraints;
	mode: DeviceLightingUnmuteModeConstraints;
};

export type DeviceLightingUnmuteColorConstraints = {
	options: Array<LightingColor | `${LightingColor}`>;
};

export type DeviceLightingUnmuteModeConstraints = {
	options: Array<LightingMode | `${LightingMode}`>;
};

export type DeviceLinkButtonLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLinkButtonLockChange = {
	linkButtonLock: Maybe<DeviceLinkButtonLock>;
};

export type DeviceLinkButtonLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceLinkage = {
	/** device and rfChannel fields are null when there is a linkage established with an access point but the access point isn't discovered */
	device: Maybe<Device>;
	/**
	 * Last known linkage information for use when the access point cannot be discovered.
	 * E.g. the transmitter was physically docked on a charger on a different subnet which cannot be discovered.
	 */
	lastKnownLinkageDetails: DeviceLastKnownLinkageDetails;
	rfChannel: Maybe<RfChannel>;
};

export type DeviceLinkedAccessPoint = {
	/** linkage field is null when there is no linkage established with an access point */
	linkage: Maybe<DeviceLinkage>;
};

export type DeviceLinkedAccessPointChange = {
	linkedAccessPoint: Maybe<DeviceLinkedAccessPoint>;
};

export type DeviceLinkingDetailResult = {
	chargerBay: ChargerBay;
	rfChannel: Maybe<RfChannel>;
	status: LinkingStatus | `${LinkingStatus}`;
};

export type DeviceLinkingInput = {
	chargerBay: Scalars['ID']['input'];
	rfChannel?: InputMaybe<Scalars['ID']['input']>;
};

/** Listener height values are scaled to represent in millimeters (mm) */
export type DeviceListenerHeight = {
	height: Scalars['Float']['output'];
};

export type DeviceListenerHeightChange = {
	listenerHeight: Maybe<DeviceListenerHeight>;
};

export type DeviceListenerHeightConstraints = {
	height: DeviceListenerHeightFieldConstraints;
};

export type DeviceListenerHeightFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type DeviceListenerHeightUpdateInput = {
	height: Scalars['Float']['input'];
};

export type DeviceLogicMute = {
	muted: Scalars['Boolean']['output'];
};

export type DeviceLogicMuteChange = {
	logicMute: Maybe<DeviceLogicMute>;
};

export type DeviceLogicMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type DeviceLogicReceiver = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLogicReceiverChange = {
	logicReceiver: Maybe<DeviceLogicReceiver>;
};

export type DeviceLogicReceiverUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceLogicTransmitter = {
	inputLightingSignal: Scalars['Boolean']['output'];
	outputSignal: Scalars['Boolean']['output'];
};

export type DeviceLogicTransmitterChange = {
	logicTransmitter: Maybe<DeviceLogicTransmitter>;
};

export type DeviceLoudspeaker = {
	available: Scalars['Boolean']['output'];
	enabled: Scalars['Boolean']['output'];
};

export type DeviceLoudspeakerChange = {
	loudspeaker: Maybe<DeviceLoudspeaker>;
};

export type DeviceLoudspeakerUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceMdnsService = {
	enabled: Scalars['Boolean']['output'];
	port: Scalars['Int']['output'];
};

export type DeviceMdnsServiceChange = {
	mdnsService: Maybe<DeviceMdnsService>;
};

export type DeviceMdnsServiceUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceMeteringModes = {
	inputMode: MeteringMode | `${MeteringMode}`;
	outputMode: MeteringMode | `${MeteringMode}`;
};

export type DeviceMeteringModesChange = {
	meteringModes: Maybe<DeviceMeteringModes>;
};

export type DeviceMeteringModesUpdateInput = {
	inputMode?: InputMaybe<MeteringMode | `${MeteringMode}`>;
	outputMode?: InputMaybe<MeteringMode | `${MeteringMode}`>;
};

export type DeviceMicSpatialOrientation = {
	orientation: MicSpatialOrientation | `${MicSpatialOrientation}`;
};

export type DeviceMicSpatialOrientationChange = {
	micSpatialOrientation: Maybe<DeviceMicSpatialOrientation>;
};

export type DeviceMicSpatialOrientationConstraints = {
	orientation: DeviceMicSpatialOrientationTypeConstraints;
};

export type DeviceMicSpatialOrientationTypeConstraints = {
	options: Array<MicSpatialOrientation | `${MicSpatialOrientation}`>;
};

export type DeviceMicSpatialOrientationUpdateInput = {
	orientation: MicSpatialOrientation | `${MicSpatialOrientation}`;
};

/** Status of MXW legacy microphone */
export type DeviceMicStatus = {
	status: MicStatus | `${MicStatus}`;
};

export type DeviceMicStatusChange = {
	micStatus: Maybe<DeviceMicStatus>;
};

export type DeviceMicStatusUpdateInput = {
	status: MicStatusInput | `${MicStatusInput}`;
};

/** Status of MXW NeXt microphone */
export type DeviceMicStatusV2 = {
	status: MicStatusV2 | `${MicStatusV2}`;
};

export type DeviceMicStatusV2Change = {
	micStatusV2: Maybe<DeviceMicStatusV2>;
};

export type DeviceMultiArrayLocalizationGroupReporter = {
	/** Indicates whether multi-array localization (MAL) group members are connected to this reporter device. */
	active: Scalars['Boolean']['output'];
	/**
	 * All online devices which are part of this multi-array localization (MAL) group as reported by this reporter device.
	 * 1) Information about a follower device in a MAL group will only be known through the reporter device.
	 * 2) A device can be a reporter for only one group.
	 * 3) A device can be both a reporter for a MAL group and a follower of a different MAL group if the device is part of multiple MAL groups.
	 */
	groupMembers: Array<MultiArrayLocalizationGroup>;
	/** Basic information about the devices which are currently part of the MAL group, but have not been discovered or not in ONLINE state. */
	missingMembers: Array<MultiArrayLocalizationGroupMissingMember>;
};

export type DeviceMultiArrayLocalizationGroupReporterChange = {
	multiArrayLocalizationGroupReporter: Maybe<DeviceMultiArrayLocalizationGroupReporter>;
};

export type DeviceMuteButtonLock = {
	/** When this field is false, the physical mute button on the device can no longer be muted/unmuted. Note: The mute state can still be toggled programatically through API even when the physical mute button on device is in disabled state. */
	enabled: Scalars['Boolean']['output'];
};

export type DeviceMuteButtonLockChange = {
	muteButtonLock: Maybe<DeviceMuteButtonLock>;
};

export type DeviceMuteButtonLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceName = {
	name: Scalars['String']['output'];
};

export type DeviceNameChange = {
	name: Maybe<DeviceName>;
};

export type DeviceNameConflict = {
	/** Audio network device name, which is in conflict */
	audioNetworkDeviceName: Scalars['String']['output'];
	/** Device that has a conflicting Network Audio device name */
	device: Device;
};

export type DeviceNameConstraints = {
	name: DeviceNameFieldConstraints;
};

export type DeviceNameFieldConstraints = IStringPatternRangeConstraints &
	IUtf8StringMaxBytesConstraints & {
		pattern: Maybe<Scalars['Regex']['output']>;
		utf8MaxBytes: Maybe<Scalars['Int']['output']>;
	};

export type DeviceNameUpdateInput = {
	name: Scalars['String']['input'];
};

export type DeviceNetworkInterface = {
	/** Example: Windows: (GUID) '{60B5DC8A-837A-44BC-B594-5027416EF5CC}', Unix: 'en0' */
	id: Scalars['String']['output'];
	ipAddress: Scalars['IpAddress']['output'];
	/**
	 * Display name, or 'Friendly name', of network interface.
	 * Example: Windows: 'Test Network', Mac: 'Thunderbolt Ethernet Slot 1'. Note: Will be copy of 'id' field for Linux.
	 */
	name: Scalars['String']['output'];
};

export type DeviceNetworkSwitchConfiguration = {
	mode: Maybe<NetworkSwitchConfigurationMode | `${NetworkSwitchConfigurationMode}`>;
};

export type DeviceNetworkSwitchConfigurationChange = {
	networkSwitchConfiguration: Maybe<DeviceNetworkSwitchConfiguration>;
};

export type DeviceNetworkSwitchConfigurationConstraints = {
	mode: DeviceNetworkSwitchConfigurationModeConstraints;
};

export type DeviceNetworkSwitchConfigurationModeConstraints = {
	options: Array<Maybe<NetworkSwitchConfigurationMode | `${NetworkSwitchConfigurationMode}`>>;
};

export type DeviceNetworkSwitchConfigurationUpdateInput = {
	id: Scalars['ID']['input'];
	mode: NetworkSwitchConfigurationMode | `${NetworkSwitchConfigurationMode}`;
};

export type DeviceOnCharger = {
	docked: Scalars['Boolean']['output'];
};

export type DeviceOnChargerChange = {
	onCharger: Maybe<DeviceOnCharger>;
};

export type DeviceOperationResult = NodeOperationResult & {
	device: Maybe<Device>;
	error: Maybe<OperationError>;
};

export type DeviceOptimizationResult = {
	device: Maybe<Device>;
	status: DeviceOptimizationStatus | `${DeviceOptimizationStatus}`;
};

export enum DeviceOptimizationStatus {
	Conflict = 'CONFLICT',
	DeviceUnavailable = 'DEVICE_UNAVAILABLE',
	Failure = 'FAILURE',
	PartialSuccess = 'PARTIAL_SUCCESS',
	Success = 'SUCCESS',
	Unsupported = 'UNSUPPORTED'
}

export type DevicePcSpecification = {
	manufacturer: Maybe<Scalars['String']['output']>;
	memory: Maybe<Scalars['String']['output']>;
	model: Maybe<Scalars['String']['output']>;
	operatingSystem: Maybe<OperatingSystem>;
	processorInfo: Maybe<ProcessorInfo>;
};

export type DevicePlacement = {
	placement: Placement | `${Placement}`;
};

export type DevicePlacementChange = {
	placement: Maybe<DevicePlacement>;
};

export type DevicePlacementConstraints = {
	placement: DevicePlacementValuesConstraint;
};

export type DevicePlacementUpdateInput = {
	placement: Placement | `${Placement}`;
};

export type DevicePlacementValuesConstraint = {
	options: Array<Placement | `${Placement}`>;
};

/** The default value of the X/Y positions is uninitialized(i.e., null). Positions are scaled to represent in millimeters (mm) */
export type DevicePosition = {
	xPosition: Maybe<Scalars['Float']['output']>;
	yPosition: Maybe<Scalars['Float']['output']>;
};

export type DevicePowerSwitchLock = {
	enabled: Scalars['Boolean']['output'];
};

export type DevicePowerSwitchLockChange = {
	powerSwitchLock: Maybe<DevicePowerSwitchLock>;
};

export type DevicePowerSwitchLockUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceProperty = {
	id: Scalars['ID']['output'];
	propertyInfo: Maybe<DevicePropertyInfo>;
	propertyKey: Scalars['String']['output'];
	propertyValue: Maybe<Scalars['String']['output']>;
};

export type DevicePropertyChangeEvent = {
	id: Scalars['ID']['output'];
	propertyKey: Scalars['String']['output'];
	propertyValue: Maybe<Scalars['String']['output']>;
};

export type DevicePropertyFilter = {
	get?: InputMaybe<Scalars['Boolean']['input']>;
	propertyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
	public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DevicePropertyInfo = {
	baseKey: Scalars['String']['output'];
	category: Scalars['String']['output'];
	eventReliable: Scalars['Boolean']['output'];
	get: Scalars['Boolean']['output'];
	isImplemented: Scalars['Boolean']['output'];
	isPublic: Scalars['Boolean']['output'];
	maxSize: Scalars['Int']['output'];
	propValueType: Maybe<Scalars['String']['output']>;
	set: Scalars['Boolean']['output'];
	subscribe: Scalars['Boolean']['output'];
};

export type DeviceProxiedDevices = {
	proxiedDevices: Array<Device>;
};

export type DeviceProxiedDevicesChange = {
	proxiedDevices: Maybe<DeviceProxiedDevices>;
};

export type DeviceQuadversity = {
	/** Indicates whether or not the device has quadversity enabled. */
	enabled: Scalars['Boolean']['output'];
};

export type DeviceQuadversityChange = {
	quadversity: Maybe<DeviceQuadversity>;
};

export type DeviceRebootPending = {
	rebootPending: Scalars['Boolean']['output'];
};

export type DeviceRebootPendingChange = {
	rebootPending: Maybe<DeviceRebootPending>;
};

export type DeviceRedundantAudioNetwork = {
	available: Scalars['Boolean']['output'];
	interface: Maybe<NetworkInterfaceInfo>;
};

export type DeviceRedundantAudioNetworkChange = {
	redundantAudioNetwork: Maybe<DeviceRedundantAudioNetwork>;
};

/**
 * Event emitted whenever a device is removed from management
 * (e.g. a physical device goes to DeviceState.Offline, a virtual device is deleted)
 */
export type DeviceRemoved = {
	removed: Scalars['ID']['output'];
};

export enum DeviceResetScope {
	/** use audio channel id as request id for resetDevice mutation */
	Automixer = 'AUTOMIXER',
	/** use device id as request id for resetDevice mutation */
	CoverageAreas = 'COVERAGE_AREAS',
	/** use audio channel id as request id for resetDevice mutation */
	EqualizerFilters = 'EQUALIZER_FILTERS',
	/** use device id as request id for resetDevice mutation */
	Factory = 'FACTORY',
	/** use audio channel id as request id for resetDevice mutation */
	Lobe = 'LOBE',
	/** use device id as request id for resetDevice mutation */
	Networks = 'NETWORKS',
	/** use device id as request id for resetDevice mutation */
	PreFadeListen = 'PRE_FADE_LISTEN',
	/** use device id as request id for resetDevice mutation */
	UserPresetable = 'USER_PRESETABLE'
}

export type DeviceReverseIdentifyEvent = {
	identifying: Scalars['Boolean']['output'];
};

export type DeviceRfBand = {
	/**
	 * The name of the radio frequency band used by the device. (e.g. G57, Z11).
	 * This is typically indicated physically on the device (usually via a sticker, badge, or label)
	 */
	band: Scalars['String']['output'];
	/** A display name for the band which may be more easily recognized in software (e.g. J-DECT) */
	displayName: Scalars['String']['output'];
	/**
	 * The overall radio frequency range covered by the band.
	 * The underlying band may be a list of ranges, and portions within the band may be unusable for regulatory reasons.
	 */
	frequencyRange: Maybe<FrequencyRange>;
};

export type DeviceRfBandChange = {
	rfBand: Maybe<DeviceRfBand>;
};

export type DeviceRfBandConstraints = {
	band: RfBandBandConstraints;
	frequencyRange: FieldSupport;
};

export type DeviceRfBandUpdateInput = {
	band: Scalars['String']['input'];
};

export type DeviceRfChannels = {
	/** RF channels present on the device */
	rfChannels: Array<RfChannel>;
};

export type DeviceRfChannelsChange = {
	rfChannels: Maybe<DeviceRfChannels>;
};

export type DeviceRfCurrentDraw = {
	/**
	 * The total DC RF current supplied by the device in milliamperes
	 * @deprecated This API is subject to drastic change while being finalized
	 */
	current: Scalars['Int']['output'];
};

export type DeviceRfCurrentDrawChange = {
	/** @deprecated This API is subject to drastic change while being finalized */
	rfCurrentDraw: Maybe<DeviceRfCurrentDraw>;
};

export type DeviceRfDensityMode = {
	mode: RfDensityMode | `${RfDensityMode}`;
};

export type DeviceRfDensityModeChange = {
	rfDensityMode: Maybe<DeviceRfDensityMode>;
};

export type DeviceRfDensityModeConstraints = {
	mode: Maybe<RfDensityModeConstraints>;
};

export type DeviceRfDensityModeUpdateInput = {
	mode: RfDensityMode | `${RfDensityMode}`;
};

export type DeviceRfMute = {
	/** Indicates whether or not the device has muted all of its RF transmissions. */
	muted: Scalars['Boolean']['output'];
};

export type DeviceRfMuteChange = {
	rfMute: Maybe<DeviceRfMute>;
};

export type DeviceRfPorts = {
	/**
	 * RF Ports on the device
	 *
	 * An RF Port may be attached to an antenna, signal combiner, amplifier, or other similar RF device
	 */
	rfPorts: Array<RfPort>;
};

export type DeviceRfPower = {
	level: RfPower | `${RfPower}`;
};

export type DeviceRfPowerChange = {
	rfPower: Maybe<DeviceRfPower>;
};

export type DeviceRfPowerConstraints = {
	level: RfPowerConstraints;
};

export type DeviceRfPowerUpdateInput = {
	level: RfPower | `${RfPower}`;
};

export type DeviceRfTransmissionProfile = {
	profile: Scalars['RfProfileName']['output'];
};

export type DeviceRfTransmissionProfileChange = {
	rfTransmissionProfile: Maybe<DeviceRfTransmissionProfile>;
};

export type DeviceRfTransmissionProfileConstraints = {
	profile: Maybe<RfTransmissionProfileConstraints>;
};

/**
 * The room that this device is currently in
 *
 * NOTE: This feature may be transiently null when the device is first discovered.
 */
export type DeviceRoom = {
	room: Maybe<Room>;
};

export type DeviceRoomChange = {
	room: Maybe<DeviceRoom>;
};

export type DeviceRotation = {
	xAxis: Scalars['Int']['output'];
	yAxis: Scalars['Int']['output'];
	zAxis: Scalars['Int']['output'];
};

export type DeviceRotationAxisConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type DeviceRotationChange = {
	rotation: Maybe<DeviceRotation>;
};

export type DeviceRotationConstraints = {
	xAxis: DeviceRotationAxisConstraints;
	yAxis: DeviceRotationAxisConstraints;
	zAxis: DeviceRotationAxisConstraints;
};

export type DeviceRotationFieldUpdateInput = {
	xAxis: Scalars['Int']['input'];
	yAxis: Scalars['Int']['input'];
	zAxis: Scalars['Int']['input'];
};

export type DeviceRotationUpdateInput = {
	xAxis?: InputMaybe<Scalars['Int']['input']>;
	yAxis?: InputMaybe<Scalars['Int']['input']>;
	zAxis?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceRoutingPositionChange = {
	routingPosition: Maybe<DevicePosition>;
};

export type DeviceRoutingPositionInput = {
	xPosition: Scalars['Float']['input'];
	yPosition: Scalars['Float']['input'];
};

export type DeviceSecondaryControlNetwork = {
	available: Scalars['Boolean']['output'];
	interface: Maybe<NetworkInterfaceInfo>;
};

export type DeviceSecondaryControlNetworkChange = {
	secondaryControlNetwork: Maybe<DeviceSecondaryControlNetwork>;
};

export type DeviceSecondaryControlNetworkDnsClientConfiguration = {
	available: Scalars['Boolean']['output'];
	configuration: Maybe<SecondaryControlNetworkDnsClientConfiguration>;
};

export type DeviceSecondaryControlNetworkDnsClientConfigurationChange = {
	secondaryControlNetworkDnsClientConfiguration: Maybe<DeviceSecondaryControlNetworkDnsClientConfiguration>;
};

export type DeviceSecondaryControlNetworkDnsClientConfigurationConstraints = {
	configuration: SecondaryControlNetworkDnsClientConfigurationConstraints;
};

export type DeviceSecondaryControlNetworkDnsClientConfigurationIpAddressArrayConstraints = {
	length: Scalars['Int']['output'];
};

export enum DeviceSecondaryControlNetworkDnsClientConfigurationMode {
	Automatic = 'AUTOMATIC',
	Manual = 'MANUAL'
}

export type DeviceSecondaryControlNetworkDnsClientConfigurationModeConstraints = {
	options: Array<
		| DeviceSecondaryControlNetworkDnsClientConfigurationMode
		| `${DeviceSecondaryControlNetworkDnsClientConfigurationMode}`
	>;
};

export type DeviceSecondaryEthernetPort = {
	/**
	 * Devices with a secondary ethernet (RJ45) port may allow the device to enable/disable this port for optimizing network security in certain network switch configuration modes,
	 * such as support the "Switched" and "Split+".
	 */
	configurable: Scalars['Boolean']['output'];
	enabled: Scalars['Boolean']['output'];
};

export type DeviceSecondaryEthernetPortChange = {
	secondaryEthernetPort: Maybe<DeviceSecondaryEthernetPort>;
};

export type DeviceSecondaryEthernetPortUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceSecurity8021X = {
	anonymousId: Maybe<Scalars['String']['output']>;
	clientCertificate: Maybe<CertificateInfo8021X>;
	eapMethod: EapMethod8021X | `${EapMethod8021X}`;
	enabled: Scalars['Boolean']['output'];
	lastAuthenticationStatus: LastAuthenticationStatus8021X | `${LastAuthenticationStatus8021X}`;
	rebootRequired: Scalars['Boolean']['output'];
	rootCertificate: Maybe<CertificateInfo8021X>;
	username: Maybe<Scalars['String']['output']>;
};

export type DeviceSecurity8021XAnonymousIdConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type DeviceSecurity8021XChange = {
	security8021X: Maybe<DeviceSecurity8021X>;
};

export type DeviceSecurity8021XConstraints = {
	anonymousId: DeviceSecurity8021XAnonymousIdConstraints;
	eapMethod: DeviceSecurity8021XConstraintsEapMethods;
	password: DeviceSecurity8021XPasswordConstraints;
	username: DeviceSecurity8021XUserNameConstraints;
};

export type DeviceSecurity8021XConstraintsEapMethods = {
	options: Array<EapMethod8021X | `${EapMethod8021X}`>;
};

export type DeviceSecurity8021XPasswordConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type DeviceSecurity8021XUserNameConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type DeviceSerialNumber = {
	serialNumber: Scalars['String']['output'];
};

export type DeviceSingleLinkingResult = {
	detail: Maybe<DeviceLinkingDetailResult>;
	overallResult: LinkingOperationResult | `${LinkingOperationResult}`;
};

export type DeviceSingleUnlinkingResult = {
	detail: Maybe<DeviceUnlinkingDetailResult>;
	overallResult: UnlinkingOperationResult | `${UnlinkingOperationResult}`;
};

/**
 * The smart gating feature helps to reduce cross talk between multiple audio inputs by distinguishing the primary talker from non-primary talker(s).
 * The information is used to determine how multiple audio signals are mixed together.
 */
export type DeviceSmartGate = {
	/** When enabled, it will help reduce cross talk between multiple different audio inputs of the device */
	enabled: Scalars['Boolean']['output'];
};

export type DeviceSmartGateChange = {
	smartGate: Maybe<DeviceSmartGate>;
};

export type DeviceSmartGateUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export enum DeviceSpecificEqualizerContour {
	Mxa310 = 'MXA310',
	Mxa320 = 'MXA320',
	Mxa710LowShelf = 'MXA710_LOW_SHELF',
	Mxa901HighPass = 'MXA901_HIGH_PASS',
	Mxa902HighPass = 'MXA902_HIGH_PASS',
	Mxa910 = 'MXA910',
	Mxa910HighPass = 'MXA910_HIGH_PASS',
	Mxa910MultiBand = 'MXA910_MULTI_BAND',
	Mxa920HighPass = 'MXA920_HIGH_PASS',
	Mxa925HighPass = 'MXA925_HIGH_PASS',
	Off = 'OFF'
}

export enum DeviceStatus {
	/**
	 * The device was discovered by a particular communication protocol,
	 * but is yet not ready to be interacted with. This state is normally transient.
	 *
	 * Factory reset and reboot operations are allowed if applicable, but with no guarantees of success.
	 */
	Discovered = 'DISCOVERED',
	/**
	 * The device was discovered, but is in an unusable state for further feature interaction.
	 *
	 * Factory reset and reboot operations are allowed if applicable, but with no guarantees of success.
	 */
	Error = 'ERROR',
	/**
	 * A connection can no logner be established with the device.
	 *
	 * This state may be transient when performing an operation which reboots the device.
	 * (e.g. factory reset, rebooting the ethernet switch a device is powered by, etc)
	 */
	Offline = 'OFFLINE',
	/** The device and all of its features can be interacted with */
	Online = 'ONLINE'
}

export type DeviceStatusChange = {
	id: Scalars['ID']['output'];
	status: DeviceStatus | `${DeviceStatus}`;
};

export type DeviceStereoAudio = {
	available: Scalars['Boolean']['output'];
	enabled: Scalars['Boolean']['output'];
};

export type DeviceStereoAudioChange = {
	stereoAudio: Maybe<DeviceStereoAudio>;
};

export type DeviceStereoAudioUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceSupportedFeatures = {
	activePreset: FeatureSupport;
	aes3WordClock: FeatureSupport;
	allEqualizersBypass: FeatureSupport;
	allIntellimixBypass: FeatureSupport;
	analogAudioOutputMode: FeatureSupport;
	analogLogic: FeatureSupport;
	analogLogicPresetSwitch: FeatureSupport;
	analogLogicPresetSwitchStatus: FeatureSupport;
	analytics: FeatureSupport;
	antennaBiasVoltage: FeatureSupport;
	assignedSpectrumManager: FeatureSupport;
	audioAutoFocus: FeatureSupport;
	audioChannelCount: FeatureSupport;
	audioChannelReassignment: FeatureSupport;
	audioChannelTemplates: FeatureSupport;
	audioChannels: FeatureSupport;
	audioCoverageAreas: FeatureSupport;
	audioInputLevel: FeatureSupport;
	audioMute: FeatureSupport;
	audioMuteControl: FeatureSupport;
	audioMuteControlGroup: FeatureSupport;
	audioMuteDefault: FeatureSupport;
	audioMuteLock: FeatureSupport;
	audioNetwork: FeatureSupport;
	audioNetworkInputChannelCount: FeatureSupport;
	audioNetworkInterface: FeatureSupport;
	audioNetworkNameSync: FeatureSupport;
	audioNetworkOutputChannelCount: FeatureSupport;
	audioSumming: FeatureSupport;
	auracast: FeatureSupport;
	authentication: FeatureSupport;
	automixGainMetering: FeatureSupport;
	availablePackages: FeatureSupport;
	batteryCapacity: FeatureSupport;
	batteryHealth: FeatureSupport;
	batteryLevel: FeatureSupport;
	batteryLowVoltageIndicator: FeatureSupport;
	batteryStorageMode: FeatureSupport;
	batteryVoltage: FeatureSupport;
	bluetoothDeviceInformationService: FeatureSupport;
	bluetoothPower: FeatureSupport;
	bodypackMicrophoneMode: FeatureSupport;
	callStatus: FeatureSupport;
	chargerBays: FeatureSupport;
	chargerSlots: FeatureSupport;
	combinedFrontPanelAndPowerLock: FeatureSupport;
	commandStringsService: FeatureSupport;
	conferencingOperationMode: FeatureSupport;
	conferencingOperationModeButtonLock: FeatureSupport;
	conferencingPlatform: FeatureSupport;
	configurationLock: FeatureSupport;
	connectedDeviceLabel: FeatureSupport;
	controlNetwork: FeatureSupport;
	controlNetworkInterface: FeatureSupport;
	coverageLock: FeatureSupport;
	coverageMode: FeatureSupport;
	coveragePosition: FeatureSupport;
	crashReport: FeatureSupport;
	danteAudioEncryption: FeatureSupport;
	danteAudioNetwork: FeatureSupport;
	danteAudioNetworkAccess: FeatureSupport;
	danteDeviceLock: FeatureSupport;
	danteDomainManagement: FeatureSupport;
	danteSampleRate: FeatureSupport;
	dcPowerModule: FeatureSupport;
	debugMode: FeatureSupport;
	dectChannelCount: FeatureSupport;
	dectRfSpectrumScan: FeatureSupport;
	deployment: FeatureSupport;
	dnsClientConfiguration: FeatureSupport;
	/** @deprecated For Cloud Managed Rooms Use Only. */
	doublestuffProxiedTransmitters: FeatureSupport;
	dspDebugAudioFenceLobes: FeatureSupport;
	dspDebugMode: FeatureSupport;
	dspDebugSettings: FeatureSupport;
	equalizerContour: FeatureSupport;
	errorIndicator: FeatureSupport;
	ethernetLights: FeatureSupport;
	ethernetPowerSource: FeatureSupport;
	eventLogExport: FeatureSupport;
	externalDisplays: FeatureSupport;
	factoryReset: FeatureSupport;
	fanMode: FeatureSupport;
	firmware: FeatureSupport;
	firmwareUpdatePolicy: FeatureSupport;
	firmwareUpdateRequests: FeatureSupport;
	forceResetCredentials: FeatureSupport;
	freqEng: FeatureSupport;
	frontPanelGainLock: FeatureSupport;
	frontPanelLock: FeatureSupport;
	frontPanelScanLock: FeatureSupport;
	frontPanelSyncLock: FeatureSupport;
	gatewayDevice: FeatureSupport;
	globalMicStatus: FeatureSupport;
	height: FeatureSupport;
	hostedFirmware: FeatureSupport;
	hostedUpdateProgress: FeatureSupport;
	identify: FeatureSupport;
	interferenceDetectionResolution: FeatureSupport;
	internetOfThings: FeatureSupport;
	iotRoomProxy: FeatureSupport;
	license: FeatureSupport;
	licenseNetworkInterface: FeatureSupport;
	licenseRefresh: FeatureSupport;
	licenseV2: FeatureSupport;
	licenseV3: FeatureSupport;
	lightingAudioActivity: FeatureSupport;
	lightingAudioMeters: FeatureSupport;
	lightingAudioMuteIndicatorOverride: FeatureSupport;
	lightingAutomixGating: FeatureSupport;
	lightingBehavior: FeatureSupport;
	lightingBrightness: FeatureSupport;
	lightingLiveAudioMeters: FeatureSupport;
	lightingMuteBehavior: FeatureSupport;
	lightingRing: FeatureSupport;
	lightingSegmentsBehavior: FeatureSupport;
	lightingSplitModeBreathingMeterColor: FeatureSupport;
	lightingSplitModeSolidMeterColor: FeatureSupport;
	lightingTouchPanelMode: FeatureSupport;
	lightingUnmuteBehavior: FeatureSupport;
	linkButtonLock: FeatureSupport;
	linkedAccessPoint: FeatureSupport;
	listenerHeight: FeatureSupport;
	logicMute: FeatureSupport;
	logicReceiver: FeatureSupport;
	logicTransmitter: FeatureSupport;
	loudspeaker: FeatureSupport;
	lowPowerStandbyMode: FeatureSupport;
	mdnsService: FeatureSupport;
	meteringModes: FeatureSupport;
	micSpatialOrientation: FeatureSupport;
	micStatus: FeatureSupport;
	micStatusV2: FeatureSupport;
	multiArrayLocalizationGroupReporter: FeatureSupport;
	muteButtonLock: FeatureSupport;
	name: FeatureSupport;
	networkSwitchConfiguration: FeatureSupport;
	onCharger: FeatureSupport;
	pcSpecification: FeatureSupport;
	placement: FeatureSupport;
	powerOff: FeatureSupport;
	powerSwitchLock: FeatureSupport;
	preFadeListenReset: FeatureSupport;
	proxiedDevices: FeatureSupport;
	quadversity: FeatureSupport;
	reboot: FeatureSupport;
	rebootPending: FeatureSupport;
	redundantAudioNetwork: FeatureSupport;
	reverseIdentify: FeatureSupport;
	rfBand: FeatureSupport;
	rfChannels: FeatureSupport;
	/** @deprecated This API is subject to drastic change while being finalized */
	rfCurrentDraw: FeatureSupport;
	rfDensityMode: FeatureSupport;
	rfMute: FeatureSupport;
	rfPorts: FeatureSupport;
	rfPower: FeatureSupport;
	rfTransmissionProfile: FeatureSupport;
	room: FeatureSupport;
	rotation: FeatureSupport;
	routingPosition: FeatureSupport;
	secondaryControlNetwork: FeatureSupport;
	secondaryControlNetworkDnsClientConfiguration: FeatureSupport;
	secondaryEthernetPort: FeatureSupport;
	security8021X: FeatureSupport;
	serialNumber: FeatureSupport;
	smartGate: FeatureSupport;
	stereoAudio: FeatureSupport;
	tags: FeatureSupport;
	talkerTracking: FeatureSupport;
	talkerTrackingConfig: FeatureSupport;
	temperature: FeatureSupport;
	transmitterIdentifyBehavior: FeatureSupport;
	transmitterInitialStateFromCharger: FeatureSupport;
	transmitterLightingBehavior: FeatureSupport;
	transmitterMuteBehavior: FeatureSupport;
	transmitterOutOfRangeBehavior: FeatureSupport;
	transmitterRejoinBehavior: FeatureSupport;
	transmitterSwitchBehavior: FeatureSupport;
	updateProgress: FeatureSupport;
	uptime: FeatureSupport;
	usbConnection: FeatureSupport;
	usbMuteSync: FeatureSupport;
	usbTerminalType: FeatureSupport;
	userInterfacePreferences: FeatureSupport;
	userPerspective: FeatureSupport;
	userPresets: FeatureSupport;
	virtual: FeatureSupport;
	virtualAcousticBoundary: FeatureSupport;
	webService: FeatureSupport;
	wirelessEncryption: FeatureSupport;
};

export type DeviceTags = {
	tags: Array<Scalars['String']['output']>;
};

export type DeviceTagsChange = {
	tags: Maybe<DeviceTags>;
};

export type DeviceTalkerTrackingConfig = {
	/** Talker position SRP/Localization sensitivity */
	localizationSensitivity: LocalizationSensitivity | `${LocalizationSensitivity}`;
	/** Used to enable reporting of advanced talker tracking on external interfaces (such as TPCI) */
	metricsIncluded: Scalars['Boolean']['output'];
	/** Talker tracking update interval in ms. null indicates talker tracking is off. */
	positionUpdateRate: Maybe<Scalars['Int']['output']>;
	/** Talker position Reflection and height correction */
	reflectionCorrection: ReflectionCorrection | `${ReflectionCorrection}`;
	/** Talker position VAD sensitivity */
	voiceActivityDetectionSensitivity: VoiceActivityDetectionSensitivity | `${VoiceActivityDetectionSensitivity}`;
};

export type DeviceTalkerTrackingConfigChange = {
	talkerTrackingConfig: Maybe<DeviceTalkerTrackingConfig>;
};

export type DeviceTalkerTrackingConfigConstraints = {
	localizationSensitivity: LocalizationSensitivityConstraints;
	positionUpdateRate: IntRangeConstraints;
	reflectionCorrection: ReflectionCorrectionConstraints;
	voiceActivityDetectionSensitivity: VoiceActivityDetectionSensitivityConstraints;
};

export type DeviceTalkerTrackingConfigUpdateInput = {
	localizationSensitivity?: InputMaybe<LocalizationSensitivity | `${LocalizationSensitivity}`>;
	metricsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
	positionUpdateRate?: InputMaybe<Scalars['Int']['input']>;
	reflectionCorrection?: InputMaybe<ReflectionCorrection | `${ReflectionCorrection}`>;
	voiceActivityDetectionSensitivity?: InputMaybe<
		VoiceActivityDetectionSensitivity | `${VoiceActivityDetectionSensitivity}`
	>;
};

/** An event indicating all detected talkers the device could find. */
export type DeviceTalkerTrackingEvent = {
	talkers: Array<Talker>;
};

export type DeviceTemperature = {
	/** The current temperature of the device measured in Celsius. */
	celsius: Scalars['Int']['output'];
};

export type DeviceTemperatureChange = {
	temperature: Maybe<DeviceTemperature>;
};

export type DeviceTransmitterIdentifyAlarm = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceTransmitterIdentifyAlarmInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceTransmitterIdentifyBehavior = {
	alarm: DeviceTransmitterIdentifyAlarm;
};

export type DeviceTransmitterIdentifyBehaviorChange = {
	transmitterIdentifyBehavior: Maybe<DeviceTransmitterIdentifyBehavior>;
};

export type DeviceTransmitterIdentifyBehaviorInput = {
	alarm?: InputMaybe<DeviceTransmitterIdentifyAlarmInput>;
};

export type DeviceTransmitterInitialStateFromCharger = {
	bodypack: TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`;
	boundary: TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`;
	gooseneck: Maybe<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
	handheld: TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`;
	stateOptions: Array<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
};

export type DeviceTransmitterInitialStateFromChargerChange = {
	transmitterInitialStateFromCharger: Maybe<DeviceTransmitterInitialStateFromCharger>;
};

export type DeviceTransmitterInitialStateFromChargerConstraints = {
	bodypack: TransmitterInitialStateFromChargerConstraints;
	boundary: TransmitterInitialStateFromChargerConstraints;
	gooseneck: TransmitterInitialStateFromChargerOptionalFormFactorConstraints;
	handheld: TransmitterInitialStateFromChargerConstraints;
};

export type DeviceTransmitterInitialStateFromChargerInput = {
	bodypack?: InputMaybe<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
	boundary?: InputMaybe<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
	gooseneck?: InputMaybe<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
	handheld?: InputMaybe<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
};

export type DeviceTransmitterLightingBehavior = {
	behavior: TransmitterLightingBehavior | `${TransmitterLightingBehavior}`;
};

export type DeviceTransmitterLightingBehaviorChange = {
	transmitterLightingBehavior: Maybe<DeviceTransmitterLightingBehavior>;
};

export type DeviceTransmitterLightingBehaviorConstraints = {
	behavior: Maybe<TransmitterLightingBehaviorConstraints>;
};

export type DeviceTransmitterLightingBehaviorUpdateInput = {
	behavior: TransmitterLightingBehavior | `${TransmitterLightingBehavior}`;
};

export type DeviceTransmitterMuteBehavior = {
	muteBehavior: TransmitterMuteBehavior | `${TransmitterMuteBehavior}`;
	/**
	 * Different options are available when changing conferencingOperationMode.
	 * muteBehavior cannot be adjusted if muteBehaviorOptions is null.
	 */
	muteBehaviorOptions: Maybe<Array<TransmitterMuteBehavior | `${TransmitterMuteBehavior}`>>;
	usbHostDisconnectMuteBehavior:
		| TransmitterUsbHostDisconnectMuteBehavior
		| `${TransmitterUsbHostDisconnectMuteBehavior}`;
	/**
	 * Different options are available when changing conferencingOperationMode.
	 * usbHostDisconnectMuteBehavior cannot be adjusted if usbHostDisconnectMuteBehaviorOptions is null.
	 */
	usbHostDisconnectMuteBehaviorOptions: Maybe<
		Array<TransmitterUsbHostDisconnectMuteBehavior | `${TransmitterUsbHostDisconnectMuteBehavior}`>
	>;
};

export type DeviceTransmitterMuteBehaviorChange = {
	transmitterMuteBehavior: Maybe<DeviceTransmitterMuteBehavior>;
};

export type DeviceTransmitterMuteBehaviorUpdateInput = {
	muteBehavior?: InputMaybe<TransmitterMuteBehavior | `${TransmitterMuteBehavior}`>;
	usbHostDisconnectMuteBehavior?: InputMaybe<
		TransmitterUsbHostDisconnectMuteBehavior | `${TransmitterUsbHostDisconnectMuteBehavior}`
	>;
};

export type DeviceTransmitterOutOfRangeAlarm = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceTransmitterOutOfRangeAlarmInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceTransmitterOutOfRangeBehavior = {
	alarm: DeviceTransmitterOutOfRangeAlarm;
};

export type DeviceTransmitterOutOfRangeBehaviorChange = {
	transmitterOutOfRangeBehavior: Maybe<DeviceTransmitterOutOfRangeBehavior>;
};

export type DeviceTransmitterOutOfRangeBehaviorInput = {
	alarm?: InputMaybe<DeviceTransmitterOutOfRangeAlarmInput>;
};

export type DeviceTransmitterRejoinAudioMute = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceTransmitterRejoinAudioMuteInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceTransmitterRejoinBehavior = {
	audioMute: DeviceTransmitterRejoinAudioMute;
};

export type DeviceTransmitterRejoinBehaviorChange = {
	transmitterRejoinBehavior: Maybe<DeviceTransmitterRejoinBehavior>;
};

export type DeviceTransmitterRejoinBehaviorInput = {
	audioMute?: InputMaybe<DeviceTransmitterRejoinAudioMuteInput>;
};

export type DeviceTransmitterSwitchBehavior = {
	behaviorOptions: Array<TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`>;
	bodypack: TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`;
	boundary: TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`;
	gooseneck: Maybe<TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`>;
	handheld: TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`;
};

export type DeviceTransmitterSwitchBehaviorChange = {
	transmitterSwitchBehavior: Maybe<DeviceTransmitterSwitchBehavior>;
};

export type DeviceTransmitterSwitchBehaviorConstraints = {
	gooseneck: FieldSupport;
};

export type DeviceTransmitterSwitchBehaviorUpdateInput = {
	bodypack?: InputMaybe<TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`>;
	boundary?: InputMaybe<TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`>;
	gooseneck?: InputMaybe<TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`>;
	handheld?: InputMaybe<TransmitterSwitchBehavior | `${TransmitterSwitchBehavior}`>;
};

export type DeviceTuningBand = {
	band: Scalars['String']['output'];
	supportedFrequencies: Array<DeviceTuningFrequencyRange>;
};

export type DeviceTuningFrequencyRange = {
	/** The end of the tunable range expressed in kHz */
	max: Scalars['Int']['output'];
	/** The start of the tunable range expressed in kHz */
	min: Scalars['Int']['output'];
	/** The band step size expressed in kHz */
	step: Scalars['Int']['output'];
};

export type DeviceType = {
	/**
	 * Radio frequency bands corresponding to the device.
	 * Returns an empty array for devices which don't have RF bands to coordinate.
	 * Can return more than one RF band if the device can operate with different user selectable bands (e.g. AD4Q, ANX4).
	 * Can also return more than one RF band if the device supports changing RF bands via the front panel, but not in software.
	 */
	bands: Array<DeviceTuningBand>;
	/**
	 * Unique device class identifier (UUID) to identify a specific device type.
	 * e.g '04DFF3A4-FD5A-11E3-A118-0015C5F3F612'
	 */
	id: Scalars['Guid']['output'];
	/** Human-readable description of the Device Class Identifier (e.g. 'AD4Q-A REV3') */
	name: Scalars['String']['output'];
};

export type DeviceTypesByManufacturerAndModel = {
	/**
	 * Category of devices that all share the exact same property interface.
	 * A device category has one or more device types.
	 */
	category: Scalars['String']['output'];
	deviceType: Array<DeviceType>;
	/** Device manufacturer name (e.g. 'Shure', 'Sennheiser', 'Wisycom', etc.) */
	manufacturer: Scalars['String']['output'];
	/** Human-readable model name (e.g. 'AD4Q-A') */
	model: Scalars['String']['output'];
};

export type DeviceUnlinkingChargerBayResult = {
	chargerBay: ChargerBay;
	success: Scalars['Boolean']['output'];
};

export type DeviceUnlinkingDetailResult = DeviceUnlinkingChargerBayResult | DeviceUnlinkingRfChannelResult;

export type DeviceUnlinkingRfChannelResult = {
	rfChannel: RfChannel;
	success: Scalars['Boolean']['output'];
};

export type DeviceUpdateInput = {
	features?: InputMaybe<DeviceFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export type DeviceUpdateProgress = {
	deviceProgressPercentage: Scalars['Int']['output'];
	firmwarePackageKey: Scalars['String']['output'];
	firmwarePackageVersion: Scalars['String']['output'];
	stageProgressPercentage: Scalars['Int']['output'];
	updateStage: FirmwareUpdateStage | `${FirmwareUpdateStage}`;
	updateStatus: FirmwareUpdateStatus | `${FirmwareUpdateStatus}`;
};

export type DeviceUpdateProgressChange = {
	updateProgress: Maybe<DeviceUpdateProgress>;
};

export type DeviceUptime = {
	uptime: Scalars['Duration']['output'];
};

export type DeviceUptimeChange = {
	uptime: Maybe<DeviceUptime>;
};

export type DeviceUsbConnection = {
	status: UsbConnection | `${UsbConnection}`;
};

export type DeviceUsbConnectionChange = {
	usbConnection: Maybe<DeviceUsbConnection>;
};

export type DeviceUsbMuteSync = {
	enabled: Scalars['Boolean']['output'];
};

export type DeviceUsbMuteSyncChange = {
	usbMuteSync: Maybe<DeviceUsbMuteSync>;
};

export type DeviceUsbMuteSyncUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

export type DeviceUsbTerminalType = {
	terminalType: UsbTerminalType | `${UsbTerminalType}`;
};

export type DeviceUsbTerminalTypeChange = {
	usbTerminalType: Maybe<DeviceUsbTerminalType>;
};

export type DeviceUsbTerminalTypeConstraints = {
	terminalType: DeviceValidUsbTerminalTypeConstraints;
};

export type DeviceUsbTerminalTypeUpdateInput = {
	terminalType: UsbTerminalType | `${UsbTerminalType}`;
};

export type DeviceUserInterfacePreferences = {
	language: Language | `${Language}`;
	unitOfMeasurement: Maybe<UnitOfMeasurement>;
};

export type DeviceUserInterfacePreferencesChange = {
	userInterfacePreferences: Maybe<DeviceUserInterfacePreferences>;
};

export type DeviceUserInterfacePreferencesConstraints = {
	language: Maybe<UserInterfacePreferredLanguageConstraints>;
	unitOfMeasurement: Maybe<UnitOfMeasurementConstraints>;
};

export type DeviceUserInterfacePreferencesUpdateInput = {
	id: Scalars['ID']['input'];
	language?: InputMaybe<Language | `${Language}`>;
	unitOfMeasurement?: InputMaybe<UnitOfMeasurementUpdateInput>;
};

export type DeviceUserPerspective = {
	/** Rotation angle around the device's axes, in degrees */
	deviceRotation: DeviceRotation;
	/** Rotation angle of the device view around the device's own axis, in degrees */
	viewRotation: DeviceViewRotation;
};

export type DeviceUserPerspectiveChange = {
	userPerspective: Maybe<DeviceUserPerspective>;
};

export type DeviceUserPerspectiveConstraints = {
	deviceRotation: DeviceUserPerspectiveDeviceRotationFieldConstraints;
	viewRotation: DeviceUserPerspectiveDeviceViewRotationFieldConstraints;
};

export type DeviceUserPerspectiveDeviceRotationFieldConstraints = {
	xAxis: DeviceUserPerspectiveRotationAxisFieldConstraints;
	yAxis: DeviceUserPerspectiveRotationAxisFieldConstraints;
	zAxis: DeviceUserPerspectiveRotationAxisFieldConstraints;
};

export type DeviceUserPerspectiveDeviceViewRotationFieldConstraints = {
	angle: DeviceUserPerspectiveRotationAxisFieldConstraints;
};

export type DeviceUserPerspectiveRotationAxisFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type DeviceUserPerspectiveUpdateInput = {
	deviceRotation: DeviceRotationFieldUpdateInput;
	viewRotation: DeviceViewRotationFieldUpdateInput;
};

export type DeviceUserPresets = {
	userPresets: Array<UserPreset>;
};

export type DeviceUserPresetsChange = {
	userPresets: Maybe<DeviceUserPresets>;
};

export type DeviceValidUsbTerminalTypeConstraints = {
	options: Array<UsbTerminalType | `${UsbTerminalType}`>;
};

export type DeviceViewRotation = {
	angle: Scalars['Int']['output'];
};

export type DeviceViewRotationFieldUpdateInput = {
	angle: Scalars['Int']['input'];
};

export type DeviceVirtual = {
	origin: Maybe<OriginDevice>;
	virtual: Scalars['Boolean']['output'];
};

export type DeviceVirtualAcousticBoundary = {
	enabled: Scalars['Boolean']['output'];
	sensitivity: Scalars['Int']['output'];
};

export type DeviceVirtualAcousticBoundaryChange = {
	virtualAcousticBoundary: Maybe<DeviceVirtualAcousticBoundary>;
};

export type DeviceVirtualAcousticBoundaryConstraints = {
	sensitivity: Maybe<DeviceVirtualAcousticBoundarySensitivityConstraints>;
};

export type DeviceVirtualAcousticBoundarySensitivityConstraints = IIntRangeConstraints & {
	/** Describes the range of values for sensitivity */
	range: IntRange;
};

export type DeviceVirtualAcousticBoundaryUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	sensitivity?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceWebService = {
	deviceRestApi: Maybe<Scalars['Boolean']['output']>;
	enabled: Scalars['Boolean']['output'];
	port: Scalars['Int']['output'];
};

export type DeviceWebServiceChange = {
	webService: Maybe<DeviceWebService>;
};

export type DeviceWebServiceConstraints = {
	deviceRestApi: FieldSupport;
};

export type DeviceWebServiceUpdateInput = {
	/** When the Web Service is disabled, the device api services are also disabled */
	deviceRestApi?: InputMaybe<Scalars['Boolean']['input']>;
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceWirelessEncryption = {
	mode: DeviceWirelessEncryptionMode | `${DeviceWirelessEncryptionMode}`;
};

export type DeviceWirelessEncryptionChange = {
	wirelessEncryption: Maybe<DeviceWirelessEncryption>;
};

export type DeviceWirelessEncryptionConstraints = {
	mode: DeviceWirelessEncryptionModeConstraints;
};

export type DeviceWirelessEncryptionInput = {
	mode: DeviceWirelessEncryptionMode | `${DeviceWirelessEncryptionMode}`;
};

export enum DeviceWirelessEncryptionMode {
	/** Turn encryption mode off */
	Off = 'OFF',
	/** Turn encryption mode on */
	On = 'ON',
	/** Turn encryption mode on with automatic key re-generation */
	OnAuto = 'ON_AUTO',
	/** Turn encryption mode on with manual key re-generation */
	OnManual = 'ON_MANUAL'
}

export type DeviceWirelessEncryptionModeConstraints = {
	options: Array<DeviceWirelessEncryptionMode | `${DeviceWirelessEncryptionMode}`>;
};

export type DevicesConnection = {
	edges: Array<DeviceEdge>;
	pageInfo: PageInfo;
};

export enum DirectOutputTapPoint {
	/** Sends a signal with automixer gating, AEC, and noise reduction, but without AGC, to the matrix mixer. */
	PostProcessingPostGate = 'POST_PROCESSING_POST_GATE',
	/** Sends a signal with AEC and noise reduction, but without automixer gating or AGC, to the matrix mixer. */
	PostProcessingPreGate = 'POST_PROCESSING_PRE_GATE',
	/** Sends a signal with automixer gating, but without AEC, noise reduction, or AGC, to the matrix mixer. */
	PreProcessingPostGate = 'PRE_PROCESSING_POST_GATE',
	/** Sends a signal without AEC, noise reduction, or AGC to the matrix mixer. */
	PreProcessingPreGate = 'PRE_PROCESSING_PRE_GATE'
}

export enum DisassociationStatus {
	/** Failed to disassociate RF Channel and Charger Bay */
	Failure = 'FAILURE',
	/** Input node id(s) provided in association request is not valid */
	InvalidInput = 'INVALID_INPUT',
	/** Provided input device(s) either does not support association feature or not a valid input for this operation */
	InvalidOperation = 'INVALID_OPERATION',
	/** Association is cleared successfully on Charger Bay */
	PartialSuccessChargerBay = 'PARTIAL_SUCCESS_CHARGER_BAY',
	/** Association is cleared successfully on RF Channel */
	PartialSuccessRfChannel = 'PARTIAL_SUCCESS_RF_CHANNEL',
	/** Successfully disassociated RF Channel and Charger Bay */
	Success = 'SUCCESS'
}

export type DiscoveredDeviceInfo = {
	hardwareId: Scalars['String']['output'];
	type: Scalars['String']['output'];
};

export type DiscoveredDevicesEvent = DeviceAdded | DeviceRemoved;

export type DiscoveredDevicesStatusChange = {
	device: Device;
};

export type DiscoveredRoomEvent = RoomAddedEvent | RoomRemovedEvent;

export enum DistanceMeasurement {
	Feet = 'FEET',
	Meters = 'METERS'
}

export type DistanceMeasurementOptions = {
	options: Array<DistanceMeasurement | `${DistanceMeasurement}`>;
};

export type DmpCommunicationProtocol = {
	ipAddress: Scalars['IpAddress']['output'];
};

export type DoubleStuffProxiedTransmitter = {
	batteryLevelPercentage: Maybe<Scalars['Int']['output']>;
	muted: Maybe<Scalars['Boolean']['output']>;
	name: Scalars['String']['output'];
	online: Scalars['Boolean']['output'];
	status: Maybe<DoubleStuffProxiedTransmitterStatus | `${DoubleStuffProxiedTransmitterStatus}`>;
};

export enum DoubleStuffProxiedTransmitterStatus {
	Active = 'ACTIVE',
	Charging = 'CHARGING',
	Unknown = 'UNKNOWN'
}

export type DspDebugAudioFenceLobe = Fragment &
	Node & {
		description: DspDebugAudioFenceLobeDescription;
		features: DspDebugAudioFenceLobeFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type DspDebugAudioFenceLobeChange = {
	features: DspDebugAudioFenceLobeFeatureChange;
	fragmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
};

export type DspDebugAudioFenceLobeConstraints = {
	lobe: Maybe<DspDebugAudioFenceLobeCoreConstraints>;
};

export type DspDebugAudioFenceLobeCore = {
	position: LobePosition;
	status: LobeStatus | `${LobeStatus}`;
};

export type DspDebugAudioFenceLobeCoreChange = {
	lobe: Maybe<DspDebugAudioFenceLobeCore>;
};

export type DspDebugAudioFenceLobeCoreConstraints = {
	position: LobePositionConstraints;
	status: LobeStatusConstraints;
};

export type DspDebugAudioFenceLobeDescription = {
	constraints: DspDebugAudioFenceLobeConstraints;
	features: DspDebugAudioFenceLobeSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type DspDebugAudioFenceLobeFeatureChange = DspDebugAudioFenceLobeCoreChange;

export type DspDebugAudioFenceLobeFeatures = {
	lobe: Maybe<DspDebugAudioFenceLobeCore>;
};

export type DspDebugAudioFenceLobeSupportedFeatures = {
	lobe: FeatureSupport;
};

export enum DspParamBlockIdDescription {
	AfAldCtrl = 'AF_ALD_CTRL',
	Agc_1 = 'AGC_1',
	Agc_2 = 'AGC_2',
	Agc_3 = 'AGC_3',
	Agc_4 = 'AGC_4',
	Agc_5 = 'AGC_5',
	Agc_6 = 'AGC_6',
	Agc_7 = 'AGC_7',
	Agc_8 = 'AGC_8',
	AldLobeGainConfig = 'ALD_LOBE_GAIN_CONFIG',
	AldVad = 'ALD_VAD',
	AldVadHandler = 'ALD_VAD_HANDLER',
	Ascii = 'ASCII',
	Automix = 'AUTOMIX',
	AutomixAec = 'AUTOMIX_AEC',
	AutomixDelay = 'AUTOMIX_DELAY',
	AutomixGain = 'AUTOMIX_GAIN',
	AutomixGainMeters = 'AUTOMIX_GAIN_METERS',
	AutomixMeter = 'AUTOMIX_METER',
	AutomixPeq = 'AUTOMIX_PEQ',
	AutomixRefRoute = 'AUTOMIX_REF_ROUTE',
	AutomixVad = 'AUTOMIX_VAD',
	Autorefgain = 'AUTOREFGAIN',
	AutoPosition = 'AUTO_POSITION',
	AutoPositionMeter = 'AUTO_POSITION_METER',
	Beam = 'BEAM',
	BoardVersionConfig = 'BOARD_VERSION_CONFIG',
	CompLim = 'COMP_LIM',
	ControlMute = 'CONTROL_MUTE',
	CoverageAreaCtrl = 'COVERAGE_AREA_CTRL',
	CoverageAreaGateIndicators = 'COVERAGE_AREA_GATE_INDICATORS',
	CoverageAreaInputMeters = 'COVERAGE_AREA_INPUT_METERS',
	CoverageAreaPostgateMeters = 'COVERAGE_AREA_POSTGATE_METERS',
	Diagnostics = 'DIAGNOSTICS',
	Events = 'EVENTS',
	FeatureFlagHandler = 'FEATURE_FLAG_HANDLER',
	Gain = 'GAIN',
	GateIndicators = 'GATE_INDICATORS',
	GmdTest = 'GMD_TEST',
	IesReferenceGain = 'IES_REFERENCE_GAIN',
	ImxParamMeters = 'IMX_PARAM_METERS',
	InputMeter = 'INPUT_METER',
	InputPeq = 'INPUT_PEQ',
	Localizer = 'LOCALIZER',
	LoudspeakerDelay = 'LOUDSPEAKER_DELAY',
	LoudspeakerHighpass = 'LOUDSPEAKER_HIGHPASS',
	LoudspeakerInGain = 'LOUDSPEAKER_IN_GAIN',
	LoudspeakerMakeupgain = 'LOUDSPEAKER_MAKEUPGAIN',
	LoudspeakerMeterReporter = 'LOUDSPEAKER_METER_REPORTER',
	LoudspeakerMulticomp = 'LOUDSPEAKER_MULTICOMP',
	LoudspeakerMute = 'LOUDSPEAKER_MUTE',
	LoudspeakerNoisegen = 'LOUDSPEAKER_NOISEGEN',
	LoudspeakerOnoffswitch = 'LOUDSPEAKER_ONOFFSWITCH',
	LoudspeakerSafetyLimiter = 'LOUDSPEAKER_SAFETY_LIMITER',
	LoudspeakerSrcGain = 'LOUDSPEAKER_SRC_GAIN',
	LoudspeakerSrcSelect = 'LOUDSPEAKER_SRC_SELECT',
	LoudspeakerThreadControl = 'LOUDSPEAKER_THREAD_CONTROL',
	LoudspeakerTonegen = 'LOUDSPEAKER_TONEGEN',
	LoudspeakerTonegenlimiter = 'LOUDSPEAKER_TONEGENLIMITER',
	LoudspeakerUseroutgain = 'LOUDSPEAKER_USEROUTGAIN',
	LoudspeakerUserLimiter = 'LOUDSPEAKER_USER_LIMITER',
	LoudspeakerUserPeq = 'LOUDSPEAKER_USER_PEQ',
	LoudspeakerVoicingPeq = 'LOUDSPEAKER_VOICING_PEQ',
	LowCutPeq = 'LOW_CUT_PEQ',
	MacAddress = 'MAC_ADDRESS',
	McuDspStatus = 'MCU_DSP_STATUS',
	Meters = 'METERS',
	MetersImx = 'METERS_IMX',
	MixRouter = 'MIX_ROUTER',
	NewMemsEq = 'NEW_MEMS_EQ',
	NewMemsGain = 'NEW_MEMS_GAIN',
	Ping = 'PING',
	PostGateGain = 'POST_GATE_GAIN',
	RequestParamDump = 'REQUEST_PARAM_DUMP',
	SnrTest = 'SNR_TEST',
	SourceRemover = 'SOURCE_REMOVER',
	SrcRemDelay = 'SRC_REM_DELAY',
	State = 'STATE',
	Version = 'VERSION'
}

export type DurationRange = {
	max: Scalars['Duration']['output'];
	min: Scalars['Duration']['output'];
	step: Scalars['Duration']['output'];
};

export enum EapMethod8021X {
	Disabled = 'DISABLED',
	EapMd5 = 'EAP_MD5',
	PeapGtc = 'PEAP_GTC',
	PeapMschapv2 = 'PEAP_MSCHAPV2',
	Pwd = 'PWD',
	Tls = 'TLS',
	TtlsGtc = 'TTLS_GTC',
	TtlsMd5 = 'TTLS_MD5',
	TtlsMschapv2 = 'TTLS_MSCHAPV2',
	TtlsPap = 'TTLS_PAP'
}

export enum EqFilterType {
	/** Rolls off the audio signal above the selected frequency */
	HighCut = 'HIGH_CUT',
	/** Attenuates or boosts the audio signal above the selected frequency */
	HighShelf = 'HIGH_SHELF',
	/** Rolls off the audio signal below the selected frequency */
	LowCut = 'LOW_CUT',
	/** Attenuates or boost the audio signal below the selected frequency */
	LowShelf = 'LOW_SHELF',
	/** Attenuates or boost the audio signal within a customizable frequency range */
	Parametric = 'PARAMETRIC'
}

export enum EqualizerContour {
	HighPass = 'HIGH_PASS',
	HighPassAndPresenceBoost = 'HIGH_PASS_AND_PRESENCE_BOOST',
	Hpf_75Hz = 'HPF_75_HZ',
	Hpf_150Hz = 'HPF_150_HZ',
	LowShelf = 'LOW_SHELF',
	MultiBand = 'MULTI_BAND',
	Off = 'OFF',
	PresenceBoost = 'PRESENCE_BOOST'
}

export type EqualizerEnabledConstraints = IFieldSupportInfo & {
	supported: Scalars['Boolean']['output'];
};

export type EqualizerFilter = Fragment &
	Node & {
		description: EqualizerFilterDescription;
		features: EqualizerFilterFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type EqualizerFilterBandwidth = {
	/** Range of frequencies affected by the filter */
	bandwidth: Fraction;
};

export type EqualizerFilterBandwidthChange = {
	bandwidth: Maybe<EqualizerFilterBandwidth>;
};

export type EqualizerFilterBandwidthConstraint = {
	options: Array<Fraction>;
};

export type EqualizerFilterBandwidthConstraints = {
	bandwidth: EqualizerFilterBandwidthConstraint;
};

export type EqualizerFilterBandwidthUpdateInput = {
	denominator: Scalars['Int']['input'];
	numerator: Scalars['Int']['input'];
};

export type EqualizerFilterChange = {
	features: EqualizerFilterFeatureChange;
	id: Scalars['ID']['output'];
};

export type EqualizerFilterConfiguration = {
	/** Indicates whether or not the filter is enabled */
	enabled: Scalars['Boolean']['output'];
	/** Equalizer Filter type */
	filterType: Maybe<EqFilterType | `${EqFilterType}`>;
};

export type EqualizerFilterConfigurationChange = {
	configuration: Maybe<EqualizerFilterConfiguration>;
};

export type EqualizerFilterConfigurationConstraints = {
	filterType: Maybe<ConfigurationFilterTypeConstraints>;
};

export type EqualizerFilterConfigurationUpdateInput = {
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	filterType?: InputMaybe<EqFilterType | `${EqFilterType}`>;
};

export type EqualizerFilterConstraints = {
	bandwidth: Maybe<EqualizerFilterBandwidthConstraints>;
	configuration: Maybe<EqualizerFilterConfigurationConstraints>;
	frequency: Maybe<EqualizerFilterFrequencyConstraints>;
	gain: Maybe<EqualizerFilterGainConstraints>;
	qFactor: Maybe<EqualizerFilterQFactorConstraints>;
};

export type EqualizerFilterDescription = {
	constraints: EqualizerFilterConstraints;
	features: EqualizerFilterSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type EqualizerFilterFeatureChange =
	| EqualizerFilterBandwidthChange
	| EqualizerFilterConfigurationChange
	| EqualizerFilterFrequencyChange
	| EqualizerFilterGainChange
	| EqualizerFilterQFactorChange;

export type EqualizerFilterFeatureUpdateInput =
	| {
			bandwidth: EqualizerFilterBandwidthUpdateInput;
			configuration?: never;
			frequency?: never;
			gain?: never;
			qFactor?: never;
	  }
	| {
			bandwidth?: never;
			configuration: EqualizerFilterConfigurationUpdateInput;
			frequency?: never;
			gain?: never;
			qFactor?: never;
	  }
	| {
			bandwidth?: never;
			configuration?: never;
			frequency: EqualizerFilterFrequencyUpdateInput;
			gain?: never;
			qFactor?: never;
	  }
	| {
			bandwidth?: never;
			configuration?: never;
			frequency?: never;
			gain: EqualizerFilterGainUpdateInput;
			qFactor?: never;
	  }
	| {
			bandwidth?: never;
			configuration?: never;
			frequency?: never;
			gain?: never;
			qFactor: EqualizerFilterQFactorUpdateInput;
	  };

export type EqualizerFilterFeatures = {
	bandwidth: Maybe<EqualizerFilterBandwidth>;
	configuration: Maybe<EqualizerFilterConfiguration>;
	frequency: Maybe<EqualizerFilterFrequency>;
	gain: Maybe<EqualizerFilterGain>;
	qFactor: Maybe<EqualizerFilterQFactor>;
};

export type EqualizerFilterFrequency = {
	/** Center frequency (Hz) */
	frequency: Scalars['Float']['output'];
};

export type EqualizerFilterFrequencyChange = {
	frequency: Maybe<EqualizerFilterFrequency>;
};

export type EqualizerFilterFrequencyConstraints = {
	frequency: EqualizerFilterFrequencyFieldConstraints;
};

export type EqualizerFilterFrequencyFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type EqualizerFilterFrequencyUpdateInput = {
	frequency?: InputMaybe<Scalars['Float']['input']>;
};

export type EqualizerFilterGain = {
	/** Gain applied to frequencies affected by the filter (dB) */
	gain: Scalars['Float']['output'];
};

export type EqualizerFilterGainChange = {
	gain: Maybe<EqualizerFilterGain>;
};

export type EqualizerFilterGainConstraints = {
	gain: EqualizerFilterGainFieldConstraints;
};

export type EqualizerFilterGainFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type EqualizerFilterGainUpdateInput = {
	gain?: InputMaybe<Scalars['Float']['input']>;
};

export type EqualizerFilterOperationResult = NodeOperationResult & {
	equalizerFilter: Maybe<EqualizerFilter>;
	error: Maybe<OperationError>;
};

export type EqualizerFilterQFactor = {
	/** Range of frequencies affected by the filter, represented as a ratio of center frequency to bandwidth */
	qFactor: Scalars['Float']['output'];
};

export type EqualizerFilterQFactorChange = {
	qFactor: Maybe<EqualizerFilterQFactor>;
};

export type EqualizerFilterQFactorConstraints = {
	qFactor: QFactorConstraint;
};

export type EqualizerFilterQFactorUpdateInput = {
	qFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type EqualizerFilterSupportedFeatures = {
	bandwidth: FeatureSupport;
	configuration: FeatureSupport;
	frequency: FeatureSupport;
	gain: FeatureSupport;
	qFactor: FeatureSupport;
};

export type EqualizerFilterUpdateInput = {
	features?: InputMaybe<EqualizerFilterFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export type EqualizerFilterValidQFactors = {
	options: Array<Scalars['Float']['output']>;
};

export type EqualizerFiltersConstraints = IFieldSupportInfo & {
	query: Scalars['Boolean']['output'];
	subscribe: Scalars['Boolean']['output'];
	supported: Scalars['Boolean']['output'];
	updateNodes: Scalars['Boolean']['output'];
};

export enum EqualizerPreset {
	Acoustic = 'ACOUSTIC',
	Band = 'BAND',
	Binaural = 'BINAURAL',
	Flat = 'FLAT',
	MultipleTalkers = 'MULTIPLE_TALKERS',
	Singing = 'SINGING',
	SingleTalker = 'SINGLE_TALKER',
	Speech = 'SPEECH'
}

export type EqualizerToneConstraints = IFieldSupportInfo &
	INullableIntRangeConstraints & {
		range: Maybe<IntRange>;
		supported: Scalars['Boolean']['output'];
	};

export enum ErrorCode {
	Conflict = 'CONFLICT',
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	DeviceUnauthenticated = 'DEVICE_UNAUTHENTICATED',
	InvalidInput = 'INVALID_INPUT',
	InvalidOperation = 'INVALID_OPERATION',
	NotImplemented = 'NOT_IMPLEMENTED',
	TimeoutExceeded = 'TIMEOUT_EXCEEDED',
	Unknown = 'UNKNOWN'
}

export enum ErrorIndicator {
	ClearableError = 'CLEARABLE_ERROR',
	NonClearableError = 'NON_CLEARABLE_ERROR',
	NoError = 'NO_ERROR'
}

export type EthernetConfig = {
	networkInterfaceId: Scalars['String']['input'];
};

export enum EthernetPowerSourceType {
	Poe = 'POE',
	PoePlus = 'POE_PLUS',
	PoePlusPlus = 'POE_PLUS_PLUS',
	Unknown = 'UNKNOWN'
}

export type EventLogExportResult = {
	error: Maybe<OperationError>;
	/** One or more lines of device events in a CSV formatted string */
	eventLog: Maybe<Scalars['String']['output']>;
};

export type ExternalDisplay = Fragment &
	Node & {
		description: ExternalDisplayDescription;
		features: ExternalDisplayFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type ExternalDisplayChange = {
	features: ExternalDisplayFeatureChange;
	fragmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
};

export type ExternalDisplayConnection = {
	connected: Scalars['Boolean']['output'];
};

export type ExternalDisplayConnectionChange = {
	connection: Maybe<ExternalDisplayConnection>;
};

export type ExternalDisplayDescription = {
	features: ExternalDisplaySupportedFeatures;
	index: Scalars['Int']['output'];
};

export type ExternalDisplayFeatureChange = ExternalDisplayConnectionChange | ExternalDisplayResolutionChange;

export type ExternalDisplayFeatures = {
	connection: Maybe<ExternalDisplayConnection>;
	resolution: Maybe<ExternalDisplayResolution>;
};

export type ExternalDisplayResolution = {
	resolution: Scalars['String']['output'];
};

export type ExternalDisplayResolutionChange = {
	resolution: Maybe<ExternalDisplayResolution>;
};

export type ExternalDisplaySupportedFeatures = {
	connection: FeatureSupport;
	resolution: FeatureSupport;
};

export enum FanMode {
	AlwaysOn = 'ALWAYS_ON',
	Auto = 'AUTO',
	High = 'HIGH',
	Low = 'LOW'
}

export type FeatureSupport = {
	/**
	 * Whether or not the feature can be queried for this particular device using APIs such as nodes(), node(), discoveredDevicesConnection(), and more.
	 * If false, the field(s) related to this feature will not be present in the schema for this device.
	 */
	query: Scalars['Boolean']['output'];
	/**
	 * Whether or not the feature can be observed for real-time updates using the nodeChanges() subscription API.
	 * If false, it is possible that there may be applicable subscriptions in the 'supportedSubscriptions' related to observing real-time updates to the feature.
	 * Refer to https://shure.atlassian.net/wiki/spaces/SDA/pages/3256365651/GraphQL+Interface+Modeling+Best+Practices#GraphQLInterfaceModelingBestPractices-DeviceFeatureBasics for more details.
	 */
	subscribe: Scalars['Boolean']['output'];
	/** Whether or not the feature is supported for this particular device. */
	supported: Scalars['Boolean']['output'];
	/** List of additional supported mutations related to this feature, beyond the conventional ones applying GraphQL device-based features in general. */
	supportedMutations: Maybe<Array<Scalars['String']['output']>>;
	/** List of additional supported subscriptions related to this feature, beyond the conventional ones applying GraphQL device-based features in general. */
	supportedSubscriptions: Maybe<Array<Scalars['String']['output']>>;
	/**
	 * Whether or not the feature can be updated through the updateNodes() API.
	 * If false, it is possible that there may be applicable mutations in the 'supportedMutations' related to updating the feature.
	 * Refer to https://shure.atlassian.net/wiki/spaces/SDA/pages/3256365651/GraphQL+Interface+Modeling+Best+Practices#GraphQLInterfaceModelingBestPractices-DeviceFeatureBasics for more details.
	 */
	updateNodes: Scalars['Boolean']['output'];
};

export type FieldSupport = IFieldSupportInfo & {
	supported: Scalars['Boolean']['output'];
};

export type FirmwarePackage = {
	description: Scalars['String']['output'];
	key: Scalars['String']['output'];
	releaseDate: Scalars['String']['output'];
	releaseNotesUrl: Scalars['String']['output'];
	version: Scalars['String']['output'];
};

export type FirmwarePackageDownloadInput = {
	firmwarePackageKey: Scalars['String']['input'];
	firmwarePackageVersion: Scalars['String']['input'];
};

export type FirmwarePackageDownloadProgress = Node & {
	id: Scalars['ID']['output'];
	/** The key of the firmware package being downloaded */
	key: Scalars['String']['output'];
	/** A percentage that indicates the progress of the firmware package download */
	progress: Scalars['Int']['output'];
	/** The current stage of the firmware package download */
	stage: FirmwarePackageDownloadStage | `${FirmwarePackageDownloadStage}`;
	/** The version of the firmware package being downloaded */
	version: Scalars['String']['output'];
};

export type FirmwarePackageDownloadRequestProgress = Node & {
	id: Scalars['ID']['output'];
	/** The progress for each package in the firmware package download request */
	packages: Array<FirmwarePackageDownloadProgress>;
	/** A percentage that indicates the overall progress of the firmware package download request */
	progress: Scalars['Int']['output'];
	/** A unique identifier for the firmware package download request */
	requestId: Scalars['Guid']['output'];
	/** The current state of the firmware package download request */
	state: FirmwarePackageDownloadRequestState | `${FirmwarePackageDownloadRequestState}`;
};

export enum FirmwarePackageDownloadRequestState {
	Canceled = 'CANCELED',
	Failed = 'FAILED',
	InProgress = 'IN_PROGRESS',
	Pending = 'PENDING',
	Successful = 'SUCCESSFUL'
}

export enum FirmwarePackageDownloadStage {
	AlreadyDownloaded = 'ALREADY_DOWNLOADED',
	Canceled = 'CANCELED',
	Complete = 'COMPLETE',
	InvalidDestination = 'INVALID_DESTINATION',
	InvalidPackage = 'INVALID_PACKAGE',
	InvalidUrl = 'INVALID_URL',
	InProgress = 'IN_PROGRESS',
	NonSpecific = 'NON_SPECIFIC',
	NoConnection = 'NO_CONNECTION',
	Pending = 'PENDING'
}

export type FirmwarePackageServerStatus = {
	available: Scalars['Boolean']['output'];
};

export type FirmwareUpdateCapabilityOutput = {
	deviceId: Scalars['Guid']['output'];
	hostedPackages: Array<FirmwarePackage>;
	primaryPackages: Array<FirmwarePackage>;
};

export enum FirmwareUpdateExecutionStage {
	/** The device is being reserved for a firmware update */
	DeviceReserved = 'DEVICE_RESERVED',
	/** The device is available for a firmware update */
	Idle = 'IDLE',
	/** The device is installing the firmware package */
	Installing = 'INSTALLING',
	/** The firmware package is being validated by the device before installation */
	PreInstallValidating = 'PRE_INSTALL_VALIDATING',
	/** The device is rebooting */
	Rebooting = 'REBOOTING',
	/** The firmware package is being transferred to the device */
	TransferringFiles = 'TRANSFERRING_FILES',
	/** The device is verifying that the firmware package was installed correctly */
	Verifying = 'VERIFYING'
}

export type FirmwareUpdateExecutionStatus = {
	/** The execution stage of the overall update process */
	stage: FirmwareUpdateExecutionStage | `${FirmwareUpdateExecutionStage}`;
	/** A percentage that indicates the progress of the current execution stage */
	stageProgress: Scalars['Int']['output'];
};

export type FirmwareUpdateProgress = Node & {
	/** The updating device. May be null in some cases, e.g. the device is rebooting when a progress event is received. */
	device: Maybe<Device>;
	/**
	 * The hardware ID of the updating device
	 * @deprecated Use the device field to access the device's hardware ID. If you have a need to use this field directly, please discuss with someone from the System API middleware group.
	 */
	deviceId: Scalars['Guid']['output'];
	/** A percentage that indicates the overall progress of the firmware update */
	deviceProgress: Scalars['Int']['output'];
	/** The key of the firmware package in use for the update */
	firmwarePackageKey: Scalars['String']['output'];
	/** The version of the firmware package in use for the update */
	firmwarePackageVersion: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	/** The current stage of the firmware update */
	stage: FirmwareUpdateStage | `${FirmwareUpdateStage}`;
	/** A percentage that indicates the progress of the current stage */
	stageProgress: Scalars['Int']['output'];
	/** The current state of the firmware update */
	status: FirmwareUpdateStatus | `${FirmwareUpdateStatus}`;
};

export type FirmwareUpdateRequest = Node & {
	/** Can this request still be canceled? */
	cancelable: Scalars['Boolean']['output'];
	/** The timestamp of when the request was created (may be null when not known) */
	createdAt: Maybe<Scalars['DateTime']['output']>;
	/** The updating device (may be null if missing or in error conditions) */
	device: Maybe<Device>;
	/** The reason why an update was rejected or failed (will be null when no error occurred) */
	error: Maybe<Scalars['FirmwareUpdateError']['output']>;
	/** Detailed progress information while performing the firmware update (may be null if not supported by firmware update method) */
	executionStatus: Maybe<FirmwareUpdateExecutionStatus>;
	/** Whether the firmware update is being hosted by the targeted device (may be null when the request is first created) */
	hosted: Maybe<Scalars['Boolean']['output']>;
	/** Node identifier of the request */
	id: Scalars['ID']['output'];
	/** The key of the firmware package in use for the update */
	packageKey: Scalars['String']['output'];
	/** The version of the firmware package in use for the update */
	packageVersion: Scalars['String']['output'];
	/** A percentage that indicates the overall progress of the firmware update */
	progress: Scalars['Int']['output'];
	/** Current status of the firmware update request */
	status: FirmwareUpdateRequestStatus | `${FirmwareUpdateRequestStatus}`;
};

export type FirmwareUpdateRequestProgress = Node & {
	/** The progress for each device in the firmware update request */
	devices: Array<FirmwareUpdateProgress>;
	id: Scalars['ID']['output'];
	/** A percentage that indicates the overall progress of the firmware update request */
	progress: Scalars['Int']['output'];
	/** A unique identifier for the firmware update request */
	requestId: Scalars['Guid']['output'];
	/** The current state of the firmware update request */
	state: FirmwareUpdateRequestState | `${FirmwareUpdateRequestState}`;
};

export enum FirmwareUpdateRequestState {
	/** The firmware update request was canceled. */
	Canceled = 'CANCELED',
	/** The firmware update request failed. */
	Failed = 'FAILED',
	/** The firmware update request is in progress. */
	InProgress = 'IN_PROGRESS',
	/** The firmware update request was received, but has not started. */
	Pending = 'PENDING',
	/** The firmware update request is complete. */
	Successful = 'SUCCESSFUL'
}

export enum FirmwareUpdateRequestStatus {
	/** The firmware update was canceled */
	Canceled = 'CANCELED',
	/** The firmware update is complete */
	Complete = 'COMPLETE',
	/** An error occurred during the firmware update or the update request was rejected */
	Errored = 'ERRORED',
	/** The firmware package is in the process of being applied */
	Executing = 'EXECUTING',
	/** The request to update the device was received, but has not started yet */
	Pending = 'PENDING'
}

/** Firmware update requests of the device */
export type FirmwareUpdateRequestsByStatus = {
	/** The firmware update request of the device that is pending, executing, or finished (maybe null if no requests are pending execution, are executing, or if no history of finished requests exists) */
	current: Maybe<FirmwareUpdateRequest>;
	/** The firmware update request that is currently executing (maybe null if no requests are executing) */
	executing: Maybe<FirmwareUpdateRequest>;
	/** The most recent finished (completed, errored, or cancelled) firmware update request of the device (maybe null if no history of finished requests exists) */
	finished: Maybe<FirmwareUpdateRequest>;
	/** The firmware update request that is going to be executed next (maybe null if no requests are pending execution) */
	pending: Maybe<FirmwareUpdateRequest>;
};

export enum FirmwareUpdateStage {
	/** The firmware update was canceled. */
	Canceled = 'CANCELED',
	/** The firmware update is complete. */
	Complete = 'COMPLETE',
	/** The device is being reserved for a firmware update. */
	DeviceReserved = 'DEVICE_RESERVED',
	/** An error occurred during the firmware update. */
	Error = 'ERROR',
	/** The device is available for a firmware update. */
	Idle = 'IDLE',
	/** The device is installing the firmware package. */
	Installing = 'INSTALLING',
	/** The request to update the device was received, but has not started yet. */
	Pending = 'PENDING',
	/** The firmware package is being validated by the device before installation. */
	PreInstallValidating = 'PRE_INSTALL_VALIDATING',
	/** The device is rebooting. */
	Rebooting = 'REBOOTING',
	/** The firmware package is being transferred to the device. */
	TransferringFiles = 'TRANSFERRING_FILES',
	/** The device is verifying that the firmware package was installed correctly. */
	Verifying = 'VERIFYING'
}

export enum FirmwareUpdateStatus {
	/** The device aborted the firmware update. */
	Aborted = 'ABORTED',
	/** The firmware update was canceled. */
	Canceled = 'CANCELED',
	/** There was a connectivity issue. */
	ConnectivityLoss = 'CONNECTIVITY_LOSS',
	/** The firmware package was corrupted locally or in transfer to the device. */
	CorruptPackage = 'CORRUPT_PACKAGE',
	/** The device is unavailable for a firmware update. */
	DeviceBusy = 'DEVICE_BUSY',
	/** The device cannot be found. */
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	DeviceRejectedPackage = 'DEVICE_REJECTED_PACKAGE',
	/** An error occurred while transferring the firmware package to the device. */
	FileTransferError = 'FILE_TRANSFER_ERROR',
	/** An error occurred while the device was installing the firmware package. */
	InstallationError = 'INSTALLATION_ERROR',
	/** The device does not support the specified firmware package. */
	InvalidPackage = 'INVALID_PACKAGE',
	/** The firmware update is complete. */
	Success = 'SUCCESS',
	/** An unknown error occurred. */
	UnknownError = 'UNKNOWN_ERROR',
	/** An error occurred while the device was verifying the installation. */
	VerificationError = 'VERIFICATION_ERROR'
}

export type FloatPosition = {
	xPosition: Scalars['Float']['output'];
	yPosition: Scalars['Float']['output'];
	zPosition: Scalars['Float']['output'];
};

export type FloatPositionUpdateInput = {
	xPosition?: InputMaybe<Scalars['Float']['input']>;
	yPosition?: InputMaybe<Scalars['Float']['input']>;
	zPosition?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatRange = {
	max: Scalars['Float']['output'];
	min: Scalars['Float']['output'];
	step: Scalars['Float']['output'];
};

export type FloatRangeConstraints = {
	range: FloatRange;
};

export type Fraction = {
	denominator: Scalars['Int']['output'];
	numerator: Scalars['Int']['output'];
};

export type Fragment = {
	fragmentId: Scalars['ID']['output'];
};

export enum FrequencyDiversityMode {
	/** The receiver mixes the same audio signal from two carrier frequencies. */
	Combining = 'COMBINING',
	/** Frequency diversity is disabled. */
	Off = 'OFF',
	/** The receiver switches between two audio signals from two carrier frequencies. */
	Selection = 'SELECTION'
}

export type FrequencyEngineBandConstraints = {
	options: Array<RfBandOptions>;
};

export type FrequencyEngineConstraints = {
	eng: Maybe<Array<FrequencyEngineEngineConstraints>>;
};

export type FrequencyEngineEngineConstraints = {
	band: FrequencyEngineBandConstraints;
	frequencyRange: FieldSupport;
	index: Maybe<Scalars['Int']['output']>;
};

/** All frequencies are represented in MHz */
export type FrequencyRange = {
	max: Scalars['Float']['output'];
	min: Scalars['Float']['output'];
};

export enum GlobalMicStatus {
	Active = 'ACTIVE',
	Mute = 'MUTE',
	NonUniform = 'NON_UNIFORM',
	Off = 'OFF',
	Standby = 'STANDBY'
}

export enum GlobalMicStatusInput {
	Active = 'ACTIVE',
	Mute = 'MUTE',
	Off = 'OFF',
	Standby = 'STANDBY'
}

export enum Grounding {
	Grounded = 'GROUNDED',
	Lifted = 'LIFTED'
}

export type GroupAssociationResult = {
	/** List of devices that were associated, includes multiple types of association */
	associatedDevices: Array<Device>;
	/** List of devices that were Network Audio associated (Dante routed), subset of associatedDevices */
	networkAudioAssociatedDevices: Array<Device>;
	overallResult: GroupAssociationStatus | `${GroupAssociationStatus}`;
	warnings: Array<GroupAssociationWarning | `${GroupAssociationWarning}`>;
	/** List of devices that were Microflex Wireless associated, subset of associatedDevices */
	wirelessAssociatedDevices: Array<Device>;
};

export enum GroupAssociationStatus {
	AllAssociationsUnsuccessful = 'ALL_ASSOCIATIONS_UNSUCCESSFUL',
	Conflict = 'CONFLICT',
	DevicesUnavailable = 'DEVICES_UNAVAILABLE',
	DeviceOperationModeFailure = 'DEVICE_OPERATION_MODE_FAILURE',
	Failure = 'FAILURE',
	IncompatibleDevice = 'INCOMPATIBLE_DEVICE',
	NoApplicableRoutesForStereoAecProcessor = 'NO_APPLICABLE_ROUTES_FOR_STEREO_AEC_PROCESSOR',
	NoEligibleMicrophonesForAccessPointProcessor = 'NO_ELIGIBLE_MICROPHONES_FOR_ACCESS_POINT_PROCESSOR',
	Success = 'SUCCESS',
	SuccessWithWarnings = 'SUCCESS_WITH_WARNINGS',
	Timeout = 'TIMEOUT'
}

export enum GroupAssociationWarning {
	AllNetworkAudioAssociationsUnsuccessful = 'ALL_NETWORK_AUDIO_ASSOCIATIONS_UNSUCCESSFUL',
	DeviceOperationModeUnsuccessful = 'DEVICE_OPERATION_MODE_UNSUCCESSFUL',
	IncompatibleDevices = 'INCOMPATIBLE_DEVICES',
	IneligibleMicrophonesForAccessPointProcessor = 'INELIGIBLE_MICROPHONES_FOR_ACCESS_POINT_PROCESSOR',
	NonImxMixOutputsUsedToFitDevices = 'NON_IMX_MIX_OUTPUTS_USED_TO_FIT_DEVICES',
	NoApplicableRoutesForStereoAecProcessor = 'NO_APPLICABLE_ROUTES_FOR_STEREO_AEC_PROCESSOR',
	SomeLinkingUnsuccessful = 'SOME_LINKING_UNSUCCESSFUL',
	SomeMxwnAssociationsUnsuccessful = 'SOME_MXWN_ASSOCIATIONS_UNSUCCESSFUL',
	SomeNetworkAudioAssociationsUnsuccessful = 'SOME_NETWORK_AUDIO_ASSOCIATIONS_UNSUCCESSFUL',
	TooManyAccessPoints = 'TOO_MANY_ACCESS_POINTS',
	TooManyAmplifiers = 'TOO_MANY_AMPLIFIERS',
	TooManyChargers = 'TOO_MANY_CHARGERS',
	TooManyLoudspeakers = 'TOO_MANY_LOUDSPEAKERS',
	TooManyMicrophones = 'TOO_MANY_MICROPHONES',
	TooManyMicrophonesForStereoAecProcessor = 'TOO_MANY_MICROPHONES_FOR_STEREO_AEC_PROCESSOR',
	TooManyMuteDevices = 'TOO_MANY_MUTE_DEVICES',
	TooManyProcessors = 'TOO_MANY_PROCESSORS'
}

export type GroupOptimizationResult = {
	deviceOptimizationResults: Array<DeviceOptimizationResult>;
	overallResult: GroupOptimizationStatus | `${GroupOptimizationStatus}`;
};

export enum GroupOptimizationStatus {
	Conflict = 'CONFLICT',
	DevicesUnavailable = 'DEVICES_UNAVAILABLE',
	Failure = 'FAILURE',
	NoDevicesToOptimize = 'NO_DEVICES_TO_OPTIMIZE',
	PartialSuccess = 'PARTIAL_SUCCESS',
	Success = 'SUCCESS'
}

export type IDurationRangeConstraints = {
	range: DurationRange;
};

export type IFieldSupportInfo = {
	supported: Scalars['Boolean']['output'];
};

export type IFloatRangeConstraints = {
	range: FloatRange;
};

export type IIntRangeConstraints = {
	range: IntRange;
};

export type INullableDurationRangeConstraints = {
	range: Maybe<DurationRange>;
};

export type INullableFloatRangeConstraints = {
	range: Maybe<FloatRange>;
};

export type INullableIntRangeConstraints = {
	range: Maybe<IntRange>;
};

export type IStringPatternRangeConstraints = {
	pattern: Maybe<Scalars['Regex']['output']>;
};

export type IUtf8StringMaxBytesConstraints = {
	utf8MaxBytes: Maybe<Scalars['Int']['output']>;
};

export type InspectKeyringOperationResult = {
	deviceIds: Array<Scalars['ID']['output']>;
	error: Maybe<OperationError>;
};

export type IntRange = {
	max: Scalars['Int']['output'];
	min: Scalars['Int']['output'];
	step: Scalars['Int']['output'];
};

export type IntRangeConstraints = {
	range: IntRange;
};

export type InterfaceDetails = {
	category: Scalars['String']['output'];
	model: Maybe<Scalars['String']['output']>;
	type: Scalars['Guid']['output'];
	version: InterfaceVersion;
};

export type InterfaceVersion = {
	beta: Scalars['Boolean']['output'];
	interfaceId: Scalars['Int']['output'];
	version: Scalars['SemanticVersion']['output'];
};

export enum IpMode {
	Dhcp = 'DHCP',
	Static = 'STATIC'
}

export type KeyringInput = {
	id: Scalars['ID']['input'];
	passphrase: Scalars['String']['input'];
};

export type KeyringOperationResult = {
	error: Maybe<OperationError>;
	keyring: Maybe<Scalars['String']['output']>;
};

/**
 * IETF language tags are used to specify the language.
 * https://en.wikipedia.org/wiki/IETF_language_tag
 */
export enum Language {
	Ar = 'AR',
	De = 'DE',
	En = 'EN',
	Es = 'ES',
	Fr = 'FR',
	It = 'IT',
	Ja = 'JA',
	Ko = 'KO',
	PtBr = 'PT_BR',
	Ru = 'RU',
	ZhCn = 'ZH_CN'
}

export enum LastAuthenticationStatus8021X {
	Failure = 'FAILURE',
	NeverAttempted = 'NEVER_ATTEMPTED',
	Success = 'SUCCESS'
}

export enum LicenseActivationState {
	Activated = 'ACTIVATED',
	Canceled = 'CANCELED',
	HostMismatchError = 'HOST_MISMATCH_ERROR',
	InsufficientFailure = 'INSUFFICIENT_FAILURE',
	InternalError = 'INTERNAL_ERROR',
	InvalidConfigurationFailure = 'INVALID_CONFIGURATION_FAILURE',
	KeyNotfoundFailure = 'KEY_NOTFOUND_FAILURE',
	NetworkFailure = 'NETWORK_FAILURE',
	ParameterError = 'PARAMETER_ERROR',
	Pending = 'PENDING',
	PendingInsufficient = 'PENDING_INSUFFICIENT',
	PendingNetwork = 'PENDING_NETWORK'
}

export enum LicenseCancelationState {
	Canceled = 'CANCELED',
	Failed = 'FAILED',
	InternalError = 'INTERNAL_ERROR',
	ParameterError = 'PARAMETER_ERROR',
	Pending = 'PENDING'
}

export enum LicenseDeactivationState {
	Deactivated = 'DEACTIVATED',
	InternalError = 'INTERNAL_ERROR',
	NetworkFailure = 'NETWORK_FAILURE',
	ParameterError = 'PARAMETER_ERROR',
	Pending = 'PENDING'
}

export enum LicenseState {
	Clockwindback = 'CLOCKWINDBACK',
	Expired = 'EXPIRED',
	FailedActivationKeyError = 'FAILED_ACTIVATION_KEY_ERROR',
	Grace = 'GRACE',
	InternalError = 'INTERNAL_ERROR',
	PendingActivationInsufficient = 'PENDING_ACTIVATION_INSUFFICIENT',
	PendingActivationNetwork = 'PENDING_ACTIVATION_NETWORK',
	PendingActivationOffline = 'PENDING_ACTIVATION_OFFLINE',
	PendingDeactivation = 'PENDING_DEACTIVATION',
	PendingExpiration = 'PENDING_EXPIRATION',
	Tampered = 'TAMPERED',
	Valid = 'VALID'
}

export enum LicenseStateV2 {
	Clockwindback = 'CLOCKWINDBACK',
	Expired = 'EXPIRED',
	FailedActivationKeyError = 'FAILED_ACTIVATION_KEY_ERROR',
	Grace = 'GRACE',
	InternalError = 'INTERNAL_ERROR',
	PendingActivationInsufficient = 'PENDING_ACTIVATION_INSUFFICIENT',
	PendingActivationNetwork = 'PENDING_ACTIVATION_NETWORK',
	PendingActivationOffline = 'PENDING_ACTIVATION_OFFLINE',
	PendingDeactivation = 'PENDING_DEACTIVATION',
	PendingExpiration = 'PENDING_EXPIRATION',
	Tampered = 'TAMPERED',
	Valid = 'VALID'
}

export enum LicenseStateV3 {
	Expired = 'EXPIRED',
	Grace = 'GRACE',
	InternalError = 'INTERNAL_ERROR',
	Valid = 'VALID'
}

export type LicenseSystemCommunication = {
	lastTransactionId: Maybe<Scalars['String']['output']>;
	state: LicenseSystemCommunicationState | `${LicenseSystemCommunicationState}`;
};

export enum LicenseSystemCommunicationState {
	Failure_4XxClientError = 'FAILURE_4XX_CLIENT_ERROR',
	Failure_5XxServerError = 'FAILURE_5XX_SERVER_ERROR',
	FailureTimeout = 'FAILURE_TIMEOUT',
	FailureUnknown = 'FAILURE_UNKNOWN',
	NotAttempted = 'NOT_ATTEMPTED',
	Success = 'SUCCESS'
}

export enum LicenseSystemIntegrityState {
	ClockWindback = 'CLOCK_WINDBACK',
	HostIdentityMismatch = 'HOST_IDENTITY_MISMATCH',
	Tampered = 'TAMPERED',
	Valid = 'VALID'
}

export enum LicenseType {
	Demo = 'DEMO',
	Paid = 'PAID',
	Trial = 'TRIAL'
}

export enum LicenseTypeV2 {
	Demo = 'DEMO',
	Paid = 'PAID',
	Trial = 'TRIAL'
}

export enum LicenseTypeV3 {
	Demo = 'DEMO',
	Paid = 'PAID',
	Trial = 'TRIAL'
}

export enum LightingColor {
	Blue = 'BLUE',
	Cyan = 'CYAN',
	Gold = 'GOLD',
	Green = 'GREEN',
	LightPurple = 'LIGHT_PURPLE',
	Orange = 'ORANGE',
	Orchid = 'ORCHID',
	Pink = 'PINK',
	PowderBlue = 'POWDER_BLUE',
	Purple = 'PURPLE',
	Red = 'RED',
	SkyBlue = 'SKY_BLUE',
	Turquoise = 'TURQUOISE',
	Violet = 'VIOLET',
	White = 'WHITE',
	Yellow = 'YELLOW',
	YellowGreen = 'YELLOW_GREEN'
}

export enum LightingMode {
	Flashing = 'FLASHING',
	Off = 'OFF',
	On = 'ON'
}

export type LightingSegmentBehavior = {
	color: RgbColorMix;
	mode: LightingSegmentMode | `${LightingSegmentMode}`;
};

export enum LightingSegmentMode {
	/** Segment lights identifying with flashing, where the intensity is abrupt */
	Flashing = 'FLASHING',
	/** Light Segment off */
	Off = 'OFF',
	/** Segment light solid on */
	On = 'ON',
	/** Segment lights ON with flashing, where the intensity is gradual */
	Pulsing = 'PULSING'
}

export enum LightingState {
	Muted = 'MUTED',
	Unmuted = 'UNMUTED'
}

export enum LightingStyle {
	Ring = 'RING',
	Segment = 'SEGMENT'
}

export enum LightingTouchPanelMode {
	Combined = 'COMBINED',
	Split = 'SPLIT'
}

export enum LinkingOperationResult {
	/** Device is not discoverable. */
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	/** Failed to link RF channel(s) and transmitter(s) */
	Failure = 'FAILURE',
	/** Input node id(s) provided in linking request is not valid. */
	InvalidInput = 'INVALID_INPUT',
	/** Provided input devices either does not support linking feature or not a valid input for this operation. */
	InvalidOperation = 'INVALID_OPERATION',
	/** No associations exist on RF channel(s) or charger bay(s). */
	NoAssociationsExist = 'NO_ASSOCIATIONS_EXIST',
	/** No transmitter is discovered for the charger bay. */
	NoTransmittersOnCharger = 'NO_TRANSMITTERS_ON_CHARGER',
	/** Successfully linked RF channel(s) and transmitter(s) */
	Success = 'SUCCESS'
}

export enum LinkingStatus {
	/**
	 * An unknown reason caused the failure.
	 * This means the middleware receive a linking result that is not expected such as BAN_SECONDARY_MIC or INVALID_APT_CHANNEL
	 */
	Failure = 'FAILURE',
	/** Linking failed due to audio protocol mismatch */
	FailureAudioProtocolMismatch = 'FAILURE_AUDIO_PROTOCOL_MISMATCH',
	/**
	 * Linking failed due to mismatched access point/charger/transmitter firmware version
	 * Major and minor version of firmware for devices should be matched to perform linking operation
	 */
	FailureFirmwareVersionMismatch = 'FAILURE_FIRMWARE_VERSION_MISMATCH',
	/** Linking failed due to RF band mismatch */
	FailureRfBandMismatch = 'FAILURE_RF_BAND_MISMATCH',
	/** Successfully linked RF channel and transmitter */
	Success = 'SUCCESS',
	/** Failed to receive linking result within the timeout */
	TimeoutExceeded = 'TIMEOUT_EXCEEDED'
}

export type LiveMeterColorConstraints = {
	customThemeLightColorGradient: LiveMeterCustomThemeLightColorGradientConstraints;
	theme: ColorThemeConstraints;
};

export type LiveMeterColorThemeInfo = {
	customThemeLightColorGradient: LiveMeterCustomThemeLightColorGradient;
	theme: ColorTheme | `${ColorTheme}`;
};

export type LiveMeterColorThemeInfoInput = {
	customThemeLightColorGradient?: InputMaybe<LiveMeterCustomThemeLightColorGradientInput>;
	theme?: InputMaybe<ColorTheme | `${ColorTheme}`>;
};

export type LiveMeterCustomThemeLightColorGradient = {
	centerLightColor: RgbColorMix;
	clippingLightColor: RgbColorMix;
	outermostLightColor: RgbColorMix;
};

export type LiveMeterCustomThemeLightColorGradientConstraints = {
	centerLightColor: RgbColorMixConstraints;
	clippingLightColor: RgbColorMixConstraints;
	outermostLightColor: RgbColorMixConstraints;
};

export type LiveMeterCustomThemeLightColorGradientInput = {
	centerLightColor?: InputMaybe<RgbColorMixInput>;
	clippingLightColor?: InputMaybe<RgbColorMixInput>;
	outermostLightColor?: InputMaybe<RgbColorMixInput>;
};

export type LoadDeviceStateInput = {
	device: Scalars['ID']['input'];
	filePath: Scalars['String']['input'];
};

export type LoadDeviceStateResult = {
	device: Maybe<Device>;
	error: Maybe<OperationError>;
	filePath: Maybe<Scalars['String']['output']>;
};

export enum LoadPerDeviceStateResult {
	LoadFailed = 'LOAD_FAILED',
	LoadSuccess = 'LOAD_SUCCESS'
}

export type LobePosition = {
	/** X coordinate for a fencing lobe in millimeters */
	xPosition: Scalars['Float']['output'];
	/** Y coordinate for a fencing lobe in millimeters */
	yPosition: Scalars['Float']['output'];
	/** Z coordinate for a fencing lobe in millimeters */
	zPosition: Scalars['Float']['output'];
};

export type LobePositionConstraints = {
	xPosition: FloatRangeConstraints;
	yPosition: FloatRangeConstraints;
	zPosition: FloatRangeConstraints;
};

export enum LobeStatus {
	Fenced = 'FENCED',
	Noise = 'NOISE',
	NotDeployed = 'NOT_DEPLOYED',
	Speech = 'SPEECH'
}

export type LobeStatusConstraints = {
	options: Array<LobeStatus | `${LobeStatus}`>;
};

export enum LobeWidth {
	Medium = 'MEDIUM',
	Narrow = 'NARROW',
	Wide = 'WIDE'
}

export type LobeWidthConstraints = {
	options: Array<LobeWidth | `${LobeWidth}`>;
};

export enum LocalizationSensitivity {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM'
}

export type LocalizationSensitivityConstraints = {
	options: Array<LocalizationSensitivity | `${LocalizationSensitivity}`>;
};

export enum Loudspeaker {
	Generic = 'GENERIC',
	Generic_4Ohm = 'GENERIC_4_OHM',
	Generic_8Ohm = 'GENERIC_8_OHM',
	Mxp_1 = 'MXP_1',
	Mxp_3 = 'MXP_3',
	Mxp_5 = 'MXP_5',
	Mxp_6 = 'MXP_6',
	NotConfigured = 'NOT_CONFIGURED'
}

export type MeterChange = AudioChannelMeterChange | AudioCoverageAreaMeterChange | RfChannelMeterChange;

export enum MeterChangeType {
	AudioChannelAcousticEchoCancellationErle = 'AUDIO_CHANNEL_ACOUSTIC_ECHO_CANCELLATION_ERLE',
	AudioChannelAcousticEchoCancellationPeak = 'AUDIO_CHANNEL_ACOUSTIC_ECHO_CANCELLATION_PEAK',
	AudioChannelAcousticEchoCancellationRms = 'AUDIO_CHANNEL_ACOUSTIC_ECHO_CANCELLATION_RMS',
	AudioChannelActivity = 'AUDIO_CHANNEL_ACTIVITY',
	AudioChannelAnalogStereoPeak = 'AUDIO_CHANNEL_ANALOG_STEREO_PEAK',
	AudioChannelAnalogStereoRms = 'AUDIO_CHANNEL_ANALOG_STEREO_RMS',
	AudioChannelAutomaticGain = 'AUDIO_CHANNEL_AUTOMATIC_GAIN',
	AudioChannelAutomaticGainControlPeak = 'AUDIO_CHANNEL_AUTOMATIC_GAIN_CONTROL_PEAK',
	AudioChannelAutomaticGainControlRms = 'AUDIO_CHANNEL_AUTOMATIC_GAIN_CONTROL_RMS',
	AudioChannelAutomixerAutoLevelMode = 'AUDIO_CHANNEL_AUTOMIXER_AUTO_LEVEL_MODE',
	AudioChannelAutomixerGate = 'AUDIO_CHANNEL_AUTOMIXER_GATE',
	AudioChannelAutomixerInputPeak = 'AUDIO_CHANNEL_AUTOMIXER_INPUT_PEAK',
	AudioChannelAutomixerInputRms = 'AUDIO_CHANNEL_AUTOMIXER_INPUT_RMS',
	AudioChannelAutomixerNoiseFloorEstimate = 'AUDIO_CHANNEL_AUTOMIXER_NOISE_FLOOR_ESTIMATE',
	AudioChannelAutomixGain = 'AUDIO_CHANNEL_AUTOMIX_GAIN',
	AudioChannelClip = 'AUDIO_CHANNEL_CLIP',
	AudioChannelCompressorEngaged = 'AUDIO_CHANNEL_COMPRESSOR_ENGAGED',
	AudioChannelDenoiserNoiseReduction = 'AUDIO_CHANNEL_DENOISER_NOISE_REDUCTION',
	AudioChannelLimiterEngaged = 'AUDIO_CHANNEL_LIMITER_ENGAGED',
	AudioChannelMatrixMixerInputPeak = 'AUDIO_CHANNEL_MATRIX_MIXER_INPUT_PEAK',
	AudioChannelMatrixMixerInputRms = 'AUDIO_CHANNEL_MATRIX_MIXER_INPUT_RMS',
	AudioChannelMatrixMixerOutputPeak = 'AUDIO_CHANNEL_MATRIX_MIXER_OUTPUT_PEAK',
	AudioChannelMatrixMixerOutputRms = 'AUDIO_CHANNEL_MATRIX_MIXER_OUTPUT_RMS',
	AudioChannelMatrixMixerPeak = 'AUDIO_CHANNEL_MATRIX_MIXER_PEAK',
	AudioChannelMatrixMixerRms = 'AUDIO_CHANNEL_MATRIX_MIXER_RMS',
	AudioChannelMatrixMixerStereoInputPeak = 'AUDIO_CHANNEL_MATRIX_MIXER_STEREO_INPUT_PEAK',
	AudioChannelMatrixMixerStereoInputRms = 'AUDIO_CHANNEL_MATRIX_MIXER_STEREO_INPUT_RMS',
	AudioChannelPeak = 'AUDIO_CHANNEL_PEAK',
	AudioChannelPostGateGainStereoPeak = 'AUDIO_CHANNEL_POST_GATE_GAIN_STEREO_PEAK',
	AudioChannelPostGateGainStereoRms = 'AUDIO_CHANNEL_POST_GATE_GAIN_STEREO_RMS',
	AudioChannelRms = 'AUDIO_CHANNEL_RMS',
	AudioChannelStereoAutomixerGate = 'AUDIO_CHANNEL_STEREO_AUTOMIXER_GATE',
	AudioChannelStereoAutomixGain = 'AUDIO_CHANNEL_STEREO_AUTOMIX_GAIN',
	AudioChannelStereoPeak = 'AUDIO_CHANNEL_STEREO_PEAK',
	AudioChannelStereoRms = 'AUDIO_CHANNEL_STEREO_RMS',
	AudioCoverageAreaAutomixerGate = 'AUDIO_COVERAGE_AREA_AUTOMIXER_GATE',
	AudioCoverageAreaPeak = 'AUDIO_COVERAGE_AREA_PEAK',
	AudioCoverageAreaRms = 'AUDIO_COVERAGE_AREA_RMS',
	/** @deprecated Basing a general notion of RF performance on RSSI without taking into account the signal to noise ratio is too short-sighted. Axient Digital quality metering addresses this. */
	RfChannelActivity = 'RF_CHANNEL_ACTIVITY',
	RfChannelAntennaDiversity = 'RF_CHANNEL_ANTENNA_DIVERSITY',
	RfChannelQuality = 'RF_CHANNEL_QUALITY',
	RfChannelSignalStrength = 'RF_CHANNEL_SIGNAL_STRENGTH',
	RfChannelSignalStrengthWithExceptions = 'RF_CHANNEL_SIGNAL_STRENGTH_WITH_EXCEPTIONS'
}

export type MeterColorConstraints = {
	customThemeLightColor: RgbColorMixConstraints;
	theme: ColorThemeConstraints;
};

export type MeterColorThemeInfo = {
	customThemeLightColor: RgbColorMix;
	theme: ColorTheme | `${ColorTheme}`;
};

export type MeterColorThemeInfoInput = {
	customThemeLightColor?: InputMaybe<RgbColorMixInput>;
	theme?: InputMaybe<ColorTheme | `${ColorTheme}`>;
};

export enum MeteringMode {
	PostFader = 'POST_FADER',
	PreFader = 'PRE_FADER'
}

export enum MicOptimizationMode {
	Mxa310 = 'MXA310',
	Mxa320 = 'MXA320',
	Mxa710 = 'MXA710',
	Mxa901 = 'MXA901',
	Mxa902 = 'MXA902',
	Mxa910 = 'MXA910',
	Mxa920 = 'MXA920',
	Mxa925 = 'MXA925',
	Normal = 'NORMAL'
}

/**
 * The microphone polar pattern determines how much audio signal is picked up from the direction from which the signal originates from.
 * RAW_MID_SIDE: Combines Cardioid and Bi-directional polar pattern. Refer to the following youtube video for more information on its usage: https://youtu.be/HXpHcO8RG1M
 * Use this setting for increased post-processing flexibility. This records signal a 2-channel signal with a stereo image that can be adjusted even after the tracks have been recorded.
 */
export enum MicPolarPattern {
	Bidirectional = 'BIDIRECTIONAL',
	Cardioid = 'CARDIOID',
	Hypercardioid = 'HYPERCARDIOID',
	Omnidirectional = 'OMNIDIRECTIONAL',
	RawMidSide = 'RAW_MID_SIDE',
	Stereo = 'STEREO',
	Supercardioid = 'SUPERCARDIOID',
	Toroid = 'TOROID'
}

export enum MicSpatialOrientation {
	Down = 'DOWN',
	Horizontal = 'HORIZONTAL',
	Up = 'UP'
}

export enum MicStatus {
	/** Sending audio to the linked MXWAPT2/4/8 device */
	Active = 'ACTIVE',
	/** Not sending audio to the linked MXWAPT2/4/8 device */
	Mute = 'MUTE',
	/** Settable only */
	Off = 'OFF',
	/** Docked onto an MXWNCS2/4/8 charger */
	OnCharger = 'ON_CHARGER',
	/**
	 * The device can no longer communicate with the MXWAPT.
	 * In practice, applications should also monitor whether this transmitter has gone into deviceState=OFFLINE,
	 * since that also commonly happens.
	 */
	OutOfRange = 'OUT_OF_RANGE',
	/**
	 * The device is in a power conservation mode (not sending audio), but is online for further commands.
	 * Using updateNodes(), one can use the states of 'MicStatusInput' once another meeting or discussion is set to start or stop to "awaken" the transmitters, or turn them off.
	 */
	Standby = 'STANDBY',
	Unknown = 'UNKNOWN'
}

export enum MicStatusInput {
	/** Unmute an on-air transmitter */
	Active = 'ACTIVE',
	/** Mute an on-air transmitter */
	Mute = 'MUTE',
	/**
	 * Remotely turn off an MXW transmitter.
	 * Once turned off, the transmitter must be turned back on again using the device's power button.
	 */
	Off = 'OFF',
	/**
	 * Conserve power by stopping audio transmission, while remaining online for further commands.
	 * Allows the user to remotely set the mic into one of the other statuses in 'MicStatusInput' once another meeting or discussion is set to start or stop.
	 */
	Standby = 'STANDBY'
}

export enum MicStatusV2 {
	/** On-air, and unmuted at the MXWAPX */
	Active = 'ACTIVE',
	/** On-air, and muted at the MXWAPX */
	Mute = 'MUTE',
	/** Docked onto an MXWNDX charger */
	OnCharger = 'ON_CHARGER'
}

export type MicrophoneAngle = {
	angle: Scalars['Int']['output'];
};

export type MultiArrayLocalizationGroup = {
	/** A device which is part of this multi-array localization group. Includes the reporter and the follower device statuses. */
	device: Device;
	/** Multi-array localization group status of this device as reported by the reporter device. Note: the reported value can differ between multi-array localization groups for the same device. */
	groupStatus: MultiArrayLocalizationGroupStatus | `${MultiArrayLocalizationGroupStatus}`;
};

export type MultiArrayLocalizationGroupMissingDevice = {
	hardwareId: Scalars['Guid']['output'];
	id: Scalars['ID']['output'];
};

/** Basic information about device which is assigned to a MAL group, but have not been discovered or not in ONLINE state. */
export type MultiArrayLocalizationGroupMissingMember = {
	/** An OFFLINE or undiscovered device which is part of this multi-array localization group. */
	device: MultiArrayLocalizationGroupMissingDevice;
	/** Multi-array localization group status of this device as reported by the reporter device. Note: the reported value can differ between multi-array localization groups for the same device. */
	groupStatus: MultiArrayLocalizationGroupStatus | `${MultiArrayLocalizationGroupStatus}`;
};

export enum MultiArrayLocalizationGroupStatus {
	/** Device connection is successful */
	Connected = 'CONNECTED',
	/** Error connecting to this device */
	ConnectionError = 'CONNECTION_ERROR',
	/** One or more device(s) within the array group is more than 12ft (366 cm) away */
	DevicesTooFar = 'DEVICES_TOO_FAR',
	/** This device is incompatible with multi-array localization group */
	IncompatibleDevice = 'INCOMPATIBLE_DEVICE',
	/** Error connecting to other device(s) */
	ProtocolError = 'PROTOCOL_ERROR'
}

export type MultiArrayLocalizationGroupUpdateInput = {
	followers: Array<Scalars['ID']['input']>;
	reporter: Scalars['ID']['input'];
};

export type MultiArrayLocalizationGroupUpdateResult = {
	error: Maybe<OperationError>;
	multiArrayLocalizationGroupReporter: Maybe<DeviceMultiArrayLocalizationGroupReporter>;
};

export type Mutation = {
	/**
	 * Activates a coverage area with the provided initial configuration.
	 *
	 * The coverage area CANNOT overlap with currently active coverage areas.
	 *
	 * The coverage area CANNOT be more than 25'(7620000μm) away from the center of the device.
	 *
	 * Dedicated coverage areas MUST have a fixed size of 6' x 6' (1828800μm x 1828800μm).
	 */
	activateAudioCoverageArea: AudioCoverageAreaOperationResult;
	activateDeviceLicense: DeviceOperationResult;
	addDevicesToAudioMuteControlGroup: DeviceOperationResult;
	addDevicesToRoom: RoomOperationResult;
	addManualDeviceIps: OperationResult;
	/**
	 * Requests to add one or more virtual devices
	 *
	 * Waits for the virtual device(s) to come online
	 */
	addVirtualDevices: VirtualDeviceAdditionResult;
	/**
	 * Requests to add one or more virtual devices
	 *
	 * Does not wait for the virtual device(s) to come online
	 */
	addVirtualDevicesAsync: VirtualDeviceAdditionAsyncResult;
	/**
	 * Requests to add one or more virtual devices from uploaded JSON state files
	 *
	 * Waits for the virtual device(s) to come online
	 */
	addVirtualDevicesFromStateFileContents: VirtualDevicesAdditionFromStateFileContentsResult;
	/**
	 * Requests to add one or more virtual devices from JSON state files
	 *
	 * Waits for the virtual device(s) to come online
	 */
	addVirtualDevicesFromStateFilePaths: VirtualDevicesAdditionFromStateFilePathsResult;
	/**
	 * Requests to add one or more virtual devices from JSON state files
	 *
	 * Does not wait for the virtual device(s) to come online
	 */
	addVirtualDevicesFromStateFilePathsAsync: VirtualDeviceAdditionAsyncResult;
	/**
	 * Requests to add one or more virtual devices from remote JSON state files
	 *
	 * Waits for the virtual device(s) to come online
	 */
	addVirtualDevicesFromStateFileUris: VirtualDevicesAdditionFromStateFileUrisResult;
	assignSpectrumManager: DeviceOperationResult;
	/**
	 * Associate an access point's RF channel and a charger's charger bay to *prepare for linking* a transmitter with an access point's RF channel.
	 * Any existing prior association for the RF channel or the charger bay will be cleared before creating the requested association.
	 */
	associateAccessPointAndCharger: DeviceAssociationResult;
	authenticate: Maybe<DeviceOperationResult>;
	bypassInitialCredentials: Array<DeviceOperationResult>;
	cancelFirmwareUpdate: OperationResult;
	/** Cancel and if needed abort firmware update requests */
	cancelFirmwareUpdateRequests: OperationResult;
	cancelPendingActivationDeviceLicense: DeviceOperationResult;
	cancelRoomCloning: OperationResult;
	/**
	 * Clear all existing association(s) on an access point's RF channel or a charger's charger bay.
	 * 'disassociateAccessPointAndCharger()' should be used instead when the associated devices are online to confirm both device acknowledge the disassociation.
	 */
	clearAllAssociations: DeviceOperationResult;
	clearAllDanteAudioRoutes: DeleteRouteOperationResult;
	/**
	 * Clear a single association association(s) on an access point's RF channel or a charger's charger bay.
	 * 'disassociateAccessPointAndCharger()' should be used instead when the associated devices are online to confirm both devices acknowledge the disassociation.
	 */
	clearAssociation: ClearAssociationResult;
	clearAudioChannelPeakHold: AudioChannelOperationResult;
	clearAudioMuteControlGroup: DeviceOperationResult;
	clearDectRfSpectrumScanResults: DeviceOperationResult;
	clearErrorIndicator: DeviceOperationResult;
	clearManualDeviceIps: OperationResult;
	clearUserPreset: UserPresetOperationResult;
	configure8021x: DeviceOperationResult;
	createCredentials: Array<DeviceOperationResult>;
	createDanteAudioRoute: CreateRouteOperationResult;
	createKeyring: KeyringOperationResult;
	createRoom: RoomOperationResult;
	/** Deactivates a coverage area. */
	deactivateAudioCoverageArea: AudioCoverageAreaOperationResult;
	deactivateDeviceLicense: DeviceOperationResult;
	deleteDanteAudioRoute: DeleteRouteOperationResult;
	/** Requests to delete one or more virtual and/or offline devices */
	deleteDevices: DeleteDevicesResult;
	deleteRoom: OperationResult;
	disableAuracastEncryption: AudioChannelOperationResult;
	disableDanteAudioEncryption: DeviceOperationResult;
	/**
	 * Disassociate an access point's RF channel and a charger's charger bay. Both devices must be online for the disassociation to succeed.
	 * Use clearAllAssociations() or clearAssociation() instead when one of the devices is offline.
	 */
	disassociateAccessPointAndCharger: DeviceDisassociationResult;
	downloadFirmwarePackages: FirmwarePackageDownloadRequestProgress;
	enable8021x: DeviceOperationResult;
	enableAuracastEncryption: AudioChannelOperationResult;
	enableDanteAudioEncryption: DeviceOperationResult;
	exportDeviceEventLogs: EventLogExportResult;
	exportUserPresetToFileContents: UserPresetExportToFileContentsOperationResult;
	exportUserPresetToFilePath: UserPresetOperationResult;
	forceResetCredentials: DeviceOperationResult;
	importUserPresetFromFileContents: UserPresetOperationResult;
	importUserPresetFromFilePath: UserPresetOperationResult;
	inspectKeyring: InspectKeyringOperationResult;
	/**
	 * Link all transmitters docked on a charger to the associated access point RF channels(when deviceId is charger device Id)
	 * or link all transmitters docked on chargers associated with an access point(when device is access point device Id).
	 * All associations between access point's RF channel and charger's charger bay should be established before linking
	 * id is charger device node Id or access point device node Id.
	 * Note: Skipped linkings for all charger bays or all RF channels will return SUCCESS with null details
	 */
	linkAllTransmitters: DeviceGroupLinkingResult;
	/**
	 * Link single transmitter on a charger to access point's RF channel remotely if RF channel Id is provided.
	 * Otherwise, link the transmitter on a charger to the associated access point's RF channel.
	 * Remote linking will link the transmitter on a charger to access point's RF channel without association.
	 * Previously linked transmitter information will be lost if you link a different transmitter to the same RF channel.
	 */
	linkSingleTransmitter: DeviceSingleLinkingResult;
	loadDeviceStates: Array<LoadDeviceStateResult>;
	loadUserPreset: UserPresetOperationResult;
	lowPowerStandbyMode: OperationResult;
	powerOffDevice: OperationResult;
	reassignAudioChannel: OperationResult;
	rebootDevice: OperationResult;
	/** The refreshDeviceLicense mutation initiates a license refresh operation on the device. This operation involves communication between the device and ShureCloud. */
	refreshDeviceLicense: DeviceOperationResult;
	/**
	 * Requests to remove all virtual devices
	 * @deprecated Use deleteDevices to remove virtual and offline devices.
	 */
	removeAllVirtualDevices: VirtualDeviceRemovalResult;
	removeCredentials: Array<DeviceOperationResult>;
	removeDevicesFromAudioMuteControlGroup: DeviceOperationResult;
	removeDevicesFromRoom: RoomOperationResult;
	removeManualDeviceIps: OperationResult;
	/**
	 * Requests to remove one or more virtual devices
	 * @deprecated Use deleteDevices to remove virtual and offline devices.
	 */
	removeVirtualDevices: VirtualDeviceRemovalResult;
	replaceManualDeviceIps: OperationResult;
	/**
	 * Repositions a coverage area according to the provided coordinates.
	 *
	 * The coverage area CANNOT overlap with currently active coverage areas.
	 *
	 * The coverage area CANNOT be more than 25'(7620000μm) away from the center of the device.
	 *
	 * Dedicated coverage areas MUST have a fixed size of 6' x 6' (1828800μm x 1828800μm).
	 */
	repositionAudioCoverageArea: AudioCoverageAreaOperationResult;
	/** @deprecated This is an internal feature used to get DSP settings for debugging purposes. The requested DSP settings will be returned through subscription. */
	requestDspDebugSettings: OperationResult;
	/** Request to update the firmware of devices */
	requestFirmwareUpdates: Array<Maybe<FirmwareUpdateRequest>>;
	reset8021x: DeviceOperationResult;
	resetDevice: ResetDeviceResult;
	saveDeviceStates: Array<SaveDeviceStateResult>;
	saveUserPreset: UserPresetOperationResult;
	startAudioChannelAutoPositioning: AudioChannelOperationResult;
	startAudioChannelIdentify: AudioChannelOperationResult;
	startDectRfSpectrumScan: DeviceOperationResult;
	startIdentify: DeviceOperationResult;
	stopAudioChannelAutoPositioning: AudioChannelOperationResult;
	stopAudioChannelIdentify: AudioChannelOperationResult;
	stopDectRfSpectrumScan: DeviceOperationResult;
	stopIdentify: DeviceOperationResult;
	/** Synchronize Shure device/channel names to audio network device/channel names on the device */
	synchronizeAudioNetworkNamesOnDevice: NameSyncOperationResult;
	/**
	 * Unlink all transmitters via charger device or access point device.
	 * This mutation will unlink all transmitters docked on a charger(when deviceId is charger device Id)
	 * or unlink all transmitters linked to access point(when deviceId is access point device Id).
	 * id can be charger device node Id or access point node Id.
	 * Note: Skipped unlinkings for all charger bays or all RF channels will return SUCCESS with null details
	 */
	unlinkAllTransmitters: DeviceGroupUnlinkingResult;
	/**
	 * Unlink single transmitter via charger bay or RF channel.
	 * This mutation will unlink the transmitter docked on a charger(when id is charger bay node Id)
	 * or unlink the transmitter linked to access point's RF channel(when id is RF channel node Id).
	 * id can be charger bay node Id or RF channel node Id.
	 */
	unlinkSingleTransmitter: DeviceSingleUnlinkingResult;
	updateAcousticEchoCancellationMonoReferenceSource: AudioChannelOperationResult;
	updateAcousticEchoCancellationStereoReferenceSource: AudioChannelOperationResult;
	updateAudioChannelCount: DeviceOperationResult;
	updateAudioNetwork: OperationResult;
	updateAudioNetworkInterface: OperationResult;
	updateAudioNetworks: OperationResult;
	updateAutomixSourceSelector: AudioChannelOperationResult;
	updateChargerBayTestDockAction: OperationResult;
	updateControlNetwork: OperationResult;
	updateControlNetworkInterface: OperationResult;
	updateCredentials: Array<DeviceOperationResult>;
	updateDeviceLightingBrightness: DeviceOperationResult;
	/** The updateDevicePropery mutation is not-supported and is only used for internal purposes */
	updateDeviceProperty: Scalars['Boolean']['output'];
	updateDiscovery: OperationResult;
	updateDnsClientConfiguration: OperationResult;
	/** @deprecated This is an internal feature used to set DSP settings for debugging purposes.  */
	updateDspDebugSettings: OperationResult;
	updateEqualizerPreset: AudioChannelOperationResult;
	updateFirmware: FirmwareUpdateRequestProgress;
	updateGlobalMicStatus: DeviceOperationResult;
	updateKeyring: KeyringOperationResult;
	/**
	 * Create new, update existing or remove multi-array localization (MAL) group on the device.
	 * If no MAL group exists on the device, a new group will be created with the information from the request.
	 * If a MAL group already exists for the device, the values will be updated with information from the request.
	 * To remove a MAL group, add the reporter device to the request with empty list of follower devices.
	 */
	updateMultiArrayLocalizationGroup: MultiArrayLocalizationGroupUpdateResult;
	/**
	 * Update the network IP configurations of a device.
	 * This mutation could trigger multiple device reboots (three reboots at maximum) depending on the changes made.
	 */
	updateNetworkIpConfigurations: OperationResult;
	updateNetworkSwitchConfiguration: OperationResult;
	/**
	 * Update one or more nodes simultaneously by patching their current state(s) with new state(s).
	 *
	 * If one or more nodes provided correspond to devices which support the 'authentication' capability, and have authentication enabled,
	 * a keyring must be provided to authorize the update for the nodes on those devices.
	 */
	updateNodes: Array<NodeOperationResult>;
	updateRfChannelTuning: RfChannelOperationResult;
	updateRoom: RoomOperationResult;
	/** The language property of the device does not require device authentication. */
	updateUserInterfacePreferences: DeviceOperationResult;
	updateUserPresetName: UserPresetOperationResult;
	validateCertificate8021X: Certificate8021XValidationResult;
	verifyCredentials: Array<DeviceOperationResult>;
};

export type MutationActivateAudioCoverageAreaArgs = {
	coordinates: RectangularCoordinatesInput;
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
	type: AudioCoverageAreaType;
};

export type MutationActivateDeviceLicenseArgs = {
	input: ActivateLicenseInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationAddDevicesToAudioMuteControlGroupArgs = {
	devices: Array<Scalars['ID']['input']>;
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationAddDevicesToRoomArgs = {
	devices: Array<Scalars['ID']['input']>;
	keyring: InputMaybe<Scalars['String']['input']>;
	room: Scalars['ID']['input'];
};

export type MutationAddManualDeviceIpsArgs = {
	input: DeviceIpsInput;
};

export type MutationAddVirtualDevicesArgs = {
	input: VirtualDeviceAdditionInput;
};

export type MutationAddVirtualDevicesAsyncArgs = {
	input: VirtualDeviceAdditionInput;
};

export type MutationAddVirtualDevicesFromStateFileContentsArgs = {
	input: Array<VirtualDeviceAdditionFromStateFileContentsInput>;
};

export type MutationAddVirtualDevicesFromStateFilePathsArgs = {
	input: Array<VirtualDeviceAdditionFromStateFilePathInput>;
};

export type MutationAddVirtualDevicesFromStateFilePathsAsyncArgs = {
	input: Array<VirtualDeviceAdditionFromStateFilePathAsyncInput>;
};

export type MutationAddVirtualDevicesFromStateFileUrisArgs = {
	input: Array<VirtualDeviceAdditionFromStateFileUriInput>;
};

export type MutationAssignSpectrumManagerArgs = {
	input: DeviceAssignSpectrumManagerUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationAssociateAccessPointAndChargerArgs = {
	input: DeviceAssociationInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationAuthenticateArgs = {
	id: Scalars['ID']['input'];
	keyring: Scalars['String']['input'];
};

export type MutationBypassInitialCredentialsArgs = {
	inputs: Array<BypassCredentialsInput>;
};

export type MutationCancelFirmwareUpdateArgs = {
	requestId: Scalars['Guid']['input'];
};

export type MutationCancelFirmwareUpdateRequestsArgs = {
	ids: Array<Scalars['ID']['input']>;
};

export type MutationCancelPendingActivationDeviceLicenseArgs = {
	input: CancelPendingActivationLicenseInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationCancelRoomCloningArgs = {
	cloneRoomId: Scalars['ID']['input'];
};

export type MutationClearAllAssociationsArgs = {
	deviceId: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationClearAllDanteAudioRoutesArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	receiveDevice: Scalars['ID']['input'];
};

export type MutationClearAssociationArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationClearAudioChannelPeakHoldArgs = {
	id: Scalars['ID']['input'];
};

export type MutationClearAudioMuteControlGroupArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationClearDectRfSpectrumScanResultsArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationClearErrorIndicatorArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationClearUserPresetArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	presetId: Scalars['ID']['input'];
};

export type MutationConfigure8021xArgs = {
	config: ConfigInput8021X;
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCredentialsArgs = {
	inputs: Array<CreateCredentialsInput>;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDanteAudioRouteArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	receiveChannel: Scalars['ID']['input'];
	transmitChannel: Scalars['ID']['input'];
};

export type MutationCreateKeyringArgs = {
	input: Array<KeyringInput>;
};

export type MutationCreateRoomArgs = {
	input: CreateRoomInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeactivateAudioCoverageAreaArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeactivateDeviceLicenseArgs = {
	input: DeactivateLicenseInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteDanteAudioRouteArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	receiveChannel: Scalars['ID']['input'];
};

export type MutationDeleteDevicesArgs = {
	input: DeleteDevicesInput;
};

export type MutationDeleteRoomArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	room: Scalars['ID']['input'];
};

export type MutationDisableAuracastEncryptionArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationDisableDanteAudioEncryptionArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationDisassociateAccessPointAndChargerArgs = {
	input: DeviceDisassociationInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationDownloadFirmwarePackagesArgs = {
	packages: Array<FirmwarePackageDownloadInput>;
};

export type MutationEnable8021xArgs = {
	enable: Scalars['Boolean']['input'];
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
	rebootNow: Scalars['Boolean']['input'];
};

export type MutationEnableAuracastEncryptionArgs = {
	input: AudioChannelAuracastEncryptionEnableInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationEnableDanteAudioEncryptionArgs = {
	input: AudioEncryptionSettingsInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationExportDeviceEventLogsArgs = {
	id: Scalars['ID']['input'];
};

export type MutationExportUserPresetToFileContentsArgs = {
	presetId: Scalars['ID']['input'];
};

export type MutationExportUserPresetToFilePathArgs = {
	input: PresetExportToFilePathInput;
};

export type MutationForceResetCredentialsArgs = {
	id: Scalars['ID']['input'];
};

export type MutationImportUserPresetFromFileContentsArgs = {
	input: PresetImportFromFileContentsInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationImportUserPresetFromFilePathArgs = {
	input: PresetImportFromFilePathInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationInspectKeyringArgs = {
	keyring: Scalars['String']['input'];
};

export type MutationLinkAllTransmittersArgs = {
	deviceId: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationLinkSingleTransmitterArgs = {
	input: DeviceLinkingInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationLoadDeviceStatesArgs = {
	input: Array<LoadDeviceStateInput>;
};

export type MutationLoadUserPresetArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	presetId: Scalars['ID']['input'];
};

export type MutationLowPowerStandbyModeArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationPowerOffDeviceArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationReassignAudioChannelArgs = {
	input: DeviceAudioChannelReassignmentInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationRebootDeviceArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefreshDeviceLicenseArgs = {
	input: RefreshDeviceLicenseInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveCredentialsArgs = {
	inputs: Array<RemoveCredentialsInput>;
	keyring: Scalars['String']['input'];
};

export type MutationRemoveDevicesFromAudioMuteControlGroupArgs = {
	devices: Array<Scalars['ID']['input']>;
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveDevicesFromRoomArgs = {
	devices: Array<Scalars['ID']['input']>;
	keyring: InputMaybe<Scalars['String']['input']>;
	room: Scalars['ID']['input'];
};

export type MutationRemoveManualDeviceIpsArgs = {
	input: DeviceIpsInput;
};

export type MutationRemoveVirtualDevicesArgs = {
	input: VirtualDeviceRemovalInput;
};

export type MutationReplaceManualDeviceIpsArgs = {
	input: DeviceIpsInput;
};

export type MutationRepositionAudioCoverageAreaArgs = {
	coordinates: RectangularCoordinatesInput;
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationRequestDspDebugSettingsArgs = {
	input: DeviceDspDebugSettingsQueryInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationRequestFirmwareUpdatesArgs = {
	input: Array<RequestFirmwareUpdateInput>;
};

export type MutationReset8021xArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
	rebootNow: Scalars['Boolean']['input'];
};

export type MutationResetDeviceArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
	scope: DeviceResetScope;
};

export type MutationSaveDeviceStatesArgs = {
	input: Array<SaveDeviceStateInput>;
};

export type MutationSaveUserPresetArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	presetId: Scalars['ID']['input'];
};

export type MutationStartAudioChannelAutoPositioningArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartAudioChannelIdentifyArgs = {
	id: Scalars['ID']['input'];
};

export type MutationStartDectRfSpectrumScanArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartIdentifyArgs = {
	id: Scalars['ID']['input'];
};

export type MutationStopAudioChannelAutoPositioningArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationStopAudioChannelIdentifyArgs = {
	id: Scalars['ID']['input'];
};

export type MutationStopDectRfSpectrumScanArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationStopIdentifyArgs = {
	id: Scalars['ID']['input'];
};

export type MutationSynchronizeAudioNetworkNamesOnDeviceArgs = {
	input: AudioNetworkNameSyncInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUnlinkAllTransmittersArgs = {
	deviceId: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUnlinkSingleTransmitterArgs = {
	id: Scalars['ID']['input'];
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAcousticEchoCancellationMonoReferenceSourceArgs = {
	input: AudioChannelAcousticEchoCancellationMonoReferenceInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAcousticEchoCancellationStereoReferenceSourceArgs = {
	input: AudioChannelAcousticEchoCancellationStereoReferenceInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAudioChannelCountArgs = {
	input: AudioChannelCountInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAudioNetworkArgs = {
	input: UpdateAudioNetworkInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAudioNetworkInterfaceArgs = {
	input: UpdateAudioNetworkInterfaceInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAudioNetworksArgs = {
	input: UpdateAudioNetworksInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAutomixSourceSelectorArgs = {
	input: AutomixSourceSelectorInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateChargerBayTestDockActionArgs = {
	input: ChargerBayTestDockActionUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateControlNetworkArgs = {
	input: UpdateControlNetworkInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateControlNetworkInterfaceArgs = {
	input: UpdateControlNetworkInterfaceInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCredentialsArgs = {
	inputs: Array<UpdateCredentialsInput>;
	keyring: Scalars['String']['input'];
};

export type MutationUpdateDeviceLightingBrightnessArgs = {
	input: DeviceLightingBrightnessUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateDevicePropertyArgs = {
	id: Scalars['ID']['input'];
	propertyKey: Scalars['String']['input'];
	propertyValue: Scalars['String']['input'];
};

export type MutationUpdateDiscoveryArgs = {
	input: SupportedProtocolsInput;
};

export type MutationUpdateDnsClientConfigurationArgs = {
	input: UpdateDnsClientConfigurationInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateDspDebugSettingsArgs = {
	input: DeviceDspDebugSettingsUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEqualizerPresetArgs = {
	input: AudioChannelEqualizerPresetUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFirmwareArgs = {
	input: Array<UpdateDeviceFirmwareInput>;
};

export type MutationUpdateGlobalMicStatusArgs = {
	input: DeviceGlobalMicStatusUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateKeyringArgs = {
	input: Array<KeyringInput>;
	keyring: Scalars['String']['input'];
};

export type MutationUpdateMultiArrayLocalizationGroupArgs = {
	input: MultiArrayLocalizationGroupUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateNetworkIpConfigurationsArgs = {
	input: UpdateNetworkIpConfigurationsInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateNetworkSwitchConfigurationArgs = {
	input: DeviceNetworkSwitchConfigurationUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateNodesArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	updates: Array<NodeUpdateInput>;
};

export type MutationUpdateRfChannelTuningArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	tuning: RfChannelTuningUpdateInput;
};

export type MutationUpdateRoomArgs = {
	input: UpdateRoomInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateUserInterfacePreferencesArgs = {
	input: DeviceUserInterfacePreferencesUpdateInput;
};

export type MutationUpdateUserPresetNameArgs = {
	input: PresetUpdateInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type MutationValidateCertificate8021XArgs = {
	certificate: Scalars['String']['input'];
};

export type MutationVerifyCredentialsArgs = {
	inputs: Array<VerifyCredentialsInput>;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export enum MuteButtonMode {
	PushToMute = 'PUSH_TO_MUTE',
	PushToTalk = 'PUSH_TO_TALK',
	Toggle = 'TOGGLE'
}

export enum MuteControlFunction {
	Disabled = 'DISABLED',
	Local = 'LOCAL',
	LogicOut = 'LOGIC_OUT'
}

export type NameSyncOperationResult = {
	error: Maybe<OperationError>;
	result: Maybe<AudioNetworkNameSyncResult>;
};

export type NetworkAddressConfiguration = {
	dhcpServer: Maybe<Scalars['IpAddress']['output']>;
	gateway: Maybe<Scalars['IpAddress']['output']>;
	ipAddress: Scalars['IpAddress']['output'];
	leaseEndTime: Maybe<Scalars['DateTime']['output']>;
	leaseStartTime: Maybe<Scalars['DateTime']['output']>;
	subnetMask: Scalars['IpAddress']['output'];
};

export type NetworkInterface = {
	description: Scalars['String']['output'];
	gateway: Maybe<Scalars['IpAddress']['output']>;
	/** Example: Windows: (GUID) '{60B5DC8A-837A-44BC-B594-5027416EF5CC}', Unix: 'en0' */
	id: Scalars['String']['output'];
	ipAddress: Scalars['IpAddress']['output'];
	macAddress: Scalars['String']['output'];
	/**
	 * Display name, or 'Friendly name', of network interface.
	 * Example: Windows: 'Test Network', Mac: 'Thunderbolt Ethernet Slot 1'. Note: Will be copy of below 'id' field for Linux.
	 */
	name: Scalars['String']['output'];
	subnetMask: Scalars['IpAddress']['output'];
};

export type NetworkInterfaceChange = {
	status: NetworkInterfaceStatus | `${NetworkInterfaceStatus}`;
};

export type NetworkInterfaceInfo = {
	gateway: Maybe<Scalars['IpAddress']['output']>;
	ipAddress: Maybe<Scalars['IpAddress']['output']>;
	ipMode: Maybe<IpMode | `${IpMode}`>;
	macAddress: Scalars['String']['output'];
	subnetMask: Maybe<Scalars['IpAddress']['output']>;
};

export enum NetworkInterfaceState {
	Connected = 'Connected',
	Disabled = 'Disabled',
	Disconnected = 'Disconnected',
	Invalid = 'Invalid'
}

export enum NetworkInterfaceStatus {
	InterfaceDisabled = 'INTERFACE_DISABLED',
	InterfaceEnabled = 'INTERFACE_ENABLED',
	IpaddressChanged = 'IPADDRESS_CHANGED',
	NetmaskChanged = 'NETMASK_CHANGED',
	NotSet = 'NOT_SET'
}

export type NetworkInterfaceV2 = {
	/** The address information for this adapter. Note multiple addresses may be configured for the same adapter */
	addressConfiguration: NetworkAddressConfiguration;
	description: Scalars['String']['output'];
	/** Array of currently discovered devices on the interface, null if discovery is not running on this adapter */
	discoveredDevices: Maybe<Array<DiscoveredDeviceInfo>>;
	/** Example: Windows: (GUID) '{60B5DC8A-837A-44BC-B594-5027416EF5CC}', Unix: 'en0' */
	hostId: Scalars['String']['output'];
	/** Current system hostname, or null if a hostname was not set or cannot be determined */
	hostname: Maybe<Scalars['String']['output']>;
	/** A unique cache-key identifier for the adapter+address pair */
	id: Scalars['String']['output'];
	/** EUI-48 adapter address */
	macAddress: Scalars['String']['output'];
	/**
	 * Display name, or 'Friendly name', of network interface.
	 * Example: Windows: 'Test Network', Mac: 'Thunderbolt Ethernet Slot 1'. Note: Will be copy of below 'id' field for Linux.
	 */
	name: Scalars['String']['output'];
	/** True if this adapter is currently selected as the SystemAPI primary adapter */
	primaryInterface: Scalars['Boolean']['output'];
	status: NetworkInterfaceState | `${NetworkInterfaceState}`;
	/** Option text describing the reason for the current status */
	statusText: Maybe<Scalars['String']['output']>;
};

export type NetworkIpConfigurationsAudioNetworkInput = {
	gateway?: InputMaybe<Scalars['IpAddress']['input']>;
	ipAddress?: InputMaybe<Scalars['IpAddress']['input']>;
	ipMode: IpMode | `${IpMode}`;
	subnetMask?: InputMaybe<Scalars['IpAddress']['input']>;
};

export type NetworkIpConfigurationsControlNetworkInput = {
	gateway?: InputMaybe<Scalars['IpAddress']['input']>;
	ipAddress?: InputMaybe<Scalars['IpAddress']['input']>;
	ipMode: IpMode | `${IpMode}`;
	subnetMask?: InputMaybe<Scalars['IpAddress']['input']>;
};

export type NetworkIpConfigurationsDnsClientConfigurationInput = {
	/**
	 * The first array item is the primary server IP address
	 * and the second array item is the secondary server IP address
	 * Missing any array item or providing more than 2 items will cause INVALID_INPUT error.
	 * This field is required for MANUAL mode
	 */
	manualConfiguration?: InputMaybe<Array<Scalars['IpAddress']['input']>>;
	mode: DeviceDnsClientConfigurationMode | `${DeviceDnsClientConfigurationMode}`;
};

export enum NetworkSwitchConfigurationMode {
	/** The device's primary ethernet port is used for control and audio networks, and the second ethernet port can be used as secondary control network */
	Bimodal = 'BIMODAL',
	/**
	 * A control network and a primary audio network is available on the device's primary ethernet port.
	 * Additionally, a redundant audio network is available on the device's secondary ethernet port.
	 */
	Redundant = 'REDUNDANT',
	/** The device's primary ethernet port is dedicated for the control network, and the secondary ethernet port is dedicated for the audio network. */
	Split = 'SPLIT',
	/**
	 * The device's ethernet ports are configured as follows
	 * 1) Control Network
	 * 2) Control Network
	 * 3) Audio Network
	 * 4) Redundant Audio Network
	 */
	SplitRedundant = 'SPLIT_REDUNDANT',
	/** The control network and audio network are available across all ethernet ports on the device */
	Switched = 'SWITCHED',
	/**
	 * Dedicate one of the ethernet ports as a control-only connection for unicast traffic.
	 * Uplink mode blocks multicast traffic, restricting network audio and Shure Discovery data.
	 * Refer to the Shure MXW user guide for more info.
	 */
	Uplink = 'UPLINK'
}

export type Node = {
	id: Scalars['ID']['output'];
};

/** Box type which allows propagation of node and fragment ids without the overhead of repeated resolution. */
export type NodeAndFragmentIds = {
	fragmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
};

export type NodeChange =
	| AudioChannel
	| AudioChannelChange
	| AudioCoverageArea
	| AudioCoverageAreaChange
	| ChargerBay
	| ChargerBayChange
	| ChargerSlot
	| ChargerSlotChange
	| CrossPoint
	| CrossPointChange
	| Device
	| DeviceChange
	| DeviceStatusChange
	| DspDebugAudioFenceLobe
	| DspDebugAudioFenceLobeChange
	| EqualizerFilter
	| EqualizerFilterChange
	| ExternalDisplay
	| ExternalDisplayChange
	| FirmwarePackageDownloadProgress
	| FirmwarePackageDownloadRequestProgress
	| FirmwareUpdateProgress
	| FirmwareUpdateRequest
	| FirmwareUpdateRequestProgress
	| PassiveSpeaker
	| PassiveSpeakerChange
	| RfChannel
	| RfChannelChange
	| RfPort
	| RfPortChange
	| Room
	| UserPreset
	| UserPresetChange;

export enum NodeChangeType {
	AudioChannelAcousticEchoCancellation = 'AUDIO_CHANNEL_ACOUSTIC_ECHO_CANCELLATION',
	AudioChannelAcousticEchoCancellationMonoReference = 'AUDIO_CHANNEL_ACOUSTIC_ECHO_CANCELLATION_MONO_REFERENCE',
	AudioChannelAcousticEchoCancellationStereoReference = 'AUDIO_CHANNEL_ACOUSTIC_ECHO_CANCELLATION_STEREO_REFERENCE',
	AudioChannelAnalogInputUse = 'AUDIO_CHANNEL_ANALOG_INPUT_USE',
	AudioChannelAnalogLevel = 'AUDIO_CHANNEL_ANALOG_LEVEL',
	AudioChannelAuracast = 'AUDIO_CHANNEL_AURACAST',
	AudioChannelAuracastEncryption = 'AUDIO_CHANNEL_AURACAST_ENCRYPTION',
	AudioChannelAutomaticGainControl = 'AUDIO_CHANNEL_AUTOMATIC_GAIN_CONTROL',
	AudioChannelAutomixer = 'AUDIO_CHANNEL_AUTOMIXER',
	AudioChannelAutomixerChannelActive = 'AUDIO_CHANNEL_AUTOMIXER_CHANNEL_ACTIVE',
	AudioChannelAutomixerEnable = 'AUDIO_CHANNEL_AUTOMIXER_ENABLE',
	AudioChannelAutomixerInput = 'AUDIO_CHANNEL_AUTOMIXER_INPUT',
	AudioChannelAutomixerInputAlwaysOn = 'AUDIO_CHANNEL_AUTOMIXER_INPUT_ALWAYS_ON',
	AudioChannelAutomixerInputPriority = 'AUDIO_CHANNEL_AUTOMIXER_INPUT_PRIORITY',
	AudioChannelAutomixerInputSendToMonoMix = 'AUDIO_CHANNEL_AUTOMIXER_INPUT_SEND_TO_MONO_MIX',
	AudioChannelAutomixerInputSendToStereoMix = 'AUDIO_CHANNEL_AUTOMIXER_INPUT_SEND_TO_STEREO_MIX',
	AudioChannelAutomixerVoiceActivityDetection = 'AUDIO_CHANNEL_AUTOMIXER_VOICE_ACTIVITY_DETECTION',
	AudioChannelAutomixSourceSelector = 'AUDIO_CHANNEL_AUTOMIX_SOURCE_SELECTOR',
	AudioChannelAutoLevel = 'AUDIO_CHANNEL_AUTO_LEVEL',
	AudioChannelAutoMute = 'AUDIO_CHANNEL_AUTO_MUTE',
	AudioChannelAutoPosition = 'AUDIO_CHANNEL_AUTO_POSITION',
	AudioChannelCarriedByRfChannels = 'AUDIO_CHANNEL_CARRIED_BY_RF_CHANNELS',
	AudioChannelChannelConfiguration = 'AUDIO_CHANNEL_CHANNEL_CONFIGURATION',
	AudioChannelCompressor = 'AUDIO_CHANNEL_COMPRESSOR',
	AudioChannelConnectionDetection = 'AUDIO_CHANNEL_CONNECTION_DETECTION',
	AudioChannelDanteEncryptionStatus = 'AUDIO_CHANNEL_DANTE_ENCRYPTION_STATUS',
	AudioChannelDanteRouteReceiver = 'AUDIO_CHANNEL_DANTE_ROUTE_RECEIVER',
	AudioChannelDanteRouteTransmitter = 'AUDIO_CHANNEL_DANTE_ROUTE_TRANSMITTER',
	AudioChannelDelay = 'AUDIO_CHANNEL_DELAY',
	AudioChannelDenoiser = 'AUDIO_CHANNEL_DENOISER',
	AudioChannelDeverb = 'AUDIO_CHANNEL_DEVERB',
	AudioChannelDeviceSpecificEqualizerContour = 'AUDIO_CHANNEL_DEVICE_SPECIFIC_EQUALIZER_CONTOUR',
	AudioChannelDirectOutputTapPoint = 'AUDIO_CHANNEL_DIRECT_OUTPUT_TAP_POINT',
	AudioChannelEqualizer = 'AUDIO_CHANNEL_EQUALIZER',
	AudioChannelEqualizerContour = 'AUDIO_CHANNEL_EQUALIZER_CONTOUR',
	AudioChannelEqualizerPreset = 'AUDIO_CHANNEL_EQUALIZER_PRESET',
	AudioChannelExternalAutomixerGate = 'AUDIO_CHANNEL_EXTERNAL_AUTOMIXER_GATE',
	AudioChannelFaderGroup = 'AUDIO_CHANNEL_FADER_GROUP',
	AudioChannelGain = 'AUDIO_CHANNEL_GAIN',
	AudioChannelGainLock = 'AUDIO_CHANNEL_GAIN_LOCK',
	AudioChannelGroundLift = 'AUDIO_CHANNEL_GROUND_LIFT',
	AudioChannelIdentify = 'AUDIO_CHANNEL_IDENTIFY',
	AudioChannelInputSource = 'AUDIO_CHANNEL_INPUT_SOURCE',
	AudioChannelLightingBehavior = 'AUDIO_CHANNEL_LIGHTING_BEHAVIOR',
	AudioChannelLimiter = 'AUDIO_CHANNEL_LIMITER',
	AudioChannelLobeConfiguration = 'AUDIO_CHANNEL_LOBE_CONFIGURATION',
	AudioChannelLobePosition = 'AUDIO_CHANNEL_LOBE_POSITION',
	AudioChannelLobeTalkerHeight = 'AUDIO_CHANNEL_LOBE_TALKER_HEIGHT',
	AudioChannelLobeWidth = 'AUDIO_CHANNEL_LOBE_WIDTH',
	AudioChannelLogicReceiver = 'AUDIO_CHANNEL_LOGIC_RECEIVER',
	AudioChannelMicrophoneAngle = 'AUDIO_CHANNEL_MICROPHONE_ANGLE',
	AudioChannelMicOptimization = 'AUDIO_CHANNEL_MIC_OPTIMIZATION',
	AudioChannelMicPolarPattern = 'AUDIO_CHANNEL_MIC_POLAR_PATTERN',
	AudioChannelMonitorMix = 'AUDIO_CHANNEL_MONITOR_MIX',
	AudioChannelMonitorMixReverb = 'AUDIO_CHANNEL_MONITOR_MIX_REVERB',
	AudioChannelMute = 'AUDIO_CHANNEL_MUTE',
	AudioChannelMuteGroup = 'AUDIO_CHANNEL_MUTE_GROUP',
	AudioChannelMuteLock = 'AUDIO_CHANNEL_MUTE_LOCK',
	AudioChannelName = 'AUDIO_CHANNEL_NAME',
	AudioChannelNoiseReduction = 'AUDIO_CHANNEL_NOISE_REDUCTION',
	AudioChannelOutputMixProcessing = 'AUDIO_CHANNEL_OUTPUT_MIX_PROCESSING',
	AudioChannelOutputPath = 'AUDIO_CHANNEL_OUTPUT_PATH',
	AudioChannelPadSwitch = 'AUDIO_CHANNEL_PAD_SWITCH',
	AudioChannelPan = 'AUDIO_CHANNEL_PAN',
	AudioChannelPassiveSpeakers = 'AUDIO_CHANNEL_PASSIVE_SPEAKERS',
	AudioChannelPcPeripheral = 'AUDIO_CHANNEL_PC_PERIPHERAL',
	AudioChannelPeakHold = 'AUDIO_CHANNEL_PEAK_HOLD',
	AudioChannelPhantomPower = 'AUDIO_CHANNEL_PHANTOM_POWER',
	AudioChannelPlosiveReduction = 'AUDIO_CHANNEL_PLOSIVE_REDUCTION',
	AudioChannelPostGateGain = 'AUDIO_CHANNEL_POST_GATE_GAIN',
	AudioChannelPostGateMute = 'AUDIO_CHANNEL_POST_GATE_MUTE',
	AudioChannelPostGateSolo = 'AUDIO_CHANNEL_POST_GATE_SOLO',
	AudioChannelPreFadeListen = 'AUDIO_CHANNEL_PRE_FADE_LISTEN',
	AudioChannelPreGateMute = 'AUDIO_CHANNEL_PRE_GATE_MUTE',
	AudioChannelReverb = 'AUDIO_CHANNEL_REVERB',
	AudioChannelSelectedLoudspeaker = 'AUDIO_CHANNEL_SELECTED_LOUDSPEAKER',
	AudioChannelSignalGenerator = 'AUDIO_CHANNEL_SIGNAL_GENERATOR',
	AudioChannelSolo = 'AUDIO_CHANNEL_SOLO',
	AudioChannelStereoGain = 'AUDIO_CHANNEL_STEREO_GAIN',
	AudioChannelStereoReverse = 'AUDIO_CHANNEL_STEREO_REVERSE',
	AudioChannelStereoWidth = 'AUDIO_CHANNEL_STEREO_WIDTH',
	AudioChannelTalkerHeight = 'AUDIO_CHANNEL_TALKER_HEIGHT',
	AudioChannelTalkSwitch = 'AUDIO_CHANNEL_TALK_SWITCH',
	AudioChannelToneGenerator = 'AUDIO_CHANNEL_TONE_GENERATOR',
	AudioChannelTransmitterClip = 'AUDIO_CHANNEL_TRANSMITTER_CLIP',
	AudioChannelUsbOutputMode = 'AUDIO_CHANNEL_USB_OUTPUT_MODE',
	AudioChannelVoiceActivityDetectionNoiseReduction = 'AUDIO_CHANNEL_VOICE_ACTIVITY_DETECTION_NOISE_REDUCTION',
	AudioChannelVoiceActivityDetectionSensitivity = 'AUDIO_CHANNEL_VOICE_ACTIVITY_DETECTION_SENSITIVITY',
	AudioChannelWirelessEncryption = 'AUDIO_CHANNEL_WIRELESS_ENCRYPTION',
	AudioCoverageAreaConfiguration = 'AUDIO_COVERAGE_AREA_CONFIGURATION',
	AudioCoverageAreaGain = 'AUDIO_COVERAGE_AREA_GAIN',
	AudioCoverageAreaMute = 'AUDIO_COVERAGE_AREA_MUTE',
	ChargerBayAssociation = 'CHARGER_BAY_ASSOCIATION',
	ChargerBayBatteryCapacity = 'CHARGER_BAY_BATTERY_CAPACITY',
	ChargerBayBatteryHealth = 'CHARGER_BAY_BATTERY_HEALTH',
	ChargerBayBatteryTemperature = 'CHARGER_BAY_BATTERY_TEMPERATURE',
	/** @deprecated Proof of concept of charger bay on device.  Do not use. */
	ChargerBayChargingMode = 'CHARGER_BAY_CHARGING_MODE',
	ChargerBayDockedBattery = 'CHARGER_BAY_DOCKED_BATTERY',
	ChargerBayDockedBatteryLevel = 'CHARGER_BAY_DOCKED_BATTERY_LEVEL',
	ChargerBayDockedDevice = 'CHARGER_BAY_DOCKED_DEVICE',
	ChargerSlotChargerBays = 'CHARGER_SLOT_CHARGER_BAYS',
	ChargerSlotFirmware = 'CHARGER_SLOT_FIRMWARE',
	ChargerSlotModel = 'CHARGER_SLOT_MODEL',
	ChargerSlotSerialNumber = 'CHARGER_SLOT_SERIAL_NUMBER',
	ChargerSlotTemperature = 'CHARGER_SLOT_TEMPERATURE',
	/** @deprecated Proof of concept of charger slot on device.  Do not use. */
	ChargerSlotTypeId = 'CHARGER_SLOT_TYPE_ID',
	CrossPointConfiguration = 'CROSS_POINT_CONFIGURATION',
	CrossPointGain = 'CROSS_POINT_GAIN',
	DeviceActivePreset = 'DEVICE_ACTIVE_PRESET',
	DeviceAes3WordClock = 'DEVICE_AES3_WORD_CLOCK',
	DeviceAllEqualizersBypass = 'DEVICE_ALL_EQUALIZERS_BYPASS',
	DeviceAllIntellimixBypass = 'DEVICE_ALL_INTELLIMIX_BYPASS',
	DeviceAnalogAudioOutputMode = 'DEVICE_ANALOG_AUDIO_OUTPUT_MODE',
	DeviceAnalogLogic = 'DEVICE_ANALOG_LOGIC',
	DeviceAnalogLogicPresetSwitch = 'DEVICE_ANALOG_LOGIC_PRESET_SWITCH',
	DeviceAnalogLogicPresetSwitchStatus = 'DEVICE_ANALOG_LOGIC_PRESET_SWITCH_STATUS',
	DeviceAnalytics = 'DEVICE_ANALYTICS',
	DeviceAntennaBiasVoltage = 'DEVICE_ANTENNA_BIAS_VOLTAGE',
	DeviceAssignedSpectrumManager = 'DEVICE_ASSIGNED_SPECTRUM_MANAGER',
	DeviceAudioAutoFocus = 'DEVICE_AUDIO_AUTO_FOCUS',
	DeviceAudioChannels = 'DEVICE_AUDIO_CHANNELS',
	DeviceAudioChannelCount = 'DEVICE_AUDIO_CHANNEL_COUNT',
	DeviceAudioChannelTemplates = 'DEVICE_AUDIO_CHANNEL_TEMPLATES',
	DeviceAudioInputLevel = 'DEVICE_AUDIO_INPUT_LEVEL',
	DeviceAudioMute = 'DEVICE_AUDIO_MUTE',
	DeviceAudioMuteControl = 'DEVICE_AUDIO_MUTE_CONTROL',
	DeviceAudioMuteControlGroup = 'DEVICE_AUDIO_MUTE_CONTROL_GROUP',
	DeviceAudioMuteDefault = 'DEVICE_AUDIO_MUTE_DEFAULT',
	DeviceAudioMuteLock = 'DEVICE_AUDIO_MUTE_LOCK',
	DeviceAudioNetwork = 'DEVICE_AUDIO_NETWORK',
	DeviceAudioNetworkInterface = 'DEVICE_AUDIO_NETWORK_INTERFACE',
	DeviceAudioSumming = 'DEVICE_AUDIO_SUMMING',
	DeviceAuracast = 'DEVICE_AURACAST',
	DeviceAuthentication = 'DEVICE_AUTHENTICATION',
	DeviceAutomixGainMetering = 'DEVICE_AUTOMIX_GAIN_METERING',
	DeviceAvailablePackages = 'DEVICE_AVAILABLE_PACKAGES',
	DeviceBatteryCapacity = 'DEVICE_BATTERY_CAPACITY',
	DeviceBatteryHealth = 'DEVICE_BATTERY_HEALTH',
	DeviceBatteryLevel = 'DEVICE_BATTERY_LEVEL',
	DeviceBatteryLowVoltageIndicator = 'DEVICE_BATTERY_LOW_VOLTAGE_INDICATOR',
	DeviceBatteryStorageMode = 'DEVICE_BATTERY_STORAGE_MODE',
	DeviceBatteryVoltage = 'DEVICE_BATTERY_VOLTAGE',
	DeviceBluetoothDeviceInformationService = 'DEVICE_BLUETOOTH_DEVICE_INFORMATION_SERVICE',
	DeviceBluetoothPower = 'DEVICE_BLUETOOTH_POWER',
	DeviceBodypackMicrophoneMode = 'DEVICE_BODYPACK_MICROPHONE_MODE',
	DeviceCallStatus = 'DEVICE_CALL_STATUS',
	DeviceCombinedFrontPanelAndPowerLock = 'DEVICE_COMBINED_FRONT_PANEL_AND_POWER_LOCK',
	DeviceCommandStringsService = 'DEVICE_COMMAND_STRINGS_SERVICE',
	DeviceConferencingOperationMode = 'DEVICE_CONFERENCING_OPERATION_MODE',
	DeviceConferencingOperationModeButtonLock = 'DEVICE_CONFERENCING_OPERATION_MODE_BUTTON_LOCK',
	DeviceConferencingPlatform = 'DEVICE_CONFERENCING_PLATFORM',
	DeviceConfigurationLock = 'DEVICE_CONFIGURATION_LOCK',
	DeviceConnectedDeviceLabel = 'DEVICE_CONNECTED_DEVICE_LABEL',
	DeviceControlNetwork = 'DEVICE_CONTROL_NETWORK',
	DeviceControlNetworkInterface = 'DEVICE_CONTROL_NETWORK_INTERFACE',
	DeviceCoverageLock = 'DEVICE_COVERAGE_LOCK',
	DeviceCoverageMode = 'DEVICE_COVERAGE_MODE',
	DeviceCoveragePosition = 'DEVICE_COVERAGE_POSITION',
	DeviceCrashReport = 'DEVICE_CRASH_REPORT',
	DeviceDanteAudioEncryption = 'DEVICE_DANTE_AUDIO_ENCRYPTION',
	DeviceDanteAudioNetwork = 'DEVICE_DANTE_AUDIO_NETWORK',
	DeviceDanteAudioNetworkAccess = 'DEVICE_DANTE_AUDIO_NETWORK_ACCESS',
	DeviceDanteDeviceLock = 'DEVICE_DANTE_DEVICE_LOCK',
	DeviceDanteDomainManagement = 'DEVICE_DANTE_DOMAIN_MANAGEMENT',
	DeviceDanteSampleRate = 'DEVICE_DANTE_SAMPLE_RATE',
	DeviceDcPowerModule = 'DEVICE_DC_POWER_MODULE',
	DeviceDebugMode = 'DEVICE_DEBUG_MODE',
	DeviceDectRfSpectrumScan = 'DEVICE_DECT_RF_SPECTRUM_SCAN',
	DeviceDeploymentCandidates = 'DEVICE_DEPLOYMENT_CANDIDATES',
	DeviceDnsClientConfiguration = 'DEVICE_DNS_CLIENT_CONFIGURATION',
	/** @deprecated For Cloud Managed Rooms Use Only. */
	DeviceDoubleStuffProxiedTransmitters = 'DEVICE_DOUBLE_STUFF_PROXIED_TRANSMITTERS',
	DeviceDspDebugMode = 'DEVICE_DSP_DEBUG_MODE',
	DeviceEqualizerContour = 'DEVICE_EQUALIZER_CONTOUR',
	DeviceErrorIndicator = 'DEVICE_ERROR_INDICATOR',
	DeviceEthernetLights = 'DEVICE_ETHERNET_LIGHTS',
	DeviceExternalDisplays = 'DEVICE_EXTERNAL_DISPLAYS',
	DeviceFanMode = 'DEVICE_FAN_MODE',
	DeviceFirmwareUpdatePolicy = 'DEVICE_FIRMWARE_UPDATE_POLICY',
	DeviceFirmwareUpdateRequests = 'DEVICE_FIRMWARE_UPDATE_REQUESTS',
	DeviceFreqEng = 'DEVICE_FREQ_ENG',
	DeviceFrontPanelGainLock = 'DEVICE_FRONT_PANEL_GAIN_LOCK',
	DeviceFrontPanelLock = 'DEVICE_FRONT_PANEL_LOCK',
	DeviceFrontPanelScanLock = 'DEVICE_FRONT_PANEL_SCAN_LOCK',
	DeviceFrontPanelSyncLock = 'DEVICE_FRONT_PANEL_SYNC_LOCK',
	DeviceGatewayDevice = 'DEVICE_GATEWAY_DEVICE',
	DeviceGlobalMicStatus = 'DEVICE_GLOBAL_MIC_STATUS',
	DeviceHeight = 'DEVICE_HEIGHT',
	DeviceHostedFirmware = 'DEVICE_HOSTED_FIRMWARE',
	DeviceHostedUpdateProgress = 'DEVICE_HOSTED_UPDATE_PROGRESS',
	DeviceIdentify = 'DEVICE_IDENTIFY',
	DeviceInterferenceDetectionResolution = 'DEVICE_INTERFERENCE_DETECTION_RESOLUTION',
	DeviceInternetOfThings = 'DEVICE_INTERNET_OF_THINGS',
	DeviceIotRoomProxy = 'DEVICE_IOT_ROOM_PROXY',
	DeviceLicense = 'DEVICE_LICENSE',
	DeviceLicenseNetworkInterface = 'DEVICE_LICENSE_NETWORK_INTERFACE',
	DeviceLicenseV2 = 'DEVICE_LICENSE_V2',
	DeviceLicenseV3 = 'DEVICE_LICENSE_V3',
	DeviceLightingAudioActivity = 'DEVICE_LIGHTING_AUDIO_ACTIVITY',
	DeviceLightingAudioMeters = 'DEVICE_LIGHTING_AUDIO_METERS',
	DeviceLightingAudioMuteIndicatorOverride = 'DEVICE_LIGHTING_AUDIO_MUTE_INDICATOR_OVERRIDE',
	DeviceLightingAutomixGating = 'DEVICE_LIGHTING_AUTOMIX_GATING',
	DeviceLightingBehavior = 'DEVICE_LIGHTING_BEHAVIOR',
	DeviceLightingBrightness = 'DEVICE_LIGHTING_BRIGHTNESS',
	DeviceLightingLiveAudioMeters = 'DEVICE_LIGHTING_LIVE_AUDIO_METERS',
	DeviceLightingMuteBehavior = 'DEVICE_LIGHTING_MUTE_BEHAVIOR',
	DeviceLightingRing = 'DEVICE_LIGHTING_RING',
	DeviceLightingSegmentsBehavior = 'DEVICE_LIGHTING_SEGMENTS_BEHAVIOR',
	DeviceLightingSplitModeBreathingMeterColor = 'DEVICE_LIGHTING_SPLIT_MODE_BREATHING_METER_COLOR',
	DeviceLightingSplitModeSolidMeterColor = 'DEVICE_LIGHTING_SPLIT_MODE_SOLID_METER_COLOR',
	DeviceLightingTouchPanelMode = 'DEVICE_LIGHTING_TOUCH_PANEL_MODE',
	DeviceLightingUnmuteBehavior = 'DEVICE_LIGHTING_UNMUTE_BEHAVIOR',
	DeviceLinkedAccessPoint = 'DEVICE_LINKED_ACCESS_POINT',
	DeviceLinkButtonLock = 'DEVICE_LINK_BUTTON_LOCK',
	DeviceListenerHeight = 'DEVICE_LISTENER_HEIGHT',
	DeviceLogicMute = 'DEVICE_LOGIC_MUTE',
	DeviceLogicReceiver = 'DEVICE_LOGIC_RECEIVER',
	DeviceLogicTransmitter = 'DEVICE_LOGIC_TRANSMITTER',
	DeviceLoudspeaker = 'DEVICE_LOUDSPEAKER',
	DeviceMdnsService = 'DEVICE_MDNS_SERVICE',
	DeviceMeteringModes = 'DEVICE_METERING_MODES',
	DeviceMicSpatialOrientation = 'DEVICE_MIC_SPATIAL_ORIENTATION',
	DeviceMicStatus = 'DEVICE_MIC_STATUS',
	DeviceMicStatusV2 = 'DEVICE_MIC_STATUS_V2',
	DeviceMultiArrayLocalizationGroupReporter = 'DEVICE_MULTI_ARRAY_LOCALIZATION_GROUP_REPORTER',
	DeviceMuteButtonLock = 'DEVICE_MUTE_BUTTON_LOCK',
	DeviceName = 'DEVICE_NAME',
	DeviceNetworkSwitchConfiguration = 'DEVICE_NETWORK_SWITCH_CONFIGURATION',
	DeviceOnCharger = 'DEVICE_ON_CHARGER',
	DevicePlacement = 'DEVICE_PLACEMENT',
	DevicePowerSwitchLock = 'DEVICE_POWER_SWITCH_LOCK',
	DeviceProxiedDevices = 'DEVICE_PROXIED_DEVICES',
	DeviceQuadversity = 'DEVICE_QUADVERSITY',
	DeviceRebootPending = 'DEVICE_REBOOT_PENDING',
	DeviceRedundantAudioNetwork = 'DEVICE_REDUNDANT_AUDIO_NETWORK',
	DeviceRfBand = 'DEVICE_RF_BAND',
	DeviceRfChannels = 'DEVICE_RF_CHANNELS',
	/** @deprecated This API is subject to drastic change while being finalized */
	DeviceRfCurrentDraw = 'DEVICE_RF_CURRENT_DRAW',
	DeviceRfDensityMode = 'DEVICE_RF_DENSITY_MODE',
	DeviceRfMute = 'DEVICE_RF_MUTE',
	DeviceRfPower = 'DEVICE_RF_POWER',
	DeviceRfTransmissionProfile = 'DEVICE_RF_TRANSMISSION_PROFILE',
	DeviceRoom = 'DEVICE_ROOM',
	DeviceRotation = 'DEVICE_ROTATION',
	DeviceRoutingPosition = 'DEVICE_ROUTING_POSITION',
	DeviceSecondaryControlNetwork = 'DEVICE_SECONDARY_CONTROL_NETWORK',
	DeviceSecondaryControlNetworkDnsClientConfiguration = 'DEVICE_SECONDARY_CONTROL_NETWORK_DNS_CLIENT_CONFIGURATION',
	DeviceSecondaryEthernetPort = 'DEVICE_SECONDARY_ETHERNET_PORT',
	DeviceSecurity_8021X = 'DEVICE_SECURITY_8021X',
	DeviceSmartGate = 'DEVICE_SMART_GATE',
	DeviceStereoAudio = 'DEVICE_STEREO_AUDIO',
	DeviceTags = 'DEVICE_TAGS',
	DeviceTalkerTrackingConfig = 'DEVICE_TALKER_TRACKING_CONFIG',
	DeviceTemperature = 'DEVICE_TEMPERATURE',
	DeviceTransmitterIdentifyBehavior = 'DEVICE_TRANSMITTER_IDENTIFY_BEHAVIOR',
	DeviceTransmitterInitialStateFromCharger = 'DEVICE_TRANSMITTER_INITIAL_STATE_FROM_CHARGER',
	DeviceTransmitterLightingBehavior = 'DEVICE_TRANSMITTER_LIGHTING_BEHAVIOR',
	DeviceTransmitterMuteBehavior = 'DEVICE_TRANSMITTER_MUTE_BEHAVIOR',
	DeviceTransmitterOutOfRangeBehavior = 'DEVICE_TRANSMITTER_OUT_OF_RANGE_BEHAVIOR',
	DeviceTransmitterRejoinBehavior = 'DEVICE_TRANSMITTER_REJOIN_BEHAVIOR',
	DeviceTransmitterSwitchBehavior = 'DEVICE_TRANSMITTER_SWITCH_BEHAVIOR',
	DeviceUpdateProgress = 'DEVICE_UPDATE_PROGRESS',
	DeviceUptime = 'DEVICE_UPTIME',
	DeviceUsbConnection = 'DEVICE_USB_CONNECTION',
	DeviceUsbMuteSync = 'DEVICE_USB_MUTE_SYNC',
	DeviceUsbTerminalType = 'DEVICE_USB_TERMINAL_TYPE',
	DeviceUserInterfacePreferences = 'DEVICE_USER_INTERFACE_PREFERENCES',
	DeviceUserPerspective = 'DEVICE_USER_PERSPECTIVE',
	DeviceUserPreset = 'DEVICE_USER_PRESET',
	DeviceVirtualAcousticBoundary = 'DEVICE_VIRTUAL_ACOUSTIC_BOUNDARY',
	DeviceWebService = 'DEVICE_WEB_SERVICE',
	DeviceWirelessEncryption = 'DEVICE_WIRELESS_ENCRYPTION',
	DspDebugAudioFenceLobe = 'DSP_DEBUG_AUDIO_FENCE_LOBE',
	EqualizerFilterBandwidth = 'EQUALIZER_FILTER_BANDWIDTH',
	EqualizerFilterConfiguration = 'EQUALIZER_FILTER_CONFIGURATION',
	EqualizerFilterFrequency = 'EQUALIZER_FILTER_FREQUENCY',
	EqualizerFilterGain = 'EQUALIZER_FILTER_GAIN',
	EqualizerFilterQFactor = 'EQUALIZER_FILTER_Q_FACTOR',
	ExternalDisplayConnection = 'EXTERNAL_DISPLAY_CONNECTION',
	ExternalDisplayResolution = 'EXTERNAL_DISPLAY_RESOLUTION',
	FirmwarePackageDownloadProgress = 'FIRMWARE_PACKAGE_DOWNLOAD_PROGRESS',
	FirmwarePackageDownloadRequestProgress = 'FIRMWARE_PACKAGE_DOWNLOAD_REQUEST_PROGRESS',
	FirmwareUpdateProgress = 'FIRMWARE_UPDATE_PROGRESS',
	FirmwareUpdateRequest = 'FIRMWARE_UPDATE_REQUEST',
	FirmwareUpdateRequestProgress = 'FIRMWARE_UPDATE_REQUEST_PROGRESS',
	PassiveSpeakerCoveragePosition = 'PASSIVE_SPEAKER_COVERAGE_POSITION',
	PassiveSpeakerHeight = 'PASSIVE_SPEAKER_HEIGHT',
	PassiveSpeakerListenerHeight = 'PASSIVE_SPEAKER_LISTENER_HEIGHT',
	PassiveSpeakerName = 'PASSIVE_SPEAKER_NAME',
	PassiveSpeakerRotation = 'PASSIVE_SPEAKER_ROTATION',
	RfChannelAssignedRfBand = 'RF_CHANNEL_ASSIGNED_RF_BAND',
	RfChannelAssignedRfProfile = 'RF_CHANNEL_ASSIGNED_RF_PROFILE',
	RfChannelAssociation = 'RF_CHANNEL_ASSOCIATION',
	RfChannelCarriedAudioChannels = 'RF_CHANNEL_CARRIED_AUDIO_CHANNELS',
	RfChannelFrequencyDiversityMode = 'RF_CHANNEL_FREQUENCY_DIVERSITY_MODE',
	RfChannelInterferenceDetection = 'RF_CHANNEL_INTERFERENCE_DETECTION',
	RfChannelInterferenceDetectionResolution = 'RF_CHANNEL_INTERFERENCE_DETECTION_RESOLUTION',
	RfChannelInterferenceDetector = 'RF_CHANNEL_INTERFERENCE_DETECTOR',
	RfChannelLinkedTransmitter = 'RF_CHANNEL_LINKED_TRANSMITTER',
	RfChannelMute = 'RF_CHANNEL_MUTE',
	RfChannelPeripheralAudioMute = 'RF_CHANNEL_PERIPHERAL_AUDIO_MUTE',
	RfChannelPeripheralAudioPolarity = 'RF_CHANNEL_PERIPHERAL_AUDIO_POLARITY',
	RfChannelPeripheralAutoLock = 'RF_CHANNEL_PERIPHERAL_AUTO_LOCK',
	RfChannelPeripheralBatteryHealth = 'RF_CHANNEL_PERIPHERAL_BATTERY_HEALTH',
	RfChannelPeripheralBatteryLevel = 'RF_CHANNEL_PERIPHERAL_BATTERY_LEVEL',
	RfChannelPeripheralBatteryTemperature = 'RF_CHANNEL_PERIPHERAL_BATTERY_TEMPERATURE',
	RfChannelPeripheralBatteryType = 'RF_CHANNEL_PERIPHERAL_BATTERY_TYPE',
	RfChannelPeripheralDevice = 'RF_CHANNEL_PERIPHERAL_DEVICE',
	RfChannelPeripheralFirmware = 'RF_CHANNEL_PERIPHERAL_FIRMWARE',
	RfChannelPeripheralSerialNumber = 'RF_CHANNEL_PERIPHERAL_SERIAL_NUMBER',
	RfChannelPeripheralWirelessEncryption = 'RF_CHANNEL_PERIPHERAL_WIRELESS_ENCRYPTION',
	RfChannelReceiveStandbyMode = 'RF_CHANNEL_RECEIVE_STANDBY_MODE',
	RfChannelTuning = 'RF_CHANNEL_TUNING',
	/** @deprecated The word utilized may be reconsidered in the near future. */
	RfChannelUtilizedRfPorts = 'RF_CHANNEL_UTILIZED_RF_PORTS',
	RfChannelWirelessEncryptionStatus = 'RF_CHANNEL_WIRELESS_ENCRYPTION_STATUS',
	/** @deprecated This API is subject to drastic change while being finalized */
	RfPortAntennaFault = 'RF_PORT_ANTENNA_FAULT',
	/** @deprecated This API is subject to drastic change while being finalized */
	RfPortDcPower = 'RF_PORT_DC_POWER',
	RfPortFrontEndPowerLimiterEngaged = 'RF_PORT_FRONT_END_POWER_LIMITER_ENGAGED',
	RfPortFrontEndPowerOverload = 'RF_PORT_FRONT_END_POWER_OVERLOAD',
	/** @deprecated The word utilized may be reconsidered in the near future. */
	RfPortUtilizedByRfChannels = 'RF_PORT_UTILIZED_BY_RF_CHANNELS',
	Room = 'ROOM',
	UserPreset = 'USER_PRESET'
}

/**
 * Result returned for an operation which may result in the associated device becoming inaccessible
 * (e.g. transitioning to DeviceState.OFFLINE)
 */
export type NodeOperationResult = {
	error: Maybe<OperationError>;
};

export type NodeUpdateInput =
	| {
			audioChannel: AudioChannelUpdateInput;
			audioCoverageArea?: never;
			crossPoint?: never;
			device?: never;
			equalizerFilters?: never;
			passiveSpeaker?: never;
			rfChannel?: never;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea: AudioCoverageAreaUpdateInput;
			crossPoint?: never;
			device?: never;
			equalizerFilters?: never;
			passiveSpeaker?: never;
			rfChannel?: never;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea?: never;
			crossPoint: CrossPointUpdateInput;
			device?: never;
			equalizerFilters?: never;
			passiveSpeaker?: never;
			rfChannel?: never;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea?: never;
			crossPoint?: never;
			device: DeviceUpdateInput;
			equalizerFilters?: never;
			passiveSpeaker?: never;
			rfChannel?: never;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea?: never;
			crossPoint?: never;
			device?: never;
			equalizerFilters: EqualizerFilterUpdateInput;
			passiveSpeaker?: never;
			rfChannel?: never;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea?: never;
			crossPoint?: never;
			device?: never;
			equalizerFilters?: never;
			passiveSpeaker: PassiveSpeakerUpdateInput;
			rfChannel?: never;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea?: never;
			crossPoint?: never;
			device?: never;
			equalizerFilters?: never;
			passiveSpeaker?: never;
			rfChannel: RfChannelUpdateInput;
			rfPort?: never;
	  }
	| {
			audioChannel?: never;
			audioCoverageArea?: never;
			crossPoint?: never;
			device?: never;
			equalizerFilters?: never;
			passiveSpeaker?: never;
			rfChannel?: never;
			rfPort: RfPortUpdateInput;
	  };

export enum NoiseDetectionSensitivity {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM',
	Off = 'OFF'
}

export type NoiseDetectionSensitivityConstraints = {
	options: Array<NoiseDetectionSensitivity | `${NoiseDetectionSensitivity}`>;
};

export enum NoiseReductionLevel {
	Auto = 'AUTO',
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM'
}

export type NoiseReductionLevelConstraints = IFieldSupportInfo & {
	options: Maybe<Array<NoiseReductionLevel | `${NoiseReductionLevel}`>>;
	supported: Scalars['Boolean']['output'];
};

export type NoiseReductionPercentageConstraints = IFieldSupportInfo & {
	range: Maybe<IntRange>;
	supported: Scalars['Boolean']['output'];
};

export enum NoiseRemovalLevel {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM',
	Off = 'OFF'
}

export type NoiseRemovalLevelConstraints = {
	options: Array<NoiseRemovalLevel | `${NoiseRemovalLevel}`>;
};

export enum NonLinearProcessingLevel {
	Auto = 'AUTO',
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM'
}

export type NonLinearProcessingLevelConstraints = IFieldSupportInfo & {
	options: Maybe<Array<NonLinearProcessingLevel | `${NonLinearProcessingLevel}`>>;
	supported: Scalars['Boolean']['output'];
};

export type OperatingSystem = {
	manufacturer: Maybe<Scalars['String']['output']>;
	version: Maybe<Scalars['String']['output']>;
};

export type OperationError = {
	code: ErrorCode | `${ErrorCode}`;
	message: Scalars['String']['output'];
};

export type OperationResult = {
	error: Maybe<OperationError>;
};

export type OptimizeRoomInput = {
	/**
	 * Indicates which operation mode access point should be switched to in order to
	 * associate with microphones within the room if one needs to be switched. This
	 * field should be provided if room does not contain a tranditional processor
	 * (e.g. IMX-Room, P300, ANIUSB) but does contain an MXWN access point device
	 * and an MXA microphone, if no access points in the room are already in either
	 * Conference or Presentation operation mode. This field is optional in all other
	 * cases.
	 */
	accessPointOperationMode?: InputMaybe<AccessPointDeviceOperationMode | `${AccessPointDeviceOperationMode}`>;
	/**
	 * Indicates whether audio setting should be applied to room devices.
	 * If not provided, true is assumed (audio settings will be applied to associated room devices).
	 */
	adjustAudioSettings?: InputMaybe<Scalars['Boolean']['input']>;
	/**
	 * Indicates whether optimizing the room should happen even if one or more room devices are offline.
	 * If not provided, false is assumed (room optimization would fail if one or more devices are offline).
	 */
	allowUnavailableDevices?: InputMaybe<Scalars['Boolean']['input']>;
	/**
	 * Indicates whether mute synchronization should be enabled on processor while optimizing room.
	 * If not provided, true is assumed (mute synchronization will be enabled on the processor).
	 */
	enableMuteSynchronization?: InputMaybe<Scalars['Boolean']['input']>;
	/**
	 * Indicates whether or not linking of wireless microphones should occur.
	 * If not provided, true is assumed (linking of wireless microphones will occur).
	 */
	linkWirelessMicrophones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptimizeRoomProgress = OptimizeRoomProgressEvent | OptimizeRoomResult;

export type OptimizeRoomProgressEvent = {
	roomOptimizationStage: RoomOptimizationStage | `${RoomOptimizationStage}`;
};

export enum OptimizeRoomProgressType {
	OptimizeRoomProgress = 'OPTIMIZE_ROOM_PROGRESS',
	OptimizeRoomResult = 'OPTIMIZE_ROOM_RESULT'
}

export type OptimizeRoomResult = {
	associationResult: GroupAssociationResult;
	optimizationResult: GroupOptimizationResult;
	status: RoomOptimizationStatus | `${RoomOptimizationStatus}`;
};

export type OriginDevice = {
	device: Maybe<Device>;
	hardwareId: Scalars['Guid']['output'];
};

/** The output mix processing type determines how the audio signal from a 2-channel audio stream should be processed based on microphone orientation setting. */
export enum OutputMixProcessing {
	/** Processes audio signals focusing on the loudest talker in the room. Automatically steers a lobe towards the loudest talker in the room. */
	AutoSteeredMonoLobe = 'AUTO_STEERED_MONO_LOBE',
	/** Processes the 2-channel audio stream creating a 3D stereo sensation for listening on headphones and earphones */
	Binaural = 'BINAURAL',
	/** Processes stereo and 2-Cardioid audio signals */
	FixedOrientationStereoLobe = 'FIXED_ORIENTATION_STEREO_LOBE',
	/** Processes Mono-directional audio signals */
	MonoDirectional = 'MONO_DIRECTIONAL'
}

export enum OutputSignalPath {
	PostDigitalSignalProcessing = 'POST_DIGITAL_SIGNAL_PROCESSING',
	PreDigitalSignalProcessing = 'PRE_DIGITAL_SIGNAL_PROCESSING'
}

export type PageInfo = {
	endCursor: Scalars['String']['output'];
	hasNextPage: Scalars['Boolean']['output'];
	hasPreviousPage: Scalars['Boolean']['output'];
	startCursor: Scalars['String']['output'];
};

/**
 * Pagination arguments for connection-based queries.
 * When no arguments are provided, all items/records are returned.
 * If pagination arguments are provided:
 *    - either 'first' or 'last' may be specified, but not both, to control the number of items returned.
 *    - it is invalid to specify 'before' without 'last'
 *    - it is invalid to specify 'after' without 'first'
 *    - if 'first' is specified, the 'after' cursor, if specified, is used to further filter results.
 *    - if 'last' is specified, the 'before' cursor, if specified, is used to further filter results.
 */
export type PaginationArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
};

export type PassiveSpeaker = Node & {
	description: PassiveSpeakerDescription;
	features: PassiveSpeakerFeatures;
	fragmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
};

export type PassiveSpeakerChange = {
	features: PassiveSpeakerFeatureChange;
	id: Scalars['ID']['output'];
};

export type PassiveSpeakerConstraints = {
	height: Maybe<PassiveSpeakerHeightConstraints>;
	listenerHeight: Maybe<PassiveSpeakerListenerHeightConstraints>;
	name: Maybe<PassiveSpeakerNameConstraints>;
	rotation: Maybe<PassiveSpeakerRotationConstraints>;
};

/** The default value of the X/Y positions is uninitialized(i.e., null). Positions are scaled to represent in millimeters (mm) */
export type PassiveSpeakerCoveragePosition = {
	xPosition: Maybe<Scalars['Float']['output']>;
	yPosition: Maybe<Scalars['Float']['output']>;
};

export type PassiveSpeakerCoveragePositionChange = {
	coveragePosition: Maybe<PassiveSpeakerCoveragePosition>;
};

export type PassiveSpeakerCoveragePositionInput = {
	xPosition: Scalars['Float']['input'];
	yPosition: Scalars['Float']['input'];
};

export type PassiveSpeakerDescription = {
	constraints: PassiveSpeakerConstraints;
	features: PassiveSpeakerSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type PassiveSpeakerFeatureChange =
	| PassiveSpeakerCoveragePositionChange
	| PassiveSpeakerHeightChange
	| PassiveSpeakerListenerHeightChange
	| PassiveSpeakerNameChange
	| PassiveSpeakerRotationChange;

export type PassiveSpeakerFeatureUpdateInput =
	| {
			coveragePosition: PassiveSpeakerCoveragePositionInput;
			height?: never;
			listenerHeight?: never;
			name?: never;
			rotation?: never;
	  }
	| {
			coveragePosition?: never;
			height: PassiveSpeakerHeightUpdateInput;
			listenerHeight?: never;
			name?: never;
			rotation?: never;
	  }
	| {
			coveragePosition?: never;
			height?: never;
			listenerHeight: PassiveSpeakerListenerHeightUpdateInput;
			name?: never;
			rotation?: never;
	  }
	| {
			coveragePosition?: never;
			height?: never;
			listenerHeight?: never;
			name: PassiveSpeakerNameUpdateInput;
			rotation?: never;
	  }
	| {
			coveragePosition?: never;
			height?: never;
			listenerHeight?: never;
			name?: never;
			rotation: PassiveSpeakerRotationUpdateInput;
	  };

export type PassiveSpeakerFeatures = {
	coveragePosition: Maybe<PassiveSpeakerCoveragePosition>;
	height: Maybe<PassiveSpeakerHeight>;
	listenerHeight: Maybe<PassiveSpeakerListenerHeight>;
	name: Maybe<PassiveSpeakerName>;
	rotation: Maybe<PassiveSpeakerRotation>;
};

/** height values are scaled to represent in millimeters (mm) */
export type PassiveSpeakerHeight = {
	height: Scalars['Float']['output'];
};

export type PassiveSpeakerHeightChange = {
	height: Maybe<PassiveSpeakerHeight>;
};

export type PassiveSpeakerHeightConstraints = {
	height: PassiveSpeakerHeightFieldConstraints;
};

export type PassiveSpeakerHeightFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type PassiveSpeakerHeightUpdateInput = {
	height: Scalars['Float']['input'];
};

/** Listener height values are scaled to represent in millimeters (mm) */
export type PassiveSpeakerListenerHeight = {
	height: Scalars['Float']['output'];
};

export type PassiveSpeakerListenerHeightChange = {
	listenerHeight: Maybe<PassiveSpeakerListenerHeight>;
};

export type PassiveSpeakerListenerHeightConstraints = {
	height: PassiveSpeakerListenerHeightFieldConstraints;
};

export type PassiveSpeakerListenerHeightFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type PassiveSpeakerListenerHeightUpdateInput = {
	height: Scalars['Float']['input'];
};

export type PassiveSpeakerName = {
	name: Scalars['String']['output'];
};

export type PassiveSpeakerNameChange = {
	name: Maybe<PassiveSpeakerName>;
};

export type PassiveSpeakerNameConstraints = {
	name: PassiveSpeakerNameFieldConstraints;
};

export type PassiveSpeakerNameFieldConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type PassiveSpeakerNameUpdateInput = {
	name: Scalars['String']['input'];
};

export type PassiveSpeakerOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	passiveSpeaker: Maybe<PassiveSpeaker>;
};

export type PassiveSpeakerRotation = {
	xAxis: Scalars['Int']['output'];
	yAxis: Scalars['Int']['output'];
	zAxis: Scalars['Int']['output'];
};

export type PassiveSpeakerRotationAxisConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type PassiveSpeakerRotationChange = {
	rotation: Maybe<PassiveSpeakerRotation>;
};

export type PassiveSpeakerRotationConstraints = {
	xAxis: PassiveSpeakerRotationAxisConstraints;
	yAxis: PassiveSpeakerRotationAxisConstraints;
	zAxis: PassiveSpeakerRotationAxisConstraints;
};

export type PassiveSpeakerRotationUpdateInput = {
	xAxis?: InputMaybe<Scalars['Int']['input']>;
	yAxis?: InputMaybe<Scalars['Int']['input']>;
	zAxis?: InputMaybe<Scalars['Int']['input']>;
};

export type PassiveSpeakerSupportedFeatures = {
	coveragePosition: FeatureSupport;
	height: FeatureSupport;
	listenerHeight: FeatureSupport;
	name: FeatureSupport;
	rotation: FeatureSupport;
};

export type PassiveSpeakerUpdateInput = {
	features?: InputMaybe<PassiveSpeakerFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export type PcPeripheral = {
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
	status: PcPeripheralStatus | `${PcPeripheralStatus}`;
};

export enum PcPeripheralStatus {
	Available = 'AVAILABLE',
	Begin = 'BEGIN',
	End = 'END',
	InProgress = 'IN_PROGRESS',
	None = 'NONE',
	Unavailable = 'UNAVAILABLE'
}

export type PendingVirtualDevice = {
	advertisedInterface: InterfaceDetails;
	compatibility: CompatibilityLevel | `${CompatibilityLevel}`;
	description: PendingVirtualDeviceDescription;
	hardwareId: Scalars['Guid']['output'];
	id: Scalars['ID']['output'];
	interface: InterfaceDetails;
	status: DeviceStatus | `${DeviceStatus}`;
	virtual: Scalars['Boolean']['output'];
};

export type PendingVirtualDeviceDescription = {
	interface: InterfaceDetails;
};

export type PhantomPowerConstraints = {
	options: Array<Scalars['Int']['output']>;
};

export enum Placement {
	Ceiling = 'CEILING',
	Table = 'TABLE',
	WallHorizontal = 'WALL_HORIZONTAL',
	WallVertical = 'WALL_VERTICAL'
}

export type PresetExportToFilePathInput = {
	/**
	 * Full file path, where preset file should be exported to, including file name;
	 * file name is expected in path to ensure naming conventions, which might be different
	 * for different clients, are satisfied
	 */
	filePath: Scalars['String']['input'];
	/** Preset Id to be exported */
	presetId: Scalars['ID']['input'];
};

/** This input is intended for REST interface */
export type PresetImportFromFileContentsInput = {
	/** Full path to JSON preset file to be imported */
	fileContents: Scalars['String']['input'];
	/** Preset Id, to which imported preset should be applied */
	presetId: Scalars['ID']['input'];
};

export type PresetImportFromFilePathInput = {
	/** Provided path to a JSON preset file to be imported */
	filePath: Scalars['String']['input'];
	/** Preset Id, to which imported preset should be applied */
	presetId: Scalars['ID']['input'];
};

export type PresetUpdateInput = {
	name: Scalars['String']['input'];
	presetId: Scalars['ID']['input'];
};

export type ProcessorInfo = {
	cores: Maybe<Scalars['String']['output']>;
	cpuSpeed: Maybe<Scalars['String']['output']>;
	logicalProcessor: Maybe<Scalars['String']['output']>;
	processor: Maybe<Scalars['String']['output']>;
};

export type ProductionDeviceIdentity = {
	category: Scalars['String']['input'];
	minVersions: Array<Scalars['SemanticVersion']['input']>;
};

export type QFactorConstraint = EqualizerFilterValidQFactors | FloatRange;

export type Query = {
	availableFirmwarePackages: Array<FirmwarePackage>;
	/** Returns a list of compatible RF bands for a given device type */
	availableRfBands: Array<RfChannelTuningBands>;
	/** Returns a list of possible RF bands for a given manufacturer and model name */
	availableRfBandsByManufacturerAndModel: Array<RfChannelTuningBandInfo>;
	/**
	 * Returns the set of group/channel frequency collections for a device type within a specific RF band and profile.
	 *
	 * The band argument must be the raw band identifier as returned by device.rfBand.band.
	 */
	availableRfGroupChannelFrequencies: Array<RfChannelTuningGroupAndChannels>;
	deviceByAddress: Device;
	deviceByHardwareId: Device;
	/**
	 * Returns a list of all device models which can be discovered given the configured device category inclusion list.
	 * This list can be used to provide device model values to the 'discoveredDevicesConnection' query.
	 */
	deviceModels: Array<Scalars['String']['output']>;
	/** The deviceProperties query is not-supported and is only used for internal purposes */
	deviceProperties: Array<Maybe<DeviceProperty>>;
	/** Returns a list of all device types which can be discovered given the configured device category inclusion list. */
	deviceTypesByManufacturerAndModel: Array<DeviceTypesByManufacturerAndModel>;
	devicesByHardwareId: Array<Maybe<Device>>;
	/**
	 * Returns a list of ALL devices which have been discovered,
	 * or still remain in the cache after transitioning to 'DeviceState.OFFLINE'
	 */
	discoveredDevices: Array<Device>;
	/**
	 * Returns a filtered list of devices (either in pages or in full) which have been discovered,
	 * or still remain in the cache after transitioning to 'DeviceState.OFFLINE'.
	 */
	discoveredDevicesConnection: DevicesConnection;
	discoveredRooms: Array<Room>;
	firmwarePackageDownloadProgress: FirmwarePackageDownloadRequestProgress;
	firmwarePackageServerStatus: FirmwarePackageServerStatus;
	firmwareUpdateProgress: FirmwareUpdateRequestProgress;
	fragmentByHardwareId: Fragment;
	latestRoomVersion: Scalars['String']['output'];
	latestVirtualDeviceInterfaceId: Scalars['Int']['output'];
	manualDeviceDiscoveryIps: Array<Scalars['IpAddress']['output']>;
	/** @deprecated networkInterfacesV2 provides richer querying capabilities and will be the maintained option going forward. */
	networkInterfaces: Array<NetworkInterface>;
	networkInterfacesV2: Array<NetworkInterfaceV2>;
	node: Node;
	nodes: Array<Maybe<Node>>;
	self: Device;
	selfFragment: Fragment;
};

export type QueryAvailableRfBandsArgs = {
	deviceType: Scalars['Guid']['input'];
};

export type QueryAvailableRfBandsByManufacturerAndModelArgs = {
	manufacturer: Scalars['String']['input'];
	model: Scalars['String']['input'];
};

export type QueryAvailableRfGroupChannelFrequenciesArgs = {
	band: Scalars['String']['input'];
	deviceType: Scalars['Guid']['input'];
	profile: Scalars['RfProfileName']['input'];
};

export type QueryDeviceByAddressArgs = {
	host: Scalars['String']['input'];
	port: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDeviceByHardwareIdArgs = {
	hardwareId: Scalars['Guid']['input'];
};

export type QueryDevicePropertiesArgs = {
	filter: InputMaybe<DevicePropertyFilter>;
	id: Scalars['ID']['input'];
};

export type QueryDevicesByHardwareIdArgs = {
	hardwareIds: Array<Scalars['Guid']['input']>;
};

export type QueryDiscoveredDevicesConnectionArgs = {
	after: InputMaybe<Scalars['String']['input']>;
	before: InputMaybe<Scalars['String']['input']>;
	deviceModels: InputMaybe<Array<Scalars['String']['input']>>;
	first: InputMaybe<Scalars['Int']['input']>;
	last: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFirmwarePackageDownloadProgressArgs = {
	requestId: Scalars['String']['input'];
};

export type QueryFirmwareUpdateProgressArgs = {
	updateRequestId: Scalars['Guid']['input'];
};

export type QueryFragmentByHardwareIdArgs = {
	fragmentId: Scalars['ID']['input'];
	hardwareId: Scalars['Guid']['input'];
};

export type QueryLatestVirtualDeviceInterfaceIdArgs = {
	category: Scalars['String']['input'];
};

export type QueryNodeArgs = {
	id: Scalars['ID']['input'];
};

export type QueryNodesArgs = {
	ids: Array<Scalars['ID']['input']>;
};

export type QuerySelfFragmentArgs = {
	fragmentId: Scalars['ID']['input'];
};

export type RectangularAreaConstraints = {
	distance: RectangularAreaFieldConstraints;
	height: RectangularAreaFieldConstraints;
	type: RectangularAreaTypeConstraints;
	width: RectangularAreaFieldConstraints;
};

export type RectangularAreaFieldConstraints = IFloatRangeConstraints & {
	range: FloatRange;
};

export type RectangularAreaTypeConstraints = {
	options: AudioCoverageAreaType | `${AudioCoverageAreaType}`;
};

export type RectangularCoordinates = {
	/** Maximum x-coordinate of the rectangular bounds, in millimeter */
	xMax: Scalars['Float']['output'];
	/** Minimum x-coordinate of the rectangular bounds, in millimeter */
	xMin: Scalars['Float']['output'];
	/** Maximum y-coordinate of the rectangular bounds, in millimeter */
	yMax: Scalars['Float']['output'];
	/** Minimum y-coordinate of the rectangular bounds, in millimeter */
	yMin: Scalars['Float']['output'];
};

export type RectangularCoordinatesInput = {
	/** Maximum x-coordinate of the rectangular bounds, in millimeters */
	xMax: Scalars['Float']['input'];
	/** Minimum x-coordinate of the rectangular bounds, in millimeters */
	xMin: Scalars['Float']['input'];
	/** Maximum y-coordinate of the rectangular bounds, in millimeters */
	yMax: Scalars['Float']['input'];
	/** Minimum y-coordinate of the rectangular bounds, in millimeters */
	yMin: Scalars['Float']['input'];
};

export enum ReflectionCorrection {
	HeightOnly = 'HEIGHT_ONLY',
	Off = 'OFF',
	ReflectionAndHeight = 'REFLECTION_AND_HEIGHT',
	ReflectionOnly = 'REFLECTION_ONLY'
}

export type ReflectionCorrectionConstraints = {
	options: Array<ReflectionCorrection | `${ReflectionCorrection}`>;
};

export type RefreshDeviceLicenseInput = {
	/** The node ID of the device to refresh the license for. */
	id: Scalars['ID']['input'];
	/** The client-generated, uuid-formatted, correlation token to use for the license refresh operation. */
	transactionId: Scalars['String']['input'];
};

export type RemoveCredentialsInput = {
	accessLevel: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export type RequestFirmwareUpdateInput = {
	/** The node identifier of the device to update */
	id: Scalars['ID']['input'];
	/** The key of the firmware package to use for the update */
	packageKey: Scalars['String']['input'];
	/** The version of the firmware package to use for the update */
	packageVersion: Scalars['String']['input'];
};

export type ResetDeviceResult = DeviceOperationResult | OperationResult;

export enum ReverbType {
	Hall = 'HALL',
	Plate = 'PLATE',
	Studio = 'STUDIO'
}

export enum RfActivityLevel {
	Adequate = 'ADEQUATE',
	Good = 'GOOD',
	None = 'NONE',
	Overload = 'OVERLOAD',
	Poor = 'POOR'
}

export type RfBandBandConstraints = {
	options: Array<RfBandOptions>;
};

export type RfBandOptions = {
	band: Scalars['String']['output'];
	profiles: Array<Scalars['RfProfileName']['output']>;
	ranges: Array<RfChannelTuningFrequencyRange>;
};

export type RfChannel = Fragment &
	Node & {
		description: RfChannelDescription;
		features: RfChannelFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type RfChannelActivityMeter = {
	/** @deprecated Basing a general notion of RF performance on RSSI without taking into account the signal to noise ratio is too short-sighted. Axient Digital quality metering addresses this. */
	level: RfActivityLevel | `${RfActivityLevel}`;
};

/**
 * Monitor which of the received signals on one or more antennas is being used.
 *
 * Remarks:
 * Devices with true digital diversity (e.g. Axient Digital) can have multiple active antennas,
 * and can use the audio information carried by RF multiple antennas to "fill in the gaps"
 * from missing data across by correlating RF signals received from other antennas.
 *
 * Devices with combining diversity, such as ratio combining diversity,
 * may use the audio carried by multiple antennas in proportion to their signal quality,
 * and thus show multiple active antennas.
 *
 * Devices with antenna switching diversity (e.g. ULX-D, QLX-D, SLX-D) will only ever be able to use one signal at a time.
 * In rare cases, both antennas may show as active for these devices due to timing of sending updates vs updating the device's state.
 */
export type RfChannelAntennaDiversityActivityMeter = {
	/** Whether or not there is a detected, decoded RF signal */
	active: Scalars['Boolean']['output'];
	/**
	 * A discriminator associated with the antenna input.
	 * Possible values are ANTENNA_A, ANTENNA_B, ANTENNA_C, or ANTENNA_D
	 */
	antenna: Scalars['String']['output'];
	/**
	 * Whether or not the signal failed to be decoded due to interference; On interference, audio will be squelched.
	 * Null when the device does not support interference detection
	 */
	interference: Maybe<RfChannelInterferenceDetectionSeverity | `${RfChannelInterferenceDetectionSeverity}`>;
};

export type RfChannelAntennaDiversityActivityMeterConstraints = {
	antenna: Scalars['String']['output'];
	/** Describes whether or not this RF channel supports detecting interference events. */
	interference: FieldSupport;
};

export type RfChannelAntennaDiversityMeter = {
	antennas: Array<RfChannelAntennaDiversityActivityMeter>;
};

export type RfChannelAntennaDiversityMeterConstraints = {
	antennas: Array<RfChannelAntennaDiversityActivityMeterConstraints>;
};

/** Describes which antenna diversity method is implemented by an RF channel. */
export type RfChannelAntennaDiversityMode = {
	mode: AntennaDiversityMode | `${AntennaDiversityMode}`;
};

export type RfChannelAntennaDiversityModeConstraints = {
	mode: RfChannelAntennaDiversityModeFieldConstraints;
};

export type RfChannelAntennaDiversityModeFieldConstraints = {
	options: Array<AntennaDiversityMode | `${AntennaDiversityMode}`>;
};

export type RfChannelAssignedRfBand = {
	/** The name of the radio frequency band used by the rf channel exactly as reported by firmware. (e.g. G57, Z11). */
	band: Scalars['String']['output'];
	/**
	 * The overall radio frequency range covered by the band.
	 * The underlying band may be a list of ranges, and portions within the band may be unusable for regulatory reasons.
	 */
	frequencyRange: FrequencyRange;
};

export type RfChannelAssignedRfBandBandConstraints = {
	options: Array<RfBandOptions>;
};

export type RfChannelAssignedRfBandChange = {
	assignedRfBand: Maybe<RfChannelAssignedRfBand>;
};

export type RfChannelAssignedRfBandConstraints = {
	band: RfChannelAssignedRfBandBandConstraints;
};

export type RfChannelAssignedRfProfile = {
	profile: Scalars['RfProfileName']['output'];
};

export type RfChannelAssignedRfProfileChange = {
	assignedRfProfile: Maybe<RfChannelAssignedRfProfile>;
};

export type RfChannelAssignedRfProfileConstraints = {
	profile: Maybe<AssignedRfProfileConstraints>;
};

export type RfChannelAssociatedCharger = {
	chargerBay: Maybe<ChargerBay>;
	/** device and chargerBay fields are null when there is an association established with a charger but the charger isn't discovered */
	device: Maybe<Device>;
	lastKnownAssociationDetails: ChargerBayLastKnownAssociationDetails;
};

export type RfChannelAssociation = {
	/** associatedCharger field is null when there is no association established with a charger */
	associatedCharger: Maybe<RfChannelAssociatedCharger>;
};

export type RfChannelAssociationChange = {
	association: Maybe<RfChannelAssociation>;
};

export type RfChannelCarriedAudioChannels = {
	audioChannels: Array<AudioChannel>;
};

export type RfChannelCarriedAudioChannelsChange = {
	carriedAudioChannels: Maybe<RfChannelCarriedAudioChannels>;
};

export type RfChannelChange = {
	features: RfChannelFeatureChange;
	id: Scalars['ID']['output'];
};

export type RfChannelConstraints = {
	antennaDiversity: Maybe<RfChannelAntennaDiversityMeterConstraints>;
	antennaDiversityMode: Maybe<RfChannelAntennaDiversityModeConstraints>;
	assignedRfBand: Maybe<RfChannelAssignedRfBandConstraints>;
	assignedRfProfile: Maybe<RfChannelAssignedRfProfileConstraints>;
	frequencyDiversityMode: Maybe<RfChannelFrequencyDiversityModeConstraints>;
	interferenceDetection: Maybe<RfChannelInterferenceDetectionConstraints>;
	interferenceDetectionResolution: Maybe<RfChannelInterferenceDetectionResolutionConstraints>;
	interferenceDetector: Maybe<RfChannelInterferenceDetectorConstraints>;
	peripheralAudioPolarity: Maybe<RfChannelPeripheralAudioPolarityConstraints>;
	peripheralBatteryHealth: Maybe<RfChannelPeripheralBatteryHealthConstraints>;
	peripheralBatteryLevel: Maybe<RfChannelPeripheralBatteryLevelConstraints>;
	peripheralBatteryType: Maybe<RfChannelPeripheralBatteryTypeConstraints>;
	peripheralWirelessEncryption: Maybe<RfChannelPeripheralWirelessEncryptionConstraints>;
	quality: Maybe<RfChannelQualityMeterConstraints>;
	signalStrength: Maybe<RfChannelSignalStrengthMeterConstraints>;
	signalStrengthWithExceptions: Maybe<RfChannelSignalStrengthWithExceptionsMeterConstraints>;
};

export type RfChannelDescription = {
	constraints: RfChannelConstraints;
	features: RfChannelSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type RfChannelFeatureChange =
	| RfChannelAssignedRfBandChange
	| RfChannelAssignedRfProfileChange
	| RfChannelAssociationChange
	| RfChannelCarriedAudioChannelsChange
	| RfChannelFrequencyDiversityModeChange
	| RfChannelInterferenceDetectionChange
	| RfChannelInterferenceDetectionResolutionChange
	| RfChannelInterferenceDetectorChange
	| RfChannelLinkedTransmitterChange
	| RfChannelMuteChange
	| RfChannelPeripheralAudioMuteChange
	| RfChannelPeripheralAudioPolarityChange
	| RfChannelPeripheralAutoLockChange
	| RfChannelPeripheralBatteryHealthChange
	| RfChannelPeripheralBatteryLevelChange
	| RfChannelPeripheralBatteryTemperatureChange
	| RfChannelPeripheralBatteryTypeChange
	| RfChannelPeripheralDeviceChange
	| RfChannelPeripheralFirmwareChange
	| RfChannelPeripheralSerialNumberChange
	| RfChannelPeripheralWirelessEncryptionChange
	| RfChannelReceiveStandbyModeChange
	| RfChannelTuningChange
	| RfChannelUtilizedRfPortsChange
	| RfChannelWirelessEncryptionStatusChange;

export type RfChannelFeatureUpdateInput =
	| {
			frequencyDiversityMode: RfChannelFrequencyDiversityModeUpdateInput;
			interferenceDetectionResolution?: never;
			interferenceDetector?: never;
			mute?: never;
			receiveStandbyMode?: never;
	  }
	| {
			frequencyDiversityMode?: never;
			interferenceDetectionResolution: RfChannelInterferenceDetectionResolutionUpdateInput;
			interferenceDetector?: never;
			mute?: never;
			receiveStandbyMode?: never;
	  }
	| {
			frequencyDiversityMode?: never;
			interferenceDetectionResolution?: never;
			interferenceDetector: RfChannelInterferenceDetectorUpdateInput;
			mute?: never;
			receiveStandbyMode?: never;
	  }
	| {
			frequencyDiversityMode?: never;
			interferenceDetectionResolution?: never;
			interferenceDetector?: never;
			mute: RfChannelMuteUpdateInput;
			receiveStandbyMode?: never;
	  }
	| {
			frequencyDiversityMode?: never;
			interferenceDetectionResolution?: never;
			interferenceDetector?: never;
			mute?: never;
			receiveStandbyMode: RfChannelReceiveStandbyModeUpdateInput;
	  };

export type RfChannelFeatures = {
	/** @deprecated Basing a general notion of RF performance on RSSI without taking into account the signal to noise ratio is too short-sighted. Axient Digital quality metering addresses this. */
	activity: Maybe<RfChannelActivityMeter>;
	antennaDiversity: Maybe<RfChannelAntennaDiversityMeter>;
	antennaDiversityMode: Maybe<RfChannelAntennaDiversityMode>;
	assignedRfBand: Maybe<RfChannelAssignedRfBand>;
	assignedRfProfile: Maybe<RfChannelAssignedRfProfile>;
	association: Maybe<RfChannelAssociation>;
	carriedAudioChannels: Maybe<RfChannelCarriedAudioChannels>;
	frequencyDiversityMode: Maybe<RfChannelFrequencyDiversityMode>;
	interferenceDetection: Maybe<RfChannelInterferenceDetection>;
	interferenceDetectionResolution: Maybe<RfChannelInterferenceDetectionResolution>;
	interferenceDetector: Maybe<RfChannelInterferenceDetector>;
	linkedTransmitter: Maybe<RfChannelLinkedTransmitter>;
	mute: Maybe<RfChannelMute>;
	peripheralAudioMute: Maybe<RfChannelPeripheralAudioMute>;
	peripheralAudioPolarity: Maybe<RfChannelPeripheralAudioPolarity>;
	peripheralAutoLock: Maybe<RfChannelPeripheralAutoLock>;
	peripheralBatteryHealth: Maybe<RfChannelPeripheralBatteryHealth>;
	peripheralBatteryLevel: Maybe<RfChannelPeripheralBatteryLevel>;
	peripheralBatteryTemperature: Maybe<RfChannelPeripheralBatteryTemperature>;
	peripheralBatteryType: Maybe<RfChannelPeripheralBatteryType>;
	peripheralDevice: Maybe<RfChannelPeripheralDevice>;
	peripheralFirmware: Maybe<RfChannelPeripheralFirmware>;
	peripheralSerialNumber: Maybe<RfChannelPeripheralSerialNumber>;
	peripheralWirelessEncryption: Maybe<RfChannelPeripheralWirelessEncryption>;
	quality: Maybe<RfChannelQualityMeter>;
	receiveStandbyMode: Maybe<RfChannelReceiveStandbyMode>;
	series: Maybe<RfChannelSeries>;
	signalStrength: Maybe<RfChannelSignalStrengthMeter>;
	/** @deprecated The sentinel values of MXWN devices ('MIC_NOT_PRESENT', 'INVALID_RSSI') should be extracted into separate properties, in order to allow interface sharing with all other wireless products Shure produces. */
	signalStrengthWithExceptions: Maybe<RfChannelSignalStrengthWithExceptionsMeter>;
	tuning: Maybe<RfChannelTuning>;
	/** @deprecated The word utilized may be reconsidered in the near future. */
	utilizedRfPorts: Maybe<RfChannelUtilizedRfPorts>;
	wirelessEncryptionStatus: Maybe<RfChannelWirelessEncryptionStatus>;
};

export type RfChannelFrequencyDiversityMode = {
	mode: FrequencyDiversityMode | `${FrequencyDiversityMode}`;
};

export type RfChannelFrequencyDiversityModeChange = {
	frequencyDiversityMode: Maybe<RfChannelFrequencyDiversityMode>;
};

export type RfChannelFrequencyDiversityModeConstraints = {
	mode: RfChannelFrequencyDiversityModeFieldConstraints;
};

export type RfChannelFrequencyDiversityModeFieldConstraints = {
	options: Array<FrequencyDiversityMode | `${FrequencyDiversityMode}`>;
};

export type RfChannelFrequencyDiversityModeUpdateInput = {
	mode: FrequencyDiversityMode | `${FrequencyDiversityMode}`;
};

/** Detect the extent to which RF interference detected by this RF channel affects the resulting audio carried. */
export type RfChannelInterferenceDetection = {
	severity: RfChannelInterferenceDetectionSeverity | `${RfChannelInterferenceDetectionSeverity}`;
};

export type RfChannelInterferenceDetectionChange = {
	interferenceDetection: Maybe<RfChannelInterferenceDetection>;
};

export type RfChannelInterferenceDetectionConstraints = {
	severity: RfChannelInterferenceDetectionSeverityConstraints;
};

export type RfChannelInterferenceDetectionResolution = {
	mode: RfChannelInterferenceDetectionResolutionMode | `${RfChannelInterferenceDetectionResolutionMode}`;
};

export type RfChannelInterferenceDetectionResolutionChange = {
	interferenceDetectionResolution: Maybe<RfChannelInterferenceDetectionResolution>;
};

export type RfChannelInterferenceDetectionResolutionConstraints = {
	mode: RfChannelInterferenceDetectionResolutionModeConstraints;
};

export enum RfChannelInterferenceDetectionResolutionMode {
	Auto = 'AUTO',
	Manual = 'MANUAL',
	Off = 'OFF'
}

export type RfChannelInterferenceDetectionResolutionModeConstraints = {
	options: Array<RfChannelInterferenceDetectionResolutionMode | `${RfChannelInterferenceDetectionResolutionMode}`>;
};

export type RfChannelInterferenceDetectionResolutionUpdateInput = {
	mode: RfChannelInterferenceDetectionResolutionMode | `${RfChannelInterferenceDetectionResolutionMode}`;
};

export enum RfChannelInterferenceDetectionSeverity {
	/** Interference is detected; audio will be silenced */
	Critical = 'CRITICAL',
	/** No interference is detected */
	None = 'NONE'
}

export type RfChannelInterferenceDetectionSeverityConstraints = {
	options: Array<RfChannelInterferenceDetectionSeverity | `${RfChannelInterferenceDetectionSeverity}`>;
};

export type RfChannelInterferenceDetector = {
	sensitivity: RfChannelInterferenceDetectorSensitivity | `${RfChannelInterferenceDetectorSensitivity}`;
};

export type RfChannelInterferenceDetectorChange = {
	interferenceDetector: Maybe<RfChannelInterferenceDetector>;
};

export type RfChannelInterferenceDetectorConstraints = {
	sensitivity: RfChannelInterferenceDetectorSensitivityConstraints;
};

/**
 * The level of sensitivity of the interference detector.
 * Sensitivity only applies when the detector is enabled.
 */
export enum RfChannelInterferenceDetectorSensitivity {
	Aggressive = 'AGGRESSIVE',
	Conservative = 'CONSERVATIVE'
}

export type RfChannelInterferenceDetectorSensitivityConstraints = {
	options: Array<RfChannelInterferenceDetectorSensitivity | `${RfChannelInterferenceDetectorSensitivity}`>;
};

export type RfChannelInterferenceDetectorUpdateInput = {
	sensitivity?: InputMaybe<RfChannelInterferenceDetectorSensitivity | `${RfChannelInterferenceDetectorSensitivity}`>;
};

export type RfChannelLastKnownAssociationDetails = {
	/** name of access point associated to this device */
	deviceName: Scalars['String']['output'];
	/** rf channel of access point associated to this device */
	rfChannelIndex: Scalars['Int']['output'];
};

export type RfChannelLinkage = {
	/** device field is null when there is a linkage established with a transmitter but the transmitter isn't discovered */
	device: Maybe<Device>;
	/**
	 *  Last known linkage information for use when the transmitter cannot be discovered.
	 * E.g. the transmitter was physically docked on a charger on a different subnet which cannot be discovered.
	 */
	lastKnownLinkageDetails: TransmitterDeviceLastKnownLinkageDetails;
};

export type RfChannelLinkedTransmitter = {
	/** linkage field is null when there is no linkage established with a transmitter */
	linkage: Maybe<RfChannelLinkage>;
};

export type RfChannelLinkedTransmitterChange = {
	linkedTransmitter: Maybe<RfChannelLinkedTransmitter>;
};

export type RfChannelMeterChange = {
	features: Maybe<RfChannelMeterFeatureChange>;
	id: Scalars['ID']['output'];
};

export type RfChannelMeterFeatureChange = {
	/** @deprecated Basing a general notion of RF performance on RSSI without taking into account the signal to noise ratio is too short-sighted. Axient Digital quality metering addresses this. */
	activity: Maybe<RfChannelActivityMeter>;
	antennaDiversity: Maybe<RfChannelAntennaDiversityMeter>;
	quality: Maybe<RfChannelQualityMeter>;
	signalStrength: Maybe<RfChannelSignalStrengthMeter>;
	signalStrengthWithExceptions: Maybe<RfChannelSignalStrengthWithExceptionsMeter>;
};

export type RfChannelMute = {
	/** Indicates whether or not the channel is muted */
	muted: Scalars['Boolean']['output'];
};

export type RfChannelMuteChange = {
	mute: Maybe<RfChannelMute>;
};

export type RfChannelMuteUpdateInput = {
	muted: Scalars['Boolean']['input'];
};

export type RfChannelOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	rfChannel: Maybe<RfChannel>;
};

export type RfChannelPeripheralAudioMute = {
	/** Indicates whether peripheral device is muted, or null if the peripheral device is unavailable */
	muted: Maybe<Scalars['Boolean']['output']>;
};

export type RfChannelPeripheralAudioMuteChange = {
	peripheralAudioMute: Maybe<RfChannelPeripheralAudioMute>;
};

export type RfChannelPeripheralAudioPolarity = {
	/** Indicates the polarity of the mic signal */
	polarity: Maybe<RfChannelPeripheralAudioPolarityPolarity | `${RfChannelPeripheralAudioPolarityPolarity}`>;
};

export type RfChannelPeripheralAudioPolarityChange = {
	peripheralAudioPolarity: Maybe<RfChannelPeripheralAudioPolarity>;
};

export type RfChannelPeripheralAudioPolarityConstraints = {
	polarity: RfChannelPeripheralAudioPolarityPolarityConstraints;
};

export enum RfChannelPeripheralAudioPolarityPolarity {
	NormalPositive = 'NORMAL_POSITIVE',
	ReversedNegative = 'REVERSED_NEGATIVE'
}

export type RfChannelPeripheralAudioPolarityPolarityConstraints = {
	options: Array<RfChannelPeripheralAudioPolarityPolarity | `${RfChannelPeripheralAudioPolarityPolarity}`>;
};

export type RfChannelPeripheralAutoLock = {
	/** Indicates whether auto lock is enabled, or null if the peripheral device is unavailable */
	enabled: Maybe<Scalars['Boolean']['output']>;
};

export type RfChannelPeripheralAutoLockChange = {
	peripheralAutoLock: Maybe<RfChannelPeripheralAutoLock>;
};

export type RfChannelPeripheralBatteryHealth = {
	/** The number of charge cycles for the peripheral device, or null if the peripheral device is unavailable */
	cycleCount: Maybe<Scalars['Int']['output']>;
	/** Battery health/usable capacity percentage, or null if the peripheral device is unavailable */
	percentage: Maybe<Scalars['Int']['output']>;
};

export type RfChannelPeripheralBatteryHealthChange = {
	peripheralBatteryHealth: Maybe<RfChannelPeripheralBatteryHealth>;
};

export type RfChannelPeripheralBatteryHealthConstraints = {
	percentage: RfChannelPeripheralBatteryHealthPercentageConstraints;
};

export type RfChannelPeripheralBatteryHealthPercentageConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type RfChannelPeripheralBatteryLevel = {
	/**
	 * The current level as a discrete number of bars. Each bar represents a specific range of battery percentage, providing a coarse representation of the remaining battery life.
	 * If the peripheral device, or RF side-channel data, is unavailable, this value will be null.
	 */
	bars: Maybe<Scalars['Int']['output']>;
	/**
	 * The current level of charge held by the device's battery, as a percentage.
	 * If the peripheral device, or RF side-channel data, is unavailable, this value will be null.
	 */
	percentage: Maybe<Scalars['Int']['output']>;
	/**
	 * Status about the battery's remaining time to the state it is targeting, whether that be charging or discharging, partially or completely.
	 * If the peripheral device, or RF side-channel data, is unavailable, this value will be null.
	 */
	status: Maybe<RfChannelPeripheralBatteryStatus>;
};

export type RfChannelPeripheralBatteryLevelBarsConstraints = IFieldSupportInfo &
	INullableIntRangeConstraints & {
		/** Describes the range of values (number of bars) for battery charge bars. */
		range: Maybe<IntRange>;
		supported: Scalars['Boolean']['output'];
	};

export type RfChannelPeripheralBatteryLevelChange = {
	peripheralBatteryLevel: Maybe<RfChannelPeripheralBatteryLevel>;
};

export type RfChannelPeripheralBatteryLevelConstraints = {
	/** Describes the range of valid bar values (number of bars) which can be reported by the battery-powered device. */
	bars: RfChannelPeripheralBatteryLevelBarsConstraints;
	/**
	 * Describes the range of valid percentage values which can be reported by the battery-powered device.
	 * E.g. Shure smart batteries can provide greater granularity about charge percentage than traditional AAs
	 * when a device is on-air.
	 */
	percentage: RfChannelPeripheralBatteryLevelPercentageConstraints;
	/** Describes the current status regarding the battery level, and any changes which are expected based on whether it is charging or discharging. */
	status: RfChannelPeripheralBatteryLevelStatusConstraints;
};

export type RfChannelPeripheralBatteryLevelPercentageConstraints = IFieldSupportInfo &
	INullableIntRangeConstraints & {
		/** Describes the range of values for battery charge percentage. */
		range: Maybe<IntRange>;
		supported: Scalars['Boolean']['output'];
	};

export type RfChannelPeripheralBatteryLevelStatusConstraints = {
	targetState: RfChannelPeripheralBatteryLevelTargetStateConstraints;
};

export type RfChannelPeripheralBatteryLevelTargetStateConstraints = {
	options: Array<RfChannelPeripheralBatteryState | `${RfChannelPeripheralBatteryState}`>;
};

export enum RfChannelPeripheralBatteryState {
	BatteryError = 'BATTERY_ERROR',
	Calculating = 'CALCULATING',
	Charging = 'CHARGING',
	Discharging = 'DISCHARGING',
	Empty = 'EMPTY',
	Full = 'FULL'
}

export type RfChannelPeripheralBatteryStatus = {
	/** Describes the current state of the battery. */
	currentState: RfChannelPeripheralBatteryState | `${RfChannelPeripheralBatteryState}`;
	/** Describes the state the battery will eventually reach. */
	targetState: Maybe<RfChannelPeripheralBatteryState | `${RfChannelPeripheralBatteryState}`>;
	/**
	 * The amount of time remaining for the battery to enter one of the following states expressed through the 'RfChannelPeripheralBatteryState' enum.
	 * If null, the attached battery does not support time calculation, or otherwise is unavailable.
	 */
	timeToTargetState: Maybe<Scalars['Duration']['output']>;
};

export type RfChannelPeripheralBatteryTemperature = {
	/** Battery temperature in degrees celsius, or null if the peripheral device is unavailable */
	celsius: Maybe<Scalars['Int']['output']>;
	/** Indicates whether the peripheral device battery is over temperature */
	overTemperature: Scalars['Boolean']['output'];
};

export type RfChannelPeripheralBatteryTemperatureChange = {
	peripheralBatteryTemperature: Maybe<RfChannelPeripheralBatteryTemperature>;
};

export type RfChannelPeripheralBatteryType = {
	/** Battery type if valid, null if no valid type found. */
	type: Maybe<RfChannelPeripheralBatteryTypeType | `${RfChannelPeripheralBatteryTypeType}`>;
};

export type RfChannelPeripheralBatteryTypeChange = {
	peripheralBatteryType: Maybe<RfChannelPeripheralBatteryType>;
};

export type RfChannelPeripheralBatteryTypeConstraints = {
	type: RfChannelPeripheralBatteryTypeTypeConstraints;
};

export enum RfChannelPeripheralBatteryTypeType {
	/** Alkaline battery */
	Alkaline = 'ALKALINE',
	/** Lithium (non-rechargeable) battery */
	Lithium = 'LITHIUM',
	/** Li-ion (lithium-ion) battery */
	LiIon = 'LI_ION',
	/** NiMH (nickel metal hydride) battery */
	Nimh = 'NIMH'
}

export type RfChannelPeripheralBatteryTypeTypeConstraints = {
	options: Array<RfChannelPeripheralBatteryTypeType | `${RfChannelPeripheralBatteryTypeType}`>;
};

export type RfChannelPeripheralDevice = {
	description: Maybe<RfChannelPeripheralDeviceDescription>;
	/**
	 * If available, provides access to the peripheral device.
	 * This value will be null if the peripheral device is:
	 * - not discoverable by net-stack
	 * - not ShowLink capable
	 */
	device: Maybe<Device>;
	/** Indicates whether the peripheral device, or RF side-channel data, is available. */
	present: Scalars['Boolean']['output'];
};

export type RfChannelPeripheralDeviceChange = {
	peripheralDevice: Maybe<RfChannelPeripheralDevice>;
};

export type RfChannelPeripheralDeviceDescription = {
	name: Scalars['String']['output'];
};

export type RfChannelPeripheralFirmware = {
	/** Indicates whether the firmware is valid. The value is null if the peripheral device is unavailable. */
	valid: Maybe<Scalars['Boolean']['output']>;
	/** The firmware version of the peripheral device. The value is null if the peripheral device is unavailable. */
	version: Maybe<Scalars['SemanticVersion']['output']>;
};

export type RfChannelPeripheralFirmwareChange = {
	peripheralFirmware: Maybe<RfChannelPeripheralFirmware>;
};

export type RfChannelPeripheralSerialNumber = {
	/** The serial number of the peripheral device. The value is null if the peripheral device is unavailable. */
	serialNumber: Maybe<Scalars['String']['output']>;
};

export type RfChannelPeripheralSerialNumberChange = {
	peripheralSerialNumber: Maybe<RfChannelPeripheralSerialNumber>;
};

export type RfChannelPeripheralWirelessEncryption = {
	/** Indicates the encryption mode of the wireless mic */
	mode: Maybe<RfChannelPeripheralWirelessEncryptionMode | `${RfChannelPeripheralWirelessEncryptionMode}`>;
};

export type RfChannelPeripheralWirelessEncryptionChange = {
	peripheralWirelessEncryption: Maybe<RfChannelPeripheralWirelessEncryption>;
};

export type RfChannelPeripheralWirelessEncryptionConstraints = {
	mode: RfChannelPeripheralWirelessEncryptionModeConstraints;
};

export enum RfChannelPeripheralWirelessEncryptionMode {
	Disabled = 'DISABLED',
	Enabled = 'ENABLED'
}

export type RfChannelPeripheralWirelessEncryptionModeConstraints = {
	options: Array<RfChannelPeripheralWirelessEncryptionMode | `${RfChannelPeripheralWirelessEncryptionMode}`>;
};

export type RfChannelQualityConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type RfChannelQualityMeter = {
	/**
	 * Non-null when there is an active RF carrier wave is successfully demodulated.
	 * Null when one cannot be successfully demodulated.
	 */
	level: Maybe<Scalars['Int']['output']>;
};

export type RfChannelQualityMeterConstraints = {
	level: RfChannelQualityConstraints;
};

export type RfChannelReceiveStandbyMode = {
	/** Indicates whether or not the channel is in receive standby mode */
	enabled: Scalars['Boolean']['output'];
};

export type RfChannelReceiveStandbyModeChange = {
	receiveStandbyMode: Maybe<RfChannelReceiveStandbyMode>;
};

export type RfChannelReceiveStandbyModeUpdateInput = {
	enabled: Scalars['Boolean']['input'];
};

/**
 * Describes the characteristics of the RF Channel and how it behaves from an RF perspective.
 *
 * Examples include, but are not limited to
 * - Desired channel spacing
 * - RF Q factor / bandwidth
 */
export type RfChannelSeries = {
	name: Scalars['RfChannelSeriesName']['output'];
};

export type RfChannelSignalStrengthAntennaMeter = {
	/**
	 * This is the discriminator field indicating each antenna's level.
	 * Possible values are ANTENNA_A, ANTENNA_B, ANTENNA_C, or ANTENNA_D
	 */
	antenna: Scalars['String']['output'];
	/** The received signal strength indicator (RSSI) over the RF antenna, in dBm */
	level: Scalars['Float']['output'];
};

export type RfChannelSignalStrengthAntennaMeterConstraints = {
	antenna: Scalars['String']['output'];
	level: FloatRangeConstraints;
};

export type RfChannelSignalStrengthMeter = {
	antennas: Array<RfChannelSignalStrengthAntennaMeter>;
};

export type RfChannelSignalStrengthMeterConstraints = {
	antennas: Array<RfChannelSignalStrengthAntennaMeterConstraints>;
};

export type RfChannelSignalStrengthWithExceptionsAntennaMeter = {
	/**
	 * This is the discriminator field indicating each antenna's level.
	 * Possible values are ANTENNA_A
	 */
	antenna: Scalars['String']['output'];
	strength: Maybe<StrengthLevel>;
};

export type RfChannelSignalStrengthWithExceptionsAntennaMeterConstraints = {
	antenna: Scalars['String']['output'];
	strength: SignalStrengthWithExceptionsConstraints;
};

export type RfChannelSignalStrengthWithExceptionsMeter = {
	antennas: Array<RfChannelSignalStrengthWithExceptionsAntennaMeter>;
};

export type RfChannelSignalStrengthWithExceptionsMeterConstraints = {
	antennas: Array<RfChannelSignalStrengthWithExceptionsAntennaMeterConstraints>;
};

export type RfChannelSupportedFeatures = {
	/** @deprecated Basing a general notion of RF performance on RSSI without taking into account the signal to noise ratio is too short-sighted. Axient Digital quality metering addresses this. */
	activity: FeatureSupport;
	antennaDiversity: FeatureSupport;
	antennaDiversityMode: FeatureSupport;
	assignedRfBand: FeatureSupport;
	assignedRfProfile: FeatureSupport;
	association: FeatureSupport;
	carriedAudioChannels: FeatureSupport;
	frequencyDiversityMode: FeatureSupport;
	interferenceDetection: FeatureSupport;
	interferenceDetectionResolution: FeatureSupport;
	interferenceDetector: FeatureSupport;
	linkedTransmitter: FeatureSupport;
	linking: FeatureSupport;
	mute: FeatureSupport;
	peripheralAudioMute: FeatureSupport;
	peripheralAudioPolarity: FeatureSupport;
	peripheralAutoLock: FeatureSupport;
	peripheralBatteryHealth: FeatureSupport;
	peripheralBatteryLevel: FeatureSupport;
	peripheralBatteryTemperature: FeatureSupport;
	peripheralBatteryType: FeatureSupport;
	peripheralDevice: FeatureSupport;
	peripheralFirmware: FeatureSupport;
	peripheralSerialNumber: FeatureSupport;
	peripheralWirelessEncryption: FeatureSupport;
	quality: FeatureSupport;
	receiveStandbyMode: FeatureSupport;
	series: FeatureSupport;
	signalStrength: FeatureSupport;
	signalStrengthWithExceptions: FeatureSupport;
	tuning: FeatureSupport;
	/** @deprecated The word utilized may be reconsidered in the near future. */
	utilizedRfPorts: FeatureSupport;
	wirelessEncryptionStatus: FeatureSupport;
};

/**
 * The frequency of the device (e.g. transmitter, receiver, etc) in MHz, or in RF Band Group and Channel.
 * Refer to https://service.shure.com/s/article/What-Are-Groups-and-Channels?language=en_US for more details
 */
export type RfChannelTuning = {
	/** The tuning frequency of the RF channel expressed in kHz */
	frequency: Scalars['Int']['output'];
	groupAndChannel: Maybe<RfChannelTuningGroupAndChannel>;
};

export type RfChannelTuningBandInfo = {
	band: Scalars['String']['output'];
	deviceTypes: Array<Scalars['Guid']['output']>;
	supportedFrequencies: Array<RfChannelTuningFrequencyRange>;
};

export type RfChannelTuningBands = {
	band: Scalars['String']['output'];
	profiles: Array<Scalars['RfProfileName']['output']>;
	ranges: Array<RfChannelTuningFrequencyRange>;
};

export type RfChannelTuningChange = {
	tuning: Maybe<RfChannelTuning>;
};

export type RfChannelTuningChannelFrequency = {
	channel: Scalars['String']['output'];
	/** The tuning frequency of the RF channel expressed in kHz */
	frequency: Scalars['Int']['output'];
};

export type RfChannelTuningFrequencyRange = {
	/** The end of the tunable range expressed in kHz */
	max: Scalars['Int']['output'];
	/** The start of the tunable range expressed in kHz */
	min: Scalars['Int']['output'];
	/** The band step size expressed in kHz */
	step: Scalars['Int']['output'];
};

export type RfChannelTuningGroupAndChannel = {
	/**
	 * A specific tuning frequency within the group.
	 * All frequencies within a group are guaranteed compatible
	 * with each other and will thus not interfere with each other.
	 */
	channel: Scalars['String']['output'];
	/** A collection of compatible frequencies */
	group: Scalars['String']['output'];
};

/** One of groupAndChannel or frequency in MHz. */
export type RfChannelTuningGroupAndChannelOrFrequencyUpdateInput =
	/** The tuning frequency of the RF channel in kHz */
	| { frequency: Scalars['Int']['input']; groupAndChannel?: never }
	| { frequency?: never; groupAndChannel: RfChannelTuningGroupAndChannelUpdateInput };

export type RfChannelTuningGroupAndChannelUpdateInput = {
	/**
	 * A specific tuning frequency within the group.
	 * All frequencies within a group are guaranteed compatible
	 * with each other and will thus not interfere with each other.
	 */
	channel: Scalars['String']['input'];
	group: Scalars['String']['input'];
};

export type RfChannelTuningGroupAndChannels = {
	/** The band the group and channels belong to */
	band: Scalars['String']['output'];
	channels: Array<RfChannelTuningChannelFrequency>;
	/** The group for the set of channels */
	group: Scalars['String']['output'];
	/** The profile the group and channels belong to */
	profile: Scalars['RfProfileName']['output'];
};

export type RfChannelTuningUpdateInput = {
	id: Scalars['ID']['input'];
	tuning: RfChannelTuningGroupAndChannelOrFrequencyUpdateInput;
};

export type RfChannelUpdateInput = {
	features?: InputMaybe<RfChannelFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export type RfChannelUtilizedRfPorts = {
	/** @deprecated The word utilized may be reconsidered in the near future. */
	ports: Array<RfPort>;
};

export type RfChannelUtilizedRfPortsChange = {
	/** @deprecated The word utilized may be reconsidered in the near future. */
	utilizedRfPorts: Maybe<RfChannelUtilizedRfPorts>;
};

export type RfChannelWirelessEncryptionStatus = {
	status: Maybe<WirelessEncryptionStatus | `${WirelessEncryptionStatus}`>;
};

export type RfChannelWirelessEncryptionStatusChange = {
	wirelessEncryptionStatus: Maybe<RfChannelWirelessEncryptionStatus>;
};

export enum RfDensityMode {
	High = 'HIGH',
	Standard = 'STANDARD'
}

export type RfDensityModeConstraints = {
	options: Array<RfDensityMode | `${RfDensityMode}`>;
};

export type RfPort = Fragment &
	Node & {
		description: RfPortDescription;
		features: RfPortFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

/**
 * Used for detecting DC power fault short circuit conditions or excessive load(s) for a device's antenna ports.
 * If this situation occurs, ...
 *     	- Check antennas and cables for damage
 *     	- Ensure that antenna ports are not overloaded
 *     	- Check antenna bias voltage setting. Turn off voltage if using passive antennas.
 */
export type RfPortAntennaFault = {
	/**
	 * Whether or not a DC power fault short circuit condition or excessive load was detected at an antenna port.
	 * If this situation occurs, ...
	 *       	- Check antennas and cables for damage
	 *       	- Ensure that antenna ports are not overloaded
	 *       	- Check antenna bias voltage setting. Turn off voltage if using passive antennas.
	 * @deprecated This API is subject to drastic change while being finalized
	 */
	faultDetected: Scalars['Boolean']['output'];
};

export type RfPortAntennaFaultChange = {
	/** @deprecated This API is subject to drastic change while being finalized */
	antennaFault: Maybe<RfPortAntennaFault>;
};

export type RfPortChange = {
	features: RfPortFeatureChange;
	id: Scalars['ID']['output'];
};

export type RfPortConstraints = {
	/** @deprecated This API is subject to drastic change while being finalized */
	dcPower: Maybe<RfPortCurrentLevelConstraints>;
};

export type RfPortCurrentLevelConstraints = IIntRangeConstraints & {
	/** @deprecated This API is subject to drastic change while being finalized */
	range: IntRange;
};

export type RfPortDcPower = {
	/** The current draw from the bias voltage supply in mA */
	currentLevel: Maybe<Scalars['Int']['output']>;
	/** @deprecated This API is subject to drastic change while being finalized */
	enable: Scalars['Boolean']['output'];
};

export type RfPortDcPowerChange = {
	/** @deprecated This API is subject to drastic change while being finalized */
	dcPower: Maybe<RfPortDcPower>;
};

export type RfPortDcPowerConstraints = {
	/** @deprecated This API is subject to drastic change while being finalized */
	currentLevel: RfPortCurrentLevelConstraints;
};

export type RfPortDcPowerUpdateInput = {
	enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RfPortDescription = {
	constraints: RfPortConstraints;
	features: RfPortSupportedFeatures;
	index: Scalars['Int']['output'];
	label: Scalars['RfPortLabel']['output'];
	role: RfPortRole | `${RfPortRole}`;
};

export type RfPortFeatureChange =
	| RfPortAntennaFaultChange
	| RfPortDcPowerChange
	| RfPortFrontEndPowerLimiterEngagedChange
	| RfPortFrontEndPowerOverloadChange
	| RfPortUtilizedByRfChannelsChange;

export type RfPortFeatureUpdateInput = { dcPower: RfPortDcPowerUpdateInput };

export type RfPortFeatures = {
	/** @deprecated This API is subject to drastic change while being finalized */
	antennaFault: Maybe<RfPortAntennaFault>;
	/** @deprecated This API is subject to drastic change while being finalized */
	dcPower: Maybe<RfPortDcPower>;
	frontEndPowerLimiterEngaged: Maybe<RfPortFrontEndPowerLimiterEngaged>;
	frontEndPowerOverload: Maybe<RfPortFrontEndPowerOverload>;
	/** @deprecated The word utilized may be reconsidered in the near future. */
	utilizedByRfChannels: Maybe<RfPortUtilizedByRfChannels>;
};

export type RfPortFrontEndPowerLimiterEngaged = {
	/** Whether or not the RF power limiter is engaged for an antenna input to attempt to prevent damage to RF circuitry */
	engaged: Scalars['Boolean']['output'];
};

export type RfPortFrontEndPowerLimiterEngagedChange = {
	frontEndPowerLimiterEngaged: Maybe<RfPortFrontEndPowerLimiterEngaged>;
};

export type RfPortFrontEndPowerOverload = {
	/** Wether or not an RF power overload is detected. */
	overloaded: Scalars['Boolean']['output'];
};

export type RfPortFrontEndPowerOverloadChange = {
	frontEndPowerOverload: Maybe<RfPortFrontEndPowerOverload>;
};

export type RfPortOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	rfPort: Maybe<RfPort>;
};

export enum RfPortRole {
	CascadeOnly = 'CASCADE_ONLY',
	Input = 'INPUT',
	InputOrCascade = 'INPUT_OR_CASCADE',
	Output = 'OUTPUT'
}

export type RfPortSupportedFeatures = {
	/** @deprecated This API is subject to drastic change while being finalized */
	antennaFault: FeatureSupport;
	/** @deprecated This API is subject to drastic change while being finalized */
	dcPower: FeatureSupport;
	frontEndPowerLimiterEngaged: FeatureSupport;
	frontEndPowerOverload: FeatureSupport;
	/** @deprecated The word utilized may be reconsidered in the near future. */
	utilizedByRfChannels: FeatureSupport;
};

export type RfPortUpdateInput = {
	features?: InputMaybe<RfPortFeatureUpdateInput>;
	id: Scalars['ID']['input'];
};

export type RfPortUtilizedByRfChannels = {
	/** @deprecated The word utilized may be reconsidered in the near future. */
	channels: Array<RfChannel>;
};

export type RfPortUtilizedByRfChannelsChange = {
	/** @deprecated The word utilized may be reconsidered in the near future. */
	utilizedByRfChannels: Maybe<RfPortUtilizedByRfChannels>;
};

export enum RfPower {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM',
	MediumHigh = 'MEDIUM_HIGH'
}

export type RfPowerConstraints = {
	options: Array<RfPower | `${RfPower}`>;
};

export type RfTransmissionProfileConstraints = {
	options: Array<Scalars['RfProfileName']['output']>;
};

export type RgbColorMix = {
	blue: Scalars['Int']['output'];
	green: Scalars['Int']['output'];
	red: Scalars['Int']['output'];
};

export type RgbColorMixConstraints = {
	blue: RgbColorMixFieldConstraints;
	green: RgbColorMixFieldConstraints;
	red: RgbColorMixFieldConstraints;
};

export type RgbColorMixFieldConstraints = IIntRangeConstraints & {
	range: IntRange;
};

export type RgbColorMixInput = {
	blue: Scalars['Int']['input'];
	green: Scalars['Int']['input'];
	red: Scalars['Int']['input'];
};

export type Room = Node & {
	compatibility: RoomVersionCompatibility | `${RoomVersionCompatibility}`;
	conflict: Scalars['Boolean']['output'];
	/** Time Stamp when room is created */
	created: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	devices: Array<Device>;
	dimensions: Maybe<RoomDimensions>;
	/**
	 * When true, the room will be held when no devices belong to it.
	 * When false, the room will be automatically deleted when no devices belong to it.
	 */
	hold: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	/** Basic information about the devices which are currently assigned to the room, but have not been discovered. */
	missingDevices: Array<RoomManifestDevice>;
	name: Scalars['String']['output'];
	roomId: Scalars['Guid']['output'];
	/** Time Stamp when room is modified for the last time */
	updated: Scalars['DateTime']['output'];
	version: Scalars['String']['output'];
};

export type RoomAddedEvent = {
	added: Room;
};

export enum RoomCloningStrategy {
	/**
	 * Cloned device has origin ID set to the ID of the device from which it is cloned
	 * Cloning of virtual device with CLONE_AS_CHILD strategy would always result
	 * in the clone with nill origin ID (identical to CLONE_AS_ORPHAN) due to the rule
	 * of "clone of a clone is pure virtual with no origin"
	 */
	CloneAsChild = 'CLONE_AS_CHILD',
	/**
	 * Cloned device has no origin ID (null UUID)
	 * Cloning of virtual device with CLONE_AS_CHILD strategy would always result
	 * in the clone with nill origin ID (identical to CLONE_AS_ORPHAN)
	 * due to the rule of "clone of a clone is pure virtual with no origin"
	 */
	CloneAsOrphan = 'CLONE_AS_ORPHAN',
	/**
	 * Cloned device has origin ID set to the origin ID of the original device
	 * Notice that for real devices this will result in the same originId as in
	 * CLONE_AS_CHILD strategy. Real devices have origin ID equal their ID
	 */
	CloneAsSibling = 'CLONE_AS_SIBLING'
}

export type RoomDeploymentInput = {
	destinationRoom?: InputMaybe<Scalars['ID']['input']>;
	destinationRoomDescription?: InputMaybe<Scalars['String']['input']>;
	destinationRoomName?: InputMaybe<Scalars['String']['input']>;
	devices: Array<DeviceDeploymentInput>;
	sourceRoom: Scalars['ID']['input'];
};

export enum RoomDeploymentOverallResult {
	/**
	 * Room deployment failed, device deployment failed and no room placement was attempted
	 * @deprecated Use the more specific failure modes instead
	 */
	DeploymentFailed = 'DEPLOYMENT_FAILED',
	/** Room deployment succeeded, devices were deployed and placed into a room */
	DeploymentSuccess = 'DEPLOYMENT_SUCCESS',
	/** Failed at creating the destination room for the target devices */
	FailedCreatingDestinationRoom = 'FAILED_CREATING_DESTINATION_ROOM',
	/** Failed at deploying audio routes between devices in room */
	FailedDeployingAudioRoutes = 'FAILED_DEPLOYING_AUDIO_ROUTES',
	/** Failed at deploying control routes (i.e. mute routes) between devices in room */
	FailedDeployingControlRoutes = 'FAILED_DEPLOYING_CONTROL_ROUTES',
	/** Failed at deploying device state from sources to targets */
	FailedDeployingDeviceState = 'FAILED_DEPLOYING_DEVICE_STATE',
	/** Failed at cleaning up and validating the room deployment */
	FailedFinalizing = 'FAILED_FINALIZING',
	/** Failed at preparing the devices and rooms for room deployment */
	FailedPreparing = 'FAILED_PREPARING',
	/** Failed for unknown reasons */
	FailedUnknown = 'FAILED_UNKNOWN',
	/**
	 * Room deployment failed, devices were successfully deployed, but could not be placed in a room
	 * @deprecated Use the more specific failure modes instead
	 */
	PlacementFailed = 'PLACEMENT_FAILED'
}

export type RoomDeploymentProgress = RoomDeploymentProgressEvent | RoomDeploymentResult;

export type RoomDeploymentProgressEvent = {
	/** Overall progress of room deployment between 0 and 100 */
	progressPercentage: Scalars['Int']['output'];
	/** The current deployment activity happening */
	roomDeploymentStage: RoomDeploymentStage | `${RoomDeploymentStage}`;
};

export enum RoomDeploymentProgressType {
	RoomDeploymentResult = 'ROOM_DEPLOYMENT_RESULT'
}

export type RoomDeploymentResult = {
	destinationRoom: Maybe<Room>;
	deviceDeploymentResults: Array<DeviceDeploymentResult>;
	overallResult: RoomDeploymentOverallResult | `${RoomDeploymentOverallResult}`;
};

export enum RoomDeploymentStage {
	/** Creating the destination room for the target devices */
	CreatingDestinationRoom = 'CREATING_DESTINATION_ROOM',
	/** Deploying audio routes between devices in room */
	DeployingAudioRoutes = 'DEPLOYING_AUDIO_ROUTES',
	/** Deploying control routes (i.e. mute routes) between devices in room */
	DeployingControlRoutes = 'DEPLOYING_CONTROL_ROUTES',
	/** Deploying device state from sources to targets */
	DeployingDeviceState = 'DEPLOYING_DEVICE_STATE',
	/** Cleaning up and validating the room deployment */
	Finalizing = 'FINALIZING',
	/** The deployment request has been accepted and is pending execution */
	Pending = 'PENDING',
	/** Preparing the devices and rooms for room deployment */
	Preparing = 'PREPARING'
}

export type RoomDimensions = {
	/** height values are scaled to represent in millimeters (mm) */
	height: Scalars['Float']['output'];
	/** length values are scaled to represent in millimeters (mm) */
	length: Scalars['Float']['output'];
	/** width values are scaled to represent in millimeters (mm) */
	width: Scalars['Float']['output'];
};

export type RoomDimensionsInput = {
	/** height values are scaled to represent in millimeters (mm) */
	height: Scalars['Float']['input'];
	/** length values are scaled to represent in millimeters (mm) */
	length: Scalars['Float']['input'];
	/** width values are scaled to represent in millimeters (mm) */
	width: Scalars['Float']['input'];
};

/** Basic information about devices which are assigned to a room */
export type RoomManifestDevice = Node & {
	hardwareId: Scalars['Guid']['output'];
	id: Scalars['ID']['output'];
	model: Scalars['String']['output'];
};

export type RoomOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	room: Maybe<Room>;
};

export enum RoomOptimizationStage {
	/** Creating audio/control routes between devices */
	CreatingAssociations = 'CREATING_ASSOCIATIONS',
	/** Applying device settings for optimal audio */
	OptimizingDeviceSettings = 'OPTIMIZING_DEVICE_SETTINGS'
}

export enum RoomOptimizationStatus {
	Conflict = 'CONFLICT',
	DevicesUnavailable = 'DEVICES_UNAVAILABLE',
	Failure = 'FAILURE',
	IncompatibleDevice = 'INCOMPATIBLE_DEVICE',
	MissingMicrophone = 'MISSING_MICROPHONE',
	MissingProcessor = 'MISSING_PROCESSOR',
	PartialSuccess = 'PARTIAL_SUCCESS',
	Success = 'SUCCESS'
}

export type RoomRemovedEvent = {
	removed: Scalars['ID']['output'];
};

export enum RoomVersionCompatibility {
	/** The version of room is equal to our latest known version */
	CompatibleLatest = 'COMPATIBLE_LATEST',
	/** The version of room is less than our latest known version */
	CompatibleOld = 'COMPATIBLE_OLD',
	/** The version of room is greater than our latest known version */
	IncompatibleTooNew = 'INCOMPATIBLE_TOO_NEW',
	/** Unable to understand the version of the room (version is 0 for some reason) */
	Unknown = 'UNKNOWN'
}

export type SaveDeviceStateInput = {
	device: Scalars['ID']['input'];
	filePath: Scalars['String']['input'];
	overwrite: Scalars['Boolean']['input'];
	saveOption: SaveDeviceStateOption | `${SaveDeviceStateOption}`;
};

export enum SaveDeviceStateOption {
	SaveAll = 'SAVE_ALL',
	SaveCacheOnly = 'SAVE_CACHE_ONLY'
}

export type SaveDeviceStateResult = {
	device: Maybe<Device>;
	error: Maybe<OperationError>;
	filePath: Maybe<Scalars['String']['output']>;
	/** @deprecated Use 'error' field instead to check for operation failure. */
	saveResult: Maybe<SavePerDeviceStateResult | `${SavePerDeviceStateResult}`>;
};

export enum SavePerDeviceStateResult {
	SaveFailed = 'SAVE_FAILED',
	SaveSuccess = 'SAVE_SUCCESS'
}

export type SecondaryControlNetworkDnsClientConfiguration = {
	/**
	 * The first array item is the primary server IP address
	 * and the second array item is the secondary server IP address
	 */
	automaticConfiguration: Array<Scalars['IpAddress']['output']>;
	/**
	 * The first array item is the primary server IP address
	 * and the second array item is the secondary server IP address
	 */
	manualConfiguration: Array<Scalars['IpAddress']['output']>;
	mode:
		| DeviceSecondaryControlNetworkDnsClientConfigurationMode
		| `${DeviceSecondaryControlNetworkDnsClientConfigurationMode}`;
};

export type SecondaryControlNetworkDnsClientConfigurationConstraints = {
	automaticConfiguration: DeviceSecondaryControlNetworkDnsClientConfigurationIpAddressArrayConstraints;
	manualConfiguration: DeviceSecondaryControlNetworkDnsClientConfigurationIpAddressArrayConstraints;
	mode: DeviceSecondaryControlNetworkDnsClientConfigurationModeConstraints;
};

/**
 * For a given frequency range, describes the valid gain range the signal generator can produce a tone for,
 * given a chosen signal type and available power source
 */
export type SignalGeneratorGainRangeByFrequencyRange = {
	/** For signal types which are not pure tones (e.g. pink noise, white noise, frequency sweeps), the frequency range does not affect the gain range */
	frequencyRange: FloatRangeConstraints;
	gainRange: FloatRangeConstraints;
};

export type SignalGeneratorPowerSourceConstraints = {
	gainRanges: Array<SignalGeneratorGainRangeByFrequencyRange>;
	powerSourceType: SignalGeneratorPowerSourceType | `${SignalGeneratorPowerSourceType}`;
};

/** The power source type available to the device, which ultimately determines the gain range the signal generator can use. */
export enum SignalGeneratorPowerSourceType {
	Poe = 'POE',
	PoePlus = 'POE_PLUS',
	PoePlusPlus = 'POE_PLUS_PLUS'
}

export type SignalGeneratorSignalTypeConstraints = {
	powerSources: Array<SignalGeneratorPowerSourceConstraints>;
	signalType: SignalType | `${SignalType}`;
};

export enum SignalLevelStrengthExceptionState {
	InvalidRssi = 'INVALID_RSSI',
	MicNotPresent = 'MIC_NOT_PRESENT'
}

export type SignalStrengthException = {
	options: Maybe<Array<SignalLevelStrengthExceptionState | `${SignalLevelStrengthExceptionState}`>>;
};

export type SignalStrengthWithExceptionsConstraints = {
	exceptionState: SignalStrengthException;
	level: IntRangeConstraints;
};

export enum SignalType {
	PinkNoise = 'PINK_NOISE',
	SineWave = 'SINE_WAVE',
	Sweep = 'SWEEP',
	WhiteNoise = 'WHITE_NOISE'
}

export type SignalTypeConstraints = {
	options: Array<SignalType | `${SignalType}`>;
};

export enum SpeakerType {
	Generic = 'GENERIC',
	Generic_4Ohm = 'GENERIC_4_OHM',
	Generic_8Ohm = 'GENERIC_8_OHM',
	Mxp_1 = 'MXP_1',
	Mxp_3Ceiling = 'MXP_3_CEILING',
	Mxp_3Wall = 'MXP_3_WALL',
	Mxp_5 = 'MXP_5',
	Mxp_6 = 'MXP_6',
	NotConfigured = 'NOT_CONFIGURED'
}

export type SpectrumManager = {
	hardwareId: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type StereoAudioChannel = Node & {
	audioChannelId: Scalars['ID']['output'];
	description: StereoAudioChannelDescription;
	features: AudioChannelFeatures;
	fragmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
};

export type StereoAudioChannelDescription = {
	constraints: AudioChannelConstraints;
	features: AudioChannelSupportedFeatures;
	/** @deprecated Use the 'groupName' field instead to ensure your code is open to extension to new audio channel groups. This enum is no longer preferred since it regularly breaks on expanding the available enum members to cover new channel groupings for new devices. */
	group: AudioChannelGroup | `${AudioChannelGroup}`;
	groupName: Scalars['AudioChannelGroupName']['output'];
	role: AudioChannelRole | `${AudioChannelRole}`;
	stereoAudioChannelSpatialSeparation: Maybe<
		StereoAudioChannelSpatialSeparation | `${StereoAudioChannelSpatialSeparation}`
	>;
};

export enum StereoAudioChannelSpatialSeparation {
	Left = 'LEFT',
	Right = 'RIGHT'
}

export type StrengthLevel = {
	exceptionState: Maybe<SignalLevelStrengthExceptionState | `${SignalLevelStrengthExceptionState}`>;
	level: Maybe<Scalars['Int']['output']>;
};

export type Subscription = {
	availableFirmwarePackages: Array<FirmwarePackage>;
	cloneRoomAsync: Maybe<CloneRoomEvent>;
	deployRoomAsync: RoomDeploymentProgress;
	deviceFirmwareUpdateCapabilities: Array<FirmwareUpdateCapabilityOutput>;
	deviceLicenseActivationProgress: DeviceLicenseActivationProgress;
	deviceLicenseCancelPendingActivationProgress: DeviceLicenseCancelPendingActivationProgress;
	deviceLicenseDeactivationProgress: DeviceLicenseDeactivationProgress;
	deviceTalkerTracking: DeviceTalkerTrackingEvent;
	/**
	 * Emits events whenever a device is added under management (e.g. discovered for the first time as DeviceState.DISCOVERED),
	 * or whenever a device is removed from management (e.g. a physical device goes to DeviceState.OFFLINE, a virtual device is deleted).
	 */
	discoveredDevices: DiscoveredDevicesEvent;
	/** Emits events whenever any device undergoes a status change (DISCOVERED, ONLINE, OFFLINE, ERROR). */
	discoveredDevicesStatus: DiscoveredDevicesStatusChange;
	discoveredRooms: Maybe<DiscoveredRoomEvent>;
	dspDebugSettings: DeviceDspDebugSettingsEvent;
	firmwarePackageDownloadProgress: FirmwarePackageDownloadRequestProgress;
	firmwarePackageServerStatus: FirmwarePackageServerStatus;
	firmwareUpdateProgress: FirmwareUpdateRequestProgress;
	/**
	 * Emits change events for a given node specified by the node's ID.
	 * A list of MeterChangeType values can be used to suppress events that do not correspond to the features being subscribed for.
	 * The update period must also be specified for the minimum amount of time between events.
	 *
	 * Note that when multiple MeterChangeTypes and meterable data are provided simultaneously,
	 * each MeterChange event can contain one or more features for that given node which have changed.
	 */
	meterChanges: MeterChange;
	networkInterfaceDiscoveryChange: NetworkInterfaceV2;
	networkInterfacechange: Maybe<NetworkInterfaceChange>;
	/**
	 * Emits change events for a given node specified by the node's ID.
	 * A list of NodeChangeType values can be used to suppress events that do not correspond to the features being subscribing for.
	 * DeviceStateChange events returned from this subscription cannot be suppressed.
	 */
	nodeChanges: NodeChange;
	optimizeRoomAsync: OptimizeRoomProgress;
	/** The subscribeDeviceProperties is not-supported and is only used for internal purposes */
	subscribeDeviceProperties: Array<DevicePropertyChangeEvent>;
	subscribeDeviceReverseIdentify: DeviceReverseIdentifyEvent;
};

export type SubscriptionCloneRoomAsyncArgs = {
	input: CloneRoomInput;
};

export type SubscriptionDeployRoomAsyncArgs = {
	input: RoomDeploymentInput;
	keyring: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDeviceLicenseActivationProgressArgs = {
	id: Scalars['ID']['input'];
};

export type SubscriptionDeviceLicenseCancelPendingActivationProgressArgs = {
	id: Scalars['ID']['input'];
};

export type SubscriptionDeviceLicenseDeactivationProgressArgs = {
	id: Scalars['ID']['input'];
};

export type SubscriptionDeviceTalkerTrackingArgs = {
	id: Scalars['ID']['input'];
};

export type SubscriptionDspDebugSettingsArgs = {
	id: Scalars['ID']['input'];
};

export type SubscriptionMeterChangesArgs = {
	id: Scalars['ID']['input'];
	types: Array<MeterChangeType>;
	updateRate: Scalars['Duration']['input'];
};

export type SubscriptionNetworkInterfacechangeArgs = {
	networkInterfaceId: Scalars['String']['input'];
};

export type SubscriptionNodeChangesArgs = {
	id: Scalars['ID']['input'];
	types: Array<NodeChangeType>;
};

export type SubscriptionOptimizeRoomAsyncArgs = {
	keyring: InputMaybe<Scalars['String']['input']>;
	request: InputMaybe<OptimizeRoomInput>;
	room: Scalars['ID']['input'];
};

export type SubscriptionSubscribeDevicePropertiesArgs = {
	id: Scalars['ID']['input'];
	propertyKeys: Array<Scalars['String']['input']>;
};

export type SubscriptionSubscribeDeviceReverseIdentifyArgs = {
	id: Scalars['ID']['input'];
};

export enum SummingMode {
	Off = 'OFF',
	Summing_1_2 = 'SUMMING_1_2',
	Summing_1_2And_3_4 = 'SUMMING_1_2_AND_3_4',
	Summing_3_4 = 'SUMMING_3_4',
	SummingAll = 'SUMMING_ALL'
}

export type SupportedProtocolsInput = {
	ethernet?: InputMaybe<EthernetConfig>;
	usb?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The battery level indication for the talk switch (separate of the portable microphone or in-ear monitoring bodypack) */
export enum TalkSwitchBatteryLevel {
	Low = 'LOW',
	Normal = 'NORMAL'
}

export type TalkSwitchOutputRoutingBehavior = {
	/**
	 * The state of the output routing over the associated output when the switch is not pressed
	 * When true, audio is sent over the output.
	 * When false, audio is not sent over the output.
	 */
	default: Scalars['Boolean']['output'];
	/**
	 * The state of the output routing over the associated output when the switch is pressed.
	 * When true, audio is sent over the output.
	 * When false, audio is not sent over the output.
	 */
	pressed: Scalars['Boolean']['output'];
};

export type TalkSwitchOutputRoutingBehaviorInput = {
	/**
	 * The state of the output routing over the associated output when the switch is not pressed
	 * When true, audio is sent over the output.
	 * When false, audio is not sent over the output.
	 */
	default: Scalars['Boolean']['input'];
	/**
	 * The state of the output routing over the associated output when the switch is pressed.
	 * When true, audio is sent over the output.
	 * When false, audio is not sent over the output.
	 */
	pressed: Scalars['Boolean']['input'];
};

export type TalkSwitchOutputRoutingConfiguration = {
	aes3: Maybe<TalkSwitchOutputRoutingBehavior>;
	dante: Maybe<TalkSwitchOutputRoutingBehavior>;
	/** When supported (e.g. ANX4), a device can have both its primary Dante channel and an alternate Dante channel, for separate downstream routing and mixing of the same signal */
	danteAlternate: Maybe<TalkSwitchOutputRoutingBehavior>;
	trs: Maybe<TalkSwitchOutputRoutingBehavior>;
	xlr: Maybe<TalkSwitchOutputRoutingBehavior>;
};

/** Input for configuring the output routing behavior of the talk switch */
export type TalkSwitchOutputRoutingConfigurationInput = {
	aes3?: InputMaybe<TalkSwitchOutputRoutingBehaviorInput>;
	dante?: InputMaybe<TalkSwitchOutputRoutingBehaviorInput>;
	/** When supported (e.g. ANX4), a device can have both its primary Dante channel and an alternate Dante channel, for separate downstream routing and mixing of the same signal */
	danteAlternate?: InputMaybe<TalkSwitchOutputRoutingBehaviorInput>;
	trs?: InputMaybe<TalkSwitchOutputRoutingBehaviorInput>;
	xlr?: InputMaybe<TalkSwitchOutputRoutingBehaviorInput>;
};

export type Talker = AudioChannelTalker | AudioCoverageAreaTalker;

export type TalkerHeight = {
	height: Scalars['Float']['output'];
};

/** Distance information (in millimeters) from the center of the device to an active talker. */
export type TalkerPosition = {
	/**
	 * A statistical confidence level in the degree of certainty that the correct positions have been provided.
	 *
	 * Null if advanced talker tracking is disabled.
	 * >= 0
	 * <= 100
	 * Example: 93.75
	 */
	confidenceLevel: Maybe<Scalars['Float']['output']>;
	/** X-distance from the center of the device to the talker in millimeters. */
	xPosition: Scalars['Int']['output'];
	/** Y-distance from the center of the device to the talker in millimeters. */
	yPosition: Scalars['Int']['output'];
	/** Z-distance from the center of the device to the talker in millimeters. */
	zPosition: Scalars['Int']['output'];
};

export type Temperature = {
	celsius: Scalars['Int']['output'];
};

export type TlsCertificateInput = {
	anonymousId?: InputMaybe<Scalars['String']['input']>;
	clientCertificate: Scalars['String']['input'];
	passphrase?: InputMaybe<Scalars['String']['input']>;
	rootCertificate: Scalars['String']['input'];
	username?: InputMaybe<Scalars['String']['input']>;
};

export type TransmitterDeviceLastKnownLinkageDetails = {
	/** name of transmitter linked to the access point */
	deviceName: Scalars['String']['output'];
	/** type of transmitter linked to this access point */
	deviceType: TransmitterDeviceType | `${TransmitterDeviceType}`;
};

export enum TransmitterDeviceType {
	Bodypack = 'BODYPACK',
	Boundary = 'BOUNDARY',
	Gooseneck = 'GOOSENECK',
	Handheld = 'HANDHELD'
}

export enum TransmitterInitialStateFromCharger {
	Active = 'ACTIVE',
	Muted = 'MUTED',
	Off = 'OFF'
}

export type TransmitterInitialStateFromChargerConstraints = {
	/** @deprecated Use stateOptions in DeviceTransmitterInitialStateFromCharger instead */
	options: Array<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>;
};

export type TransmitterInitialStateFromChargerOptionalFormFactorConstraints = IFieldSupportInfo & {
	/** @deprecated Use stateOptions in DeviceTransmitterInitialStateFromCharger instead */
	options: Maybe<Array<TransmitterInitialStateFromCharger | `${TransmitterInitialStateFromCharger}`>>;
	supported: Scalars['Boolean']['output'];
};

export enum TransmitterLightingBehavior {
	/** External LED control */
	ExternalControl = 'EXTERNAL_CONTROL',
	/** Solid green when the mic is unmuted and solid red when the mic is muted */
	UnmuteSolidGreenMuteSolidRed = 'UNMUTE_SOLID_GREEN_MUTE_SOLID_RED',
	/** Solid red when the mic is unmuted and flashing red when the mic is muted */
	UnmuteSolidRedMuteFlashingRed = 'UNMUTE_SOLID_RED_MUTE_FLASHING_RED',
	/** Solid red when the mic is unmuted and off when the mic is muted */
	UnmuteSolidRedMuteOff = 'UNMUTE_SOLID_RED_MUTE_OFF'
}

export type TransmitterLightingBehaviorConstraints = {
	options: Array<TransmitterLightingBehavior | `${TransmitterLightingBehavior}`>;
};

export enum TransmitterMuteBehavior {
	ExternalMute = 'EXTERNAL_MUTE',
	LocalMuteAll = 'LOCAL_MUTE_ALL',
	LocalMuteIndividual = 'LOCAL_MUTE_INDIVIDUAL',
	LogicMute = 'LOGIC_MUTE',
	UsbHostSync = 'USB_HOST_SYNC'
}

export enum TransmitterSwitchBehavior {
	Disabled = 'DISABLED',
	PushToMute = 'PUSH_TO_MUTE',
	PushToTalk = 'PUSH_TO_TALK',
	Toggle = 'TOGGLE'
}

export enum TransmitterUsbHostDisconnectMuteBehavior {
	AlwaysMute = 'ALWAYS_MUTE',
	LocalMuteAll = 'LOCAL_MUTE_ALL',
	LocalMuteIndividual = 'LOCAL_MUTE_INDIVIDUAL'
}

export type UnitOfMeasurement = {
	distance: DistanceMeasurement | `${DistanceMeasurement}`;
};

export type UnitOfMeasurementConstraints = {
	distance: DistanceMeasurementOptions;
};

export type UnitOfMeasurementUpdateInput = {
	distance: DistanceMeasurement | `${DistanceMeasurement}`;
};

export enum UnlinkingOperationResult {
	/** Device is not discoverable. */
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	/** Failed to unlink RF channel(s) and transmitter(s). */
	Failure = 'FAILURE',
	/** Input node id(s) provided in linking request is not valid. */
	InvalidInput = 'INVALID_INPUT',
	/** Provided input devices either does not support linking feature or not a valid input for this operation. */
	InvalidOperation = 'INVALID_OPERATION',
	/** No transmitter is linked to RF channel. */
	NoLinkedTransmitterOnRfChannel = 'NO_LINKED_TRANSMITTER_ON_RF_CHANNEL',
	/** No transmitter is discovered for the charger bay. */
	NoTransmitterOnChargerBay = 'NO_TRANSMITTER_ON_CHARGER_BAY',
	/** Successfully unlinked RF channel(s) and transmitter(s) */
	Success = 'SUCCESS',
	/** Failed to receive unlinking result within the timeout */
	TimeoutExceeded = 'TIMEOUT_EXCEEDED'
}

export type UpdateAudioNetworkInput = {
	gateway?: InputMaybe<Scalars['IpAddress']['input']>;
	id: Scalars['ID']['input'];
	ipAddress?: InputMaybe<Scalars['IpAddress']['input']>;
	ipMode: IpMode | `${IpMode}`;
	subnetMask?: InputMaybe<Scalars['IpAddress']['input']>;
};

export type UpdateAudioNetworkInterfaceInput = {
	id: Scalars['ID']['input'];
	networkInterfaceId: Scalars['String']['input'];
};

export type UpdateAudioNetworksInput = {
	id: Scalars['ID']['input'];
	primary?: InputMaybe<AudioNetworkConfiguration>;
	redundant?: InputMaybe<AudioNetworkConfiguration>;
};

export type UpdateControlNetworkInput = {
	gateway?: InputMaybe<Scalars['IpAddress']['input']>;
	id: Scalars['ID']['input'];
	ipAddress?: InputMaybe<Scalars['IpAddress']['input']>;
	ipMode: IpMode | `${IpMode}`;
	subnetMask?: InputMaybe<Scalars['IpAddress']['input']>;
};

export type UpdateControlNetworkInterfaceInput = {
	id: Scalars['ID']['input'];
	networkInterfaceId: Scalars['String']['input'];
};

export type UpdateCredentialsInput = {
	accessLevel: Scalars['String']['input'];
	id: Scalars['ID']['input'];
	newPassphrase: Scalars['String']['input'];
};

export type UpdateDeviceFirmwareInput = {
	firmwarePackageKey: Scalars['String']['input'];
	firmwarePackageVersion: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export type UpdateDnsClientConfigurationInput = {
	id: Scalars['ID']['input'];
	/**
	 * The first array item is the primary server IP address
	 * and the second array item is the secondary server IP address
	 * Missing any array item or providing more than 2 items will cause INVALID_INPUT error.
	 * This field is required for MANUAL mode
	 */
	manualConfiguration?: InputMaybe<Array<Scalars['IpAddress']['input']>>;
	mode: DeviceDnsClientConfigurationMode | `${DeviceDnsClientConfigurationMode}`;
};

export type UpdateNetworkIpConfigurationsInput = {
	audioNetwork?: InputMaybe<NetworkIpConfigurationsAudioNetworkInput>;
	controlNetwork?: InputMaybe<NetworkIpConfigurationsControlNetworkInput>;
	dnsClientConfiguration?: InputMaybe<NetworkIpConfigurationsDnsClientConfigurationInput>;
	id: Scalars['ID']['input'];
	redundantAudioNetwork?: InputMaybe<NetworkIpConfigurationsAudioNetworkInput>;
	secondaryControlNetwork?: InputMaybe<NetworkIpConfigurationsControlNetworkInput>;
	secondaryDnsClientConfiguration?: InputMaybe<NetworkIpConfigurationsDnsClientConfigurationInput>;
};

/**
 * Result from attempting to update a node via updateNodes().
 *
 * Typically, the 'node' to update will be returned with and can be queried to observe the updated data, or query for additional data.
 * In the event that the 'node' cannot be successfully queried back on behalf of the first operation, it will be returned as null (instead of additionally compounding separate errors).
 *
 * Typically, 'error' will be null.
 * If the update to the node was unsuccessful, an error will be returned via this field.
 */
export type UpdateNodeResult = {
	error: Maybe<OperationError>;
	node: Maybe<Node>;
};

export type UpdateRoomInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<RoomDimensionsInput>;
	hold?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	room: Scalars['ID']['input'];
};

export enum UsbConnection {
	Connected = 'CONNECTED',
	Disconnected = 'DISCONNECTED',
	Error = 'ERROR'
}

export enum UsbOutputMode {
	Mixdown = 'MIXDOWN',
	Stereo = 'STEREO',
	Tracking = 'TRACKING'
}

export enum UsbTerminalType {
	EchoCancelingSpeakerphone = 'ECHO_CANCELING_SPEAKERPHONE',
	SpeakerphoneNoEchoReduction = 'SPEAKERPHONE_NO_ECHO_REDUCTION'
}

export type UserInterfacePreferredLanguageConstraints = {
	options: Array<Language | `${Language}`>;
};

export type UserPreset = Fragment &
	Node & {
		description: UserPresetDescription;
		features: UserPresetFeatures;
		fragmentId: Scalars['ID']['output'];
		id: Scalars['ID']['output'];
	};

export type UserPresetChange = {
	features: UserPresetFeatureChange;
	fragmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
};

export type UserPresetConstraints = {
	preset: Maybe<UserPresetCoreConstraints>;
};

export type UserPresetCore = {
	created: Maybe<Scalars['DateTime']['output']>;
	empty: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	readOnly: Scalars['Boolean']['output'];
};

export type UserPresetCoreChange = {
	preset: Maybe<UserPresetCore>;
};

export type UserPresetCoreConstraints = {
	name: UserPresetCoreNameConstraints;
};

export type UserPresetCoreNameConstraints = IStringPatternRangeConstraints & {
	pattern: Scalars['Regex']['output'];
};

export type UserPresetDescription = {
	constraints: UserPresetConstraints;
	features: UserPresetSupportedFeatures;
	index: Scalars['Int']['output'];
};

export type UserPresetExportToFileContentsOperationResult = {
	error: Maybe<OperationError>;
	fileContents: Maybe<Scalars['String']['output']>;
};

export type UserPresetFeatureChange = UserPresetCoreChange;

export type UserPresetFeatures = {
	preset: Maybe<UserPresetCore>;
};

export type UserPresetOperationResult = NodeOperationResult & {
	error: Maybe<OperationError>;
	userPreset: Maybe<UserPreset>;
};

export type UserPresetSupportedFeatures = {
	preset: FeatureSupport;
};

export type UsernamePassphraseInput = {
	passphrase: Scalars['String']['input'];
	username: Scalars['String']['input'];
};

export type VerifyCredentialsInput = {
	accessLevel: Scalars['String']['input'];
	id: Scalars['ID']['input'];
	passphrase: Scalars['String']['input'];
};

export type VirtualDeviceAdditionAsyncResult = {
	/** Requested virtual devices that were added, or will be added */
	addedDevices: Array<PendingVirtualDevice>;
	error: Maybe<OperationError>;
};

export type VirtualDeviceAdditionFromStateFileContentsInput = {
	/** Device ID to assign to the virtual device (optional) */
	deviceId?: InputMaybe<Scalars['Guid']['input']>;
	/** Uploaded contents of a JSON state file */
	fileContents: Scalars['String']['input'];
	/** Device ID of the original device represented by the state file (optional) */
	originDeviceId?: InputMaybe<Scalars['Guid']['input']>;
};

export type VirtualDeviceAdditionFromStateFileContentsResult = {
	/** Indicates whether or not the virtual device was added */
	added: Scalars['Boolean']['output'];
	/** Virtual device that was added */
	device: Device;
	/** Device ID of the original device represented by the state file, if provided */
	originDeviceId: Maybe<Scalars['Guid']['output']>;
};

export type VirtualDeviceAdditionFromStateFilePathAsyncInput = {
	/** Number of identical virtual devices to load */
	count: Scalars['Int']['input'];
	/** Path to a JSON state file */
	filePath: Scalars['String']['input'];
};

export type VirtualDeviceAdditionFromStateFilePathInput = {
	/** Device ID to assign to the requested virtual device (optional) */
	deviceId?: InputMaybe<Scalars['Guid']['input']>;
	/** Path to a JSON state file */
	filePath: Scalars['String']['input'];
	/** Device ID of the original device represented by the state file (optional) */
	originDeviceId?: InputMaybe<Scalars['Guid']['input']>;
};

export type VirtualDeviceAdditionFromStateFilePathResult = {
	/** Indicates whether or not the requested virtual device was added */
	added: Scalars['Boolean']['output'];
	/** Virtual device */
	device: Device;
	/** Provided path to a JSON state file */
	filePath: Scalars['String']['output'];
	/** Device ID of the original device represented by the state file, if provided */
	originDeviceId: Maybe<Scalars['Guid']['output']>;
};

export type VirtualDeviceAdditionFromStateFileUriInput = {
	/** Device ID to assign to the virtual device (optional) */
	deviceId?: InputMaybe<Scalars['Guid']['input']>;
	/** URI of a JSON state file */
	fileUri: Scalars['String']['input'];
	/** Device ID of the original device represented by the state file (optional) */
	originDeviceId?: InputMaybe<Scalars['Guid']['input']>;
};

export type VirtualDeviceAdditionFromStateFileUriResult = {
	/** Indicates whether or not the requested virtual device was added */
	added: Scalars['Boolean']['output'];
	/** Virtual device that was added */
	device: Device;
	/** Provided URI to a JSON state file */
	fileUri: Scalars['String']['output'];
	/** Device ID of the original device represented by the state file, if provided */
	originDeviceId: Maybe<Scalars['Guid']['output']>;
};

export type VirtualDeviceAdditionInput = {
	/** Number of identical virtual devices to add */
	count: Scalars['Int']['input'];
	/**
	 * Device category
	 * @deprecated Device category is now be inferred from device type.
	 */
	deviceCategory?: InputMaybe<Scalars['String']['input']>;
	/** Device type ID */
	deviceType: Scalars['Guid']['input'];
	/**
	 * Property interface ID (optional)
	 *
	 * If one is not provided, the latest supported interface will be used
	 */
	interfaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type VirtualDeviceAdditionResult = {
	/** Requested virtual devices that were successfully added */
	addedDevices: Array<Device>;
	error: Maybe<OperationError>;
};

export type VirtualDeviceRemovalInput = {
	/** Node IDs of the virtual devices to remove */
	ids: Array<Scalars['ID']['input']>;
};

export type VirtualDeviceRemovalResult = {
	error: Maybe<OperationError>;
	/** Virtual devices that were not removed */
	failedDevices: Array<Device>;
};

export type VirtualDevicesAdditionFromStateFileContentsResult = {
	error: Maybe<OperationError>;
	/** Results for each requested virtual device */
	results: Array<VirtualDeviceAdditionFromStateFileContentsResult>;
};

export type VirtualDevicesAdditionFromStateFilePathsResult = {
	error: Maybe<OperationError>;
	/** Results for each requested virtual device */
	results: Array<VirtualDeviceAdditionFromStateFilePathResult>;
};

export type VirtualDevicesAdditionFromStateFileUrisResult = {
	error: Maybe<OperationError>;
	/** Results for each requested virtual device */
	results: Array<VirtualDeviceAdditionFromStateFileUriResult>;
};

export type VoiceActivityDetection = {
	/** A statistical confidence level in the degree of certainty that the audio has been correctly characterized. */
	confidenceLevel: Scalars['Float']['output'];
	/** The type of audio source which was detected in a given location in search of talkers. */
	type: VoiceActivityDetectionType | `${VoiceActivityDetectionType}`;
};

export enum VoiceActivityDetectionSensitivity {
	High = 'HIGH',
	Low = 'LOW',
	Medium = 'MEDIUM',
	Moderate = 'MODERATE'
}

export type VoiceActivityDetectionSensitivityConstraints = {
	options: Array<VoiceActivityDetectionSensitivity | `${VoiceActivityDetectionSensitivity}`>;
};

/** The type of audio source which was detected in a given location in search of talkers. */
export enum VoiceActivityDetectionType {
	/** Audio corresponds to the far end of an active conference call being reinforced within the room */
	FarEndActivity = 'FAR_END_ACTIVITY',
	/** Audio was detected, but the source of the audio could not be distinguished */
	Uncertain = 'UNCERTAIN',
	/** Background noise, utterances, muttering, whispering, etc which may not be appropriate for capture */
	UnvoicedSpeechOrNoise = 'UNVOICED_SPEECH_OR_NOISE',
	/** Clearly voiced speech of a talker to track */
	VoicedSpeech = 'VOICED_SPEECH'
}

export enum WirelessEncryptionStatus {
	Active = 'ACTIVE',
	Inactive = 'INACTIVE',
	KeyMismatch = 'KEY_MISMATCH'
}
